[
{
    "title": "LA BELLA ESTATE",
    "director": "Laura Luchetti",
    "country": "Italia",
    "releaseYear": 2023,
    "runtime": 111,
    "version": "OmU",
    "screeningDate": "19.03.2026",
    "readableDate": "2026-03-19",
    "screeningTime": "20:00",
    "actors": "Yile Yara Vianello, Deva Cassel, Nicolas Maupas, Alessandro Piavani, Adrien Dewitte, Cosima Centurioni e altri",
    "subtitle": ["Che la storia sia ambientata nell'Italia fascista, non gioca veramente un ruolo. Parla piuttosto della sessualità e della sua liberazione, ma anche delle limitazioni nell'autorealizzazione femminile."],
    "bodycopy": ["Una giovane sarta si innamora di un modello di nudo. Al contrario di suo fratello, lei è alla ricerca di una vita migliore, più eccitante, di tanta libertà e trasgressioni. Si avvale quindi della nuova amicizia per diventare la musa di vari pittori. È la trasposizione sullo schermo della trilogia di Cesare Pavese, che porta lo stesso titolo."],
    "image": "../la bella estate.jpg"
  },
  {
    "title": "LA MAFIA NON È PIÙ QUELLA DI UNA VOLTA",
    "director": "Franco Maresco",
    "country": "Italia",
    "releaseYear": 2019,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "16.04.2026",
    "readableDate": "2026-04-16",
    "screeningTime": "20:00",
    "actors": "Letizia Battaglia, Ciccio Mira, Franco Maresco, Matteo Mannino, Cristian Mischel, Franco Zecchin, Pino Maniaci",
    "subtitle": ["Quando due personaggi, che hanno condizionato in modo decisivo l'immagine della mafia nell'opinione pubblica, si uniscono ne esce sempre qualcosa di speciale: si tratta di Franco Maresco, osservatore cinico-satirico di Cosa nostra, e Letizia Battaglia, la fotografa dei delitti mafiosi."],
    "bodycopy": ["Il tema di questo documentario è il rapporto della popolazione siciliana con la mafia in base alle reazioni all'assassinio dei due magistrati antimafia, Giovanni Falcone e Paolo Borsellino, avvenuto 25 anni prima. L'episodio culminante della pellicola è una festa dedicata ai due famosi magistrati. Indifferenza, aperta ostilità o assurde manovre per sottrarsi dimostrano l'atteggiamento del pubblico. E la festa si trasforma così in una farsa."],
    "image": "../la mafia non è più quella di una volta.jpg"
   },
{
    "title": "PRIMADONNA",
    "director": "Marta Savina",
    "country": "Italia",
    "releaseYear": 2023,
    "runtime": 102,
    "version": "OmU",
    "screeningDate": "21.05.2026",
    "readableDate": "2026-05-21",
    "screeningTime": "20:00",
    "actors": "Claudia Gusmano, Fabrizio Ferracane, Francesco Colella, Manuela Ventura, Dario Aita e altri",
    "subtitle": ["Negli anni 1960 la logica di una società patriarcale costringe la vittima di uno stupro al matrimonio con il suo violentatore. La pratica legittimata del cosiddetto “matrimonio riparatore” inserisce la violenza maschile nell'ordine sociale. Ambientato in un villaggio siciliano, il film racconta il dramma di una ragazza che si oppone a questo meccanismo e denuncia il suo stupratore. La storia, ispirata alle vicende realmente accadute alla diciassettenne Franca Viola, segna un cambio fondamentale nella logica del diritto e della morale pubblica in Italia."],
    "bodycopy": ["Lia, la protagonista 21enne, è caparbia e volitiva. Dopo un flirt iniziale si rifiuta di continuare la relazione con il figlio di un importante imprenditore mafioso, e subisce una violenza brutale. Invece di ripristinare l'”onore” sposandosi, decide di ricorrere al tribunale. Servendosi di una scenografia classica, PRIMADONNA raffigura questa lotta personale e giuridica che conduce poi ad una riflessione sulla violenza strutturale, all'influsso ecclesiastico e alla persistenza di norme patriarcali, trasformandosi così in uno studio storico di evidente rilevanza attuale."],
    "image": "../Primadonna.jpg"
  },
  {
    "title": "UN MONDO A PARTE",
    "director": "Riccardo Milani",
    "country": "Italia",
    "releaseYear": 2024,
    "runtime": 113,
    "version": "OmU",
    "screeningDate": "19.02.2026",
    "readableDate": "2026-02-19",
    "screeningTime": "20:00",
    "actors": "Antonio Albanese, Virginia Raffaele, Corrado Oddi, Sergio Meogrossi, Carmelo Gentile e altri",
    "subtitle": [
      "Il maestro di scuola Michele Cortese lascia Roma e chiede di essere trasferito a Rupe, uno sperduto paesino montano negli Abruzzi. Nel villaggio ha il compito di infondere nuovo coraggio nei sette sparuti alunni appartenenti a tre classi scolastiche e perciò riuniti in una cosiddetta pluriclasse."
    ],
    "bodycopy": [
      "La risoluta collega Agnese lo sostiene, ma poi arriva una brutta notizia: vista la scarsità di alunni si prevede la chiusura della scuola. Inizia la lotta contro il tempo per salvare non soltanto la scuola, ma anche il futuro della comunità montana. Milani intreccia la vita quotidiana, comicità e realismo sociale in una struttura narrativa che con una certa leggerezza tocca dei temi piuttosto seri. UN MONDO A PARTE sviluppa il suo fascino nella tensione tra tradizione e trasformazione, familiarità ed estraneità. La telecamera riprende splendidi paesaggi montani e scene luminose, piene di atmosfera, in cui la natura diventa lo specchio di rivolgimenti personali. Il film mette in luce in modo affascinante e raffinato le sfide sociali del nostro tempo come: fuga dalle campagne, crisi di identità e senso civile. UN MONDO A PARTE parla di arrivi, di responsabilità e della forza di piccole azioni in spazi grandiosi."
    ],
    "image": "../un mondo a parte.jpg"
  },
  {
    "title": "IL SOL DELL’AVVVENIRE",
    "director": "Nanni Moretti",
    "country": "Italia",
    "releaseYear": 2023,
    "runtime": 95,
    "version": "OmU",
    "screeningDate": "15.01.2026",
    "readableDate": "2026-01-15",
    "screeningTime": "20:00",
    "actors": "Nanni Moretti, Margherita Buy, Silvio Orlando, Barbora Bobulova, Mathie Amalric e altri",
    "subtitle": [
      "Chi avrebbe potuto fornire un ritratto più ironico di Nanni Moretti se non lui stesso? Citando più volte le sue opere, manda il suo alter ego, un regista di film d'autore in crisi, in giro per Roma."
    ],
    "bodycopy": [
      "Parlare con amici, scrivere sceneggiature, trattare con Netflix, litigare con la moglie che sta lavorando ad un film mainstream, confrontarsi con i bambini - svariate sono le situazioni e le occasioni per filosofare e riflettere in modo divertente sul cinema e la creatività di Moretti. Facendosi l'occhiolino e prendendo un po' in giro se stesso, crea delle scene brillanti a sfondo filosofico, ad esempio quando blocca un set per discutere sul cinema d'arte con un regista di film popolari. Regista di film d'autore: “Fermati, ma cosa stai facendo. Non si fa così, si è già visto migliaia di volte. Ma che vuoi? La gente ci si è abituata, e vuole proprio vedere questo.",
      "A chi piace l'ironia di Nanni Moretti, la trova concentrata in questo film."
    ],
    "image": "../ilSoldellavvenire.jpg"
  },
  {
    "title": "VERMIGLIO",
    "director": "Maura Delpero",
    "country": "Italia, Francia, Belgio",
    "releaseYear": 2024,
    "runtime": 119,
    "version": "OmU",
    "screeningDate": "18.12.2025",
    "readableDate": "2025-12-18",
    "screeningTime": "20:00",
    "actors": "Tommaso Ragno, Giuseppe De Domenico,·Roberta Rovelli,·Martina Scrinzi, Orietta Notari, Carlotta Gamba, Santiago Fondevila Sancet e altri",
    "subtitle": [
      "Il film ha un secondo titolo, più lungo e cioè: VERMIGLIO O LA SPOSA DI MONTAGNA. Ed è proprio lo sguardo dagli angusti paesaggi alpini verso il mondo che a Vermiglio, un paesino nelle montagne trentine, tiene assieme il tutto sia in senso figurato che nella vita reale."
    ],
    "bodycopy": [
      "Le tre sorelle, Lucia, Ada e Flavia nell'ultimo anno di guerra devono nascondersi nel fienile, il che non impedisce a Lucia di rimanere incinta di Pietro, un disertore siciliano. Seguono di gran fretta uno dopo l'altro la richiesta della mano, il matrimonio e la fine della guerra. La famiglia trentina insiste perché Pietro vada dalla madre in Sicilia per annunciarle le due belle notizie: il figlio è sopravvissuto e si è pure appena sposato. Ma Pietro sapeva perché inizialmente si opponeva al viaggio. Con la sua partenza il destino prende il suo corso. Sarà in grado di mantenere la promessa di tornare a Vermiglio?"
    ],
    "image": "../Vermiglio.jpg"
  },
  {
    "title": "UCCELLACCI E UCCELLINI",
    "director": "Pier Paolo Pasolini",
    "country": "Italia",
    "releaseYear": 1965,
    "runtime": 85,
    "version": "OmU",
    "screeningDate": "20.11.2025",
    "readableDate": "2025-11-20",
    "screeningTime": "20:00",
    "actors": "Totò, Ninetto Davoli,·Femi Benussi, Rossana Di Rocco, Lena Lin Solaro",
    "subtitle": [
      "50 anni fa: L'omicidio di Pasolini. Una manifestazione organizzata assieme all'associazione italo-tedesca di Düsseldorf. Conferenza del Dr. Thomas Brückner (docente privato): Omaggio a Pasolini e introduzione al film."
    ],
    "bodycopy": [
      "Un film di Pier Paolo Pasolini forte e poetico, concentrato sulla fragilità e la bellezza della natura nonché sui complessi rapporti tra gli esseri viventi. Con la sua tipica mescolanza di profonde riflessioni critico-sociali e raffinatezza estetica, Pasolini ci mostra un mondo in cui gli uccelli rappresentano la libertà, la brama e la fugacità nella vita. Padre e figlio camminano su una noiosa strada in mezzo ad una campagna monotona. Li accompagna un corvo filosofeggiante. E passando tra la raffigurazione delle sue favole, la realizzazione fantasiosa dei racconti del padre con i suoi episodi nasce un film riflessivo e allo stesso tempo divertente."
    ],
    "image": "../UCCELLACCI E UCCELLINI.jpg"
  },
  {
    "title": "PARTHENOPE",
    "director": "Paolo Sorrentino",
    "country": "Italia, Francia",
    "releaseYear": 2024,
    "runtime": 107,
    "version": "OmU",
    "screeningDate": "16.10.2025",
    "readableDate": "2025-10-16",
    "screeningTime": "20:00",
    "actors": "Celeste Dalla Porta, Dario Aita, Daniele Rienzo, Gary Oldman, Silvia Degrandi e altri",
    "subtitle": [
      "Lei, intelligente, attraente e napoletana, negli anni 70 è alla ricerca, allora diffusa, del senso della vita e di un obiettivo professionale. Cosa che risulta più difficoltosa di quanto se lo aspettava. Il racconto di Sorrentino è una storia \"coming of age\", intersecata dai miti di Napoli. Per Sorrentino è una ricerca del suo approccio e del suo legame sentimentale con la città natale."
    ],
    "bodycopy": [
      "Tuttavia in vari punti rimane attaccato alla bellezza della protagonista e segue la grazia dei suoi movimenti. Lei può essere sicura di ricevere le attenzioni del mondo maschile. Perciò, diventando adulta, le riesce ancor più difficile trovare e provare amore e passione. Così usa la sua bellezza per far progressi nella vita. Secondo Sorrentino, si tratta di una biografia che rappresenta in modo allegorico il carattere di Napoli. Ha ragione?"
    ],
    "image": "../Parthenope.jpg"
  },
  {
    "title": "CARO DIARIO",
    "director": "Nanni Moretti",
    "country": "Italia",
    "releaseYear": 1993,
    "runtime": 96,
    "version": "OmU",
    "screeningDate": "18.09.2025",
    "readableDate": "2025-09-18",
    "screeningTime": "20:00",
    "actors": "Nanni Moretti, Giulio Base, Carlo Mazzacurati, Jennifer Beals, Renato Carpentieri, Antonio Neiwiller e altri",
    "subtitle": [],
    "bodycopy": [
      "In forma di diario cinematografico Nanni Moretti sviluppa in tre capitoli le sue considerazioni personali sulle correlazioni tra società e individuo, cinema e televisione, tra le piccole e grandi \"meraviglie\" della vita e della sopravvivenza. I suoi giri in vespa nei sobborghi romani, la sua ricerca di tranquillità sulle isole Eolie e infine la sua disputa tragicomica con la sua malattia e i tentativi di guarigione dei medici costituiscono un'odissea contemporanea, ludica e arzigogolata, meditativa e parimenti divertente."
    ],
    "image": "../Caro diario.jpg"
  },
  {
    "title": "L’ULTIMA NOTTE DI AMORE",
    "director": "Andrea Di Stefano",
    "country": "Italia",
    "releaseYear": 2023,
    "runtime": 126,
    "version": "OmU",
    "screeningDate": "19.06.2025",
    "readableDate": "2025-06-19",
    "screeningTime": "20:00",
    "actors": "Pierfrancesco Favino, Linda Caridi, Antonio Gerardi, Francesco Di Leva, Martin Francisco Montero Baez e altri",
    "subtitle": [
      "Un thriller nella migliore tradizione dei film polizieschi italiani. Inizia con un volo notturno su Milano che termina nell'appartamento del poliziotto Franco Amore dove Viviana, la sua seconda moglie, ha organizzato un festino a sorpresa per festeggiare l'ultimo giorno di lavoro del marito. La festa finisce però presto per Franco che inaspettatamente viene chiamato d'urgenza in servizio sul luogo di un incidente in cui è morto un poliziotto. E nulla rimane come sembrava all'inizio."
    ],
    "bodycopy": [
      "La causa di quanto avvenuto è un “piacere” fatto da Amore ad un amico e collega, immerso fino al collo nel fango della corruzione. Franco deve sostituire un collega assentato e fare un lavoretto come corriere, accompagnato dall'amico. Sembra che si tratti di un lavoretto senza rischi e ben remunerato. Però qualcosa va storto e così inizia per lui l'ultima notte piena di imprevisti."
    ],
    "image": "../Ultima notte di Amore.jpg"
  },
  {
    "title": "GLORIA!",
    "director": "Margherita Vicario",
    "country": "Italia/Svizzera",
    "releaseYear": 2024,
    "runtime": 111,
    "version": "OmU",
    "screeningDate": "15.05.2025",
    "readableDate": "2025-05-15",
    "screeningTime": "20:00",
    "actors": "Galatéa Bellugi, Carlotta Gamba, Maria Vittoria Dallastra, Sara Mafodda, Veronica Lucchesi e altri",
    "subtitle": [
      "La ribellione femminile e come la musica divide e congiunge. In prima linea ci sono un pianoforte, fonte e strumento di ribellione, e un gruppetto di ragazze scontrose, unite nella musica per lottare contro l'incrostata autorità maschile."
    ],
    "bodycopy": [
      "In un istituto musicale per educande provenienti da famiglie borghesi, lavora come domestica Teresa, una ragazza musicale, a cui però viene negata la possibilità di suonare. In cantina Teresa scopre in una stanza recondita un pianoforte e impara da sola a suonarlo. Intuitivamente sviluppa una vivacità musicale che trasmette alle allieve della scuola mettendo in dubbio l'autorità del loro maestro, immerso nel suo mondo musicale tradizionale. La necessità di scrivere un brano musicale in occasione della visita del papa, mette in cristi il maestro che lotta invano con il suo materiale, mentre le allieve preparano una messa in scena musicale moderna e pomposa."
    ],
    "image": "../Gloria.jpg"
  },
  {
    "title": "L'UOMO DELLE STELLE",
    "director": "Giuseppe Tornatore",
    "country": "Italia",
    "releaseYear": 1995,
    "runtime": 113,
    "version": "OF",
    "screeningDate": "02.08.2006",
    "readableDate": "2006-08-02",
    "screeningTime": "18:00",
    "actors": "Sergio Castellitto, Tiziana Lodato, Franco Scaldati, Cleilia Rondinella e altri",
    "subtitle": [],
    "bodycopy": [
      "Nella Sicilia del 1953, Joe Morelli (vero nome Giuseppe Romolo) gira con un autocarro, un tendone e una macchina da presa: si presenta come inviato di una casa cinematografica romana e invita la gente a fare provini per la cifra di 1500 lire, promettendo fama e denaro e dispensando a chiunque lodi e incoraggiamenti su una probabile carriera attoriale. In ogni paese il suo arrivo suscita entusiasmo, senza distinzione di età o sesso."
    ],
    "image": "../L'uomo_delle_stelle.png"
  },
  {
    "title": "Non è giusto",
    "director": "Antonietta De Lillo",
    "country": "Italia",
    "releaseYear": 2001,
    "runtime": 102,
    "version": "OmU",
    "screeningDate": "14.05.2004",
    "readableDate": "2004-05-14",
    "screeningTime": "19:30",
    "actors": "Maddalena Polistina, Daniel Podromo, Antonio Manzini, Valerio Binasco",
    "subtitle": ["Il film ha fatto parte della rassegna CON GLI OCCHI DI LEI"],
    "bodycopy": [
      "Sofia e Valerio, entrambi con famiglie divise, durante un'afosa estate napoletana imparano a conoscersi. Sono due ragazzini ancora sottoposti agli sbalzi d'umore e alla confusione generazionale dei loro genitori. Nell'attesa delle vacanze e dell'entrata in un'età più adulta impareranno a guardare i grandi con distacco."
    ],
    "image": "../non-e-giusto.jpg"
  },
  {
    "title": "ENNIO",
    "director": "Giuseppe Tornatore",
    "country": "Italia",
    "releaseYear": 2022,
    "runtime": 156,
    "version": "OmU",
    "screeningDate": "03.06.2023",
    "readableDate": "2023-06-03",
    "screeningTime": "20:00",
    "actors": "",
    "subtitle": [
      "Il film ha inaugurato la rassegna SPOTLIGHT ON ENNIO MORRICONE in programma nel giugno 2023 nella sala Black Box"
    ],
    "bodycopy": [
      "Con ENNIO Giuseppe Tornatore ha creato un vero monumento in onore di Ennio Morricone, il compositore di colonne sonore più noto e più proficuo del cinema del XX secolo. Famoso divenne con la musica di C'ERA UNA VOLTA IL WEST e ancor oggi molti associano il suo nome ai western all'italiana, per i quali compose molti brani musicali.",
      "Nell'ambito di un'avvincente sequenza di scene raffiguranti la vita e l'operato di Morricone, Tornatore monta le interviste con il “Maestro” e altri musicisti intervallandole con osservazioni e ricordi di registi che hanno lavorato con lui.",
      "Costituiscono dei punti salienti del film delle testimonianze ancora sconosciute della vita di Morricone nonché alcune riprese originali di lui mentre compone la sua musica e dirige i suoi concerti. Si tratta di materiali provenienti in parte da archivi privati a cui Tornatore ha potuto accedere solamente perché è stato legato da una profonda amicizia con il Maestro stesso e la sua famiglia.",
      "Un film che entusiasmerà non solo gli appassionati di musica."
    ],
    "image": "../Ennio.jpeg"
  },
  {
    "title": "GRAZIE RAGAZZI",
    "director": "Riccardo Milani",
    "country": "Italia",
    "releaseYear": 2023,
    "runtime": 117,
    "version": "OmU",
    "screeningDate": "17.04.2025",
    "readableDate": "2025-04-17",
    "screeningTime": "20:00",
    "actors": "Antonio Albanese, Fabrizio Bentivoglio, Sonia Bergamasco, Giacomo Ferrara, Andrea Lattanzi e altri",
    "subtitle": [],
    "bodycopy": [
      "Chi è contento di fallire? Quando poi gli dicono pure che non ha più chance e che deve accettare un progetto che ha una pessima fama, non sono motivi per disperarsi? La passione di Antonio per la recitazione però è talmente forte da non poterci rinunciare. Quindi si impegna a preparare un gruppo teatrale in carcere per il palcoscenico.",
      "L’entusiasmo dei partecipanti lascia alquanto a desiderare, la realtà di tutti i giorni si inserisce nella dinamica di gruppo. Appena Antonio riesce a risvegliare almeno un certo interesse, amministratori, politici e colleghi gli mettono i bastoni tra le ruote. Riuscirà a trionfare come desidera?"
    ],
    "image": "../Grazie Ragazzi.jpg"
  },
  {
    "title": "BANGLA",
    "director": "Phaim Bhuiyan",
    "country": "Italia",
    "releaseYear": 2019,
    "runtime": 87,
    "version": "OmU",
    "screeningDate": "20.03.2025",
    "readableDate": "2025-03-20",
    "screeningTime": "20:00",
    "actors": "Phaim Bhuiyan, Pietro Sermonti, Carlotta Antonelli, Simone Liberati e altri",
    "subtitle": [
      "Non soltanto l’Italia ha un problema con i migranti, ma anche i migranti della seconda generazione. Il giovane mussulmano, Phaim, lo descrive così: “Anche se ho la pelle un po’ scura, sono italiano, una via di mezzo, metà italiano, metà bangla, ma 100% torpignattaro. Torpignattara è un quartiere multietnico di Roma."
    ],
    "bodycopy": [
      "Di giorno lavora come guardiano in un museo, di sera suona in una banda. Durante un concerto incontra Asia, una ragazza aperta e vivace, proprio il contrario di lui. È amore a prima vista, ma la vita insieme si rivela difficile. I genitori di Phaim hanno trovato una ragazza mussulmana per lui e si aspettano che lui la sposi. E poi c’è un altro problema: come fa Phaim a spiegare ad Asia che un mussulmano deve arrivare illibato al matrimonio?"
    ],

    "image": "../Bangla.jpg"
  },
  {
    "title": "COMANDANTE",
    "director": "Edoardo De Angelis",
    "country": "Italia/Belgio",
    "releaseYear": 2023,
    "runtime": 155,
    "version": "OmU",
    "screeningDate": "20.02.2025",
    "readableDate": "2025-02-20",
    "screeningTime": "20:00",
    "actors": "Pierfrancesco Favino, Johannes Wirix, Johan Heldenbergh, Massimiliano Rossi, Arturo Muselli, Giuseppe Brunetti, Gianluca Di Gennaro, Silvia D'Amico, Paolo Bonacelli e altri",
    "subtitle": [
      "È facile descriverlo così: “Dramma bellico in cui un capitano di marina, la sua nave e il suo equipaggio sono pronti ad affrontare qualsiasi battaglia”. (Lessico del film internazionale)"
    ],
    "bodycopy": [
      "La pellicola fa parte della categoria dei film ambientati in un sottomarino: “claustrofobia, dinamica di gruppo”, “uomini arditi”, “trovarsi rinchiusi” ecc. La novità qui è il fatto che dopo l’affondamento di una nave nemica, il suo equipaggio non viene abbandonato in mare, ma si tenta di salvarlo. A causa del carattere autoritario del comandante in Italia il film è stato definito fascista. Ma in effetti è il contrario perché predica l’umanità e il superamento dell’ostilità. “Noi non l’avremmo fatto” dice il capo nemico, “ma noi siamo italiani”, così giustifica l’azione il comandante. Esiste un commento più mordace sull’attuale politica migratoria in Italia?"
    ],

    "image": "../Comandante.jpg"
  },
  {
    "title": "IL COLIBRÌ",
    "director": "Francesca Archibugi",
    "country": "Italia/Francia",
    "releaseYear": 2022,
    "runtime": 126,
    "version": "OmU",
    "screeningDate": "16.01.2025",
    "readableDate": "2025-01-16",
    "screeningTime": "20:00",
    "actors": "Pierfrancesco Favino, Nanni Moretti, Bérénice Bejo, Kasia Smutniak, Laura Morante e altri",
    "subtitle": [
      "Il film accompagna la vita di un uomo, il suo grande amore irrealizzato, il mancato raggiungimento di se stesso. Guidato come un burattino dal mondo che lo circonda, sviluppa una sorprendente pacatezza. Il film si muove come nei sogni attraverso lo spazio, il tempo, le situazioni e i temi."
    ],
    "bodycopy": [
      "Incontriamo Marco bambino, un ragazzino sensibile cresciuto in un ambiente borghese, seguiamo il suo amore per Luisa, siamo testimoni della sua umiliazione. La sorella maggiore muore suicida a 24 anni, con il fratello è inconciliabile. Tuttavia studia all’università e diventa medico praticante. Il suo matrimonio fallisce, però trova un equilibrio occupandosi del proprio figlio. Ma il destino non gli dà tregua. E infine gioca professionalmente a poker. Questo gioco a carte è come una parabola su vittoria e sconfitta, successo e fallimento. Sebbene le vicende sembrino prevalentemente negative, Marco riesce ad emanare una tranquillità interiore che semplicemente rigetta tutti i mali."
    ],
    "image": "../IlColibri.jpg"
  },
  {
    "title": "Rose e pistole",
    "director": "Carla Apuzzo",
    "country": "Italia",
    "releaseYear": 1998,
    "runtime": 81,
    "version": "OmU",
    "screeningDate": "21.05.2004",
    "readableDate": "2004-05-21",
    "screeningTime": "19:30",
    "actors": "Anna Anunirati, Duccio Giordano, Luigi Petrucci",
    "subtitle": [""],
    "bodycopy": [
      "Tra Bagnoli e i Campi Flegrei, Rosa e Angelo, entrambi ventenni, sono in fuga dal marito di lei. Il ricco macellaio Pappalardo ha assunto un killer..."
    ],
    "image": "../../rose-e-pistole.jpg"
  },
  {
    "title": "SIAMO SOLO NOI",
    "director": "Marco Pejrolo",
    "country": "Italia/Germania",
    "releaseYear": 2023,
    "runtime": 151,
    "version": "OmU",
    "screeningDate": "19.09.2024",
    "readableDate": "2024-09-24",
    "screeningTime": "20:00",
    "actors": "Barbara Calabrese, Cristina Cozzini, Alessandra Jucca, Aida Loggiodice, Irene Rosin",
    "subtitle": [""],
    "bodycopy": [
      "Cinque amiche che vivono da sole hanno qualcosa in comune, ognuna di loro ha una super-sensibilità e ognuna, a modo suo, si confronta con un mondo maschile penoso, immaturo ed egocentrico che l'affascina, l'attira e la disgusta. Da questa costellazione iniziale nascono delle situazioni assurde, umoristiche, caricaturali. Situazioni che lo spettatore già conosce nella sua vita abituale, sia che si tratti ad esempio delle difficoltà di carattere amoroso o della paura insorgente della solitudine.",
      "Per la prima volta il Club del Cinema Italiano mostra un film prima della sua uscita ufficiale. Inizialmente progettato come cortometraggio con attrici dilettanti, ma con un regista e cameraman professionista, è diventato una commedia con i migliori ingredienti dell'umorismo italiano e tedesco, recitata con un impeto che mette in ombra tanti attori professionisti."
    ],
    "image": "../Siamo solo noi-Nur wir.JPG"
  },
  {
    "title": "C’È ANCORA UN DOMANI",
    "director": "Paola Cortellesi",
    "country": "Italia",
    "releaseYear": 2023,
    "runtime": 118,
    "version": "OmU",
    "screeningDate": "17.10.2024",
    "readableDate": "2024-10-17",
    "screeningTime": "20:00",
    "actors": "Paola Cortellesi, Valerio Mastandrea, Romana Maggiora Vergano; Emanuela Fanelli e altri",
    "subtitle": [""],
    "bodycopy": [
      "Record: nominato ben 19 volte per il Davide di Donatello, record: il film di maggior successo di pubblico degli ultimi decenni con grande risonanza sui media. Una pellicola che perciò non può essere ignorata nella nostra rassegna.",
      "Il successo del film sembra essere dovuto soprattutto alla sua trama. La discussione politica in Italia da qualche anno gira intorno al tema del femminicidio, che include anche quello della violenza domestica, e cioè del tema di questo film. La regista ha affermato che voleva puntare il dito su una grave problematica sociale del nostro tempo. Ciò fa eco a quanto da lei espresso altrove: “La durezza di quanto si vede ho cercato di smorzarla con effetti di straniamento. Ad esempio il ballo dopo le botte significa anche qualcosa come amore”. Il ragionamento è un po' difficile da seguire e non è l'unica scena contraddittoria in questo film che stupisce anche sotto questo aspetto."
    ],
    "image": "../un domani.jpg"
  },
  {
    "title": "LA CHIMERA",
    "director": "Alice Rohrwacher",
    "country": "Italia/Germania",
    "releaseYear": 2023,
    "runtime": 151,
    "version": "OmU",
    "screeningDate": "21.11.2024",
    "readableDate": "2024-11-21",
    "screeningTime": "20:00",
    "actors": "Josh O’Connor, Isabella Rossellini, Alba Rohrwacher, Carol Duarte, Vincenzo Nemolato e altri",
    "subtitle": [""],
    "bodycopy": [
      "Uscito dal carcere, Arthur, un giovane inglese, torna a casa in una cittadina sul Tirreno. Ha un quinto senso nell'individuare i punti dove nel sottosuolo si trovano reperti archeologici etruschi da vendere illegalmente con profitto. Perciò è la star per un gruppo di tombaroli locali, la cui solidarietà tuttavia lascia alquanto a desiderare. Riallacciare i rapporti con il suo vecchio amore, invece, non gli riesce così facilmente.",
      "Questo terzo film della Trilogia tirrenica (dopo LAZZARO FELICE e LE MERAVIGLIE) è nuovamente una riflessione sull'influsso del passato sul presente e sulle sue conseguenze. I personaggi del film non sembrano vivere ed agire esclusivamente nella realtà presente, bensì parallelamente in un ambiente magico tanto che quanto avviene può essere interpretato in svariati modi. Sogno e immaginazione diventano realtà e il passato si trasforma in una componente del presente. Tuttavia i rapporti interpersonali sembrano caratterizzati da una vita quotidiana normalissima che si dipana durante il racconto."
    ],
    "image": "../La chimera.jpg"
  },
  {
    "title": "IL PRIMO NATALE",
    "director": "Ficarra e Picone",
    "country": "Italia/Germania",
    "releaseYear": 2019,
    "runtime": 104,
    "version": "OmU",
    "screeningDate": "19.12.2024",
    "readableDate": "2024-12-19",
    "screeningTime": "20:00",
    "actors": "Salvatore Ficarra, Valentino Picone, Massimo Popolizio, Roberta Mattei, Giacomo Mattia e altri",
    "subtitle": [""],
    "bodycopy": [
      "Una mescolanza tra BRIAN DI NAZARETH, il film francese I VISITATORI e l'ambiente di Asterix. Il tutto chiaramente all'italiana. La coppia di comici Ficarra e Picone si avvalgono della Storia Sacra per sfottere certe abitudini religiose e sociali e, creando situazioni farsesche, metterle sottosopra con gran chiasso tanto che alla fine non si capisce più qual era ordine preesistente.",
      "Ficarra nella veste di Padre Valentino, un religioso super perfezionista, e Picone nella veste di Salvo, un ladruncolo lesto e furbetto, si ritrovano per caso in un casting per la rappresentazione di un presepe nell'anno della nascita di Gesù Cristo. I due cercano di adattarsi a questo nuovo mondo, provvisti del sapere, non sempre affidabile, del futuro XX secolo, ma ignorando le abitudini e le usanze delle forze dell'ordine di quel tempo lontano. I due non possono perciò evitare di fare dei passi falsi e introdurre cose che oggigiorno consideriamo tradizionali. Padre Valentino impara comunque che è più utile agire piuttosto che pregare e insistere sulla perfezione. Anche Salvo inizia a perdere il suo atteggiamento presuntuoso ed egocentrico. Piano piano si integrano nel nuovo ambiente. Riusciranno pure ad imparare che non ha nessun senso fare domande su Gesù Cristo nell'anno in cui è nato?"
    ],
    "image": "../il primo Natale.jpg"
  },
  {
    "title": "CALCINCULO",
    "director": "Chiara Bellosi",
    "country": "Italia",
    "releaseYear": 2022,
    "runtime": 88,
    "version": "OmU",
    "screeningDate": "18.04.2024",
    "readableDate": "2024-04-18",
    "screeningTime": "20:00",
    "actors": "Gaia Di Pietro, Andrea Carpenzano, Barbara Chichiarelli, Giandomenico Cupaiuolo e altri",
    "subtitle": [""],
    "bodycopy": [
      "In una località di provincia nel Meridione:",
      "La 15enne Benedetta si barcamena fra il mobbing dei coetanei a causa della sua obesità e il generale disinteresse dei genitori per la sua persona. Nel suo intimo cerca l’amore e desidera un cambiamento nella sua vita. Quando di fronte a casa sua si piazza un lunapark, fa conoscenza con Amanda/Amando. Lei/lui non ha un sesso ben definito, non ha un passato, né un piano per il futuro, non ha legami né una vera famiglia – per Benedetta la libertà sognata. Tra i due ragazzi si instaura un fragile rapporto che lei interpreta erroneamente come amore, ma che d'altra parte li mette a confronto con i lati positivi e negativi della presunta libertà e dell’assenza di legami.",
      "Il film si serve di un pacato racconto, quasi meditativo, e di un linguaggio visivo ristretto. Ad esso si susseguono osservazioni precise che conferiscono un tono poetico alla vicenda senza tuttavia travisare le condizioni di vita reali, piuttosto deprimenti."
    ],
    "image": "../Calcinculo 3.jpg"
  },

  {
    "title": "RAPITO",
    "director": "Marco Bellocchio",
    "country": "Italia/Francia/Germania",
    "releaseYear": 2023,
    "runtime": 134,
    "version": "OmU",
    "screeningDate": "16.05.2024",
    "readableDate": "2024-05-16",
    "screeningTime": "20:00",
    "actors": "Paolo Pierobon, Barbara Ronchi, Fabrizio Gifuni e altri",
    "subtitle": [""],
    "bodycopy": [
      "Dopo IL TRADITORE Marco Bellocchio, già 85enne, presenta un'opera straordinaria: un film storico in costume che racconta un episodio realmente avvenuto e ci fornisce un ritratto di quell'epoca. Contemporaneamente si tratta di un giallo e di una ricerca psicologica su quello che plasma un individuo.",
      "Il titolo italiano RAPITO rivela il fatto senza mezzi termini: Nonostante la protesta disarmata dei genitori il papa fa rapire e portare a Roma il loro figliolo, affermando che è stato battezzato, con lo scopo di educarlo cristianamente.",
      "Il ragazzino è intelligente e apprende tutto con grande facilità, ma mostra un carattere ribelle e anarchico di fronte agli sforzi educativi dei prelati. Ciononostante non si può sottrarre all’influsso del Vaticano."
    ],
    "image": "../Rapito 4.jpg"
  },

  {
    "title": "L’OMBRA DI CARAVAGGIO",
    "director": "Michele Placido",
    "country": "Italia/Francia",
    "releaseYear": 2022,
    "runtime": 119,
    "version": "OmU",
    "screeningDate": "20.06.2024",
    "readableDate": "2024-06-20",
    "screeningTime": "20:00",
    "actors": "Riccardo Scamarcio, Louis Garrel, Isabelle Huppert, Micaela Ramazzotti e altri",
    "subtitle": [""],
    "bodycopy": [
      "Caravaggio non è soltanto un pittore straordinario, ma anche un attaccabrighe, un dissoluto e uno zotico che non ha timore di scontrarsi a coltellate. Orge, molestie sessuali e atteggiamenti offensivi della morale borghese fanno parte delle sue abitudini quotidiane. Per il Vaticano un buon motivo per mettergli alle calcagna uno spione – l'ombra di Caravaggio.",
      "Michele Placido, regista, produttore, sceneggiatore e pure attore seppure in un ruolo secondario, inventando la figura dello spione riesce a rappresentare il pittore dal punto di vista di un osservatore. Il carattere di Caravaggio si riflette così nell'ambiente spiato e viene illustrato mediante flashback.",
      "Una simile tecnica l'aveva già utilizzata Orson Wells in CITIZEN CANE per presentare il protagonista con la distanza del narratore e fornire un suo ritratto meno impulsivo."
    ],
    "image": "../L'ombra di Caravaggio 2.jpg"
  },
  {
    "title": "COSA SARÀ",
    "director": "Francesco Bruni",
    "country": "Italia",
    "releaseYear": 2020,
    "runtime": 101,
    "version": "OmU",
    "screeningDate": "18.01.2024",
    "readableDate": "2024-01-24",
    "screeningTime": "20:00",
    "actors": "Kim Rossi Stuart, Lorenza Indovina,·Barbara Ronchi·e altri",
    "subtitle": [""],
    "bodycopy": [
      "\"Qualcuno deve esserci nel 5%\" ribatte Bruno, quando la dottoressa gli spiega che il 95% di chi si ammala di leucemia guarisce. Il suo fondamentale pessimismo è stata la causa del suo insuccesso come regista e del suo allontanamento dalla moglie e dai figli. Questa vita senza speranza lo riporta dal padre. E la ricerca di un donatore o donatrice da parte degli ottimisti della sua famiglia riserva delle inaspettate sorprese.",
      "Allo stesso tempo coglie l’occasione di visitare i luoghi della sua infanzia e adolescenza e si immerge nei ricordi. Si procura una motocicletta, come possedeva una volta, per ripercorrere le vecchie strade di un tempo. Tutto sembra rimasto come allora."
    ],

    "image": "../cosa_sara01.jpg"
  },
  {
    "title": "ATLANTIDE",
    "director": "Yuri Ancarani",
    "country": "Italia/Francia/Stati Uniti/Katar/Messico/Spagna",
    "releaseYear": 2021,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "15.02.2024",
    "readableDate": "2024-02-15",
    "screeningTime": "20:00",
    "actors": "Daniele Barison, Maila Dabalà, Bianka Berényi, Alberto Tedesco e altri",
    "subtitle": [""],
    "bodycopy": [
      "Sebbene il film racconti una storia, la stessa passa in secondo piano per lasciar posto ad una sinfonia creata dai rombi dei motori di barche veloci sfreccianti nella laguna di Venezia e dalla musica da discoteca ad alto volume che i ragazzi annoiati ascoltano quando non si dedicano alle loro barche o gareggiano tra di loro. Il tutto presentato da una fotografia estetico-artistica la cui armonia contrasta con il concerto minimalistico assordante appena descritto.",
      "È un modo di descrivere la vita, i rituali maschilisti e la passione per le barche veloci di giovani che vivono nell’hinterland di Venezia, del quale pochi si accorgono."
    ],
    "image": "../ATLANTIDE.jpg"
  },
  {
    "title": "ARIAFERMA",
    "director": "Leonardo Di Costanzo",
    "country": "Italia/Svizzera",
    "releaseYear": 2021,
    "runtime": 117,
    "version": "OmU",
    "screeningDate": "21.03.2024",
    "readableDate": "2024-03-21",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Silvio Orlando, Fabrizio Ferracane, Salvatore Striano, Roberto De Francesco e altri",
    "subtitle": [""],
    "bodycopy": [
      "Fuori potremmo forse essere amici. Qui però tu sei il delinquente che devo sorvegliare. Tu sei il mio lavoro afferma più o meno uno dei protagonisti. Tra il detenuto e il suo secondino sembrava nascere per un attimo un pizzico di simpatia o comprensione. Però i rapporti all’interno di un carcere possono mutare e imporsi, ma vengono sempre riportati alla costellazione caratteristica.",
      "Dimenticati nello svolgimento del trasloco, 12 detenuti rimangono rinchiusi in un carcere pericolante assieme ad un paio di secondini, senza servizi (cucina, infermeria, riparazioni, ecc.). La permanenza provvisoria sembra non aver fine.",
      "Tra i componenti del gruppetto si sviluppa una certa dinamica, ricompaiono le tensioni tra i carcerati e i vecchi conflitti tra i secondini. Però tra le singole persone si formano anche alleanze impensabili al di fuori di un ambiente così ristretto.",
      "Uno studio psicologico interessante e un film avvincente."
    ],
    "image": "../ARIAFERMA.jpg"
  },

  {
    "title": "NOSTALGIA",
    "director": "Mario Martone",
    "country": "Italia",
    "releaseYear": 2022,
    "runtime": 118,
    "version": "OmU",
    "screeningDate": "21.12.2023",
    "readableDate": "2023-12-21",
    "screeningTime": "20:00",
    "actors": "Pierfrancesco Favino, Sofia Essaïdi, Tommaso Ragno, Francesco Di Leva, Aurora Quattrocchi e altri",
    "subtitle": [
      "Martone tratta nel film la potenza della memoria presentando contemporaneamente il ritratto di una Napoli vivace e in parte rattristita dalla presenza della Camorra. Il racconto serpeggia nel labirinto dei vicoli cittadini e anche nei rapporti umani volgendo lo sguardo a destra e sinistra del percorso per terminare tragicamente."
    ],
    "bodycopy": [
      "Felice che aveva abbandonato da giovane la sua città natale, vi ritorna benestante. Il motivo del suo ritorno è la madre ormai avanti negli anni. Non la trova più nel suo solito appartamento, ma in un tugurio in cantina. Allora le procura quanto le serve e le trova un appartamento luminoso, lussuoso per una città come Napoli.",
      "Allo stesso tempo coglie l’occasione di visitare i luoghi della sua infanzia e adolescenza e si immerge nei ricordi. Si procura una motocicletta, come possedeva una volta, per ripercorrere le vecchie strade di un tempo. Tutto sembra rimasto come allora.",
      "Tuttavia i ragazzi che vagabondano e sparano in giro nella notte indicano che qualcosa è cambiato. Felice viene a sapere che il suo vecchio amico d'infanzia è diventato un capo-camorra a Napoli, e sebbene lo mettano in guardia, vuole incontrarlo. Nel frattempo si moltiplicano i segnali che esprimono quanto non sia benvenuto qui, non per ultimo, perché è impegnato in un'iniziativa comunale contro la criminalità organizzata.",
      "Muovendosi ingenuamente tra i diversi mondi della città, il protagonista sfiora eventi e luoghi fornendo un'immagine di Napoli e dei suoi abitanti, aliena da quella turistica."
    ],

    "image": "../Nostalgia.jpg"
  },
  {
    "title": "L’IMMENSITÀ",
    "director": "Emanuele Crialese",
    "country": "Italia/Francia",
    "releaseYear": 2022,
    "runtime": 99,
    "version": "OmU",
    "screeningDate": "16.11.2023",
    "readableDate": "2023-11-16",
    "screeningTime": "20:00",
    "actors": "Penélope Cruz, Vincenzo Amato, Luana Giuliani, Elena Arvigo, Maria Chiara Goretti e altri",
    "subtitle": [
      "Il ragazzo con i lineamenti femminili forse è veramente una ragazza? Però prima che il racconto si intrattenga sull'identità di genere, cambia tema: i ragazzi, disobbedendo ai genitori, attraversano una distesa di granoturco per raggiungere un campo di nomadi. Il padre si infuria quando lo viene a sapere mentre la madre li protegge sopportando senza difendersi addirittura le botte del marito. I figli sono l'unica cosa che le è rimasta; con un marito che la tradisce, pur godendo di un certo benessere, sente il vuoto della sua vita di casalinga piccolo-borghese."
    ],
    "bodycopy": [
      "Per la prima volta sullo schermo Luana Giuliani nel ruolo di Adriana, una ragazza che vorrebbe essere un maschio. La sua recitazione è all'altezza di quella di Penelope Cruz, la madre oppressa che non vede possibilità di scampo dal vicolo cieco in cui si trova.",
      "Adriana in sua madre vede i limiti della femminilità in un mondo maschilista ed è proprio lei a difendere la madre minacciata dal padre violento. Per lui la famiglia è materiale malleabile e ha la funzione di parafulmine. Infatti deve sopportare i suoi scatti d'ira e le sue imposizioni.",
      "Con maestria Crialese compone il quadro di una famiglia nell'Italia degli anni '70 e mescola con destrezza i vari aspetti e intrecci del racconto. Con il valido supporto delle sue protagoniste è riuscito a presentare un ritratto impressionante di quell'epoca."
    ],
    "image": "../Limmensita.jpg"
  },
  {
    "title": "WELCOME VENICE",
    "director": "Andea Segre",
    "country": "Italia",
    "releaseYear": 2021,
    "runtime": 103,
    "version": "OmU",
    "screeningDate": "19.10.2023",
    "readableDate": "2023-10-19",
    "screeningTime": "20:00",
    "actors": "Paolo Pierobron , Andrea Pennacchi, Anna Bellato, Giuliana Musso, Sara Lazzaro, Roberto Citran e altri",
    "subtitle": [
      "Pensando a Venezia di solito non vengono in mente i granchietti della laguna, ma piuttosto le masse di turisti che invadono la città e inducono i veneziani a lasciarla. I fratelli Pietro e Alvise devono affrontare entrambi i temi. Sono pescatori di granchietti, in dialetto moeche, nella laguna veneta. Nonostante le difficoltà crescenti, Pietro non intende cambiar mestiere, mentre Alvise vorrebbe sfruttare la casa di famiglia per entrare nel potente e lucrativo settore immobiliare. Si mette in contatto con immobiliaristi senza scrupoli che dominano la città ed entra in conflitto con tutta la famiglia."
    ],
    "bodycopy": [
      "WELCOME VENICE mostra gli angoli più nascosti e autentici della città, come raramente succede. Una città che si trova ad un punto di svolta di fronte perché i suoi cittadini oriundi devono fare una difficile scelta per il loro futuro: rimanere a vivere in una delle loro modeste case veneziane oppure venderla ad alto prezzo ai turisti e trasferirsi con un gruzzolo non indifferente sulla terraferma? Segre ha scelto un'immagine spettacolare e indimenticabile per concludere il film.",
      "Di Segre il Club del Cinema Italiano ha già mostrato nel 2014 il film IO SONO LI (VENEZIANISCHE FREUNDSCHAFT)"
    ],
    "image": "../welcome_venice.jpg"
  },
  {
    "title": "IO STO BENE",
    "director": "Donato Rotunno",
    "country": "Belgio/Germania/Italia/Lussemburgo",
    "releaseYear": 2020,
    "runtime": 94,
    "version": "OmU",
    "screeningDate": "21.09.2023",
    "readableDate": "2023-09-21",
    "screeningTime": "20:00",
    "actors": "Renato Carpentieri,·Sara Serraiocco, Alessio Lapice, Marie Jung, Vittorio Nastri e altri",
    "subtitle": [
      "Talvolta un’unica giornata cambia la vita e termina con nuove prospettive inaspettate. Così succede anche ad Antonio e Mary: si incontrano per caso, tra di loro si instaura una fiducia reciproca e dalle rispettive esperienze ricavano impulsi decisivi per il proprio futuro."
    ],
    "bodycopy": [
      "Mary è un'artista disorientata, Antonio un vecchio signore che se la prende con la sua vita e non riesce a riprendersi dopo la morte della moglie. Servendosi di flashback il film parla delle cose più importanti e caratterizzanti per le loro vite. A poco a poco scoprono dei punti comuni e constatano che, nonostante due generazioni li separino, tanti loro problemi hanno soltanto una veste diversa."
    ],
    "image": "../Io sto bene.jpg"
  },
  {
    "title": "BAARÌA",
    "director": "Giuseppe Tornatore",
    "country": "Italia",
    "releaseYear": 2009,
    "runtime": 151,
    "version": "OmU",
    "screeningDate": "15.06.2023",
    "readableDate": "2023-06-15",
    "screeningTime": "20:00",
    "actors": "Francesco Scianna, Margareth Madè, Nicole Grimaudo, Angela Molina, Gaetano Aronica, Alfio Sorbello, Enrico Lo Verso, Nino Frassica, Laura Chiatti, Michele Placido, Giorgio Faletti Corteccia e altri",
    "subtitle": [
      "In un’intervista del 3 ottobre 2011 alla domanda con quale regista lavorasse più volentieri in quel periodo, Morricone rispose: Giuseppe Tornatore. In effetti i due hanno collaborato costruttivamente per decenni, una cooperazione di una tale intensità che Morricone nella sua vita aveva avuto soltanto con Sergio Leone. <<Mi piace quando i registi riescono a mollare affidando alla musica il flusso di alcuni passaggi del film. Sono pochi quelli che hanno il coraggio di farlo>>"
    ],
    "bodycopy": [
      "Al centro della pellicola c’è Bagheria, una piccola località nell’area metropolitana di Palermo. Qui il film segue la vita di tre generazioni e da ciò nasce un quadro della storia italiana dipinto dal basso: fascismo, seconda guerra mondiale, comunismo italiano, ma anche i cambiamenti sociali del Dopoguerra, inclusa la mafia. Quasi troppo per un unico film. Meno male che la musica di Morricone fa ordine, commenta, struttura e sostiene il racconto.",
      "BAARÌA è stato il primo film italiano che dopo ben 18 anni ha potuto inaugurare la Mostra del cinema di Venezia."
    ],
    "image": "../Baaria.jpg"
  },
  {
    "title": "LE OTTO MONTAGNE",
    "director": "Felix van Groeningen, Charlotte Vandermeersch",
    "country": "Italia/Belgio/Francia",
    "releaseYear": 2022,
    "runtime": 148,
    "version": "OmU",
    "screeningDate": "18.05.2023",
    "readableDate": "2023-05-18",
    "screeningTime": "20:00",
    "actors": "Alessandro Borghi, Luca Marinelli, Filippo Timi, Elena Lietti, Gualtiero Burzi e altri",
    "subtitle": [
      "Le otto montagne compaiono piuttosto tardi nel film. In stato di ebrezza Bruno e Pietro scherzano scioccamente su una parabola che Pietro ha appreso nel Nepal: il mondo sarebbe un cerchio circondato da otto montagne con una più grande al centro.  La domanda è: chi conosce dunque di più il mondo, quello che ha viaggiato sulle otto montagne o l’altro che guarda il mondo dall’alto della montagna centrale? Solo più tardi capiscono che la parabola parla proprio di loro due. "
    ],
    "bodycopy": [
      "Pietro, da bambino, va con i suoi genitori in vacanza da Torino in un paesino in montagna e fa amicizia con Bruno, l’unico bambino che vive ancora lì. Bruno piace anche ai genitori di Pietro e vorrebbero ospitarlo in modo che possa andare a scuola in città per offrigli un’opportunità per il futuro. Il padre di Bruno però non è d’accordo e prende il figlio con sé in cantiere dove lo fa lavorare da manovale. Solo dopo la morte del padre, Pietro torna nel villaggio e Bruno lo convince ad occuparsi con lui della sua eredità: Bruno ha promesso di rimettere a posto una casa diroccata di proprietà del padre di Pietro. Insieme si mettono al lavoro e così si riaccende la loro vecchia amicizia.",
      "Ma hanno dei concetti di vita completamente divergenti. Bruno cerca la sua fortuna producendo formaggio in una malga, mentre Pietro trova il suo grande amore nel Nepal. Tuttavia sente sempre una gran voglia di tornare da Bruno e fra i due si sviluppa una famigliarità che li fa condividere reciprocamente le loro vite. Materialmente entrambi falliscono nei loro intenti, ma la loro profonda amicizia compensa tutto ciò finché il destino non li colpisce."
    ],
    "image": "../otto montagne.png"
  },
  {
    "title": "COME UN GATTO IN TANGENZIALE",
    "director": "Riccardo Milani",
    "country": "Italia",
    "releaseYear": 2017,
    "runtime": 98,
    "version": "OmU",
    "screeningDate": "20.04.2023",
    "readableDate": "2023-04-20",
    "screeningTime": "20:00",
    "actors": "Paola Cortellesi, Antonio Albanese, Sonia Bergamasco, Luca Angeletti, Antonio D’Ausilio e altri",
    "subtitle": [
      "Ma i politici si rendono conto di quello che fanno e per chi lo fanno? Giovanni è convinto del suo lavoro politico. Presiede un <<think tank>> che elabora per l’UE uno studio sui sobborghi socialmente problematici di Roma e ha il compito di proporre adeguati interventi. Nulla di ciò capisce Monica che vive lì e deve risolvere giorno per giorno i suoi complessi problemi. Il film mostra lo scontro tra due caratteri inconciliabili e da questo incontro sa far sprizzare con maestria spassose scintille umoristiche. Un umorismo che va da una comicità dozzinale fino a intelligenti battute cabarettistiche, servendosi di tutta la scala disponibile e riflettendo con leggerezza su un tema effettivamente molto serio."
    ],
    "bodycopy": [
      "Il mondo di Giovanni è in ordine e lui ci tiene molto a mantenerlo tale. Perciò intrattiene un rapporto amichevole con la sua ex moglie e si impegna a capire sua figlia. Ma quando quest’ultima si mette seriamente assieme ad Alessio che proviene dal malfamato quartiere di Bastogi, il padre li segue e si scontra con il carattere vulcanico di Monica, madre del ragazzo. Entrambi i genitori non sono entusiasti di questo rapporto tra due ceti fra loro così lontani e, anche se i loro motivi però sono diversi, si uniscono per cercare di dissuadere i due ragazzi. Siccome tuttavia non ci riescono, le due famiglie, pur socialmente così diverse, cercano di stabilire un contatto reciproco e si accorgono che le stesse parole possono avere significati tra loro molto disparati, ad esempio, tempo libero, rilassamento, invito a cena, solidarietà ecc. I due mondi iniziano a comprendersi, ne nasce però un <<attrito>> dal quale si sviluppano battute e situazioni umoristiche.",
      ""
    ],
    "image": "../come un gatto.jpg"
  },
  {
    "title": "A CHIARA",
    "director": "Jonas Carpignano",
    "country": "Italia/Francia",
    "releaseYear": 2021,
    "runtime": 122,
    "version": "OmU",
    "screeningDate": "16.03.2023",
    "readableDate": "2023-03-16",
    "screeningTime": "20:00",
    "actors": "Swamy Rotolo, Claudio Rotolo, Grecia Rotolo, Antonio Rotolo Uno, Koudous Seihon e altri",
    "subtitle": ["", ""],
    "bodycopy": [
      "Come si sente una ragazza di 15 anni quando il padre dopo aver festeggiato il suo compleanno sparisce da casa, intorno alla casa di notte c’è un andirivieni frenetico di persone, si fa vedere pure la polizia, l’automobile di famiglia esplode e succedono altre cose strane. Forse suo padre ha a che fare con la N’drangheta? La madre non fornisce spiegazioni. Poco dopo alla televisione annunciano che il padre è ricercato dalla polizia. A questo punto Chiara chiede chiarimenti, vuole conoscere tutta la verità. Ben presto capisce che lei stessa deve indagare. Allora si scontra contro un muro di silenzio e i legami familiari e quelli con gli amici improvvisamente acquistano un altro significato.",
      "Capignano tematizza le strutture e le azioni delle organizzazioni mafiose dal punto di vista inconsueto dei legami familiari. La prospettiva della quindicenne Chiara diventa quella dello spettatore che, assieme a lei, perde la sua ingenuità e piano piano si accorge delle conseguenze delle azioni criminose per le persone più care e vicine, mentre i delinquenti le ignorano o le vedono troppo tardi. Proprio lo sguardo circoscritto di Chiara su quanto accade permette allo spettatore di accrescere e approfondire la sua comprensione e sensibilità per il fenomeno mafioso."
    ],
    "image": "../a chiara.jpg"
  },
  {
    "title": "A CASA TUTTI BENE",
    "director": "Gabriele Muccino",
    "country": "Italia",
    "releaseYear": 2018,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "16.12.2021",
    "readableDate": "2021-12-16",
    "screeningTime": "20:00",
    "actors": "Stefania Sandrelli, Carolina Crescentini, Stefano Accorsi, Gianmarco Tognazzi, Sandra Milo e altri",
    "subtitle": [
      " Nei film gli incontri di famiglia sono spesso caratterizzati da rapporti incrinati, ipocrisie e conflitti sopiti. Così pure nel film di Gabriele Muccino. Solo che lui inscena l’incontro della numerosa famiglia sull’isola di Ischia durante una mareggiata che non soltanto sconvolge i piani delle singole persone presenti, ma lascia grande spazio per caratterizzarle e sondare i loro rapporti reciproci. Si sviluppano vari racconti, paralleli, incrociati o collegati che vengono coreografati drammaticamente con grande maestria. "
    ],
    "bodycopy": [
      " Alba (Stefania Sandrelli) e Pietro (Ivano Marescotti) vogliono festeggiare le loro nozze d’oro e invitano tutta la famiglia. Ma nella loro gioia per l’imminente evento hanno sottovalutato il temperamento dei loro familiari: c’è la moglie gelosa dell’ex marito, il marito che pensa solo all’amante parigina e non nota i tentativi di flirt di sua moglie, il genero timido che comincia a corteggiare la cugina e molti altri. Li accomunano amore e simpatia, gelosia e invidia, bramosie e sogni. E non manca neppure un tradimento. Un labirinto di passioni in un ambiente paradisiaco."
    ],
    "image": "../a-casa-tutti-bene.jpg"
  },
  {
    "title": "A CIASCUNO IL SUO",
    "director": "Elio Petri",
    "country": "Italia",
    "releaseYear": 1967,
    "runtime": 99,
    "version": "OmitU",
    "screeningDate": "02.06.2010",
    "readableDate": "2010-06-02",
    "screeningTime": "20:00",
    "actors": "Gian Maria Volonté, Irene Papas, Gabriele Ferzetti, Salvo Randone, Luigi Pistillim, Laura Nucci",
    "subtitle": [""],
    "bodycopy": [
      "Libera trasposizione di Elio Petri dell’omonimo romanzo di Leonardo Sciascia: Dopo l’uccisione di due uomini durante una battuta di caccia, l’insegnante liceale Paolo Laurana (Gian Maria Volontè) indaga per suo conto nello strano groviglio per venire a capo del caso. Un intreccio di tabù sessuali, intrighi criminali e intrallazzi politici."
    ],
    "image": "../a-ciascuno-il-suo.jpg"
  },
  {
    "title": "ACAB - ALL COPS ARE BASTARDS",
    "director": "Stefano Sollima",
    "country": "Italia/Francia",
    "releaseYear": 2012,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "20.09.2018",
    "readableDate": "2018-09-20",
    "screeningTime": "20:00",
    "actors": "Pierfrancesco Favino, Filippo Nigro, Marco Giallini, Eugenio Mastrandrea, Domenico Diele, Andrea Sartoretti, Roberta Spagnuolo",
    "subtitle": [
      "Come si sente un poliziotto che deve mantenere l'ordine quando si trova di fronte ad un'orda di skinhead scalmanati, ultrà di sinistra infervorati o tifosi alcolizzati che scandiscono \"All Cops are Bastards\" (tutti i poliziotti sono dei bastardi)? Sa che dipende dall'aiuto dei colleghi con o quali nasce una solidarietà, che talvolta non si ferma all'ambiente di lavoro, ma può sconfinare fino a diventare incontrollabile."
    ],
    "bodycopy": [
      "Cobra, Nero e Mazinga fanno parte di un'unità speciale che interviene a nome dello Stato in caso di violenza di massa di qualsiasi tipo. E non vanno per il sottile tanto che il manganello di tanto in tanto lascia il suo segno anche su persone casualmente coinvolte. Questo mondo guidato dall'odio, dalla violenza a cui risponde la violenza invade anche la vita privata. D'altra parte è compensato da una profonda comprensione e fiducia reciproca, un mondo a sé con una propria dinamicità che si difende accanitamente contro i superiori e gli estranei. In questo ambiente capita una giovane recluta che mette alla prova le strutture ormai radicate.",
      "Stefano Sollima, figlio di Sergio Sollima, il noto regista di italowestern e gialli, fa vivere da vicino il formarsi non solo di violenza e controviolenza, odio cieco o provocato, ma anche di solidarietà e amicizia avvalendosi degli elementi di un linguaggio visivo che ha trovato una sua prima maturazione alcuni anni più tardi in SUBURRA."
    ],
    "image": "../acab.jpg"
  },
  {
    "title": "Accattone",
    "director": "Pier Paolo Pasolini",
    "country": "Italia",
    "releaseYear": 1961,
    "runtime": 116,
    "version": "OmU",
    "screeningDate": "04.02.2011",
    "readableDate": "2011-02-04",
    "screeningTime": "20:00",
    "actors": "Franco Citti, Franca Pasut, Silvana Corsini, Adele Cmbria, Paola Guidi, Adriana Asti",
    "subtitle": [""],
    "bodycopy": [
      "Con ACCATTONE Pasolini descrive per la prima volta il mondo con e nel linguaggio del film. Trasforma la struttura a episodi del Neorealismo nella compattezza ermetica della tragedia. La trama del piccolo magnaccia romano Accattone viene raccontata come la Passione di Cristo con gli strumenti del cinema della poesia."
    ],
    "image": "../accattone.jpg"
  },
  {
    "title": "Agata e la tempesta",
    "director": "Silvio Soldini",
    "country": "Italia",
    "releaseYear": 2004,
    "runtime": 118,
    "version": "OmU",
    "screeningDate": "15.09.2005",
    "readableDate": "2005-09-15",
    "screeningTime": "19:30",
    "actors": "Licia Maglietta, Giuseppe Battiston, Silvana Bosi, Emilio Soffrizzi, Marina Massironi, Claudio Santamaria, Gisela Volodi, Ann Eleonora Jargensen, Remo Remotti, Monica Nappo, Carlo Luca De Ruggieri",
    "subtitle": [""],
    "bodycopy": [
      "Dopo “Pane e tulipani” Soldini ha girato una nuova commedia con Licia Marietta come protagonista. Agata, una dinamica libraia, scoppia di energia e con lei anche le lampadine elettriche. Il caos è completo quando Agata si innamora di un uomo che ha 13 anni meno di lei e suo fratello Gustavo viene a sapere di essere un figlio adottivo, quasi “venduto” dalla madre naturale. I due vengono a conoscere il trasognato donnaiolo Romeo che si rivela essere il fratello di lui. Una costellazione che fa vacillare i concetti di vita dei protagonisti. Parimenti però sembra che permetta loro di realizzare all’improvviso i desideri più nascosti."
    ],
    "image": "../agata.jpg"
  },
  {
    "title": "Agostino d’Ippona",
    "director": "Roberto Rossellini",
    "country": "Italia",
    "releaseYear": 1972,
    "runtime": 117,
    "version": "OmitU",
    "screeningDate": "06.06.2007",
    "readableDate": "2007-06-06",
    "screeningTime": "19:00",
    "actors": "Dary Berkani, Virginio Gazzolo, Cesare Barbetti, Bruno Cattaneo, Leonardo Fioravanti",
    "subtitle": ["Rassegna di Roberto Rossellini"],
    "bodycopy": [
      "Dal 395 al 430 Sant'Augusto è vescovo di Ippona, nell'attuale Algeria. È un'epoca di transizione. Nel 410 avviene il \"Sacco di Roma\" e l'Impero romano, in piena decadenza, è ormai agli sgoccioli. Nel 431, un anno dopo la morte di Augusto, i Vandali conquistano la città di Ippona che domineranno poi per cent'anni. Rossellini si avvale di questo sfondo storico per tematizzare il ruolo della religione e dei suoi rappresentanti nel contesto politico."
    ],
    "image": "../agostinodippona.png"
  },
  {
    "title": "Alla luce del sole",
    "director": "Roberto Faenza",
    "country": "Italia",
    "releaseYear": 2005,
    "runtime": 90,
    "version": "OmitU",
    "screeningDate": "01.04.2009",
    "readableDate": "2009-04-01",
    "screeningTime": "20:00",
    "actors": "Luca Zingaretti, Alessia Goria, Corrado Fortuna, Giovanna Bozzolo, Francesco Foti, Piero Nicosia",
    "subtitle": ["Rassegna di Roberto Faenza"],
    "bodycopy": [
      "Diventato parroco in un quartiere malfamato di Palermo, Giuseppe Puglisi crea un centro per recuperare i bambini e gli adolescenti che vivono per la strada. Lottando per l’essenziale, come l’allacciamento alla rete fognaria o l’assistenza sanitaria nella sua scuola, entra in conflitto con la mafia. In concomitanza con gli attentati mortali ai giudici Falcone e Borsellino, la situazione precipita. Faenza ha girato il film attingendo dalla documentazione autentica d’archivio."
    ],
    "image": "../alla-luce-del-sole.jpg"
  },
  {
    "title": "Allonsanfan",
    "director": "Paolo e Vittorio Taviani",
    "country": "Italia",
    "releaseYear": 1974,
    "runtime": 106,
    "version": "OmitU",
    "screeningDate": "06.04.2011",
    "readableDate": "2011-04-06",
    "screeningTime": "20:00",
    "actors": "150 anni dall’unità d’Italia",
    "subtitle": [""],
    "bodycopy": [
      "Sono gli anni della restaurazione. L’aristocratico Fulvio, che viene imprigionato come rivoluzionario con l’accusa di presunto tradimento, dopo il rilascio ha solo voglia di ritirarsi nella tranquilla villa di famiglia con la sua donna. Però mentre lui sogna di scappare con lei in America, lei cerca di convincerlo a partecipare assieme agli excompagni di lotta a una spedizione rivoluzionaria nel Meridione. Gli eventi cominciano ad accavallarsi e l’incapacità di Fulvio di prendere decisioni termina in una tragedia."
    ],
    "image": "../allonsanfan.jpg"
  },
  {
    "title": "ALLONSANFAN",
    "director": "Paolo und Vittorio Taviani",
    "country": "Italia",
    "releaseYear": 1974,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "19.12.2013",
    "readableDate": "2013-12-19",
    "screeningTime": "20:00",
    "actors": "Marcello Mastroianni, Lea Massari, Mimsy Farmer, Claudio Cassinelli, Laura Betti, Benjamin Lev, Bruno Cirino, Stanko Molnar, Luisa De Santis, Biagio Pelligra, Renato De Carmine, Michael Berger",
    "subtitle": [""],
    "bodycopy": [
      "Sono gli anni della restaurazione. L’aristocratico Fulvio, che viene imprigionato come rivoluzionario con l’accusa di presunto tradimento, dopo il rilascio ha solo voglia di ritirarsi nella tranquilla villa di famiglia con la sua donna. Però mentre lui sogna di scappare con lei in America, lei cerca di convincerlo a partecipare assieme agli ex compagni di lotta a una spedizione rivoluzionaria nel Meridione. Gli eventi cominciano ad accavallarsi e l’incapacità di Fulvio di prendere decisioni termina in una tragedia."
    ],
    "image": "../allonsanfan.jpg"
  },
  {
    "title": "Amarcord",
    "director": "Federico Fellini",
    "country": "Italia/Francia",
    "releaseYear": 1973,
    "runtime": 127,
    "version": "OmU",
    "screeningDate": "18.03.2010",
    "readableDate": "2010-03-18",
    "screeningTime": "20:00",
    "actors": "Magali Noël, Pupella Maggio, Bruno Zanin, Armando Brancia, Nando Orfei, Gianfilippo Carcano, Josiane Tanzilli, Maria Antonietta Beluzzi, Giuseppe Ianigro, Stefano Proietti, Luigi Rossi",
    "subtitle": ["Federico Fellini: 90 anni (20.01.1920-31.10.1993) "],
    "bodycopy": [
      "\"Amarcord” significa in dialetto romagnolo: “Mi ricordo”. Anche se Fellini per tutta la sua vita ha negato ogni influsso autobiografico, il riferimento personale è evidente: con la prospettiva di uno stupefatto sedicenne Fellini presenta un caleidoscopio di episodi strani, sia divertenti sia spaventosi, ricreando con essi l’atmosfera della Rimini ai tempi del fascismo, negli anni ‘30."
    ],
    "image": "../amarcord.gif"
  },
  {
    "title": "Amarcord",
    "director": "Federico Fellini",
    "country": "Italia/Francia",
    "releaseYear": 1973,
    "runtime": 127,
    "version": "OmU",
    "screeningDate": "15.12.2005",
    "readableDate": "2005-12-15",
    "screeningTime": "19:30",
    "actors": "Magali Noël, Pupella Maggio, Bruno Zanin, Armando Brancia, Nando Orfei, Gianfilippo Carcano, Josiane Tanzilli, Maria Antonietta Beluzzi, Giuseppe Ianigro, Stefano Proietti, Luigi Rossi",
    "subtitle": [""],
    "bodycopy": [
      "“Amarcord” significa in dialetto romagnolo: “Mi ricordo”.“Amarcord” significa in dialetto romagnolo: “Mi ricordo”.Anche se Fellini per tutta la sua vita ha negato ogni influsso autobiografico, il riferimento personale è evidente: Dallaprospettiva di un sedicenne stupito Fellini presenta un caleidoscopio di episodi strani, sia divertenti sia spaventosicreando con essi l’atmosfera della Rimini ai tempi del fascismo, negli anni Trenta. In Germania il film, le poche volte che succede, viene proiettato di solito in versione doppiata. Perciò cogliete questa rara occasione di potervi godere uno dei film più amati di Fellini initaliano (con sottotitoli tedeschi)."
    ],
    "image": "../amarcord.jpg"
  },
  {
    "title": "Amnesia",
    "director": "Gabriele Salvatores",
    "country": "Italia",
    "releaseYear": 2002,
    "runtime": 111,
    "version": "OmitU",
    "screeningDate": "04.11.2009",
    "readableDate": "2009-11-04",
    "screeningTime": "20:00",
    "actors": "Diego Abantantuono, Sergio Rubini, Martina Stella, Bebo Storti, Juanjo Puigcorbé, Rubén Ochandiano, Maria Jurado, Antonia San Juan, Ian McNeice, Alessandra Martines",
    "subtitle": [
      "Rassegna: Un caso per due - Gabriele Salvatores (regista) e Diego Abantantuono (attore)"
    ],
    "bodycopy": [
      "Amnesia è la megadiscoteca, dove si intreccia il destino di tre uomini: un registra di film porno, che riceve la visita della figlia 17enne sul set, Angelino, che gestisce un bar e spaccia droga, e il capo della polizia locale che ha più da lottare con il figlio ribelle che con la criminalità."
    ],
    "image": "../amnesia.jpg"
  },
  {
    "title": "Andiamo",
    "director": "Thomas Crecelius",
    "country": "Italia/Germania",
    "releaseYear": 2004,
    "runtime": 94,
    "version": "OmU",
    "screeningDate": "18.08.2005",
    "readableDate": "2005-08-18",
    "screeningTime": "19:30",
    "actors": [""],
    "subtitle": [
      "Noto: non stanno letteralmente sbriciolandosi solamente gli splendidi palazzi barocchi, ma anche le prospettive future dei giovani dopo la maturità sono proprio rosee. Perciò si pongono la domanda se rimanere o emigrare nel nord. In una mescolanza di racconto e documentazione il film di Thomas Creceius cerca di capire il fenomeno dell’Italia meridionale. Ne è uscito un ritratto della città di Noto e dei suoi abitanti che simboleggia un aspetto, spesso trascurato, della vita italiana."
    ],
    "bodycopy": [""],
    "image": "../andiamo.jpg"
  },
  {
    "title": "Angela",
    "director": "Roberta Torre",
    "country": "Italia",
    "releaseYear": 2002,
    "runtime": 95,
    "version": "OmU",
    "screeningDate": "02.06.2004",
    "readableDate": "2004-06-02",
    "screeningTime": "19:30",
    "actors": " Andrea Di Stefano, Donatella Finocchiaro, Mario Pupella",
    "subtitle": [""],
    "bodycopy": [
      "Angela, nata e cresciuta a Ballarò, il quartiere del mercato di Palermo, a vent'anni sposa Saro e con lui condivide una vita fatta di traffico di droga e guadagni facili. Quando conosce Masino, diventato il braccio destro di suo marito, nasce tra i due un'attrazione irresistibile."
    ],
    "image": "../Angela.jpg"
  },
  {
    "title": "ANNI FELICI",
    "director": "Daniele Luchetti",
    "country": "Italia",
    "releaseYear": 2014,
    "runtime": 101,
    "version": "OmU",
    "screeningDate": "21.01.2016",
    "readableDate": "2016-01-21",
    "screeningTime": "20:00",
    "actors": "Kim Rossi Stuart, Martina Gedeck, Micaela Ramazzotti, Nicolò Cavagna",
    "subtitle": [""],
    "bodycopy": [
      "Litigano e rifanno pace: Guido, artista d'arte e di vita, dipende economicamente da sua moglie Serena, il che non gli impedisce di cercare avventure amorose e umiliarla finché lei non inizia a rispondere alle avance della gallerista Helke. La famiglia viene tenuta insieme dai figli Paolo e Dario. Ed è quest'ultimo che nel film racconta gli “anni felici della famiglia”."
    ],
    "image": "../anni-felici.jpg"
  },
  {
    "title": "Anno Uno",
    "director": "Roberto Rossellini",
    "country": "Italia",
    "releaseYear": 1974,
    "runtime": 118,
    "version": "OmU",
    "screeningDate": "02.05.2007",
    "readableDate": "2007-05-02",
    "screeningTime": "19:00",
    "actors": " Luigi Vannucchi, Dminique Darel, Corrado Olmi, Renato Montanari, Tino Bianchi, Rita Forzano, Valeria Sabel, Paolo Bonacelli, Francesco Di Federico, Omero Antonutti, Renato Scarpa",
    "subtitle": ["Rassegna di Roberto Rossellini"],
    "bodycopy": [
      "Nelle sue produzioni storiche per la televisione, l'anziano Rossellini ritrova tutta la sua originaria forza creativa. In base alla vita di personalità storiche fornisce un quadro della rispettiva epoca ponendosi la domanda delle responsabilità politiche. Alcide de Gasperi, sotto la protezione del Vaticano, fece resistenza contro Mussolini e diventò poi uno dei padri della \"nuova Italia\". Il film descrive il periodo che va dal 1945, l'anno della liberazione, fino alla morte dello statista nel 1954."
    ],
    "image": "../anno-uno.jpg"
  },
  {
    "title": "Appunti di viaggio per un film sull'India",
    "director": "Pier Paolo Pasolini",
    "country": "Italia",
    "releaseYear": 1968,
    "runtime": 35,
    "version": "OmU",
    "screeningDate": "14.03.2011",
    "readableDate": "2011-03-14",
    "screeningTime": "20:00",
    "actors": "Pier Paolo Pasolini",
    "subtitle": ["Con: Pier Paolo Pasolini"],
    "bodycopy": [
      "Un diario di viaggio, la raffigurazione di un tentativo di girare un film che racconta una leggenda del mondo mitico indiano: la storia di un maragià che offre il suo corpo in cibo ai cuccioli di una tigre che stanno per morire di fame. Pasolini intervista personaggi rappresentativi di diversi ceti sociali."
    ],
    "image": "../Appunti.jpg"
  },
  {
    "title": "Appunti per un'Orestiade africana",
    "director": "Pier Paolo Pasolini",
    "country": "Italia",
    "releaseYear": 1970,
    "runtime": 65,
    "version": "OmU",
    "screeningDate": "27.02.2011",
    "readableDate": "2011-02-27",
    "screeningTime": "15:00",
    "actors": "Pier Paolo Pasolini, Gato Barbieri, Marcelli Melis",
    "subtitle": [""],
    "bodycopy": [
      "Il tentativo di una trasposizione dell'ORESTIADE di Eschilo nell'Africa moderna. In cerca di possibili luoghi per le sue riprese cinematografiche e di personaggi, Pasolini tiene un diario cinematografico."
    ],
    "image": "../Orestiade.jpg"
  },
  {
    "title": "Asmarina",
    "director": "Alan Maglio, Medhin Paolos",
    "country": "Italia",
    "releaseYear": 2015,
    "runtime": 69,
    "version": "OmenU",
    "screeningDate": "15.01.2017",
    "readableDate": "2017-01-15",
    "screeningTime": "20:00",
    "actors": "",
    "subtitle": [
      "Un’epoca postcoloniale quasi dimenticata: l’integrazione, avvenuta nel corso di quasi mezzo secolo, dei gruppi etnici eritrei ed etiopici nella vita sociale e culturale italiana."
    ],
    "bodycopy": [
      "Alan Maglio e Medhin Paolos presentano nel loro documentario i ricordi del popolo degli Habescha a Milano, mostrano destini personali e indagano sulle diverse forme di identità, migrazione e inserimento in terra straniera.",
      "Il risultato è la storia di questa minoranza etnica in Italia: la vita di tutti i giorni di chi è nato lì e di chi ci vive da lungo tempo o dei rifugiati appena arrivati nel paese."
    ],
    "image": "../asmarina.jpg"
  },
  {
    "title": "Azzurro",
    "director": "Denis Rabaglia",
    "country": "Svizzera/Italia/Francia",
    "releaseYear": 2000,
    "runtime": 82,
    "version": "OmU",
    "screeningDate": "19.01.2006",
    "readableDate": "2006-01-19",
    "screeningTime": "19:30",
    "actors": "Paolo Villaggio, Francesca Pipoli, Marie-Cristine Barrault, Jean-Luc Bideau, Renato Scarpa, Julien Boisselier",
    "subtitle": [""],
    "bodycopy": [
      "Dopo aver avuto un infarto cardiaco Giuseppe, ormai 75enne, vuole tornare in Svizzera dove ha lavorato come capo operaio per 30 anni. Su due piedi prende Carla con sé, la nipotina cieca di 7 anni, per chiedere al suo ex datore di lavoro il denaro per pagare l'operazione agli occhi della bimba. Il viaggio, che doveva essere breve, diventa un itinerario nel passato di Giuseppe con incontri che talvolta sono incomprensibili e non soltanto per la bambina cieca."
    ],
    "image": "../azzurro.jpg"
  },
  {
    "title": "BASILICATA COAST TO COAST",
    "director": "Rocco Papaleo",
    "country": "Italia",
    "releaseYear": 2010,
    "runtime": 92,
    "version": "OmitU",
    "screeningDate": "04.04.2012",
    "readableDate": "2012-04-04",
    "screeningTime": "20:00",
    "actors": "Alessandro Gassman, Paolo Briguglia, Max Gazzè, Rocco Papaleo, Giovanna Mezzogiorno",
    "subtitle": [""],
    "bodycopy": [
      "Un gruppo musicale invitato a un festival decide di attraversare la Basilicata, “coast to coast”, a scopo di marketing. Incaricata di documentare l’impresa è una giornalista un po’ insicura. Un romantico road movie che getta uno sguardo ironico sulla dinamica di gruppo di questi protagonisti un po’ imbranati, ma non disposti ad ammetterlo."
    ],
    "image": "../basilicata-coast-to-coast.jpg"
  },
  {
    "title": "BELLA E PERDUTA",
    "director": "Pietro Marcello",
    "country": "Italia",
    "releaseYear": 2015,
    "runtime": 87,
    "version": "OmU",
    "screeningDate": "15.12.2016",
    "readableDate": "2016-12-15",
    "screeningTime": "20:00",
    "actors": "Tommaso Cestrone, Sergio Vitolo, Gesuino Pittalis, Maurizio Braucci",
    "subtitle": [""],
    "bodycopy": [
      "Immagini provenienti dal mondo delle leggende e dal teatro si incrociano a riprese documentarie dell'Italia di oggi e ad un racconto poetico pieno di scene melanconiche: Pulcinella deve salvare il bufalo Sarchiapone e percorre con lui un'Italia ancora arcaica. Un buffone e un bufalo sperimentano amicizia e fiducia, ma anche la lacerazione di un paese."
    ],
    "image": "../bella-e-perduta.jpg"
  },
  {
    "title": "BELLUSCONE. UNA STORIA SICILIANA",
    "director": "Franco Maresco",
    "country": "Italia",
    "releaseYear": 2014,
    "runtime": 95,
    "version": "OmU",
    "screeningDate": "06.07.2015",
    "readableDate": "2015-07-06",
    "screeningTime": "20:00",
    "actors": "",
    "subtitle": [""],
    "bodycopy": [
      "Sono i protagonisti bislacchi di Maresco che assicurano i voti a Berlusconi, chiamato in Sicilia semplicemente \"Belluscone\". Le strade di Palermo, nelle immagini di Maresco, appaiono come un mondo mafioso parallelo nel quale una mano lava l'altra, e dal quale non c'è scampo. Maresco mette in luce con tutta la sua spaventosa evidenza come funzioni il sistema della mafia nel suo piccolo."
    ],
    "image": "../belluscone.jpg"
  },
  {
    "title": "Buonanotte Topolino",
    "director": "Jan Henrik Stahlberg",
    "country": "Germania",
    "releaseYear": 2005,
    "runtime": 89,
    "version": "OmU",
    "screeningDate": "26.04.2006",
    "readableDate": "2006-04-26",
    "screeningTime": "19:30",
    "actors": "Maurizio Antonini, Lucia Chiarla, Pietro Bontempo, Pietro Ragusa, Tullio Sorrentino, Fabio Bezzi, Franco Lei, Oscar Stahlberg",
    "subtitle": [""],
    "bodycopy": [
      "Si può girare un film su Berlusconi senza il suo permesso? Certo, se non si cita il suo nome ed è subito evidente che si tratta di una satira. Seguendo questa regola Stahlberg l'ha realizzato raccontando in esso quali problemi si incontrino girando un film del genere: La storia viene trasferita nel mondo di Topolino e il vero nome del protagonista viene sostituito da un segnale acustico. Oltre alla mania di persecuzione che assale tutto il team che sta girando vediamo come nasce un film satirico su Berlusconi, basato su fatti veramente accaduti."
    ],
    "image": "../buonanotte-topolino.jpg"
  },
  {
    "title": "Buongiorno, notte",
    "director": "Marco Bellocchio",
    "country": "Italia",
    "releaseYear": 2003,
    "runtime": 106,
    "version": "OmU",
    "screeningDate": "18.09.2008",
    "readableDate": "2008-09-18",
    "screeningTime": "19:00",
    "actors": "Maya Sansa, Roberto Herlitzka, Luigi Lo Cascio, Paolo Briguglia, Pier Giorgio Bellocchio, Giovanni Calcagno, Giulio Bosetti",
    "subtitle": ["Sequestro e assassinio di ALDO MORO:"],
    "bodycopy": [
      "Aldo Moro fu sequestrato e assassinato nel 1978 dal gruppo terroristico di estrema sinistra delle Brigate Rosse. L’eminente uomo politico cristiano-democratico era stato più volte ministro e dal 1963al 1968 nonché dal 1974 al 1976 presidente del consiglio in Italia. Controverso era stato il suo appoggio al “compromesso storico”, e cioè all'entrata del partito comunista (PCI) nella coalizione di governo con la Democrazia Cristiana. Il 16 marzo 1978 le Brigate Rosse sequestrarono Aldo Moro. Dopo 55 giorni di prigionia fu trovato morto nel cofano di un'autovettura.",
      "Bellocchio nella sua ricostruzione dei 55 giorni di sequestro di Aldo Moro si cimenta in unostudio psicologico di persone che si ritrovano insieme in situazioni eccezionali. In base ai rapporti delle autorità indaganti e di soggetti coinvolti nonché a ricerche d'archivio, la prigionia di Aldo Moro viene raccontata dal punto di vista dell'unica donna facente parte del gruppo che, contro la volontà degli altri partecipanti, inizia a prendere contatto con il prigioniero. Il film fu criticato per il suo approccio apolitico che d'altra parte, tuttavia, permette nuove prospettive sul lato umano degli “anni di piombo”."
    ],
    "image": "../buongiorno-notte.jpg"
  },
  {
    "title": "Cadaveri eccellenti",
    "director": "Francesco Rosi",
    "country": "Italia/Gran Bretagna",
    "releaseYear": 1976,
    "runtime": 112,
    "version": "OmitU",
    "screeningDate": "01.11.2006",
    "readableDate": "2006-11-01",
    "screeningTime": "18:00",
    "actors": "Lino Ventura, Tino Carraro, Paolo Bonacelli, Alain Cuny, Maria Carta, Luigi Pistilli, Max von Sydow, Charles Vanet, Marcel Bozzuffi, Tina Aumonr, Fernando Rey",
    "subtitle": ["Rassegna di Francesco Rosi"],
    "bodycopy": [
      "„Cadaveri eccellenti“: Das sind prominente Opfer der Mafia - Repräsentanten des Staates, Politiker und Journalisten. Lino Ventura kommt in der Rolle des Polizeiinspektors Rogas einer gigantischen Verschwörung auf die Spur und gerät dabei selbst in Gefahr. Nach dem Roman von Leonardo Sciascia drehte Rosi einen Thriller über die Verstrickung von organisierter Kriminalität und Politik. Damit traf Rosi den Nerv der Zeit und wurde selbst von der Staatsanwaltschaft verfolgt."
    ],
    "image": "../caos-calmo.jpg"
  },
  {
    "title": "CAOS CALMO",
    "director": "Antonello Grimaldi",
    "country": "Italia/Gran Bretagna",
    "releaseYear": 2007,
    "runtime": 112,
    "version": "OmU",
    "screeningDate": "20.05.2010",
    "readableDate": "2010-05-20",
    "screeningTime": "20:00",
    "actors": " Nanni Moretti, Alessandro Gassman, Isabella Ferrari, Hippolyte Girardot, Silvio Orlando, Roman Polanski",
    "subtitle": [""],
    "bodycopy": [
      "Un trauma: mentre sua moglie muore a casa senza ricevere soccorso, Pietro (Nanni Moretti) salva una donna al mare. Poi mette da parte la sua attività di manager di successo in una pay TV e si dedica esclusivamente a sua figlia. Alla fine delle vacanze la porta a scuola e l’aspetta su una panchina del parco di fronte all’entrata. Col passare delle settimane e dei mesi questo posto diventa il luogo centrale della sua vita. Passanti casuali e conoscenti vanno e vengono, i partner d’affari (tra i quali Roman Polanski) tessono i loro intrighi … mentre Pietro sta ritrovando se stesso."
    ],
    "image": "../caos-calmo.jpg"
  },
  {
    "title": "Casomai",
    "director": "Alessandro D'Alatri",
    "country": "Italia",
    "releaseYear": 2002,
    "runtime": 114,
    "version": "OmU",
    "screeningDate": "18.06.2009",
    "readableDate": "2009-06-18",
    "screeningTime": "20:00",
    "actors": "Stefania Rocca, Fabio Volo, Rino Manni, Sara D’Amario",
    "subtitle": [
      "Cinque film di successo del quinquennio del“Club del cinema italiano” nella sala Black Box"
    ],
    "bodycopy": [
      "Tommaso e Stefania vogliono sposarsi. Però sono veramente i soli responsabili della loro futura felicità? Il prete, Don Livio, ha qualche dubbio. E mette in scena una cerimonia contraria a tutte le aspettative in cui sembra più concentrarsi sugli invitati che sulla coppia. Non sono infatti loro a determinare la riuscita del matrimonio?"
    ],
    "image": "../caso-mai.jpg"
  },
  {
    "title": "CASOMAI",
    "director": "Alessandro D'Alatri",
    "country": "Italia",
    "releaseYear": 2002,
    "runtime": 114,
    "version": "OmU",
    "screeningDate": "21.08.2004",
    "readableDate": "2004-08-21",
    "screeningTime": "19:30",
    "actors": " Stefania Rocca, Fabio Volo, Rino Manni, Sara D’Amario",
    "subtitle": [""],
    "bodycopy": [
      "Il desiderio di una coppia e le idee poco convenzionali di un prete formano il canovaccio di uno dei più inconsueti film della storia del cinema sul tema matrimonio.",
      "Tommaso e Stefania vogliono sposarsi. Però sono veramente i soli responsabili della loro futura felicità? Il prete, Don Livio, ha qualche dubbio. Come un Don Camillo dei nostri giorni mette in scena una cerimonia nunziale inaspettata e sembra concentrarsi più sugli invitati che sulla coppia stessa. Infatti non sono loro i responsabili della buona o cattiva riuscita della futura vita matrimoniale degli sposini?",
      "Con una serie di sorprendenti trovate spiritose e umoristiche, il film tratta con leggerezza un tema esistenziale del nostro tempo: la capacità di affrontare la vita di coppia, la responsabilità per se stessi e gli altri, e la sensibilità per le note più sommesse della vita in un mondo sempre più \"chiassoso\".",
      "Durante il festival “Cinema! Italia 2003” il film è stato il favorito non solo di tutti gli spettatori in Germania, ma anche il più apprezzato dal pubblico di Düsseldorf."
    ],
    "image": "../casomai.jpg"
  },
  {
    "title": "Cento giorni a Palermo",
    "director": "Giuseppe Ferrara",
    "country": "Italia/Francia",
    "releaseYear": 1983,
    "runtime": 93,
    "version": "S",
    "screeningDate": "11.06.2010",
    "readableDate": "2010-06-11",
    "screeningTime": "20:00",
    "actors": "Lino Ventura, Giuliana ",
    "subtitle": [""],
    "bodycopy": [
      "Il film descrive gli sforzi del generale Dalla Chiesa (Lino Ventura), che nonostante si fosse distinto nella lotta contro le Brigate Rosse, viene spedito inaspettatamente dai politici a Palermo in qualità di prefetto di polizia. Il generale, fedele ai suoi obblighi e fiducioso nelle istituzioni dello stato, assume inizialmente questo ruolo per lui inconsueto e combatte con successo contro la mafia. Tuttavia si accorge che con le sue indagini, intraprese con tanta energia, incappa sempre di più nelle reti dei vari interessi e infine rischia di perdere qualsiasi sostegno."
    ],
    "image": "../cento-giorni-a-palermo.jpg"
  },
  {
    "title": "CENTOCHIODI",
    "director": "Ermanno Olmi",
    "country": "Italia",
    "releaseYear": 2007,
    "runtime": 92,
    "version": "OmU",
    "screeningDate": "17.05.2012",
    "readableDate": "2012-05-17",
    "screeningTime": "20:00",
    "actors": " Raz Degan, Luna Bendandi, Michele Zattara, Amina Syed, Andrea Lanfredi, Damiano Scaini, Franco Andreani, Angela Fornacciari, Ylenia Mezzani",
    "subtitle": [""],
    "bodycopy": [
      "Il professore ha crocifisso i libri con centinaia di chiodi a terra e sui tavoli della biblioteca. Ora vive modestamente in una capanna e i suoi vicini piano piano lo prendono per un santo."
    ],
    "image": "../centochiodi.jpg"
  },
  {
    "title": "CESARE DEVE MORIRE (CÄSAR MUSS STERBEN)",
    "director": "Paolo und Vittorio Taviani",
    "country": "Italia",
    "releaseYear": 2012,
    "runtime": 76,
    "version": "OmU",
    "screeningDate": "17.10.2013",
    "readableDate": "2013-10-17",
    "screeningTime": "20:00",
    "actors": " prigionieri di un carcere a Roma",
    "subtitle": [""],
    "bodycopy": [
      "L’uccisione di un tribuno, recitata da assassini e delinquenti? L’eccellenza della cultura, Shakespeare, sinonimo di libertà intellettuale, messo in scena in un carcere: sotto costante sorveglianza? L’arte può veramente cambiare le persone?",
      "Un documentario drammatico, diretto dai fratelli Taviani con grande ottimismo e con la convinzione che la cultura sia in grado di cambiare il mondo, anche se talvolta solo di poco."
    ],
    "image": "../cesare-deve-morire.jpg"
  },
  {
    "title": "CHI SALVERÀ LE ROSE",
    "director": "Cesare Furesi",
    "country": "Italia",
    "releaseYear": 2017,
    "runtime": 103,
    "version": "OmU",
    "screeningDate": "17.01.2019",
    "readableDate": "2019-01-17",
    "screeningTime": "20:00",
    "actors": " Carlo Delle Piane, Caterina Murino, Lando Buzzanca, Antonio Careddu, Guenda Goria, Philippe Leroy, Massimiliano Buzzanca, Eleonora Vallone",
    "subtitle": [
      "Il titolo italiano “Chi salverà le rose” e quello tedesco “Per te ci vogliono sempre le rose” (de: “Für Dich soll’s ewig Rosen geben”) descrivono ognuno con una metafora diversa il complesso tematico di ciò che racconta il film: si tratta dell’amore nella terza età e dello sbriciolamento di successi biografici, ma anche della prospettiva di qualcosa di nuovo e degli sforzi per ripristinare i contatti familiari. Tra uno sguardo melanconico al passato e un approccio ottimistico per la vita futura, la pellicola presenta la storia toccante di due uomini invecchiati e del loro modo di affrontare le situazioni critiche del momento."
    ],
    "bodycopy": [
      "Giulio gode del suo ruolo di gentleman. Da decenni ha rinunciato alla professione di avvocato per vivere con Claudio, il suo grande amore. Grande giocatore di poker ha finanziato a lungo la fastosa vita di entrambi. Però i bei tempi sono passati e per le loro necessità finanziarie ora Giulio deve vendere poco per volta l’inventario.",
      "Il personale della proprietà comune è stato licenziato anni prima. Claudio è ammalato e non può più muoversi dal letto, ma crede che la vita di una volta vada avanti come sempre perché Giulio glielo fa credere e gli porta ogni giorno una rosa fresca quale simbolo del suo amore. Però l’illusione non regge più: le rose appassiscono e le preoccupazioni finanziarie diventano schiaccianti.",
      "Ma Giulio può aspettarsi un aiuto dalla figlia e dal nipote? Il rapporto con sua figlia Valeria è teso, mentre il nipote Marco, figlio di Valeria, adora lui e Claudio.",
      "Allora si accinge a rimuovere i vecchi conflitti e ricostruire il suo rapporto con Valeria. Ma anche con Marco non funziona tutto nel modo migliore.",
      "Il film è stato pluripremiato in vari festival italiani."
    ],
    "image": "../chi-salvera-le-rose.jpg"
  },
  {
    "title": "Chora",
    "director": "Lorenzo Adorisio",
    "country": "Italia",
    "releaseYear": 2004,
    "runtime": 15,
    "version": "OmU",
    "screeningDate": "03.07.2010",
    "readableDate": "2010-07-03",
    "screeningTime": "20:00",
    "actors": "Valeria Sabel, Dario Gioncardi",
    "subtitle": [
      "Sottotitolato dagli studenti della facoltà di romanistica, indirizzo \"traduzione letteraria\" dell'Università Heinrich Heine di Düsseldorf."
    ],
    "bodycopy": [
      "Giulio, tredicenne, e sua nonna hanno un rapporto molto stretto. Durante una loro breve visita della famiglia nel paese d'origine in Calabria, la nonna muore improvvisamente. Alla ricerca di un telefono Giulio si perde nelle strade del suo luogo d'origine a lui sconosciuto e vi trova una parte di se stesso.",
      "Con il suo breve film che ha ricevuto vari premi, il registra Lorenzo Adorisio tematizza il rapporto ambivalente di molti migranti all'interno dell'Italia con il loro luogo d'origine cogliendo lo spirito del tempo",
      "In presenza del regista Lorenzo Adorisio."
    ],
    "image": "../chora.png"
  },
  {
    "title": "Ciao Aracà",
    "director": "Daniel Chisholm",
    "country": "Germania",
    "releaseYear": 2019,
    "runtime": 63,
    "version": "OmU",
    "screeningDate": "17.09.2020",
    "readableDate": "2020-09-17",
    "screeningTime": "20:00",
    "actors": "",
    "subtitle": [
      "Ospite nella sala Black Box: Daniel Chisholm, il regista e autore di CIAO ARACÀ",
      "Un paese rurale in Italia sta andando in rovina, ma i suoi abitanti ormai invecchiati cercano di impedirlo con coraggio mentre la nuova generazione lotta per la sopravvivenza nella piccola comunità."
    ],
    "bodycopy": [
      "Aracà, un villaggio sulle montagne liguri, è in subbuglio. I vecchi contadini e le loro famiglie devono affrontare una serie di gravi problemi. La perdita dei tradizionali metodi di coltivazione, i mercati agricoli globalizzati, l'emigrazione dei giovani e l'afflusso di estranei, che comprano gli immobili a buon prezzo. Nonostante queste sfide esistenziali affrontano il futuro con grazia, dignità, stoicismo e un astuto senso dell'umorismo.",
      "Allo stesso tempo i loro discendenti rimasti nel luogo si danno da fare per frenare il declino dell'ambiente rurale investendo in nuovi vitigni, in nuovi attrezzi per la produzione di vino, nel ringiovanimento degli oliveti, in moderne macchine agricole e in una migliore commercializzazione dei loro prodotti. Sebbene abbiano riconosciuto che la qualità e la provenienza siano di grande importanza, le loro possibilità di farcela rimangono incerte.",
      "CIAO ARACÀ documenta la vita dei contadini e delle loro famiglie. Con accuratezza e sensibilità il regista illustra la lotta di un piccolo comune contro l'industrializzazione e la globalizzazione senza perdere di vista i brevi momenti di sollievo che pure esistono."
    ],
    "image": "../ciaoaraca.png"
  },
  {
    "title": "CIPOLLA COLT",
    "director": "Enzo G. Castellari (als Enzo Girolami)",
    "country": "Italia/Spanien/Germania",
    "releaseYear": 1975,
    "runtime": 91,
    "version": "OmU",
    "screeningDate": "25.09.2016",
    "readableDate": "2016-09-25",
    "screeningTime": "16:30",
    "actors": " Franco Nero, Sterling Hayden, Martin Balsam, Emma Cohen, Leo Anchóriz, Romano Puppo",
    "subtitle": [""],
    "bodycopy": [
      "In questa commedia parodistica Franco Nero (“Django”) interpreta un coltivatore di cipolle che se la prende con un magnate del petrolio che mira alla sua terra e alla sua vita. Elementi della Commedia dell'arte e della Commedia all’italiana si coniugano con la tradizione dello slapstick. Il film ironizza la fase precedente di questo genere basata su una comicità sciocca e banale."
    ],
    "image": "../cipolla-colt-1.jpg"
  },
  {
    "title": "Concorrenza sleale",
    "director": "Ettore Scola",
    "country": "Italia",
    "releaseYear": 2001,
    "runtime": 106,
    "version": "OmitU",
    "screeningDate": "04.06.2008",
    "readableDate": "2008-06-04",
    "screeningTime": "19:00",
    "actors": "Diego Abantantuono, Sergio Castellitto, Gérard Depardieu, Antonella Attili, Elio Germano, Sabrina Impiacciatore, Rolando Ravello",
    "subtitle": ["Rassegna di Ettore Scola"],
    "bodycopy": [
      "Un film tragicomico, recitato da grandi attori (ad es. Diego Abantantuono, Sergio Castelitto, Gérard Depardieu). Umberto e Leone sono i titolari di due negozi vicini. Si fanno concorrenza con dispettucci, trovate scherzose e punzecchiature. La situazione cambia però quando nel 1938 vengono emanate le leggi razziali. Infatti Leone è ebreo. Improvvisamente nulla rimane come prima. Non perdetevelo: il film non è indistribuzione nelle sale cinematografiche tedesche."
    ],
    "image": "../concorrenza-sleale.jpg"
  },
  {
    "title": "Concorso di colpa",
    "director": "Claudio Fragasso",
    "country": "Ittalien",
    "releaseYear": 2003,
    "runtime": 95,
    "version": "OmitU",
    "screeningDate": "07.01.2009",
    "readableDate": "2009-01-07",
    "screeningTime": "20:00",
    "actors": "Francesco Nuti, Alessandro Benvenuti, Antonella Ponziani, Luca Lionello, Massimo Bonetti, Lorenzo Balducci, Felicia Della Corte, Luigi Maria Burruano",
    "subtitle": [""],
    "bodycopy": [
      "Il commissario che conduce le indagini non solo deve confrontarsi con il figlio, ma pure Il commissario che conduce le indagini non solo deve confrontarsi con il figlio, ma pure rendersi conto di non potersi sottrarre al suo passato. I cinefili devono arrivare puntuali: raramente troveranno così tanti richiami alla storia del cinema in una sequenza così breve, proprio all’inizio del film. Promette molto. Saprà mantenerlo?"
    ],
    "image": "../concorso-di-colpa.jpg"
  },
  {
    "title": "COSA VOGLIO DI PIÙ",
    "director": "Silvio Soldini",
    "country": "Italia",
    "releaseYear": 2006,
    "runtime": 121,
    "version": "OmU",
    "screeningDate": "17.11.2011",
    "readableDate": "2011-11-17",
    "screeningTime": "20:00",
    "actors": "Alba Rohrwacher, Pierfrancesco Favino, Giuseppe Battiston, Teresa Saponangelo, Fabio Troiano, Tatiana Lepore, Adriana De Guilmi, Gigio Alberti, Ninni Bruschetta, Clelia Piscitello, Carla Chiarelli",
    "subtitle": [""],
    "bodycopy": [
      "In questo film Soldini si dedica seriamente ai vari aspetti dei rapporti di coppia, all’amore e alla sessualità. Talvolta il suo racconto è permeato di una drammatica malinconia così diversa dallo stile che aveva caratterizzato il suo famoso \"Pane e tulipani“: Anna e Domenico hanno nella loro vita solidi rapporti familiari che però cominciano a vacillare dopo il loro incontro. Quello che inizia come un’avventura sessuale, diventa amore e dipendenza. Combattuti tra i loro sentimenti reciproci e tra quelli per le loro famiglie si mettono alla ricerca di una soluzione che sembra irraggiungibile."
    ],
    "image": "../cosa-voglio-di-piu.jpg"
  },
  {
    "title": "Cristo si è fermato a Eboli",
    "director": "Francesco Rosi",
    "country": "Italia",
    "releaseYear": 1979,
    "runtime": 145,
    "version": "OmitU",
    "screeningDate": "06.12.2006",
    "readableDate": "2006-12-06",
    "screeningTime": "18:00",
    "actors": "Gian Maria Volonté, Lea Massari, Alain Cuny, Irene Papas, Paolo Bonacelli, François Simon, Francesco Càllari, Antonio Allocca",
    "subtitle": ["Rassegna di Francesco Rosi"],
    "bodycopy": [
      "Adattamento cinematografico dell'omonimo romanzo autobiografico e bestseller mondiale di Carlo Levi, mandato dal regime fascista al confino nel Meridione, ad Aliano. La località, a detta dei suoi stessi abitanti, è talmente isolata che addirittura il Cristianesimo sembra arrivato qui soltanto come una delle tante superstizioni. Il film descrive la vita quotidiana in quel paesino che pare fuori dal mondo: la miseria dei contadini, il disinteresse per la politica, l'assenza della cultura borghese e il ridicolo atteggiamento del sindaco fascista che sa solo darsi delle arie."
    ],
    "image": "../cristo-si-e-fermato-a-eboli.jpg"
  },
  {
    "title": "DICKTATORSHIP: FALLO E BASTA",
    "director": "Gustav Hofer und Luca Ragazzi",
    "country": "Italia",
    "releaseYear": 2019,
    "runtime": 90,
    "version": "OmU",
    "screeningDate": "16.09.2021",
    "readableDate": "2021-09-16",
    "screeningTime": "20:00",
    "actors": "Nel film compaiono Gustav Hofer e Luca Ragazzi con esperti dei vari settori.",
    "subtitle": [
      "Ci troviamo senza dubbio in un film di Gustav Hofer e Luca Ragazzi: uno sempre con il dito nella piaga del malato chiamato Italia e l’altro sempre in difesa della “Bella Italia”. Discutendo su come Trump, Erdogan e simili abbiano potuto raggiungere il potere nonostante il loro maschilismo, Gustav Hofer afferma che la risposta la si può trovare in un unico posto al mondo e cioè in Italia. Una valutazione che Luca Ragazzi accoglie con scetticismo. ",
      "Nel corso della disputa sul machismo i due riescono a ironizzare benignamente su situazioni, che in effetti dovrebbero far piangere, e trattano problemi veramente gravi con grande leggerezza facendo scoprire agli spettatori alcuni aspetti curiosi che rivelano impietosamente gli abissi del maschilismo. "
    ],
    "bodycopy": [
      "In ITALY-LOVE IT OR LEAVE IT i due autori, con grande divertimento degli spettatori, avevano descritto con ilarità i disservizi e le disfunzioni in Italia. Nel loro nuovo film esaminano il legame tra sessualità e potere o come dicono loro, le tre “P”: pene, potere, politica.",
      "In luoghi significativi o durante un normale giro in gondola i due riflettono mantenendo le loro posizioni il sistema fallocentrico globale prendendo ad esempio l’Italia che sembra abbia addirittura 887 denominazioni per il pene.",
      "Durante il loro viaggio parlano con esperti di vari settori approfondendo con loro i problemi intavolati o cercando soluzioni per i temi controversi discussi.",
      "Un documentario molto particolare per chi ama gli ammonimenti semiseri, per chi vuole scoprire nuovi aspetti di questioni apparentemente note e naturalmente per tutti quelli che ci tengono ai diritti delle donne.",
      "Il film è stato proiettato in Germania al Nuremberg International Film Festival nella sezione Internationales Forum e ha preso parte a numerosi altri festival all’estero."
    ],
    "image": "../dicktatorship-5.jpg"
  },
  {
    "title": "Dimenticare Palermo",
    "director": "Francesco Rosi",
    "country": "Italia/Francia",
    "releaseYear": 1989,
    "runtime": 100,
    "version": "OmitU",
    "screeningDate": "21.10.2010",
    "readableDate": "2010-10-21",
    "screeningTime": "20:00",
    "actors": "James Belushi, Mimi Rogers, Joss Ackland, Vittorio Gassman, Philippe Noiret, Vyto Ruginis, Carolina Rosi, Marco Leonardi, Tiziana Stella, Salvatore Borgese",
    "subtitle": ["Storia della mafia - Storie di mafia"],
    "bodycopy": [
      "Un politico americano con radici italiane si reca per motivi elettorali nella sua “patria”. Arrivato a Palermo, la mafia gli fa capire chiaramente di quanto ritenga deleteria per i propri affari la sua politica a favore della legalizzazione delle droghe pesanti. Rosi riesce a creare un’atmosfera di permanente minaccia, sebbene rinunci ai classici momenti di tensione esteriore. La mafia è continuamente presente, ma non si vede e non si tocca mai con mano. I due famosi attori protagonisti, James Belushi e MimiRogers, riescono a mettere in luce con maestria la perplessità che gli estranei provano di fronte al fenomeno mafioso."
    ],
    "image": "../dimenticare-palermo-1.jpg"
  },
  {
    "title": "DIVORZIO ALL'ITALIANA (SCHEIDUNG AUF ItaliaISCH)",
    "director": "Pietro Germi",
    "country": "Italia",
    "releaseYear": 1961,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "19.04.2018",
    "readableDate": "2018-04-19",
    "screeningTime": "20:00",
    "actors": "Marcello Mastroianni, Daniela Rocca, Stefania Sandrelli, Leopoldo Trieste, Angela Cardile, Odoardo Spadaro, Margherita Girelli, Lando Buzzanca, Pietro Tordi, Ugo Torrente",
    "subtitle": [
      "In tempi in cui il divorzio era vietato, mentre il delitto d’onore rimaneva quasi impunito, si potevano escogitare magari idee strampalate. Questo è il complesso tematico dal quale Pietro Germi prende spunto per il film diventato da tempo un classico della commedia all’italiana."
    ],
    "bodycopy": [
      "Nel matrimonio del barone Cefalù (Marcello Mastroianni) è ormai svanito qualsiasi entusiasmo e il suo cuore batte ora per la giovane Angela (Stefania Sandrelli). Dopo aver fantasticato più volte l’omicidio della moglie, ispirato da un articolo di giornale gli viene l’idea di trovarle un amante. Però quando finalmente ci riesce e un pittore si appassiona per lei, il piano del barone, che cerca di sorprendere la coppia in flagrante, non va in porto."
    ],
    "image": "../divorzio-allitaliana.jpg"
  },
  {
    "title": "Divorzio all'italiana (Scheidung auf Italiaisch)",
    "director": "Pietro Germi",
    "country": "Italia",
    "releaseYear": 1961,
    "runtime": 120,
    "version": "OmitU",
    "screeningDate": "07.06.2006",
    "readableDate": "2006-06-07",
    "screeningTime": "18:00",
    "actors": "Marcello Mastroianni, Daniela Rocca, Stefania Sandrelli, Lando Buzzanca, Leopoldo Trieste, Odoardo Spadaro, Saro Archidiacono",
    "subtitle": [""],
    "bodycopy": [
      "Il divorzio è vietato dalla legge, che invece tollera l'omicidio passionale: che c'è di più logico che spingere la propria moglie al tradimento, poi ucciderla per questione d'onore e, dopo aver scontato una breve pena, sposare la bella cugina e amante. Una commedia nera e un pamphlet contro le leggi matrimoniali e penali dell'Italia di allora."
    ],
    "image": "../divorzio.jpg"
  },
  {
    "title": "DJANGO",
    "director": "Sergio Corbucci",
    "country": "Italia/Spanien",
    "releaseYear": 1966,
    "runtime": 91,
    "version": "OmU",
    "screeningDate": "15.09.2016",
    "readableDate": "2016-09-15",
    "screeningTime": "20:00",
    "actors": " Franco Nero, José Canalejas, José Bódalo, Loredana Nusciak, Ángel Álvarez, Gino Pernice, Simón Arriaga, Giovanni Ivan Scratuglia",
    "subtitle": [""],
    "bodycopy": [
      "Nella lotta fra due gruppi di banditi si immischia uno straniero che trascina dietro a sé una cassa da morto contenente una mitragliatrice: Django. “Questo appassionante e brutale italo-western, caratterizzato da una struttura singolare, ebbe un tale successo commerciale da produrre una vera e propria valanga di Django”. (Filmdienst)"
    ],
    "image": "../django-2.jpg"
  },
  {
    "title": "Dogman",
    "director": "Matteo Garrone",
    "country": "Italia/Francia",
    "releaseYear": 2018,
    "runtime": 102,
    "version": "OmU",
    "screeningDate": "21.03.2019",
    "readableDate": "2019-03-21",
    "screeningTime": "20:00",
    "actors": "Marcello Fonte, Edoardo Pesce, Nunzia Schiano, Adamo Dionisi, Alida Baldari Calabria, Francesco Acquaroli, Gianluca Gobbi, Aniello Arena",
    "subtitle": [
      "La lotta contro la camorra non si può vincere oppure forse sì? Quando Matteo Garrone (GOMORRA) ne parla nella sua ultima pellicola, si può aspettasi qualcosa di speciale. Già la località in cui si svolge quasi tutto il film - rovine pittoresche che producono un effetto di straniamento - caratterizza anche l’ambiente sociale. E questo luogo esiste davvero: `il Villaggio Coppola sulla costa campana, in mezzo ad un parco naturale."
    ],
    "bodycopy": [
      "Il protagonista è un parrucchiere di cani che all’inizio del film ha avuto un bel da fare con un cane da combattimento, che non voleva farsi lavare. Ma Marcello lo ha \"convinto“ e vediamo poi come il cane apprezza evidentemente il fon. Con l’amico Simone, più forte e decisamente più grande di lui, ha i suoi problemi. Si lascia trascinare da questo piccolo criminale collerico e irrazionale che lo coinvolge, suo malgrado, nelle sue azioni delittuose. Marcello deve subire le vessazioni di Simone come tutti i negozianti del vicinato. E poi c’è anche l’adorata figlioletta che ama il padre: potrebbe essere una convivenza felice se non ci fossero le precarie situazioni finanziarie e il terrore emozionale e fisico esercitato da Simone coinvolto negli affari di droga della Camorra. Marcello va addirittura in carcere al posto suo a causa di un furto con scasso, commesso con ben poca perizia dal solito Simone. Quando esce di prigione, Simone si mostra indifferente. Così comincia un’impari lotta che il mingherlino Marcello può soltanto perdere o esiste un’alternativa?"
    ],
    "image": "../dogman.jpg"
  },
  {
    "title": "Domani",
    "director": "Francesca Archibugi",
    "country": "Italia",
    "releaseYear": 2001,
    "runtime": 88,
    "version": "OmU",
    "screeningDate": "22.04.2004",
    "readableDate": "2004-04-22",
    "screeningTime": "19:30",
    "actors": "Marco Baliani, Ornella Muti, David Bracci, Valerio Mastandrea",
    "subtitle": [""],
    "bodycopy": [
      "Dopo il terremoto del 1997 in Umbria, un intero paese ritroverà la voglia di ricostruire la vita e gli affetti, di amare e sorridere nuovamente."
    ],
    "image": "../Domani.jpg"
  },
  {
    "title": "Domenica",
    "director": "Wilma Labate",
    "country": "Italia",
    "releaseYear": 2001,
    "runtime": 95,
    "version": "OmU",
    "screeningDate": "28.04.2004",
    "readableDate": "2004-04-28",
    "screeningTime": "19:30",
    "actors": "Claudio Amendola, Annabella Sciorra, Domenica Giuliano, ",
    "subtitle": [""],
    "bodycopy": [
      "Un ispettore di polizia e una bambina orfana affrontano insieme un viaggio lungo un giorno per le strade di Napoli. Tra i vicoli, in un garbuglio di piccoli avvenimenti, la bambina conduce il taciturno e rude ispettore per una Napoli povera, segreta, innocente e maledetta."
    ],
    "image": "../Domenica.jpg"
  },
  {
    "title": "Dopo mezzanotte",
    "director": "Davide Ferrario",
    "country": "Italia",
    "releaseYear": 2004,
    "runtime": 92,
    "version": "OmU",
    "screeningDate": "19.01.2012",
    "readableDate": "2012-01-19",
    "screeningTime": "20:00",
    "actors": "Giorgio Pasotti, Francesca Inaudi, Fabio Troiano, Francesca Picozza, Gianpiero Perone, Ivan Negro, Silvo Orlando (Stimme aus dem Off)",
    "subtitle": [""],
    "bodycopy": [
      "Martino, il guardiano notturno, si è creato il proprio nido nel Museo del cinema di Torino. Improvvisamente si trova di fronte una sconosciuta in fuga alla quale, tra un episodio e l’altro della storia del cinema, fa una dichiarazione d’amore."
    ],
    "image": "../dopo-mezzanotte.jpg"
  },
  {
    "title": "DOPO MEZZANOTTE",
    "director": "Davide Ferrario",
    "country": "Italia",
    "releaseYear": 2004,
    "runtime": 92,
    "version": "OmU",
    "screeningDate": "16.05.2014",
    "readableDate": "2014-05-16",
    "screeningTime": "2:00",
    "actors": "Giorgio Pasotti, Francesca Inaudi, Fabio Troiano, Francesca Picozza, Gianpiero Perone, Ivan Negro, Silvo Orlando (Stimme aus dem Off)",
    "subtitle": [
      "10° anniversario: i maggiori successi del Club del Cinema Italiano"
    ],
    "bodycopy": [
      "Amanda, la ragazza di Angelo, un ladruncolo di automobili, fuggendo si ritrova nel Museo del cinema di Torino in cui Martino, il guardiano notturno, si è creato il proprio nido. Di notte si sente il padrone dei sogni creati dai film che ora improvvisamente deve dividere con una sconosciuta. Un omaggio poetico alla storia del cinema e un’inconsueta storia d’amore."
    ],
    "image": "../dopo-mezzanotte.jpg"
  },
  {
    "title": "DRAMMA DELLA GELOSIA. TUTTI I PARTICOLARI IN CRONACA",
    "director": "Ettore Scola",
    "country": "Italia/Spanien",
    "releaseYear": 1970,
    "runtime": 107,
    "version": "OmU",
    "screeningDate": "19.06.2008",
    "readableDate": "2008-06-19",
    "screeningTime": "19:00",
    "actors": "Monica Vitti, Marcello Mastroianni, Giancarlo Giannini, Marisa Marlini, Manolo Zardo, Hercules Cortes, Gioia Desideri, Juan Diego, Bruno Scipioni, Serafina Serratosa",
    "subtitle": ["Rassegna di Ettore Scola"],
    "bodycopy": [
      "Una tragicommedia nella Roma della fine degli anni 60. In modo spiritoso e satirico Scola prende di mira le abitudini degli italiani e i rapporti tra i due sessi. Il muratore Oreste (Marcello Mastroianni), coniugato, si innamora di Adelaine (Monica Vitti), che ha conosciuto durante una manifestazione politica. Lei però gli preferisce l'affascinante Nello (Giancarlo Giannini), con conseguenze mortali."
    ],
    "image": "../fabiettomariasaverio.jpg"
  },
  {
    "title": "È STATA LA MANO DI DIO",
    "director": "Paolo Sorrentino",
    "country": "Italia/USA",
    "releaseYear": 2021,
    "runtime": 130,
    "version": "OmU",
    "screeningDate": "17.03.2022",
    "readableDate": "2022-03-17",
    "screeningTime": "20:00",
    "actors": "mano di dio.jpg",
    "subtitle": [
      "Campionato mondiale di calcio 1986: una presunta palla di testa di Diego Maradona si rivela a posteriori un fallo di mano. “A deviare il pallone è stata la mano di Dio”, così si giustifica il calciatore. Anche se questa affermazione ha dato il titolo alla pellicola il tema del film non è solamente il calcio. In prima linea si tratta di un confronto di Sorrentino stesso con la sua infanzia e adolescenza a Napoli: la figura centrale del racconto è Fabietto e la sua eccentrica famiglia. Il retroscena è costituito dall'arrivo di Maradona nella squadra di calcio partenopea, che sta per essere declassata. E più avanti sarà Maradona a salvare indirettamente la vita di Fabietto. Come nella vera vita di Sorrentino. Che si debba trattare del film più personale di Sorrentino (FAZ), che sia addirittura un eccesso narcisistico (SWR), sembra esagerato. Con il racconto di una storia familiare, che si focalizza su eventi calcistici, il regista ricrea l'atmosfera e lo spirito di un'epoca ormai passata con i suoi miti e leggende. "
    ],
    "bodycopy": [
      "Sorrentino attraverso gli occhi critici dell'adolescente Fabietto osserva la realtà della sua famiglia. E ci fa conoscere la città di Napoli e i suoi abitanti: ad esempio sua zia Patrizia che afferma di essere stata agganciata per la strada dal santo patrono della città in Rolls Royce per essere presentata al piccolo monaco, leggendaria figura napoletana; suo marito presume invece che era andata dal suo amante e la picchia di santa ragione. Osservando la famiglia Fabietto comprende il carattere machista della Napoli degli anni '80 e viene a conoscenza delle leggende e dei miti della città, usati ripetutamente come scusa.  Siccome il padre gli regala l'abbonamento alle partite del Napoli, nel momento in cui i suoi genitori muoiono a causa di un incidente Fabietto si trova nello stadio a guardare una partita in cui gioca Maradona. Napoli è infatti presa dalla febbre chiamata Maradona, cosa di cui approfitta Sorrentino per rendere omaggio a questa star del calcio.",
      "Il film ha ricevuto il Gran Premio della Giuria alla Mostra del Cinema di Venezia."
    ],
    "image": "../fabiettomariasaverio.jpg"
  },
  {
    "title": "Edipo re",
    "director": "Pier Paolo Pasolini",
    "country": "Italia",
    "releaseYear": 1967,
    "runtime": 104,
    "version": "OmitU",
    "screeningDate": "05.08.2009",
    "readableDate": "2009-08-05",
    "screeningTime": "20:00",
    "actors": "Franco Citti, Silvana Mangano, Alida Valli, Carmelo Bene, Julian Beck, Luciano Bartoli",
    "subtitle": ["Rassegna di Pier Paolo Pasolini"],
    "bodycopy": [
      "Pasolini, contrariamente alle nostre aspettative influenzate dalla psicoanalisi, non vede nel mito di Edipo la predominanza del tema dell’incesto, ma il parricidio con le sue implicazioni allegoriche e sociali. Il regista racconta due storie di Edipo: una sul calco di quella classica, arcaica, l’altra, storicamente collocata tra il 1920 e il 1960, che mette in luce l’attualità del soggetto nel contesto sociale."
    ],
    "image": "../edipo-re.jpg"
  },
  {
    "title": "Ein Dorf in Europa",
    "director": "Robert Krieg und Monika Nolte",
    "country": "Germania",
    "releaseYear": 2007,
    "runtime": 90,
    "version": "OmU",
    "screeningDate": "17.01.2008",
    "readableDate": "2008-01-17",
    "screeningTime": "19:00",
    "actors": "",
    "subtitle": ["Premiere"],
    "bodycopy": [
      "Un paesino a nord di Roma in cui, come in un microcosmo, si rispecchia lo sviluppo europeo. Negli anni 20 gli uomini emigrano negli USA, nel dopoguerra arriva una certa ripresa economica dovuta alla ricerca di comparse da parte dei registi neorealisti. Oggi il villaggio è un dormitorio di Roma, l'agricoltura non ha più quasi nessuna importanza e nel frattempo ospita persone provenienti da 20 nazioni. Qualche centinaio di stranieri lavorano illegalmente nel mercato semisommerso dei dintorni della capitale italiana. Lo sguardo all'Europa nel suo complesso devia spesso la vista dalla prospettiva di chi appartiene ai ceti più bassi. Cosa che il film cerca di indagare.",
      "Una cooperazione con la Filmwerkstatt Düsseldorf."
    ],
    "image": "../ein-dorf-in-europa.jpg"
  },
  {
    "title": "EUFORIA",
    "director": "Valeria Golino",
    "country": "Italia",
    "releaseYear": 2018,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "14.10.2021",
    "readableDate": "2021-10-14",
    "screeningTime": "20:00",
    "actors": "Riccardo Scamarcio, Valerio Mastandrea, Isabella Ferrari, Valentina Cervi, Jasmine Trinca e altri",
    "subtitle": [
      "Sicuramente non è facile prendersi cura del fratello maggiore, ammalato di cancro. In particolare se lui non è mai riuscito ad uscire dal suo ambiente provinciale né a far carriera, mentre l’altro, omosessuale dichiarato, ce l’ha fatta a salire la scala sociale e conduce una vita agiata a Roma. Però anche per l’assistito non è facile sopportare il nuovo ambiente mondano e accettare le cure del fratello. Valeria Golino, in Germania conosciuta in genere solo come attrice, scandaglia le sfaccettature di un rapporto apparentemente a rotoli in cui gli originari meccanismi decisionali si invertono: non sta all’ammalato decidere come passare i suoi ultimi mesi. Questo compito vuole assumerselo il fratello minore. Però i sentimenti offesi del primo esigono sempre più giustizia. "
    ],
    "bodycopy": [
      "Matteo si sente a suo agio se è al centro dell’attenzione, adora le feste romane e abita in una lussuosa penthouse. Per lui è naturale ospitare a casa sua Ettore, il fratello maggiore, non appena viene a sapere della diagnosi. Ettore, invece, che ha passato tutta la sua vita nella piccola località dove sono cresciuti entrambi e dove insegna a scuola, è afflitto costantemente dalla sensazione di essere un fallito. Ettore si trasferisce nella casa di Matteo, ma è difficile che si instauri un’atmosfera di fiducia tra di loro perché la vita di Matteo è caratterizzata da impegni professionali, vita di società e cura delle amicizie, tanto che Ettore si sente ben presto marginalizzato e inizia a reagire.",
      "Matteo deve imparare a riconoscere che anche un provincialotto ha valori e sentimenti che rendono la vita degna di essere vissuta nonostante la malattia. Un processo di apprendimento che termina con l’ultima inquadratura che già per se stessa è un buon motivo per guardarsi il film."
    ],
    "image": "../euforia.jpg"
  },
  {
    "title": "FACCIA A FACCIA",
    "director": "Sergio Sollima",
    "country": "Italia/Spanien",
    "releaseYear": 1967,
    "runtime": 112,
    "version": "OmU",
    "screeningDate": "03.09.2016",
    "readableDate": "2016-09-03",
    "screeningTime": "19:00",
    "actors": "Gian Maria Volontè, Tomas Milian, William Berger, Jolanda Modio, Gianni Rizzo, Carole André, Ángel del Pozo",
    "subtitle": [""],
    "bodycopy": [
      "Un duello di altro tipo: Fletcher, preso come ostaggio dal bandito Bennet, comincia a prender gusto per la vita criminale, mentre il delinquente si rimette sulla buona strada. FACCIA A FACCIA, dopo la RESA DEI CONTI, è il secondo film di una trilogia ed è considerato uno dei più profondi tra i western all'italiana. Infatti si occupa di questioni come la relatività delle questioni morali in ambienti criminali."
    ],
    "image": "../faccia-a-faccia-2.jpg"
  },
  {
    "title": "FAI BEI SOGNI",
    "director": "Marco Bellocchio",
    "country": "Italia/Francia",
    "releaseYear": 2016,
    "runtime": 134,
    "version": "OmU",
    "screeningDate": "15.03.2018",
    "readableDate": "2018-03-15",
    "screeningTime": "20:00",
    "actors": "Bérénice Bejo, Valerio Mastandrea, Fabrizio Gifuni, Miriam Leone, Guido Caprino, Roberto Herlitzka, Barbara Ronchi",
    "subtitle": [
      "Come si sente un ragazzino quando, ad appena nove anni, intuisce che l’amata mamma si è suicidata, mentre gli adulti cercano appena di avvicinarlo a rate alla verità. Tutta la vita si trascinerà questo peso e si chiederà che cosa sia successo veramente quello giorno fatale."
    ],
    "bodycopy": [
      "Nel momento in cui Massimo si appresta a sgomberare l’appartamento del padre appena scomparso e trova delle cose che gli fanno passare in rassegna tutta la sua vita, deve confrontarsi anche con il trauma della sua infanzia.",
      "Il suo lavoro di rinomato giornalista, che racconta quello che succede agli altri, era forse una necessità per poter nascondere a se stesso la propria incapacità di avere rapporti emozionalmente profondi e di innamorarsi.",
      "Ora questo sgombero definitivo gli causa attacchi di panico che lo portano a conoscere l’affascinante internista Elisa. Una chance per liberarsi dai demoni del passato? Massimo deve affrontare la sua verità."
    ],
    "image": "../fai-bei-sogni.jpg"
  },
  {
    "title": "FAVOLACCE",
    "director": "Fabio D'Innocenzo, Damiano D'Innocenzo",
    "country": "Italia",
    "releaseYear": 2020,
    "runtime": 96,
    "version": "OmU",
    "screeningDate": "19.01.2023",
    "readableDate": "2023-01-19",
    "screeningTime": "20:00",
    "actors": "favolacce.jpg",
    "subtitle": [
      "Elio Germano, Barbara Chichiarelli, Lino Musella, Gabriel Montesi, Max Malatesta e altri"
    ],
    "bodycopy": [
      "Una famiglia, figli, una villetta, vicini - con famiglia, figli, una villetta, vicini con famiglia... e così va avanti fino al limite dell'immagine e sembra volersi ripetersi all'infinito. La vita si svolge – ognuno per sé, ma sotto gli occhi di tutti - sulla striscia di terreno di proprietà che funge da terrazza e da giardino. Di tanto in tanto ci si riunisce, si fa una grigliata, si mangia e beve assieme. Di tanto in tanto si litiga senza temere di diventare ridicoli nel tentativo di rendersi importanti. Può succedere di ritrovarsi al centro dell’attenzione perché si mette una piscinetta gonfiabile nel giardino e si invitano i vicini a passare, quando hanno tempo e voglia. Così svanisce la tipica tranquillità piccolo borghese. Il nuovo vecchio status quo va ripristinato.",
      "I bambini osservano l'animazione degli adulti, mentre nessuno bada veramente a loro - la telecamera segue i loro sguardi e racconta gran parte del film dall'altezza dei loro occhi. A loro volta i ragazzini cercano di fare la caricatura dei grandi, ma tentano pure di imitarli, sempre alla ricerca della propria strada e pur costantemente in balia degli adulti. Ne risulta un ritratto maligno della piccola borghesia italiana oggi. Nel vero e proprio senso della parola FAVOLACCIA, una favola piena di brutte sorprese."
    ],
    "image": "../favolacce.jpg"
  },
  {
    "title": "Figli di Annibale",
    "director": "Davide Ferrario",
    "country": "Italia",
    "releaseYear": 1997,
    "runtime": 93,
    "version": "OmU",
    "screeningDate": "20.10.2005",
    "readableDate": "2005-10-20",
    "screeningTime": "19:30",
    "actors": "Diego Abantantuono, Silvio Orlando, Flavio Insinna, Valentina Cervi, Ugo Conti",
    "subtitle": [""],
    "bodycopy": [
      "Che cosa potrebbe capitare di meglio ad un imprenditore quasi in rovina che venire sequestrato? E anche se il rapitore se nevuole andare in Svizzera, si va invece verso sud con destinazione l’Africa. Infatti che imprenditore sarebbe, se non prendesse in mano le redini? Ai due si aggiunge la figlia dell’imprenditore e la sorella cieca del sequestratore. Fino a qui tutto bene. Le complicazioni iniziano quando un poliziotto si innamora dell’imprenditore e lo “accompagna” durante il viaggio. Una commedia eccellente con protagonisti eccellenti."
    ],
    "image": "../figli-di-annibale.jpg"
  },
  {
    "title": "FIGLIA MIA",
    "director": "Laura Bispuri",
    "country": "Italia/Germania/Svizzera",
    "releaseYear": 2018,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "18.10.2018",
    "readableDate": "2018-10-18",
    "screeningTime": "20:00",
    "actors": "Valeria Golino, Alba Rohrwacher, Sara Casu, Michele Carboni, Udo Kier",
    "subtitle": [
      "Due madri attorniano una bambina, la madre naturale e quella che l'ha cresciuta con tanto amore. Un'amicizia tra due donne che deve affrontare una crisi essenziale. Una ragazzina di 10 anni che impara ad emanciparsi dal mondo degli adulti e ad assumersi le proprie responsabilità. Questi filoni narrativi si intrecciano in una storia emozionale."
    ],
    "bodycopy": [
      "Tina è sua madre, perlomeno è quanto crede Vittoria. Madre e figlia aiutano Angelica, una donna piuttosto caotica, che vive precariamente e ama soprattutto le feste. Quando lo spettro della bancarotta minaccia di espropriarla del tutto, Angelica vuole congedarsi da Vittoria, che in verità è la sua figlia naturale. Con l'approvazione di Tina, la vera madre passa così sempre più tempo con la ragazza, che girovagando con Angelica, piano piano capisce qual è la verità. La catastrofe si verifica quanto un creditore vuole appropriarsi con violenza del cavallo di Angelica, mentre Vittoria, superando ogni paura, entra nel buco del terreno selvaggio in cui Angelica presume di trovare un tesoro. Però da ogni catastrofe nasce qualcosa di nuovo e il film termina lasciandoci sperare il meglio."
    ],
    "image": "../figlia-mia.jpg"
  },
  {
    "title": "FILM D’AMORE E D’ANARCHIA OVVERO STAMATTINA ALLE 10 IN VIA DEI FIORI NELLA NOTA CASA DI TOLLERANZA...",
    "director": "Lina Wertmüller",
    "country": "Italia",
    "releaseYear": 1973,
    "runtime": 124,
    "version": "OmU",
    "screeningDate": "18.07.2013",
    "readableDate": "2013-07-18",
    "screeningTime": "20:00",
    "actors": "Giancarlo Giannini, Mariangela Melato, Eros Pagni, Elena Fiore, Lina Polito, Pina Cei",
    "subtitle": ["Lina Wertmüller fa 85 anni"],
    "bodycopy": [
      "L’ingenuo Tonino si reca a Roma con l’intenzione di uccidere Mussolini e si rifugia in un bordello. Confuso nella grande città e ammaliato dalle seducenti ragazze della casa di tolleranza, non si sveglia in tempo per l’attentato e si lascia prendere dal panico durante una retata."
    ],
    "image": "../film-damore.jpg"
  },
  {
    "title": "FILM D’AMORE E D’ANARCHIA, OVVERO STAMATTINA ALLE 10 IN VIA DEI FIORI NELLA NOTA CASA DI TOLLERANZA ...",
    "director": "Lina Wertmüller",
    "country": "Italia/Francia",
    "releaseYear": 1973,
    "runtime": 125,
    "version": "OmU",
    "screeningDate": "20.11.2008",
    "readableDate": "2008-11-20",
    "screeningTime": "19:00",
    "actors": "Giancarlo Giannini, Mariangela Melato, Lina Polito, Eros Pagni, Pina Cei, Elena Fiore ",
    "subtitle": ["Lina Wertmüller compie 80 anni"],
    "bodycopy": [
      "L’ingenuo contadino Tunin vuole uccidere Mussolini e, attraverso un suo compagno, viene ospitato a Roma in un bordello. Qui trova l’amore della sua vita. Sconvolto da queste nuove esperienze e poco pratico della “grande città” si lascia sfuggire l’occasione dell’attentato, cosa che non impedisce tuttavia ai fascisti di arrestarlo e punirlo. “Potenza politica, idillio sentimentale, farsa crudele e tragedia melodrammatica, con la grandiosa colonna sonora di Nino Rota e Carlo Savina: un grande film d’intrattenimento con una grande profondità di contenuto."
    ],
    "image": "../film-damore.jpg"
  },
  {
    "title": "Francesco",
    "director": "Liliana Cavani",
    "country": "Italia/Germania",
    "releaseYear": 1989,
    "runtime": 130,
    "version": "OmU",
    "screeningDate": "20.12.2005",
    "readableDate": "2005-12-20",
    "screeningTime": "19:00",
    "actors": "Mickey Rourke, Helena Bonham Carter, Andréa Ferrèol, Nikolaus Dutsch, Peter Berling, Mario Adorf",
    "subtitle": ["Rassegna di Mario Adorf"],
    "bodycopy": [
      "Il film racconta la storia di San Francesco d'Assisi, il fondatore dell'ordine francescano. Nato nel 1182, Francesco Bernadone lascia incompreso la sua famiglia abbiente per andare a vivere assieme ai poveri e agli ammalati. Per lungo tempo lotta per il riconoscimento del suo movimento da parte del Vaticano. Dopo averlo ricevuto, cade in profonda disperazione di fronte alla richiesta dei suoi discepoli di una “Regola”. Allora si ritira nei boschi alla ricerca di illuminazione spirituale. Mario Adorf ha un piccolo ruolo: impersona il Cardinale Ugolino dei Conti di Segni."
    ],
    "image": "../franziskus.jpg"
  },
  {
    "title": "FUOCOAMMARE",
    "director": "Gianfranco Rosi",
    "country": "Italia/Francia",
    "releaseYear": 2016,
    "runtime": 114,
    "version": "OmU",
    "screeningDate": "21.09.2017",
    "readableDate": "2017-09-21",
    "screeningTime": "20:00",
    "actors": "Samuele Pucillo, Mattias Cucina, Samuele Caruana, Pietro Bartolo, Giuseppe Fragapane, Maria Signorello, Francesco Paterna, Francesco Mannino, Maria Costa",
    "subtitle": [
      "Qual è l'anello di congiunzione tra i profughi ammassati in un barcone e i bambini che giocano? L'isola di Lampedusa: per i primi una meta da raggiunge superando grandi difficoltà, per gli altri il loro ambiente familiare. Gianfranco Rosi racconta questi aspetti contrastanti dell'isola con immagini in parte spettacolari, in parte banali."
    ],
    "bodycopy": [
      "Il risultato è un quadro impressionistico di due realtà che convivono ed entrano in contatto pur essendo estremamente diverse; da un lato una vita quotidiana oziosa e senza grandi emozioni, dall'altro la lotta per la sopravvivenza a condizioni disumane. Il documentario è il prodotto di un anno di osservazione delle vicende a Lampedusa."
    ],
    "image": "../fuocoammare.jpg"
  },
  {
    "title": "Fuori dal mondo",
    "director": "Giuseppe Piccioni",
    "country": "Italia",
    "releaseYear": 1999,
    "runtime": 101,
    "version": "OmU",
    "screeningDate": "16.12.2004",
    "readableDate": "2004-12-16",
    "screeningTime": "19:30",
    "actors": "Margherita Buy, Silvio Orlando, Carolina Freschi, Marina Massironi, Giuliana Lojodice, Francesco Foti",
    "subtitle": [""],
    "bodycopy": [
      "Che cosa succede se una novizia si ritrova con un neonato che un jogger le ha messo in braccio? Si mette a cercare la madre. Lo scontrino attaccato al pullover in cui è avvolto il bimbo, la conduce nella lavanderia gestita da Ernesto, un misantropo che si interessa ben poco per le persone che lo circondano. Il suo atteggiamento cambia poco a poco quando si accorge che il pullover è suo. Gli viene in mente una breve storia con una sua dipendente: non risale a circa nove mesi fa?",
      "Mentre la novizia Caterina scopre sempre di più i suoi sentimenti materni e rapisce il neonato dall'ospedale dove è in attesa dei suoi futuri genitori adottivi, Ernesto inizia a riemergere dal suo mondo ermetico.",
      "Alla ricerca di Teresa, la madre del bimbo, le concezioni di vita dei due personaggi, che appaiono entrambi fuori dal mondo, si scontrano sia tra di loro che con la realtà della vita quotidiana a Milano. Lentamente sembra che stia nascendo una storia d'amore... ma Piccioni, riuscendo ad evitare qualsiasi scivolata nel sentimentalismo e i soliti stereotipi, mostra invece un quadro sensibile di due persone estraniate dalla società in cui si ritrovano."
    ],
    "image": "../fuori-dam-mondo.jpg"
  },
  {
    "title": "Generazione 1000 euro",
    "director": "Massimo Vernier",
    "country": "Italia",
    "releaseYear": 2009,
    "runtime": 101,
    "version": "OmitU",
    "screeningDate": "07.12.2011",
    "readableDate": "2011-12-07",
    "screeningTime": "20:00",
    "actors": "Alessandro Tiberi, Valentina Lodovini, Carolina Crescentini, Francesco Mandelli, Francesca Inaudi, Paolo Villaggio",
    "subtitle": ["150 anni dall'unità d'Italia"],
    "bodycopy": [
      "A che cosa serve un esame eccellente e la passione per la matematica se si ha un lavoro precario in una società di marketing che non smette di riorganizzarsi? Marco ha messo su casa con il suo migliore amico, un moderno “artista della vita” e potrebbe continuare ad arrangiarsi, se non ci fosse l’affascinante vicedirettrice e una nuova coinquilina che mettono in subbuglio le sue abitudini. Una commedia divertente su un tema serio: le condizioni di vita precarie della giovane generazione in Italia."
    ],
    "image": "../generazione-1000-euro.jpg"
  },
  {
    "title": "GENERAZIONE MILLE EURO",
    "director": "Massimo Vernier",
    "country": "Italia",
    "releaseYear": 2009,
    "runtime": 101,
    "version": "OmU",
    "screeningDate": "17.01.2013",
    "readableDate": "2013-01-17",
    "screeningTime": "20:00",
    "actors": "Alessandro Tiberi, Valentina Lodovini, Carolina Crescentini, Francesco Mandelli",
    "subtitle": [""],
    "bodycopy": [
      "Posti di lavoro precari e convivenze arrangiate hanno un influsso anche sui rapporti interpersonali. Tragico e comico: in tono leggero e divertente il film fornisce un quadro della giovane generazione senza trascurarne i problemi."
    ],
    "image": "../generazionemilleeuro.jpg"
  },
  {
    "title": "GENITORI & FIGLI:) AGITARE BENE PRIMA DELL’USO",
    "director": "Giovanni Veronesi",
    "country": "Italia",
    "releaseYear": 2010,
    "runtime": 106,
    "version": "OmitU",
    "screeningDate": "02.05.2012",
    "readableDate": "2012-05-02",
    "screeningTime": "20:00",
    "actors": " Margherita Buy, Silvio Orlando, Michele Placido, Luciana Littizzetto",
    "subtitle": [""],
    "bodycopy": [
      "Ispirata dal tema scolastico “Genitori e figli: istruzioni per l’uso”, Nina racconta le sue osservazioni mettendo in luce con umorismo le numerose assurdità dei rapporti intergenerazionali. Lo spettatore lascia il cinema divertito e arricchito di tante nuove impressioni.Ispirata dal tema scolastico “Genitori e figli: istruzioni per l’uso”, Nina racconta le sue osservazioni mettendo in luce con umorismo le numerose assurdità dei rapporti intergenerazionali. Lo spettatore lascia il cinema divertito e arricchito di tante nuove impressioni."
    ],
    "image": "../genitori-e-figli.jpg"
  },
  {
    "title": "Gente di Roma",
    "director": "Ettore Scola",
    "country": "Italia",
    "releaseYear": 2003,
    "runtime": 93,
    "version": "OmU",
    "screeningDate": "17.04.2008",
    "readableDate": "2008-04-17",
    "screeningTime": "19:00",
    "actors": null,
    "subtitle": ["Rassegna di Ettore Scola"],
    "bodycopy": [
      "Un omaggio ironico-melanconico alla \"sua\" città. Un documentario fittizio che non soltanto riprende con virtuosismo le piccole manie dei nostri simili, ma studia anche lo sfondo filosofico della vita quotidiana. In una carrellata di episodi tra assurdità e poesia Scola riesce a dare un quadro della città e dei suoi abitanti, a cui va tutta la sua simpatia. Un'\"opera matura\", tranquilla e allo stesso tempo stimolante che, speriamo, non sia l'ultima di questo grande maestro del cinema."
    ],
    "image": "../gente-di-roma.jpg"
  },
  {
    "title": "Gianni e le donne (GIANNI UND DIE FRAUEN)",
    "director": "Gianni Di Gregorio",
    "country": "Italia",
    "releaseYear": 2011,
    "runtime": 89,
    "version": "OmU",
    "screeningDate": "19.07.2012",
    "readableDate": "2012-07-19",
    "screeningTime": "20:00",
    "actors": "Gianni Di Gregorio, Valeria De Franciscis, Alfonso Santagata, Elisabetta Piccolomini, Valeria Cavalli",
    "subtitle": [""],
    "bodycopy": [
      "Commedia di Gianni Di Gregorio, in cui il regista stesso interpreta un uomo invecchiato con le sue fantasie erotiche in un mondo fatto di matrimonio, portare a spasso il cane e ammirare gli amici."
    ],
    "image": "../gianni-e-le-donne.jpg"
  },
  {
    "title": "GINGER E FRED",
    "director": "Federico Fellini",
    "country": "Italia",
    "releaseYear": 1986,
    "runtime": 125,
    "version": "OmU",
    "screeningDate": "18.12.2018",
    "readableDate": "2018-12-18",
    "screeningTime": "20:00",
    "actors": "Marcello Mastroianni, Giulietta Masina, Franco Fabrizi, Friedrich von Ledebur, Augusto Poderosi, Martin Maria Blau, Jacques-Henri Lartigue",
    "subtitle": [
      "Chi si aspetta un film con Fred Astaire e Ginger Rogers, sarà deluso. Anche se i protagonisti (Giulietta Masina nel ruolo di Amelia Bonetti e Marcello Mastroianni in quello di Pippo Botticella), imitano la famosa coppia di ballerini di tap tap, il film racconta la storia di un assurdo show televisivo in cui non è chiaro chi dovrebbero impersonare i due. Con questo film Fellini ha ripreso uno dei suo temi preferiti: la TV che rende ridicoli ad altro livello."
    ],
    "bodycopy": [
      "Negli anni '80 (in cui è stato girato il film) è passata da tempo l'epoca in cui Pippo e Amelia, in coppia, con il loro spettacolo di tip tap nello stile di Fred Astair e Ginger Rogers avevano più o meno successo. Da quando si sono separati negli anni '50 non si sono più né visti, né hanno più lavorato assieme. Un invito ad uno show televisivo li riporta insieme e insieme aspettano di vedere quale ruolo dovrebbero assumere in tale produzione. Nel frattempo davanti ai loro occhi passa il mondo della televisione in forma di personaggi strambi che dovrebbero partecipare come ospiti allo show, e che fanno capire ben presto ai due che anche loro dovrebbero far parte di un freak show. Amelia, accecata dalla sua ambizione artistica, vuole rimanere, mentre Pippo fin dall'inizio si distanzia: lo fa solo per i soldi. La prova generale in una sala fuori uso fa temere il peggio per lo spettacolo. E poi arriva il \"grande momento\"."
    ],
    "image": "../ginger-e-fred.jpg"
  },
  {
    "title": "GIORNI E NUVOLE",
    "director": "Silvio Soldini",
    "country": "Italia/Svizzera",
    "releaseYear": 2007,
    "runtime": 115,
    "version": "OmU",
    "screeningDate": "19.03.2009",
    "readableDate": "2009-03-19",
    "screeningTime": "20:00",
    "actors": "Margherita Buy, Antonio Albanese, Giuseppe Battiston, Alba Rohrwacher, Carla SIgnoris, Fabio Troiano",
    "subtitle": ["Rassegna di Silvio Soldini"],
    "bodycopy": [
      "La bella vita può finire in fretta: costretto dagli altri titolari a lasciare la sua impresa, un imprenditore deve smettere la sua vita lussuosa e trasferirsi con sua moglie in periferia. Rapidamente lei riesce a riprender piede anche nelle nuove circostanze, mentre lui, collerico e disorientato, affonda nell’autocommiserazione. Come in tutti i suoi altri film Soldini scandaglia i rapporti umani e prova nuovi modi di raccontare."
    ],
    "image": "../giorni-e-nuvole.jpg"
  },
  {
    "title": "Giovanni Falcone",
    "director": "Giuseppe Ferrara",
    "country": "Italia",
    "releaseYear": 1993,
    "runtime": 124,
    "version": "OmitU",
    "screeningDate": "01.12.2010",
    "readableDate": "2010-12-01",
    "screeningTime": "20:00",
    "actors": "Michele Placido, Anna Bonaiuto, Giancarlo Giannini, Massimo Bonetti, Nello Riviè, Gianni Musi, Marco Leto, Paolo De Giorgio",
    "subtitle": ["Storia della mafia - Storie di mafia"],
    "bodycopy": [
      "Giuseppe Ferrara nel suo film di carattere documentaristico indaga i retroscena dell’uccisione del pubblico ministero antimafia di cui porta il nome e mostra come imagistrati indaganti devono letteralmente procedere “clandestinamente” per potersi proteggere da tradimenti (mostriamo il film in lunghezza originale)."
    ],
    "image": "../giovanni-falcone.jpg"
  },
  {
    "title": "GIULIA IN OTTOBRE",
    "director": "Silvio Soldini",
    "country": "Italia",
    "releaseYear": 1985,
    "runtime": 60,
    "version": "OmU",
    "screeningDate": "15.01.2009",
    "readableDate": "2009-01-15",
    "screeningTime": "20:00",
    "actors": "Carla Chiarelli, Roberto Casali, Giuseppe Cederna, Daniela Morelli, Andrea Novicov, Moni Ovadia",
    "subtitle": ["Rassegna di Silvio Soldini"],
    "bodycopy": [
      "Questo film low-budget conosciuto soltanto da pochi “intimi” risale al primo periodo creativo di questo regista di successo. Racconta cinque giorni della vita di una donna che, dopo il fallimento di un suo rapporto amoroso, cerca di ricominciare nell’ambiente in cui è sempre vissuta. Già in questo film Soldini si cimenta in quel mondo di immagini e in quel modo di raccontare per i quali è diventato poi famoso. La pellicola, presentata in Germania nella rassegna Forum della Berlinale con il nome sbagliato del regista, sparì negli archivi."
    ],
    "image": "../giulia-in-ottobre.jpg"
  },
  {
    "title": "GIULIA NON ESCE LA SERA",
    "director": "Giuseppe Piccioni",
    "country": "Italia",
    "releaseYear": 2009,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "15.03.2012",
    "readableDate": "2012-03-15",
    "screeningTime": "20:00",
    "actors": "Valerio Mastandrea, Valeria Golino, Sonia Bergamasco, Domiziana Cardinali, Jacopo Domenicucci, Chiara Nicola, Sara Tosti",
    "subtitle": [""],
    "bodycopy": [
      "La storia di un fragile amore. Separato dalla famiglia per un nuovo progetto, lo scrittore Guido si innamora di una maestra di nuoto. Però lei non esce mai la sera. Un film pieno di misteri!"
    ],
    "image": "../giulia-non-esce-la-sera.jpg"
  },
  {
    "title": "GLI ANNI PIÙ BELLI",
    "director": "Gabriele Muccino",
    "country": "Italia",
    "releaseYear": 2019,
    "runtime": 129,
    "version": "OmU",
    "screeningDate": "15.09.2022",
    "readableDate": "2022-09-15",
    "screeningTime": "20:00",
    "actors": "Pierfrancesco Favino, Micaela Ramazzotti, Claudio Santamaria, Kim Rossi Stuart e altri",
    "subtitle": [
      "Si ha l’impressione che in ogni decennio arrivi nelle sale italiane un film che raffigura una generazione e racconta il destino di certi gruppi (attivisti politici, famiglie, colleghi ecc.) o di persone singole nel corso del tempo. In questo caso si tratta di quattro amici, di cui noi spettatori seguiamo alcune tappe della loro vita, la scuola, il primo amore, l’ingresso nel mondo del lavoro, la fondazione della propria famiglia, l’avvicendarsi di crisi inevitabili, separazioni e ricongiungimenti."
    ],
    "bodycopy": [
      "“Noi tutti veniamo formati dal tempo. Crediamo di avere il controllo sulla nostra vita, però in verità è il tempo, che passa e ci cambia sempre di più, a tirare le fila nella nostra vita.  Ci fa tollerare cose che in gioventù ci sarebbero apparse inaccettabili.  Ci ruba le illusioni, ci disincanta e ci incanta insperatamente sempre di nuovo facendoci sentire nuovamente giovani, sebbene non lo siamo più. Il tempo contrassegna le figure di questo film, le forma e le trasforma in modo tale da sottrarle al loro controllo”. (Gabriele Muccino in un’intervista)"
    ],
    "image": "../gli-anni-piu-belli-03.jpg"
  },
  {
    "title": "GOMORRA",
    "director": "Matteo Garrone",
    "country": "Italia",
    "releaseYear": 2008,
    "runtime": 136,
    "version": "OmU",
    "screeningDate": "18.11.2010",
    "readableDate": "2010-11-18",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Gianfelice Imparato, Maria Nazionale, Salvatore Cantalupo, Gigio Morra, Salvatore abruzzese, Marco Macor, Ciro Petrone, Salvatore Ruocco",
    "subtitle": ["Storia della mafia- Storie di mafia"],
    "bodycopy": [
      "Dall’uscita del suo libro sulla camorra, intitolato GOMORRA, la vita di Roberto Saviano è in pericolo. È costretto perciò a vivere nascosto in caserme di polizia e altri luoghi segreti. Matteo Garrone ha cercato di trasferire la descrizione dettagliata del libro con citazione di nomi ed episodi della società mafiosa campana in un film dal carattere documentaristico. Anche se tanti dettagli vanno naturalmente persi e, in primo piano, risalta maggiormente l’aspetto delittuoso, tutti gli eventi corrispondono alla realtà, anche se lo spettatore spesso non ci può credere."
    ],
    "image": "../gomorra.jpg"
  },
  {
    "title": "GOMORRA",
    "director": "Matteo Garrone",
    "country": "Italia",
    "releaseYear": 2008,
    "runtime": 136,
    "version": "OmU",
    "screeningDate": "20.03.2014",
    "readableDate": "2014-03-20",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Gianfelice Imparato, Maria Nazionale, Salvatore Cantalupo, Gigio Morra, Salvatore abruzzese, Marco Macor, Ciro Petrone, Salvatore Ruocco",
    "subtitle": [
      "10° anniversario: i maggiori successi del Club del Cinema Italiano"
    ],
    "bodycopy": [
      "Dall’uscita del suo libro sulla camorra, intitolato GOMORRA, la vita di Roberto Saviano è in pericolo. È costretto perciò a vivere nascosto in caserme di polizia e altri luoghi segreti. Matteo Garrone ha cercato di trasferire la descrizione dettagliata del libro con citazione di nomi ed episodi della società mafiosa campana in un film dal carattere documentaristico. Anche se tanti dettagli vanno naturalmente persi e, in primo piano, risalta maggiormente l’aspetto delittuoso, tutti gli eventi corrispondono alla realtà, anche se lo spettatore spesso non ci può credere."
    ],
    "image": "../gomorra.jpg"
  },
  {
    "title": "Gorbaciof",
    "director": "Stefano Incerti",
    "country": "Italia",
    "releaseYear": 2010,
    "runtime": 81,
    "version": "OmitU",
    "screeningDate": "07.03.2012",
    "readableDate": "2012-03-07",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Mi Yang, Geppy Gleijeses, Gaetano Bruno, Nello Mascia, Salvatore Ruocco",
    "subtitle": [""],
    "bodycopy": [
      "Gorbaciof, un appassionato giocatore d’azzardo, è il contabile nel penitenziario napoletano di Poggioreale. Quando si accorge che il padre del suo grande amore, la giovane cinesina Lila, non riesce a pagare i suoi debiti di gioco, sottrae dei soldi dalla cassa del carcere. E il dramma comincia. Una storia d’amore raccontata con le immagini, perfettamente comprensibile anche senza i pochi dialoghi del film."
    ],
    "image": "../gorbaciof.jpg"
  },
  {
    "title": "GRUPPO DI FAMIGLIA IN UN INTERNO",
    "director": "Luchino Visconti",
    "country": "Italia/Francia",
    "releaseYear": 1974,
    "runtime": 121,
    "version": "OmU",
    "screeningDate": "22.01.2022",
    "readableDate": "2022-01-22",
    "screeningTime": "19:00",
    "actors": "Burt Lancaster, Helmut Berger, Silvana Mangano e altri",
    "subtitle": [
      "Una cooperazione tra il team \"Neu restauriert (da poco restaurato)\" e il \"Filmclub del Cinema Italiano (entrambi del Museo del Cinema di Düsseldorf).\"",
      "In una casa lussuosa con un arredamento ormai antiquato vive ritirato e solo un vecchio professore assieme ai suoi quadri, fotografie, libri, oggetti d'arte e ricordi. Piano piano nel corso degli anni si è sempre più isolato, ma affitta, anche se di malavoglia, l'appartamento vuoto del suo palazzo. I ragazzi e le ragazze che ci abitano lo mettono a confronto con un mondo moderno e conturbante, sconvolgendo la sua vita pacifica e ritirata. Fa amicizia soprattutto con Konrad, un giovane ex sessantottino, sviluppando verso di lui un rapporto paterno. "
    ],
    "bodycopy": [
      "“Si tratta della storia di un intellettuale. Attraverso il contatto con un gruppo di giovani pieni di vitalità e sventatezza, interessati solamente a spazzar via tutto quello che c'era prima di loro, il vecchio avverte tutto il peso della sua solitudine”. (Luchino Visconti)",
      "L'allestimento gioca un ruolo decisivo nel film. Visconti descrive l'ambiente familiare con scrupolosa esattezza quasi volesse dipingere un quadro nello stile del XVIII secolo. L'amore per i dettagli e la precisione si avvertono in ogni inquadratura.",
      "Il restauro del film è avvenuto nel 2013 nel Centro sperimentale di Cinematografia - Cineteca Nazionale di Roma."
    ],
    "image": "../gewalt-und-leidenschaft.jpg"
  },
  {
    "title": "HABEMUS PAPAM",
    "director": "Nani Moretti",
    "country": "Italia/Francia",
    "releaseYear": 2011,
    "runtime": 104,
    "version": "OmU",
    "screeningDate": "20.12.2012",
    "readableDate": "2012-12-20",
    "screeningTime": "20:00",
    "actors": "Michel Piccoli, Nanni Moretti, Renato Scarpa, Jerzy Stuhr, Franco Graziosi, Camillo Milli, Roberto Nobile, Ulrich von Dobschütz, Gianluca Gobbi, Margherita Buy",
    "subtitle": [""],
    "bodycopy": [
      "Il papa neoeletto, non sicuro di essere all’altezza del suo compito, fugge e si mescola alla popolazione della città di Roma mentre al Vaticano, dove non riescono a capacitarsi dell’avvenuto, cercano affannosamente una soluzione."
    ],
    "image": "../habemus-papam.jpg"
  },
  {
    "title": "Heaven",
    "director": "Tom Tykwer",
    "country": "Germania/USA/Francia",
    "releaseYear": 2000,
    "runtime": 97,
    "version": "OmU",
    "screeningDate": "18.11.2004",
    "readableDate": "2004-11-18",
    "screeningTime": "19:30",
    "actors": "Cate Blanchett, Giovanni Ribisi, Remo Girone, Stefania Rocca",
    "subtitle": [""],
    "bodycopy": [
      "Un regista tedesco, uno sceneggiatore polacco, un produttore statunitense (Miramax). È veramente il film giusto per il club del cinema italiano?",
      "Se accanto a Cate Banchett noti attori italiani recitano i ruoli principali, gran parte del film è in lingua italiana e si svolge in Italia, a Torino e alla fine in Toscana, perché no?",
      "Tom Tykwer (“Lola rennt”) ha realizzato la sceneggiatura del defunto regista polacco Kieslowski (Tre colori “Rosso”-“Bianco”-“Blu”). Il risultato è un film con gli ingredienti sia di un thriller che di un dramma da camera e pure un avvicinamento alla tradizione spirituale europea.",
      "Filippa vuole vendicarsi del boss della droga che ritiene responsabile della morte di suo marito. A causa di circostanze sfortunate invece le vittime sono i componenti di una famiglia. Poiché dopo l'arresto si scopre che Filippa parla inglese, il giovane carabiniere Filippo si offre come interprete. Spontaneamente si innamora di Filippa e vuole aiutarla a fuggire. All'inizio Filippa sfrutta senza passione quest’offerta utente incondizionata d'aiuto. Però, passata una galleria che sfocia nella campagna toscana, i due fuggiaschi iniziano assieme la ricerca del loro “paradiso”. Il tutto raffigurato con immagini di grande effetto e piene di contenuti simbolici."
    ],
    "image": "../heaven.jpg"
  },
  {
    "title": "I cento passi",
    "director": "Marco Tullio Giordana",
    "country": "Italia",
    "releaseYear": 2000,
    "runtime": 114,
    "version": "OmU",
    "screeningDate": "15.01.2004",
    "readableDate": "2004-01-15",
    "screeningTime": "19:30",
    "actors": "Luigi Lo Cascio, Luigi Maria Burruano, Paolo Bruglia, Lucia Sardo",
    "subtitle": [""],
    "bodycopy": [
      "Il 9 maggio 1978 viene trovato il cadavere di Aldo Moro. A causa di questo evento passa quasi inosservata la notizia della morte di Peppino Impastato, fatto esplodere lo stesso giorno dalla mafia. Appena ora la giustizia italiana si preoccupa di perseguire questo delitto.",
      "I suoi genitori hanno già preparato la carriera di mafioso per Peppino, ma lui prende un’altra decisione. I 100 passi che dividono la casa dei suoi genitori da quella del locale capo mafioso definiscono la distanza e la vicinanza rispetto all’associazione criminale.",
      "Genitori, amici e vicini di casa sono strettamente intrecciati con la mafia e inizialmente possono ancora proteggere Peppino Impastato dalle conseguenze dei suoi accessi di collera contro gli “uomini d’onore”. Quando tuttavia fonda una stazione radio e diventa uno dei protagonisti del movimento di sinistra “Lotta continua”, riceve ripetutamente chiari avvertimenti di cui lui però non si cura.",
      "Con la sua ricostruzione cronologica del “Caso Impastato” Marco Tullio Giordana si allinea nella tradizione del cinema politico italiano degli anni 60 e 70, alla quale fa esplicito riferimento citando il film “Le mani sulla città” di Francesco Rosi."
    ],
    "image": "../cento-passi.jpg"
  },
  {
    "title": "I cento passi",
    "director": "Marco Tullio Giordana",
    "country": "Italia",
    "releaseYear": 2000,
    "runtime": 114,
    "version": "OmU",
    "screeningDate": "21.04.2005",
    "readableDate": "2005-04-21",
    "screeningTime": "19:30",
    "actors": "Luigi Lo Cascio, Luigi Maria Burruano, Lucia Sardo, Paolo Briguglia, Tony Sperandeo, Andrea Tidona",
    "subtitle": ["Rassegna di Luigi Lo Cascio"],
    "bodycopy": [
      "Giuseppe \"Peppino“ Impastato si oppone alle strutture mafiose della sua cittadina, fonda una stazione radio, infrange la legge dell'omertà e alla fine è lui stesso vittima di un attentato. Altro spettacolo italiano: Concerto di PIPPO POLLINA & Quartetto Palermo Acoustics, 09.04.2005, ore 20.00, Haus der Jugend, Lacombletstraße 10, Düsseldorf - Pippo Pollina è amico di Leoluca Orlando e, durante il concerto, dedicherà una canzone proprio a questo film."
    ],
    "image": "../cento-passi.jpg"
  },
  {
    "title": "I CENTO PASSI",
    "director": "Marco Tullio Giordana",
    "country": "Italia",
    "releaseYear": 2000,
    "runtime": 114,
    "version": "OmU",
    "screeningDate": "16.12.2010",
    "readableDate": "2010-12-16",
    "screeningTime": "20:00",
    "actors": "Luigi Lo Cascio, Luigi Maria Burruano, Lucia Sardo, Paolo Briguglia, Tony Sperandeo, Andrea Tidona",
    "subtitle": ["Storia della mafia- Storie di mafia"],
    "bodycopy": [
      "Giuseppe Impastato aveva potuto gestire a lungo la sua radio antimafia – 100 passi separavano la casa dei suoi genitori da quella del boss mafioso. Una distanza che simboleggia sia la lontananza dalla mafia che la vicinanza alla stessa dei suoi genitori, amici e vicini. Quando Impastato però, vista l’evidente inutilità dei suoi programmi radiofonici, passa ad una provocazione sempre più accentuata, la mafia si vendica. La fine patetico-ottimista del film non sarebbe più possibile in questa forma a dieci anni di distanza dall’uscita del film."
    ],
    "image": "../cento-passi.jpg"
  },
  {
    "title": "I clowns",
    "director": "Federico Fellini",
    "country": "Italia",
    "releaseYear": 1970,
    "runtime": 92,
    "version": "OmitU",
    "screeningDate": "03.03.2010",
    "readableDate": "2010-03-03",
    "screeningTime": "20:00",
    "actors": "Riccardo Billi, Gigi Reder, Tino Scotti, Leopoldo Valentini, Fanfulla, Sandro Merli, Carlo Rizzo",
    "subtitle": ["Federico Fellini: 90 anni (20.01.1920-31.10.1993)"],
    "bodycopy": [
      "Tutta la vita è un gran circo e nulla è più autentico dei clown. Questo presunto reportage sulla predestinata scomparsa dei clown del circo (commissionatagli effettivamente dalla televisione italiana) offre a Fellini l’occasione per mostrare un caleidoscopio di personaggi bizzarri, grotteschi e stravaganti che, tuttavia, proprio nella loro singolarità mettono in luce una profonda umanità."
    ],
    "image": "../i-clowns.jpg"
  },
  {
    "title": "I compagni",
    "director": "Mario Monicelli",
    "country": "Italia/Francia",
    "releaseYear": 1963,
    "runtime": 124,
    "version": "OmitU",
    "screeningDate": "04.05.2011",
    "readableDate": "2011-05-04",
    "screeningTime": "20:00",
    "actors": "Marcello Mastroianni, Renato Salvatori, Annie Giranrdot, François Périer, Raffaella Carrà, Gabriella Giorgetlli, Folco Lulli, Bernard Blier",
    "subtitle": ["150 anni dall#unità d'Italia"],
    "bodycopy": [
      "Torino fine Ottocento. La situazione nelle filande è indicibile, le condizioni di vita degli operai sono pessime. Fallite le trattative per ridurre l’orario di lavoro a 13 ore giornaliere, si arriva allo sciopero. Ma quando lo stesso si inasprisce sfociando nell’occupazione della fabbrica, intervengono i militari. Un film dall’eccellente fotografia sulla nascita del movimento dei lavoratori in Italia."
    ],
    "image": "../i-compagni.jpg"
  },
  {
    "title": "I giorni dell'abbandono",
    "director": "Roberto Faenza",
    "country": "Italia",
    "releaseYear": 2005,
    "runtime": 96,
    "version": "OmitU",
    "screeningDate": "06.05.2009",
    "readableDate": "2009-05-06",
    "screeningTime": "20:00",
    "actors": "Margherita Buy, Luca Zingaretti, Goran Bregovic, Alessia Goria, Geo Lionello, Gaia Bermani Amarai, Sara Santostasi, Simone Della Croce",
    "subtitle": ["Rassegna di Roberto Faenza"],
    "bodycopy": [
      "Mauro pianta in asso Olga per la sua giovane amante. Dovendosi occupare da sola dei due figli e del cane Olga subisce un tracollo. La sensazione di abbandono la trascina in una spirale che l'allontana sempre di più dalla realtà. Un “thriller dell’anima” recitato da attori di primo piano come Margherita Buy, Luca Zingaretti e Goran Bregovic (che fa la parte del vicino di casa)."
    ],
    "image": "../i-giorni-dellabbandono.jpg"
  },
  {
    "title": "I mostri",
    "director": "Dino Risi",
    "country": "Italia",
    "releaseYear": 1963,
    "runtime": 117,
    "version": "OmU",
    "screeningDate": "03.07.2010",
    "readableDate": "2010-07-03",
    "screeningTime": "20:00",
    "actors": "Ugo Tognazzi, Vittorio Gassman, Ricky Tognazzi, Lando Buzzanca, Michéle Mercier, Marisa Merlini, Rika Dialina",
    "subtitle": [
      "Sottotitolato dagli studenti della facoltà di romanistica, indirizzo \"traduzione letteraria\" dell'Università Heinrich Heine di Düsseldorf.."
    ],
    "bodycopy": [
      "In zwanzig Episoden skizziert Dino Risi die Italiaische Wohlstandsgesellschaft der 1960er Jahre. Mal ironisch, mal zynisch karikiert er das Verhalten von kleinen Gaunern, Ehemännern und –frauen, Abgeordneten und anderen alltäglichen „Monstern“ auf humorvolle Weise."
    ],
    "image": "../imostri.png"
  },
  {
    "title": "I racconti di Canterbury",
    "director": "Pier Paolo Pasolini",
    "country": "Italia/Francia",
    "releaseYear": 1972,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "04.03.2011",
    "readableDate": "2011-03-04",
    "screeningTime": "20:00",
    "actors": "Hugh Griffith, Laura Betti, Ninetto Davoli, Franco Citti, Josephine Chaplin, Alan Webb, Pier Paolo Pasolini, Vernon Dobtcheff, Adrian Street, Michael Balfour, Jenny Runacre, Tom Baker",
    "subtitle": [""],
    "bodycopy": [
      "Si può dire che si tratta della seconda parte della trasposizione della letteratura più insolente del Medioevo. Di nuovo la stessa grossolanità del DECAMERONE. Pasolini dipinge con molto gusto il cattivo gusto."
    ],
    "image": "../I racconti di Canterbury.jpg"
  },
  {
    "title": "I soliti ignoti",
    "director": "Mario Monicelli",
    "country": "Italia",
    "releaseYear": 1958,
    "runtime": 85,
    "version": "OmU",
    "screeningDate": "02.08.2006",
    "readableDate": "2006-08-02",
    "screeningTime": "18:00",
    "actors": "Vittorio Gassman, Marcello Mastroianni, Carlo Pisacane, Tiberio Murgia, Renato Salvatori, Totò, Memmo Carotenuto, Rosaria Rory, Carla Gravina, Claudia CArdinale, Gina Rovere, Gina Amendola, Elvira Tonelli",
    "subtitle": [""],
    "bodycopy": [
      "Una rara occasione di rivedere Totò, il famosissimo comico napoletano. Un gruppetto di ladruncoli si preparano a scassinare un'agenzia del Monte dei pegni. Come in ogni \"commedia all’italiana\", nel film succede un po' di tutto. Girato con protagonisti di grande spicco come Vittorio Gassmann, Marcello Mastroianni, Claudia Cardinale il film ha lasciato più volte segno nella storia del cinema."
    ],
    "image": "../i-soliti-ignoti.jpg"
  },
  {
    "title": "I vicerè",
    "director": "Roberto Faenza",
    "country": "Italia/Spanien/Germania/USA",
    "releaseYear": 2007,
    "runtime": 120,
    "version": "OmitU",
    "screeningDate": "03.06.2009",
    "readableDate": "2009-06-03",
    "screeningTime": "20:00",
    "actors": "Alessandro Preziosi, Lando Buzzanca, Cristiana Capotondi, Guido Caprino, Assumpta Serna, Magdalena Grochowska, Sebastiano Lo Monaco, Lucia Bosè, Anna Marcello",
    "subtitle": ["Rassegna di Roberto Faenza"],
    "bodycopy": [
      "Acclamato dalla stampa come il \"nuovo GATTOPARDO\" (Faenza non è d’accordo) il film racconta la storia di una famiglia siciliana. Faenza compone il quadro di una società alla fine del XIX secolo passando dal tirannico capofamiglia a un monastero peccaminoso fino alla corruzione politica in un’epoca di grandi cambiamenti. Grazie a costumi e allestimenti splendidi e a strumenti cinematografici modernissimi rivive una Catania storica che non ha bisogno di temere confronti con Visconti. "
    ],
    "image": "../i-vicere.jpg"
  },
  {
    "title": "Identificazione di una donna",
    "director": "Michelangelo Antonioni",
    "country": "Italia/Francia",
    "releaseYear": 1982,
    "runtime": 125,
    "version": "OmitU",
    "screeningDate": "03.10.2007",
    "readableDate": "2007-10-03",
    "screeningTime": "19:00",
    "actors": "Thomas Milian, Daniela Silverio, Christine Boisson, Lara Wendelm Veronica Lazar, Enrica Fico, Marcel Bozzuffi, Gianpaolo Saccarola",
    "subtitle": ["In memoria di Michelangelo Antonioni"],
    "bodycopy": [
      "Uno degli ultimi \"grandi\" film di Antonioni: alla ricerca della donna ideale per i suoi film e la sua vita un registra incontra due signore. Si innamora, però la mancata comprensione tra i sessi e la confusione fra finzione e realtà fanno fallire qualsiasi rapporto. Alla fine la ricerca della \"donna ideale\" diventa una ricerca della propria identità."
    ],
    "image": "../identificazione.jpg"
  },
  {
    "title": "Ieri, oggi, domani",
    "director": "Vittorio De Sica",
    "country": "Italia",
    "releaseYear": 1963,
    "runtime": 118,
    "version": "OmU",
    "screeningDate": "19.05.2011",
    "readableDate": "2011-05-19",
    "screeningTime": "20:00",
    "actors": "Sophia Loren, Marcello Mastroianni, Armando Trovajoli, Tina Pica, Gianni Ridolfi, Gennario Di Gregorio",
    "subtitle": ["Omaggio a Vittorio de Sica"],
    "bodycopy": [
      "Una commedia a episodi recitata da due star: Marcello Mastroianni e Sophia Loren. In “Ieri” una contrabbandiera cerca di evitare la prigione facendosi mettere continuamente incinta, in “Oggi” la moglie di un industriale milanese cerca la sua fortuna con un amante scalcinato e in “Domani”, ambientato a Roma, una squillo riporta un seminarista sulla “retta via”. Una riflessione umoristica sull'immagine della donna negli anni 60."
    ],
    "image": "../ieri-oggi-domani.jpg"
  },
  {
    "title": "Il bacio di Tosca",
    "director": "Daniel Schmid",
    "country": "Svizzera",
    "releaseYear": 1984,
    "runtime": 87,
    "version": "OmU",
    "screeningDate": "17.12.2009",
    "readableDate": "2009-12-17",
    "screeningTime": "20:00",
    "actors": null,
    "subtitle": ["\"Ritratti italiani\" - Documentari su temi italiani"],
    "bodycopy": [
      "Un film tra documentazione e finzione sugli ospiti della casa di riposo fondata da Verdi nel 1896 per gli artisti meno fortunati. Nelle loro stanzette sognano i loro “grandi” successi operistici continuando a vivere nel mondo della musica, una vita che nessun autore teatrale potrebbe inventarsi più interessante. “Nasce una specie di realtà mediata; infatti se per trent’anni ci si è illusi di essere un certo personaggio, lo si diventa anche se soltanto con la fantasia” (ha affermato il registra del film, Daniel Schmid)."
    ],
    "image": "../il-bacio-di-tosca.jpg"
  },
  {
    "title": "Il caimano",
    "director": "Nanni Moretti",
    "country": "Italia/Francia",
    "releaseYear": 2006,
    "runtime": 112,
    "version": "OmU",
    "screeningDate": "21.02.2008",
    "readableDate": "2008-02-21",
    "screeningTime": "19:00",
    "actors": "Silvio Orlando, Margherita Buy, Jasmine Trinca, Michele Placido, Elio De Capitani, Toni Bertorelli, Anna Bonaiuto",
    "subtitle": [""],
    "bodycopy": [
      "I critici cinematografici italiani hanno ritenuto questo film come una resa dei conti con Berlusconi. Però la pellicola mostra di più: lo stato dell'Italia oggi. Il precariato è arrivato alla classe media: un mediocre produttore cinematografico deve in qualche modo arrangiarsi, gli amici si allontanano da lui. L'apoliticità governa l'Italia: il produttore si rende ridicolo perché non si accorge che la sceneggiatura del giallo a lui proposto è in effetti la storia di Berlusconi. A chi interessa ancora questo tema? Il produttore disperato lotta per questo film credendo chesia la sua ultima opportunità."
    ],
    "image": "../il-caimano.jpg"
  },
  {
    "title": "IL CAPITALE UMANO",
    "director": "Paolo Virzì",
    "country": "Italia",
    "releaseYear": 2013,
    "runtime": 109,
    "version": "OmU",
    "screeningDate": "15.10.2015",
    "readableDate": "2015-10-15",
    "screeningTime": "20:00",
    "actors": " Fabrizio Bentivoglio, Matilde Gioli, Valeria Bruni-Tedeschi, Guglielmo Pinelli: Massimiliano Bernaschi, Fabrizio Gifuni, Gigio Alberti, ",
    "subtitle": [""],
    "bodycopy": [
      "Un piccolo intermediatore immobiliare sogna il successo e la ricchezza, una moglie ricca lotta per il suo riconoscimento e il ripristino di un teatro e una giovane è alla ricerca della sua identità e del vero amore. E un incidente stradale incide sulle biografie dei tre protagonisti."
    ],
    "image": "../il-capitale-umano.jpg"
  },
  {
    "title": "IL CARATTERE ITALIANO. LA STORIA DI UNA GRANDE ORCHESTRA ITALIANA.",
    "director": "Angelo Bozzolini",
    "country": "Germania/Italia",
    "releaseYear": 2013,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "01.03.2015",
    "readableDate": "2015-03-01",
    "screeningTime": "12:00",
    "actors": null,
    "subtitle": [""],
    "bodycopy": [
      "L’Orchestra dell’Accademia Nazionale di Santa Cecilia suonerà il 3 marzo 2015 a Düsseldorf nella Tonhalle. Con due giorni di anticipo mostriamo questo documentario sulla storia dell’orchestra, dei suoi membri e della sua musica.",
      "Mediante riprese attuali e pregiato materiale d’archivio la pellicola disegna un ritratto dell’Orchestra. Grazie al film lo spettatore vive da vicino i preparativi di un concerto, conosce i musicisti e la loro musica, condivide con loro sia l’attesa trepidante dell’esecuzione sia il sollievo e la gioia che provano dopo l’applauso finale del pubblico."
    ],
    "image": "../die-italienische-art.jpg"
  },
  {
    "title": "Il caso Aldo Moro",
    "director": "Giuseppe Ferrara",
    "country": "Italia",
    "releaseYear": 1986,
    "runtime": 112,
    "version": "OmitU",
    "screeningDate": "03.09.2008",
    "readableDate": "2008-09-03",
    "screeningTime": "19:00",
    "actors": "Gian Maria Volonté, Margarita Lozano, Mattia Sbraia, Bruno Zanin, Consuelo Ferrara, Enrico Maria Modugno, Enrica Rosso",
    "subtitle": [
      "Sequestro e assassinio di ALDO MORO: Aldo Moro fu sequestrato e assassinato nel 1978 dal gruppo terroristico di estrema sinistra delle Brigate Rosse. L’eminente uomo politico cristiano-democratico era stato più volte ministro e dal 1963al 1968 nonché dal 1974 al 1976 presidente del consiglio in Italia. Controverso era stato il suo appoggio al “compromesso storico”, e cioè all'entrata del partito comunista (PCI) nella coalizione di governo con la Democrazia Cristiana. Il 16 marzo 1978 le Brigate Rosse sequestrarono Aldo Moro. Dopo 55 giorni di prigionia fu trovato morto nel cofano di un'autovettura."
    ],
    "bodycopy": [
      "Otto anni dopo l'attentato Ferrara cerca di ricostruire gli intricati avvenimenti. Il film si concentra sulla figura di Aldo Moro premurandosi di riprodurre con esattezza visiva i fatti in base a materiale autentico. Ferrara riesce ad evidenziare la dimensione politica, ma non può che fallire nel tentativo di chiarire i retroscena politici, rimasti in gran parte fino ad oggi insoluti. Quando uscì, il film suscitò le ire dell'establishment politico poiché poneva nuovamente la domanda se i cristiano-democratici e i comunisti avevano fatto a suo tempo tutto il possibile per salvare la vita di Moro."
    ],
    "image": "../il-caso-aldo-moro.jpg"
  },
  {
    "title": "Il ciclone",
    "director": "Leonardo Pieraccion",
    "country": "Italia",
    "releaseYear": 1996,
    "runtime": 90,
    "version": "OmU",
    "screeningDate": "16.09.2004",
    "readableDate": "2008-09-03",
    "screeningTime": "19:00",
    "actors": "Leonardo Pieraccioni, Lorenza Fortezza, Massimo Ceccherini, Paolo Hendel, Natalia Estrada, Barbara Enrichi, Alessandro Haber, Tosca D’Aquino, Bebedetta Mazzini",
    "subtitle": [""],
    "bodycopy": [
      "Tranquilla è la vita nel villaggio toscano in cui il giovane ragioniere Levante Quarini vive con la famiglia in mezzo ad idilliaci campi di girasole. L'inventiva costruzione di un'antenna TV e un piccolo flirt innocente sono gli avvenimenti più emozionanti che offre la vita.",
      "Finché un giorno un piccolo bus si inceppa proprio qui. Ne escono cinque danzatrici di flamenco che mettono completamente a soqquadro la vita della famiglia di Levante. E improvvisamente il padre Osvaldo si fuma uno spinello in cucina e russa al ritmo del flamenco, il fratello un po' ritardato di Levante, gira intimorito per la casa a bocca aperta. E Selvaggia, la sorella lesbica, inizia ad amoreggiare senza inibizioni con Penelope, la danzatrice dalle curve mozzafiato. Che alla fine Levante si prenda una cotta per la bellissima Caterina non può stupire più nessuno.",
      "Questa divertente commedia con il suo romanticismo e i suoi simpatici episodi al ritmo del flamenco fa venire il buonumore. Per la sua leggerezza non poteva che essere italiana."
    ],
    "image": "../il-ciclone.jpg"
  },
  {
    "title": "IL COLORE NASCOSTO DELLE COSE",
    "director": "Silvio Soldini",
    "country": "Italia/Svizzera",
    "releaseYear": 2017,
    "runtime": 116,
    "version": "OmU",
    "screeningDate": "20.06.2019",
    "readableDate": "2019-06-20",
    "screeningTime": "20:00",
    "actors": "Valeria Golino, Adriano Giannini, Arianna Scommegna, Laura Adriani, Anna Ferzetti, Andrea Pennacchi, Beniamino Marcone, Italo Amerighi",
    "subtitle": [
      "Che si possa vivere bene anche da non vedente, se ci si adegua opportunamente, è qualcosa di sconcertante per Teo, un pubblicitario di successo, che però non sa né organizzare, né gestire la propria vita. Nonostante la bella ragazza con cui vuole andare a convivere, un appartamento lussuoso e promettenti prospettive di carriera, è scontento. Così l’appuntamento con un’osteopata cieca diventa per lui una nuova avventura eccitante. "
    ],
    "bodycopy": [
      "Emma invece ha la sua vita sotto controllo e, dopo la separazione dal marito, è disposta a nuove prove. Ma sa anche quello che vuole. Questo atteggiamento rende insicuro Teo, che si sente sempre più irritato e allo stesso tempo affascinato dal mondo dei disabili. Quanto più Emma e Teo si avvicinano e familiarizzano, tanto più Teo riesce a scoprire questo nuovo mondo. Ma Emma capisce il doppio gioco e la debolezza di Teo che non sa decidersi. Improvvisamente è messa in forse la prospettata vita in comune.",
      "Dopo aver girato un documentario sulla vita dei minorati della vista (DIFFERENT EYES, 2014), Silvio Soldini (PANE E TULIPANI), voleva assolutamente far tesoro di questa sua esperienza in un film finzionale per mostrare a un pubblico più ampio la vita con un handicap. In esso Valeria Golino è una Emma perfetta: \"Anche se non ci credete: durante le riprese ero cieca! Lo giuro: ero cieca! Se c’era un ostacolo di mezzo, ci sbattevo contro [...]“ "
    ],
    "image": "../il-colore-nascoste-delle-cose.jpg"
  },
  {
    "title": "IL COLPO DEL CANE",
    "director": "Fulvio Risuleo",
    "country": "Italia",
    "releaseYear": 2019,
    "runtime": 93,
    "version": "OmU",
    "screeningDate": "15.12.2022",
    "readableDate": "2022-12-15",
    "screeningTime": "20:00",
    "actors": "Eduardo Pesce, Silvia D’Amico, Daphne Scoccia, Anna Bonaiuto e altri",
    "subtitle": [
      "Festival internazionale del cinema di Rotterdam",
      "In effetti il tema farebbe presumere un dramma: Il precariato spinge i giovani socialmente emarginati ad arrangiarsi e improvvisare e favorisce la loro disponibilità ad associarsi in macchinazioni criminali. Se però nella vicenda entra un cane, il racconto può risultare leggero e spiritoso, soprattutto se si tratta di un bulldog francese di razza pura con tanta voglia di libertà, amato e coccolato dalla padrona, un'abbiente signora anziana. "
    ],
    "bodycopy": [
      "Dogsitter: un guadagno facile, pensano Rana e Marti, mentre promettono alla ricca signora di curarsi del suo cane, Ugo. E anche se Ugo ha un caratterino tutto suo, i due ce la fanno a gestirlo, ma poi si prospetta a loro l'opportunità di intascare una bella somma. Il dottor Mopsi, un veterinario, attacca bottone con Rana in un parco perché è entusiasta di Ugo e lo vorrebbe utilizzare per il suo allevamento canino. Non ci vuole molto tempo, afferma il veterinario, per far incontrare Ugo con una sua cagna della stessa razza. I due quattrozampe si divertirebbero insieme e poi Ugo potrebbe essere riportato a casa. Alcune banconote di un certo peso aiutano i due giovani a superare il loro scetticismo iniziale e così... Ugo di colpo viene rapito. Ma anche il rapitore ha i suoi problemi con Ugo e con il suo committente che si cela dietro tutta la faccenda.Dogsitter: un guadagno facile, pensano Rana e Marti, mentre promettono alla ricca signora di curarsi del suo cane, Ugo. E anche se Ugo ha un caratterino tutto suo, i due ce la fanno a gestirlo, ma poi si prospetta a loro l'opportunità di intascare una bella somma. Il dottor Mopsi, un veterinario, attacca bottone con Rana in un parco perché è entusiasta di Ugo e lo vorrebbe utilizzare per il suo allevamento canino. Non ci vuole molto tempo, afferma il veterinario, per far incontrare Ugo con una sua cagna della stessa razza. I due quattrozampe si divertirebbero insieme e poi Ugo potrebbe essere riportato a casa. Alcune banconote di un certo peso aiutano i due giovani a superare il loro scetticismo iniziale e così... Ugo di colpo viene rapito. Ma anche il rapitore ha i suoi problemi con Ugo e con il suo committente che si cela dietro tutta la faccenda.",
      "\"Nel suo nuovo film Risuleo dimostra di nuovo la sua abilità nel creare situazioni strampalate e orripilanti. E mette in luce pure di nuovo gli angoli più inosservati della sua amata Roma. Come in tutte le commedie ben riuscite, il tono generale è inevitabilmente tragico\"."
    ],
    "image": "../il-colpo-del-cane-1024x576.jpg"
  },
  {
    "title": "IL COMPAGNO DON CAMILLO",
    "director": "Luigi Comencini",
    "country": "Italia",
    "releaseYear": 1965,
    "runtime": 109,
    "version": "OmU",
    "screeningDate": "19.07.2007",
    "readableDate": "2007-07-19",
    "screeningTime": "17:00",
    "actors": "Fernandel, Gino Cervi, Leda Gloria, Saro Urzì, Ganni Garko, Marco Tulli, Silla Bettini, Graziella Granata, Alessandro Gottlieb, Paul Müller",
    "subtitle": ["La famiglia Comencini"],
    "bodycopy": [
      "Prima Don Camillo, aderendo al partito comunista, costringe il rivale Peppone a portarlo con sé come funzionario a Mosca, dove crea un bel po' di guai. Quando Peppone però vuole accompagnarlo negli Stati Uniti come religioso, Don Camillo naturalmente pretende tutt'altro. È l'ultimo film completo della serie \"Don Camillo e Peppone\". Durante le riprese della sesta pellicola della serie, Fernandel muore. Questo è un tipico esempio dei tanti film popolari che caratterizzano l'opera cinematografica di Luigi Comencini."
    ],
    "image": "../il-compagno-don-camillo.jpg"
  },
  {
    "title": "Il Decameron",
    "director": "Pier Paolo Pasolini",
    "country": "Italia",
    "releaseYear": 1971,
    "runtime": 112,
    "version": "OmenU",
    "screeningDate": "01.03.2011",
    "readableDate": "2011-03-01",
    "screeningTime": "20:00",
    "actors": "Franco Citti, Ninetto Davoli, Jovan Jovanović, Angela Luce, Pier Paolo Pasolini, Giuseppe Zigaina, Vincenzo Amato, Guido Alberti, Giacomo Rizzo, Monique van Vooren, Elisabetta Genovese, Silvana Mangano",
    "subtitle": [""],
    "bodycopy": [
      "Persone che non hanno nulla a che fare con l'allegoria, si dice, questa volta hanno attratto l'interesse di Pasolini dirigendo la sua attenzione sull'originalità della cultura meridionale con il suo temperamento focoso permettendogli di sfogarsi in un istrionismo furioso."
    ],
    "image": "../Decameron.jpg"
  },
  {
    "title": "IL DECAMERON",
    "director": "Pier Paolo Pasolini",
    "country": "Italia",
    "releaseYear": 1971,
    "runtime": 116,
    "version": "OmU",
    "screeningDate": "05.10.2022",
    "readableDate": "2022-10-05",
    "screeningTime": "19:00",
    "actors": "Franco Citti, Ninetto Davoli, Jovan Jovanović, Angela Luce, Pier Paolo Pasolini, Giuseppe Zigaina, Vincenzo Amato, Guido Alberti, Giacomo Rizzo, Monique van Vooren, Elisabetta Genovese, Silvana Mangano",
    "subtitle": [
      "Una cooperazione tra la Società Italo-Tedesca e.V. - Dante Alighieri - Düsseldorf e il Club del Cinema Italiano ",
      "IL DECAMERON assieme a I RACCONTI DI CANTERBURY e IL FIORE DELLE MILLE E UNA NOTTE costituisce la Trilogia della vita. Pasolini ha riunito tre opere che, pur avendo una struttura simile, fanno parte del patrimonio letterario di diverse epoche e culture. Le ha scelte per raffigurare in modo spassoso le questioni esistenziali per la vita dell’individuo e per il suo ruolo nella società."
    ],
    "bodycopy": [
      "Ispirandosi all’omonima opera del Boccaccio, Pasolini presenta negli otto episodi del suo DECAMERON la sessualità e il piacere dei sensi in un tetro mondo arcaico. Una violenza insidiosa minaccia sempre e dovunque la vita delle persone semplici che esprimono la loro gioia di vivere nell’appagamento dei loro istinti sessuali.",
      "Diversamente dalla cornice narrativa di Boccaccio, basata su un gruppo di giovani sfuggiti alla peste, che passano il tempo raccontandosi novelle, Pasolini congiunge gli otto episodi attraverso la figura di un pittore allievo di Giotto.",
      "Introdurrà il film Donatella Chiancone-Schneider, storica dell’arte e del cinema, che ne sottolineerà gli aspetti artistici e storico-cinematografici nel contesto della filmografia pasoliniana e li confronterà con le opere letterarie e pittoriche che hanno ispirato il regista."
    ],
    "image": "../decamerone001.jpg"
  },
  {
    "title": "Il deserto dei Tartari",
    "director": "Valerio Zurlini",
    "country": "Italia/Francia",
    "releaseYear": 1976,
    "runtime": 150,
    "version": "OmitU",
    "screeningDate": "01.02.2006",
    "readableDate": "2006-02-01",
    "screeningTime": "19:30",
    "actors": "Giuliano Gemma, Giancarlo Maestri, Luciano Melani, Luigi Vannucchi, Alberto Lionello, Gino La Monica, Massimo Foschi, ROberto Villa, Gianna Piaz",
    "subtitle": [""],
    "bodycopy": [
      "Il film, basato sul famoso romanzo di Dino Buzzati, è stato girato nella città iraniana di Bam, che fu distrutta durante il terremoto del 2003, e accompagnato dalla straordinaria musica di Ennio Morricone. Un giovane ufficiale, trasferito in un forte ai margini del deserto, aspetta con impazienza di poter affrontare il nemico. L’attesa gli fa dimenticare la sua vita e così muore senza aver combattuto."
    ],
    "image": "../il-deserto-dei-tartari.jpg"
  },
  {
    "title": "IL DESERTO ROSSO",
    "director": "Michelangelo Antonioni",
    "country": "Italia/Francia",
    "releaseYear": 1964,
    "runtime": 117,
    "version": "OmU",
    "screeningDate": "05.05.2022",
    "readableDate": "2022-05-05",
    "screeningTime": "20:00",
    "actors": "Monica Vitti, Richard Harris, Carlo Chionetti, Xenia Valderi, Rita Renior, Lili Rheims, Aldo Grotti, Valerio Bartoleschi, Emanuela Pala Carboni e altri ",
    "subtitle": [
      "Una cooperazione tra il team responsabile della rassegna \"Neu restauriert (Nuovo restauro)\" e il \"Filmclub del Cinema Italiano\" (entrambi del Museo del Cinema di Düsseldorf).",
      "Giuliana, moglie dell’ingegnere Ugo, non si ritrova più in un ambiente che l’avanzante industrializzazione e tecnicizzazione ha drasticamente cambiato e cade in una profonda crisi. La location principale della pellicola è la centrale elettrica nella zona industriale della città di Ravenna.",
      " Il restauro è stato realizzato in 4K a partire dai negativi scena e colonna, messi a disposizione da RTI-Mediaset. La correzione del colore è stata supervisionata dal direttore della fotografia Luciano Tovoli nel laboratorio Fotocinema al fine di restituire al film la giusta colorimetria e il tono fotografico voluti all’epoca da Michelangelo Antonioni e dal cameraman Carlo Di Palma. Tutte le lavorazioni sono state eseguite presso il laboratorio Fotocinema di Roma, il suono è stato restaurato a cura di Federico Favina nel Centro Sperimentale di Cinematografia - Cineteca nazionale di Roma. "
    ],
    "bodycopy": [
      "La sofferenza di Giuliana viene raffigurata nel DESERTO ROSSO come un fenomeno fisico usando metafore visive e cromatiche nonché sequenze oniriche. Il regista Michelangelo Antonioni affermò di aver usato i colori per esprimere stati d’animo, analogamente all’effetto della musica, con l’intenzione di coinvolgere gli spettatori in prima persona. Il critico cinematografico Andrew Sarris osserva che “i tubi e le ringhiere dipinti di rosso… strutturano il senso di oppressione di Giuliana”. Antonioni nella pellicola prende così in esame una donna i cui disturbi psichici trasmettono pure un messaggio politico-sociale: l’ambiente industriale, il \"deserto rosso\", in cui Giuliana vive, è rappresentativo di una vita sentimentale squallida che opprime sempre di più le persone. "
    ],

    "image": "../desertorosso-04.jpg"
  },
  {
    "title": "Il Divo",
    "director": "Paolo Sorrentino",
    "country": "Italia/Francia",
    "releaseYear": 2008,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "19.08.2010",
    "readableDate": "2010-08-19",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Anna Bonaiuto, Giulio Bosetti, Flavio Bucci, Carlo Buccirosso, Paolo Graziosi, Giorgio Colangeli, Alberto Cracco",
    "subtitle": [""],
    "bodycopy": [
      "Un ritratto dell'indecifrabile politico italiano Giulio Andreotti, accusato di aver intrattenuto contatti con la mafia, ma assolto per mancanza di prove. Durante la sua vita politica attiva Andreotti ha saputo destreggiarsi con abilità nelle stanze del potere e \". Tra il 1972 e il 1992 è stato sette volte Presidente del Consiglio dei Ministri. Orientandosi allo stile dei drammi sui regnanti il film cerca di dare un quadro del personaggio tra uomo privato e uomo di potere non risparmiando allusioni al corrotto sistema politico italiano."
    ],
    "image": "../il-divo.jpg"
  },
  {
    "title": "Il figlio più piccolo",
    "director": "Pupi Avati",
    "country": "Italia",
    "releaseYear": 2010,
    "runtime": 104,
    "version": "OmitU",
    "screeningDate": "04.01.2012",
    "readableDate": "2012-01-04",
    "screeningTime": "20:00",
    "actors": "Christian De Sica, Laura Morante, Luca Zingaretti, Nicola Nocella, Marcello Maietta, Maurizio Battista, Massimo Bonetti, Pino Calabresi",
    "subtitle": [""],
    "bodycopy": [
      "Sull’orlo del fallimento l’imprenditore Baietti si ricorda di sua moglie che l’ha abbandonato con i due figli il giorno delle nozze 18 anni prima. Mettere al suo posto in azienda il figlio più giovane, un po’ scemo e ingenuo, potrebbe salvarlo. Una commedia che prende in giro la precarietà di certa imprenditoria italiana."
    ],
    "image": "../il-figlio-piu-piccolo.jpg"
  },
  {
    "title": "Il fiore delle Mille e una notte",
    "director": "Pier Paolo Pasolini",
    "country": "Italia",
    "releaseYear": 1974,
    "runtime": 129,
    "version": "OmU",
    "screeningDate": "05.03.2011",
    "readableDate": "2011-03-05",
    "screeningTime": "20:00",
    "actors": " Ninetto Davoli, Franco Citti, Franco Merli, Tessa Bouché, Ines Pellegrini, Margaret Clementi, Luigina Rocchi, Alberto Argentino, Francesco Paolo Governale, Salvatore Sapienza, Franca Sciutto",
    "subtitle": [""],
    "bodycopy": [
      "Dei tre film costituenti la \"trilogia della vita\" questo è quello meglio riuscito. Una serie di avventure erotiche culmina ripetutamente in nudità e sessualità che lasciano effettivamente intuire quello che poteva aver in mente Pasolini parlando di espressione di una \"gioia di vivere\"."
    ],
    "image": "../Il fiore.jpg"
  },
  {
    "title": "Il Gattopardo",
    "director": "Luchino Visconti",
    "country": "Italia/Francia",
    "releaseYear": 1963,
    "runtime": 180,
    "version": "OmU",
    "screeningDate": "08.03.2020",
    "readableDate": "2020-03-08",
    "screeningTime": "16:00",
    "actors": "Burt Lancaster, Claudia Cardinale, Alain Delon, Paolo Stoppa e altri",
    "subtitle": [
      " Non appena pubblicato nel 1958 “Il Gattopardo” di Tomasi di Lampedusa, che descrive i rivolgimenti sociali del XIX secolo in Italia, fu immediatamente considerato un capolavoro della letteratura mondiale. Quattro anni dopo, nel 1962, Luchino Visconti basandosi sul romanzo girò un film che si annovera tra i migliori della storia del cinema. Si tratta della storia del passaggio dal potere feudale a quello borghese descritta con gli strumenti del cinema, in immagini di straordinaria magnificenza e decadente splendore."
    ],
    "bodycopy": [
      "L’anziano principe di Salina, Don Fabrizio (Burt Lancaster) vede avanzare l’erosione del potere nobiliare e si rifiuta di collaborare con il nuovo Regno d’Italia. Allo stesso tempo promuove il matrimonio di suo nipote Tancredi (Alain Delon) con Angelica (Claudia Cardinale), la figlia del sindaco. Visconti mette in scena l’incontro della nuova e della vecchia società in una grande sala da ballo con una coreografia indimenticabile. ",
      " Con simpatia e spirto critico il film accompagna l’ultima fase della vita del principe. Leggendaria è anche oggi la frase, pronunciata dal giovane Tancredi, nel romanzo e nel film, per spiegare allo zio il cambiamento in corso: “Se vogliamo che tutto rimanga come è, bisogna che tutto cambi”.",
      " “Un toccante panorama storico e sociale di incredibile bellezza e precisione analitica” (Lexikon des Internationalen Films)"
    ],
    "image": "../Il gattopardo.jpg"
  },
  {
    "title": "Il Gattopardo",
    "director": "Luchino Visconti",
    "country": "Italia/Francia/Gran Bretagna",
    "releaseYear": 1963,
    "runtime": 180,
    "version": "OmitU",
    "screeningDate": "02.11.2005",
    "readableDate": "2005-11-02",
    "screeningTime": "17:30",
    "actors": "Burt Lancaster, Alain Delon, Claudia Cardinale, Paolo Stoppa, Rina Morelli, Lucilla MOrlacchi, Romolo Valli, Terence Hill, Pierre Clémenti, Serge Reggiani, Maurizio Merli, Giuliano Gemma, Ida Galli, Ottavia Piccolo",
    "subtitle": [""],
    "bodycopy": [
      "“Il Gattopardo”, l’unico libro scritto da Tomasi di Lampedusa, è entrato nella storia della letteratura. E Visconti ha creato un film che riproduce mirabilmente lo spirito del romanzo. In esso viene descritta la trasformazione sociale in Sicilia tra il 1860 eil 1862, nel periodo in cui Garibaldi si batte per un’Italia unita. La famiglia nobile dei Salina avverte il disagio di trovarsi tra la propria tradizione e le abitudini di una borghesia emergente."
    ],
    "image": "../il-gattopardo.gif"
  },
  {
    "title": "IL GENERALE DELLA ROVERE",
    "director": "Roberto Rossellini",
    "country": "Italia",
    "releaseYear": 1959,
    "runtime": 138,
    "version": "OmU",
    "screeningDate": "21.06.2007",
    "readableDate": "2007-06-21",
    "screeningTime": "19:00",
    "actors": "Vittorio de Sica, Hannes Messemer, Giovanna Ralli, Sandra Milo, Anne Vernon, Vittorio Capriol, Kurt Selge, Giuseppe Roselli, Nando Angelini, Herbert Fischer",
    "subtitle": [""],
    "bodycopy": [
      "Rossellini pone il suo protagonista maschile Bardone, un abile truffatore interpretato da Vittorio De Sica, davanti a un dilemma esistenziale. Quando nell'inverno 1943, durante l'occupazione tedesca di Genova, le SS lo costringono a spiare i suoi concittadini assumendo a tale scopo il ruolo del defunto generale Della Rovere, un simpatizzante della Resistenza, deve decidersi tra il tradimento e la morte. Il film sarà proiettato nella versione originale di Rossellini, che dura 6 minuti di più di quella proiettata normalmente al cinema."
    ],
    "image": "../il-generale-della-rovere.jpg"
  },
  {
    "title": "IL GENERALE DELLA ROVERE",
    "director": "Roberto Rossellini",
    "country": "Itaien",
    "releaseYear": 1959,
    "runtime": 138,
    "version": "OmU",
    "screeningDate": "17.04.2014",
    "readableDate": "2014-04-17",
    "screeningTime": "20:00",
    "actors": "Vittorio de Sica, Hannes Messemer, Giovanna Ralli, Sandra Milo, Anne Vernon, Vittorio Capriol, Kurt Selge, Giuseppe Roselli, Nando Angelini, Herbert Fischer",
    "subtitle": [
      "10° anniversario: i maggiori successi del Club del Cinema Italiano"
    ],
    "bodycopy": [
      "Una rara occasione di rivedere Totò, il famosissimo comico napoletano. Un gruppetto di ladruncoli si preparano a scassinare un'agenzia del Monte dei pegni. Come in ogni \"commedia all’italiana\", nel film succede un po' di tutto. Girato con protagonisti di grande spicco come Vittorio Gassmann, Marcello Mastroianni, Claudia Cardinale il film ha lasciato più volte segno nella storia del cinema."
    ],
    "image": "../il-generale-della-rovere.jpg"
  },
  {
    "title": "Il giorno della civetta",
    "director": "Damiano Damiani",
    "country": "Italia/Francia",
    "releaseYear": 1967,
    "runtime": 104,
    "version": "OmitU",
    "screeningDate": "03.03.2010",
    "readableDate": "2010-03-03",
    "screeningTime": "20:20",
    "actors": "Claudia Cardinale, Franco Nero, Lee J. Cobb, Nehemiah Persoff, Serge Reggiani, Tano Cimarosa, Ennio Balbo",
    "subtitle": ["Storia della mafia - Storie di mafia"],
    "bodycopy": [
      "Questo film girato sulla falsariga del romanzo di Leonardo Sciascia tratta l’impossibilità delle indagini giudiziarie di fronte all’omertà (il fenomeno, molto diffuso soprattutto in Sicilia, di tacere su quanto si è visto e sentito), alla diffidenza reciproca e a una “società di persone che si sorvegliano a vicenda di nascosto”."
    ],
    "image": "../il-giorno-della-civetta.jpg"
  },
  {
    "title": "IL GIOVEDÌ",
    "director": "Dino Risi",
    "country": "Italia",
    "releaseYear": 1963,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "19.02.2015",
    "readableDate": "2015-02-19",
    "screeningTime": "20:00",
    "actors": " Walter Chiari, Michéle Mercier, Roberto Ciccolini, Silvio Bagolini, Umberto D'Orsi, «Die Kessler-Zwillinge»",
    "subtitle": [""],
    "bodycopy": [
      "Dopo il divorzio per anni Dino non ha rivisto il figlio e perciò al primo incontro vuole fare una buona impressione su di lui. Gli vuol far credere che sta conducendo una vita agiata, ma il figlio lentamente si accorge dell’inganno."
    ],
    "image": "../il-giovedi-1.png"
  },
  {
    "title": "IL GIOVEDÌ",
    "director": "Dino Risi",
    "country": "Italia",
    "releaseYear": 1963,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "16.05.2013",
    "readableDate": "2013-05-16",
    "screeningTime": "20:00",
    "actors": " Walter Chiari, Michéle Mercier, Roberto Ciccolini, Silvio Bagolini, Umberto D'Orsi, «Die Kessler-Zwillinge»",
    "subtitle": [""],
    "bodycopy": [
      "Dopo il divorzio per anni Dino non ha rivisto il figlio e perciò al primo incontro vuole fare una buona impressione su di lui. Gli vuol far credere che sta conducendo una vita agiata, ma il figlio lentamente si accorge dell’inganno."
    ],
    "image": "../il-giovedi-1.jpg"
  },
  {
    "title": "IL GRIDO",
    "director": "Michelangelo Antonioni",
    "country": "Italia/USA",
    "releaseYear": 1957,
    "runtime": 111,
    "version": "OmU",
    "screeningDate": "21.05.2015",
    "readableDate": "2015-05-21",
    "screeningTime": "20:00",
    "actors": "Steve Cochran, Alida Valli, Dorian Gray, Pina Boldrini, Betsy Blair, Lynn Shaw, Gabriella Pallotta, Mirna Girardi",
    "subtitle": [""],
    "bodycopy": [
      "Un capolavoro disconosciuto di Michelangelo Antonioni. Un operaio, piantato dalla sua donna, girovaga desolato con la figlioletta per la pianura padana. Gli incontri con altre donne accentuano la sua depressione. ll film segue il protagonista sulla sua strada verso l'abisso delineando parallelamente il ritratto melanconico del paesaggio."
    ],
    "image": "../il-grido.jpg"
  },
  {
    "title": "Il ladro di bambini",
    "director": "Gianni Amelio",
    "country": "Italia/Francia/Svizzera",
    "releaseYear": 1992,
    "runtime": 122,
    "version": "OmU",
    "screeningDate": "19.08.2004",
    "readableDate": "2004-08-19",
    "screeningTime": "19:30",
    "actors": "Enrico Lo Verso, Valentina Scalici, Giuseppe Ieracitano, Florence Darel, Marina Golovine, Fabio Alessandrini, Agostino Zumbo, Vitalba Andrea",
    "subtitle": [""],
    "bodycopy": [
      "Dopo l'arresto della madre, i figli Rosetta e Luciano vengono affidati al carabiniere Antonio perché li porti da Milano a Caltanissetta. Durante il lungo viaggio l'iniziale diffidenza si trasforma in fiducia reciproca. Il film è anche un ritratto sensibile dell'Italia degli anni 90."
    ],
    "image": "../ladro-di-bambini.jpg"
  },
  {
    "title": "Il mestiere delle armi",
    "director": "Ermanno Olmi",
    "country": "Italia/Francia/Germania",
    "releaseYear": 2001,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "06.12.2003",
    "readableDate": "2003-12-06",
    "screeningTime": "19:30",
    "actors": "Hristo Jivkov, Sergio Grammatico, Fabio Giubbani, Sandra Ceccarelli, Dessy Tenekedjieva, Dimitar Ratchkov",
    "subtitle": [""],
    "bodycopy": [
      "Inverno 1526. L’Italia è minacciata da un esercito imponente. L’imperatore Carlo V ha mandato i suoi lanzichenecchi sotto il comando del Generale Georg von Frundsberg in Italia allo scopo di attaccare lo Stato della Chiesa, alleato della Francia. Le truppe papali al comando del Generale della Rovere si oppongono a quelle imperiali, primo fra tutti l’abile capitano delle temute Bande Nere: Giovanni de’ Medici.",
      "Il film inizia con l’esposizione del suo feretro e poi riprende dall’inizio la storia, nella quale l’eroismo si contrappone alle moderne tecnologie belliche. Olmi non ha semplicemente girato un film storico, ma ha messo in scena una serie di immagini arcaiche, silenziose, in parte meditative, in cui prevale l’aspetto umano. Il film è stato premiato con 9  “Donatelli”."
    ],
    "image": "../2003-12-medici-kriegerdepdf-adobeacrobatstandard2017.jpg"
  },
  {
    "title": "IL PALIO",
    "director": "John Appel",
    "country": "Paesi Bassi",
    "releaseYear": 2004,
    "runtime": 88,
    "version": "OmU",
    "screeningDate": "16.07.2009",
    "readableDate": "2009-07-16",
    "screeningTime": "20:00",
    "actors": null,
    "subtitle": ["\"Ritratti italiani\" - Documentari su temi italiani"],
    "bodycopy": [
      "Rappresenta il momento culminante della vita a Siena: “Il Palio”, la famosa corsa dei cavalli nel centro storico della città. Dieci delle sue sedici contrade prendono parte alla competizione. Oltre alla vittoria, quello che conta è soprattutto l’onore e la fama. Il film segue i preparativi della Contrada della Civetta e riprende da vicino le aspettative e i sentimenti dei partecipanti. Privo di commenti, questo divertente documentario mostra un aspetto particolare della vita italiana in cui si mescolano straordinariamente individualità, tradizione, affarismo e religione."
    ],
    "image": "../il-palio.jpg"
  },
  {
    "title": "IL PARADISO DEL PAVONE",
    "director": "Laura Bispuri",
    "country": "Italia/Germania",
    "releaseYear": 2021,
    "runtime": 88,
    "version": "OmU",
    "screeningDate": "17.11.2022",
    "readableDate": "2022-11-17",
    "screeningTime": "20:00",
    "actors": "Dominique Sanda, Alba Rohrwacher, Maya Sansa, Carlo Cerciello, Fabrizio Ferracane Manfredi e altri",
    "subtitle": [
      "TRE PIANI, il film di Nanni Moretti, mostrato in ottobre 2022, e quello di Laura Bispuri, IL PARADISO DEL PAVONE, pur essendo così diversi trattano in effetti lo stesso tema. Le persone e i rapporti con se stesse, con i loro partner e il loro ambiente. Mentre Moretti sceglie una narrazione cinematografica tradizionale, nella pellicola di Bispuri la situazione viene descritta in modo enigmatico e metaforico nonostante la rappresentazione realistica."
    ],
    "bodycopy": [
      "L’irritazione dello spettatore inizia con un pavone che viene portato ad una festa come un qualsiasi animale domestico. A poco a poco arrivano gli ospiti, ma nessuno sembra stupirsi della presenza del pavone. L’uccello a sua volta si innamora di un colombo bianco dipinto, cosa che lo conduce ad un tragico destino. Attraverso la frase pronunciata da uno degli ospiti alla fine del film, e cioè “Noi tutti avremmo potuto essere il pavone”, si deduce quello che è accaduto: ad un presunto attimo di profonda felicità segue un crollo più o meno grave.",
      "I protagonisti, ospiti della madre autoritaria, vogliono sottolineare il loro successo, sia personale che professionale. Amicizia e solidarietà vengono dichiarate, ma la formulazione e la voce rivelano già la loro inconsistenza. Così si spezza quella vaga apparenza di armonia. Le coppie difendono la loro vita a due, però si attaccano a vicenda dando luogo a inaspettate alleanze di breve durata. Sembra che stiano nascendo nuove costellazioni, che tuttavia si rivelano fragili e alla fine predominano le nevrosi. Nel bel mezzo c’è una ragazzina, l’unica che mostra compassione per il pavone."
    ],
    "image": "../261268.jpg"
  },
  {
    "title": "Il partigiano Johnny",
    "director": "Guido Chiesa",
    "country": "Italia",
    "releaseYear": 2000,
    "runtime": 127,
    "version": "OmitU",
    "screeningDate": "07.09.2011",
    "readableDate": "2011-09-07",
    "screeningTime": "20:00",
    "actors": "Stefano Dionisi, Fabrizio Gifuni, Andrea Prodan, Alberto Gimignani, Giuseppe Cederna, Umberto Orsini, Chiara Muti, Lina Bernardi, Tony Bertorelli, Claudio Amendola, Barbara Lerici",
    "subtitle": ["150 anni dall'unità d'Italia"],
    "bodycopy": [
      "Un’impressionante storia della lotta partigiana in Italia. Johnny, studente universitariodi letteratura inglese, diserta dall’esercito e, dopo il suo ritorno nel paese d’origine, si ritira in una casa in collina per studiare. Dopo la morte di un amico decide di unirsi ai partigiani e combattere in prima linea. Senza convinzione politica viene accolto da formazioni di vario orientamento, ma rimane in fondo un individualista."
    ],
    "image": "../il-partigiano-jonny.jpg"
  },
  {
    "title": "Il più bel giorno della mia vita",
    "director": "Cristina Comencini",
    "country": "Italia/Gran Bretagna",
    "releaseYear": 2002,
    "runtime": 102,
    "version": "OmU",
    "screeningDate": "19.01.2005",
    "readableDate": "2005-01-19",
    "screeningTime": "19:30",
    "actors": "Virna Lisi, Margherita Buy, Sandra Ceccarelli, Luigi Lo Cascio, Marco Baliani, Marco Quaglia",
    "subtitle": [""],
    "bodycopy": [
      "Nonna Irene vive in una casa piena di ricordi e le riunioni familiari con i suoi tre figli, Sara, Rita e Claudio sono il contenuto della sua vita. Non vede però che la loro vita non si svolge in modo così armonioso come lei si immagina. Questa immagine lacunosa la registra con la massima precisione la bambina di Rita, Chiara. Con la videocamera ricevuta in regalo per la prima comunione, segue le tracce delle (dis)avventure familiari, dei disorientamenti, dei segreti e dei desideri."
    ],
    "image": "../il-piu-bel-girno-della-mia-vita-1.png"
  },
  {
    "title": "IL PIÙ BEL GIORNO DELLA MIA VITA",
    "director": "Cristina Comencini",
    "country": "Italia/Gran Bretagna",
    "releaseYear": 2002,
    "runtime": 102,
    "version": "OmU",
    "screeningDate": "16.08.2007",
    "readableDate": "2006-08-16",
    "screeningTime": "20:00",
    "actors": "Virna Lisi, Margherita Buy, Sandra Ceccarelli, Luigi Lo Cascio, Marco Baliani, Marco Quaglia",
    "subtitle": ["La famiglia Comencini"],
    "bodycopy": [
      "Nonna Irene vive in una casa piena di ricordi e le riunioni familiaricon i suoi tre figli, Sara, Rita e Claudio sono il contenuto della sua vita. Non vede però che la loro vita non si svolge in modo così armonioso come lei si immagina. Questa immagine lacunosa la registra con la massima precisione la bambina di Rita, Chiara, con la videocamera che ha ricevuto in regalo per la prima comunione. In parte anche attraverso gli occhi della bambina, Cristina Comencini mostra la sua sensibilità analitica per i rapporti familiari e sociali."
    ],
    "image": "../il-piu-bel-girno-della-mia-vita-1.png"
  },
  {
    "title": "Il porcile",
    "director": "Pier Paolo Pasolini",
    "country": "Italia/Francia",
    "releaseYear": 1969,
    "runtime": 99,
    "version": "OmU",
    "screeningDate": "23.02.2011",
    "readableDate": "2011-02-23",
    "screeningTime": "20:00",
    "actors": "Pierre Clémenti, Jean-Pierre Léaud, Alberto Lionello, Ugo Tognazzi, Marco Ferreri, Anne Wiazemsk<, Ninetto Davoli",
    "subtitle": [""],
    "bodycopy": [
      "Un attacco alla nostra società dei consumi con similitudini inquietanti. Pasolini sviluppa una comicità grottesca, per lui nuova, così velenosa che blocca la risata."
    ],
    "image": "../IL porcile.jpg"
  },
  {
    "title": "Il postino",
    "director": "Michael Radford",
    "country": "Italia",
    "releaseYear": 1994,
    "runtime": 109,
    "version": "OmU",
    "screeningDate": "28.06.2009",
    "readableDate": "2009-06-28",
    "screeningTime": "20:00",
    "actors": "Philippe Noiret, Massimo Troisi, Maria Grazia Cucinotta, Renato Scarpa, Linda Moretti, Mariano Rigillo, Anna Bonaiuti, Simona Caparrini",
    "subtitle": [
      "Cinque film di successo del quinquennio del“Club del cinema italiano” nella sala Black Box"
    ],
    "bodycopy": [
      "La storia dell'amicizia che si instaura poco a poco tra il poeta cileno esiliato in Italia, Pablo Neruda, e il suo postino. Descritto con grande sensibilità e con un'eccellente fotografia, il film è un piacere per i sensi e commuove per la sua umanità."
    ],
    "image": "../il-postino.jpg"
  },
  {
    "title": "IL POSTINO",
    "director": "Michael Radford",
    "country": "Italia",
    "releaseYear": 1994,
    "runtime": 109,
    "version": "OmU",
    "screeningDate": "19.05.2007",
    "readableDate": "2007-05-19",
    "screeningTime": "19:00",
    "actors": "Philippe Noiret, Massimo Troisi, Maria Grazia Cucinotta, Renato Scarpa, Linda Moretti, Mariano Rigillo, Anna Bonaiuti, Simona Caparrini",
    "subtitle": [""],
    "bodycopy": [
      "La storia dell'amicizia che si instaura poco a poco tra il poeta cileno Pablo Neruda, esiliato in Italia, e il suo postino ha entusiasmato subito il pubblico ed è il film maggiormente richiesto dagli spettatori del Club del cinema italiano. Descritto con grande sensibilità e con un'eccellente fotografia, il film è un vero piacere per i sensi e commuove per la sua umanità. In effetti, alla fin fine la poesia fa parte della vita di ogni persona. Basta imparare a scoprirla e farla vibrare."
    ],
    "image": "../il-postino.jpg"
  },
  {
    "title": "IL ROSSO E IL BLU",
    "director": "Giuseppe Piccioni",
    "country": "Italia",
    "releaseYear": "il_rosso_e_il_blu.jpg",
    "runtime": 98,
    "version": "OmU",
    "screeningDate": "16.06.2016",
    "readableDate": "2016-06-16",
    "screeningTime": "",
    "actors": "20:00",
    "subtitle": [""],
    "bodycopy": [
      "La più recente commedia di Giuseppe Piccioni (“Fuori dal mondo”, “Luce dei miei occhi”) prende in giro il mondo della scuola: un cosmo di diversi tipi di insegnanti a confronto con i secchioni, i ribelli e tanta pubertà."
    ],
    "image": "../il-rosso-e-il-blu.jpg"
  },
  {
    "title": "IL TRADITORE",
    "director": "Marco Bellocchio",
    "country": "Italia/Francia/Germania/Brasilien",
    "releaseYear": 2019,
    "runtime": 153,
    "version": "OmU",
    "screeningDate": "20.01.2022",
    "readableDate": "2022-01-20",
    "screeningTime": "20:00",
    "actors": "Pierfrancesco Favino, Maria Fernanda Candido, Nicola Calì, Luigi Lo Cascio e altri",
    "subtitle": [
      "Il film racconta il momento di svolta nella storia della “classica mafia siciliana”. Negli anni Ottanta la lotta per il potere scatenatesi tra i clan mafiosi contrassegna le vicende quotidiane di Cosa Nostra. Il giudice Falcone cerca di tagliare il groviglio criminale. Tommaso Buscetta, sempre più isolato in mezzo alla guerra di Cosa Nostra, dopo il suo arresto incontra Falcone, prende fiducia, diventa il primo pentito della mafia e apre la strada al maxiprocesso. "
    ],
    "bodycopy": [
      "Bellocchio, ormai anziano, riprende con modernità la tradizione del film politico italiano e raffigura non solo in modo impressionante la struttura di Cosa Nostra, lo sviluppo storico verso il maxiprocesso e il suo decorso, ma tematizza pure l'effetto vincolante dell'associazione a un clan, i problemi psichici e morali del tradimento nonché il dissidio tra la convinzione di fare la cosa giusta, ma anche di mettere così in pericolo la propria famiglia. Sul film pesa costantemente una diffusa diffidenza di tutti verso tutti, inevitabile in tale ambiente.",
      "Bellocchio riesce a mostrare un cosmo differenziato pur mantenendo una stretta vicinanza al protagonista. Allo stesso tempo mette in luce le strutture della criminalità organizzata, di cui l'Italia ha sofferto per decenni e in parte soffre ancora."
    ],
    "image": "../il-traditore-3.jpg"
  },
  {
    "title": "Il Vangelo secondo Matteo",
    "director": "Pier Paolo Pasolini",
    "country": "Italia/Francia",
    "releaseYear": 1964,
    "runtime": 131,
    "version": "OmU",
    "screeningDate": "18.02.2011",
    "readableDate": "2011-02-18",
    "screeningTime": "20:00",
    "actors": "Enrique Irazoqui, Margherita Caruso, Susanna Pasolini, Marcello Morante, Rossana di Rocco, Mario Socrate, Alessandro Chierici",
    "subtitle": [""],
    "bodycopy": [
      "Pasolini gira il Vangelo secondo Matteo come se fosse un film neorealista sul Mezzogiorno. Non cela né il contenuto social-rivoluzionario né quello religioso del Vangelo."
    ],
    "image": "../Il Vangelo.jpg"
  },
  {
    "title": "Il Vedovo",
    "director": "Dino Rii",
    "country": "Italia",
    "releaseYear": 1959,
    "runtime": 86,
    "version": "OmitU",
    "screeningDate": "05.11.2008",
    "readableDate": "2008-11-05",
    "screeningTime": "18:00",
    "actors": "Alberto Sordi, Franca Valeri, Livio Lorenzon, Leonora Ruffo, Nando Bruno, Nanda Primavera, Mario Passante, Enzo Petito",
    "subtitle": ["In memoria di Dino Risi"],
    "bodycopy": [
      "L’opinione che Alberto Nardi ha di se stesso non coincide con il suo successo negli affari. Infatti si augura la morte della sua ricca consorte che lo tratta come un pagliaccio. Le sue speranze aumentano quando sembra che sia deceduta in un incidente ferroviario. In verità non è mai salita su quel treno. Quando lo viene a sapere, comincia a tessere trame diaboliche ...Dini Risi mostra un uomo distrutto e non ha remore a servirsi di un umorismo macabro. Un quadro della \"moralità italiana\" degli anni 50."
    ],
    "image": "../il-vedovo.jpg"
  },
  {
    "title": "Il Vedovo",
    "director": "Dino Rii",
    "country": "Italia",
    "releaseYear": 1959,
    "runtime": 86,
    "version": "OmitU",
    "screeningDate": "04.08.2010",
    "readableDate": "2010-08-05",
    "screeningTime": "28:00",
    "actors": "Alberto Sordi, Franca Valeri, Livio Lorenzon, Leonora Ruffo, Nando Bruno, Nanda Primavera, Mario Passante, Enzo Petito",
    "subtitle": ["Rassegna: Dino Risi"],
    "bodycopy": [
      "Quando gli affari vanno male, si può tentare magari di rimediare usando tutte le arti maschili della seduzione e provare una nuova “denominazione sociale”: vedovo. Ma chi ha difficoltà nel mondo degli affari, dovrà affrontare sicuramente dei problemi anche con questa nuova “società”."
    ],
    "image": "../il-vedovo2.jpg"
  },
  {
    "title": "Il vento di sera",
    "director": "Andrea Adriatico",
    "country": "Italia",
    "releaseYear": 2004,
    "runtime": 92,
    "version": "OmU",
    "screeningDate": "15.05.2006",
    "readableDate": "2006-05-15",
    "screeningTime": "20:30",
    "actors": "Corso Salani, Francesca Mazza, Luca Levi, Paolo Porto, Giovanni Lindo Ferretti, Ivano Marescotti, Sergio Romano, Alessandro Fullin, Fabio Valletta",
    "subtitle": [""],
    "bodycopy": [
      "Luca viene ucciso perché è capitato per caso in mezzo a un attentato politico. La sua morte improvvisa provoca uno shock all'amico Paolo che disperato girovaga tutta la notte per Bologna. I suoi incontri casuali creano un piccolo microcosmo italiano in cui vengono scandagliati i rapporti tra vita e morte, tra amore e desiderio. \"Gli esseri umani sono appesi a un filo sottile come le foglie che possono essere staccate da un soffio di vento\" (catalogo della Berlinale)."
    ],
    "image": "../il-vento-di-sera.jpg"
  },
  {
    "title": "IL VENTO FA IL SUO GIRO",
    "director": "Giorgio Diritti",
    "country": "Italia",
    "releaseYear": 2006,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "15.10.2009",
    "readableDate": "2009-10-15",
    "screeningTime": "20:00",
    "actors": "hierry Toscan, Alessandra Agosti, Dario Anghilante, Giovanni Foresti",
    "subtitle": [""],
    "bodycopy": [
      "Il successo di questo film, precedentemente più volte rifiutato dall’industria cinematografica, è dovuto ai festival, a coraggiosi gestori di cinematografi e all'entusiasmo del pubblico italiano. Girato con pochi mezzi, ma con una fotografia eccellente, il film racconta le vicende di un uomo che ha tagliato con la sua vita precedente per dedicarsi alla pastorizia in un arcaico villaggio, che vede nel turismo. la sua salvezza Gli abitanti accolgono inizialmente l’estraneo e il suo progetto per un caseificio con entusiasmo, ma poi insorgono dei conflitti e alla fine il mondo moderno ha il sopravvento."
    ],
    "image": "../Il vento fa il suo giro.jpg"
  },
  {
    "title": "Il viaggio di Capitan Fracassa",
    "director": "Ettore Scola",
    "country": "Italia",
    "releaseYear": 1990,
    "runtime": 132,
    "version": "OmitU",
    "screeningDate": "07.05.2008",
    "readableDate": "2008-05-07",
    "screeningTime": "19:00",
    "actors": "Vincent Perez, Emmanuelle Béart, Massimo Troisi, Ornella Muti, Lauretta Masiero, Toni Ucci, Massimo Wertmüller",
    "subtitle": ["Rassegna di Ettore Scola"],
    "bodycopy": [
      "In pochi film Scola ha preso alla lettera questo motto che è il filo conduttore della sua creatività di regista. Nel XVII secolo una compagnia teatrale prende con sé un giovane nobile che vive l'incontro con il teatro come una liberazione. Nel ruolo di Capitan Fracassa conduce al successo la troupe e il suo pezzo teatrale. Si racconta la teoria del teatro oppure una filosofia di vita indossando il costume di Arlecchino? Scola lascia la decisione allo spettatore."
    ],
    "image": "../il-viaggio-di-capitan-fracassa.jpg"
  },
  {
    "title": "IN GRAZIA DI DIO",
    "director": "Edoardo Winspeare",
    "country": "Italia",
    "releaseYear": 2014,
    "runtime": 129,
    "version": "OmU",
    "screeningDate": "17.11.2016",
    "readableDate": "2016-11-17",
    "screeningTime": "20:00",
    "actors": "Celeste Casciaro, Laura Licchetta, Anna Boccadamo, Gustavo Caputo, Barbara de Matteis, Amerigo Russo, Angelico Ferrarese, Antonio Carluccio",
    "subtitle": [""],
    "bodycopy": [
      "Per la famiglia di Adele la chiusura della propria fabbrica significa cadere nella trappola dei debiti. Con la sorella e la figlia si trasferisce nella capanna di campagna della madre che coltiva lì un piccolo appezzamento di terreno. La realizzazione dei sogni e desideri delle tre donne si allontana sempre di più, dovendo ricominciare a vivere della propria terra e sopravvivere barattando."
    ],
    "image": "../in-grazia-di-dio.jpg"
  },
  {
    "title": "In nome del popolo italiano",
    "director": "Dino Risi",
    "country": "Italia",
    "releaseYear": 1971,
    "runtime": 103,
    "version": "OmitU",
    "screeningDate": "01.12.2007",
    "readableDate": "2007-12-01",
    "screeningTime": "19:00",
    "actors": "Ugo Tognazzi, Vittorio Gassman, Ely Galleani, Yvonnw Furneaux, Pietro Tondi, Simonetta Stefanelli, Franco Angrisano, Rebnato Baldini, Pietro Nuti, Checco Durante",
    "subtitle": ["In memoria di Dino Risi"],
    "bodycopy": [
      "Un giudice durante le sue indagini sulla strana morte di una ragazza si imbatte in un imprenditore senza scrupoli e senza un alibi per l’ora del delitto. Dibattuto tra i dubbi sulla responsabilità dell’uomo trova degl iindizi per convincere se stesso e gli altri della sua colpevolezza. Alla fine trova del materiale che lo scagiona e deve arrivare a una decisione. Una commedia, prolissa in alcuni punti, che affronta però con intensità il tema del conflitto morale dell’individuo tra la propria responsabilità morale e il suo dovere professionale di trovare la verità."
    ],
    "image": "../in-nome-del-popolo-italiano.jpg"
  },
  {
    "title": "INCOMPRESA",
    "director": "Asia Argento",
    "country": "Italia/Francia",
    "releaseYear": 2014,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "16.07.2015",
    "readableDate": "2015-07-16",
    "screeningTime": "20:00",
    "actors": "Giulia Salerno, Charlotte Gainsbourg, Gabriel Garko, Carolina Poccioni, Anna Lou Castoldi, Alice Pea, Andrea Pittorino, Riccardo Russo, Sofia Patron, Max Gazzè, Justin Pearson",
    "subtitle": [""],
    "bodycopy": [
      "Storia di Aria, una ragazzina disadattata di nove anni, di cui i genitori, presi dalle loro liti, non si curano, mentre viziano la sorella maggiore. Anche a scuola non trova comprensione. Così si mette a girovagare per le strade di Roma e fa amicizia con un gatto randagio."
    ],
    "image": "../incompresa.jpg"
  },
  {
    "title": "INDAGINE SU UN CITTTADINO AL DI SOPRA DI OGNI SOSPETTO",
    "director": "Elio Petri",
    "country": "Italia",
    "releaseYear": 1970,
    "runtime": 110,
    "version": "OmitU",
    "screeningDate": "07.04.2010",
    "readableDate": "2010-04-07",
    "screeningTime": "20:00",
    "actors": "Gian Maria Volonté, Florinda Bolkan, Gianni Santuccio, Sergio Tramonti, Massimo Foschi, Salvo Randone, Orazio Orlando, Arturo Dominici, Aldo Rendine, Aleka Paizi",
    "subtitle": [""],
    "bodycopy": [
      "Il giorno della sua promozione all’ufficio politico, l’ispettore capo della Squadra Omicidi di Roma (Gian Maria Volontè) uccide, in un gioco erotico, l’amante Augusta Terzi (Florinda Bolkan) e si prodiga a seminare ovunque le tracce della propria colpevolezza. Vuole dimostrare a se stesso e al mondo che con il suo potere è al di sopra di ogni sospetto e di ogni possibile incriminazione."
    ],
    "image": "../indagine.jpg"
  },
  {
    "title": "Intervista",
    "director": "Federico Fellini",
    "country": "Italia",
    "releaseYear": 1986,
    "runtime": 107,
    "version": "OmitU",
    "screeningDate": "06.01.2010",
    "readableDate": "2010-01-06",
    "screeningTime": "20:00",
    "actors": "Anika Ekberg, Marcello Mastroianni, Federico Fellini, Sergio Rubini",
    "subtitle": ["Federico Fellini: 90 anni (20.01.1920-31.10.1993)"],
    "bodycopy": [
      "Fellini e la sua Cinecittà: un’intervista rilasciata a un gruppo di giornalisti giapponesi è l’occasione per rievocare i suoi quarant’anni di attività cinematografica. Inizia con gli anni ‘40, quando, giovane ed inesperto, arriva a Cinecittà e prosegue attraverso attori, fotografi, tecnici, costumisti, tutti i personaggi che danno vita a quella affascinante e meravigliosa fabbrica dei sogni che è il cinema."
    ],
    "image": "../invervista.jpg"
  },
  {
    "title": "IO E LEI",
    "director": "Maria Sole Tognazzi",
    "country": "Italia",
    "releaseYear": 2015,
    "runtime": 102,
    "version": "OmU",
    "screeningDate": "16.03.2017",
    "readableDate": "2017-03-16",
    "screeningTime": "20:00",
    "actors": "Margherita Buy, Sabrina Ferilli, Fausto Maria Sciarappa, Alessia Barela, Domenico Diele, Ennio Fantastichini, Massimiliano Gallo, Anna Bellato, Antonio Zavatteri, Emanuel Caserio",
    "subtitle": [
      "A prima vista si racconta la storia di un amore lesbico tra due donne mature. Però il film tratta anche il tema della solidità dell’amore, la questione dell’identità personale, della sincerità e, non per ultimo, della crisi di mezza età.."
    ],
    "bodycopy": [
      "Sebbene Federica e Marina vivano già da anni insieme, la prima non riesce a vivere apertamente questo rapporto. A suo tempo aveva abbandonato il marito per mettersi assieme a Marina e ha paura della reazione dell’ambiente, mentre Marina professa senza remore la sua passione. Marina crede fermamente in questa relazione, invece Federica va in crisi. Si delinea una svolta.",
      "Un film sensibile e toccante interpretato da due famose attrici: Margherita Buy nel ruolo di Federica e Sabrina Ferilli nel ruolo di Marina."
    ],
    "image": "../io-e-lei.jpg"
  },
  {
    "title": "IO E TE",
    "director": "Bernardo Bertolucci",
    "country": "Italia",
    "releaseYear": 2012,
    "runtime": 97,
    "version": "OmU",
    "screeningDate": "18.12.2014",
    "readableDate": "2014-12-18",
    "screeningTime": "20:00",
    "actors": " Jacopo Olmo Antinori, Tea Falco, Sonia Bergamasco, Veronica Lazar, Tommaso Ragno, Pippo Delbono, Carlo Cozzani, Alessandra Vanzi",
    "subtitle": [""],
    "bodycopy": [
      "Il più recente dramma di Bertolucci, quasi un pezzo da camera, sul rapporto fra due giovani. Invece che prendere parte a una gita scolastica, Lorenzo si ritira di nascosto in cantina. Ma neanche lì può stare in pace. Infatti la sorellastra, che vive già per conto suo, sta cercando un rifugio e pretende improvvisamente il suo aiuto."
    ],
    "image": "../io-e-te.jpg"
  },
  {
    "title": "Io non ho paura",
    "director": "Gabriele Salvatores",
    "country": "Italia/Spanien/Gran Bretagna",
    "releaseYear": 2003,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "18.03.2004",
    "readableDate": "2004-03-18",
    "screeningTime": "19:30",
    "actors": "Giuseppe Cristiano; Mattia Di Pierro; Aitana Sánchez-Gijón, Dino Abbrescia",
    "subtitle": [""],
    "bodycopy": [
      "Di grano piegate dal vento, un paesaggio del Meridione, senza alberi, sotto un sole bruciante. Ma questa superficie apparentemente pacifica nasconde sotto di sé un segreto.",
      "Quando l'undicenne Michele scopre una buca profonda in mezzo ai campi di grano, non viene solamente a conoscenza del segreto, ma sotto gli occhi dei bambini va in subbuglio anche il mondo degli adulti, fino allora apparentemente intatto.",
      "Michele, superato il primo sgomento, trova un nuovo amico, impara ciò che significa responsabilità e, opponendosi al padre, conquista quell'indipendenza che lo fa maturare.",
      "\"Io non ho paura\" viene raccontato sempre dal punto di vista dei bambini, la cinepresa rimane con loro, all'altezza dei loro occhi. Tuttavia non si tratta di un film per bambini, ma di una parabola poetica su quanto c’è di represso e quanto affiora alla luce e su un paesaggio che plasma la sua gente.",
      "Il produttore del film, Riccardo Tozzi, afferma che l'intenzione non era quella di girare un tipico film italiano, né di raccontare una storia realistica, psicologica, geograficamente localizzabile. All'inizio invece c'era la visione di un film internazionale: epico, simbolico e “grande visualmente”."
    ],
    "image": "../io-non-ho-paura.png"
  },
  {
    "title": "Io non ho paura",
    "director": "Gabriele Salvatores",
    "country": "Italia/Spanien/Gran Bretagna",
    "releaseYear": 2003,
    "runtime": 109,
    "version": "OmU",
    "screeningDate": "15.03.2007",
    "readableDate": "2007-03-15",
    "screeningTime": "19:00",
    "actors": "Giuseppe Cristiano; Mattia Di Pierro; Aitana Sánchez-Gijón, Dino Abbrescia",
    "subtitle": [""],
    "bodycopy": [
      "Nel marzo 2004 purtroppo nella sala non c'era posto sufficiente pertutti gli spettatori. Perciò ripetiamo il film nell'ambito di una piccola retrospettiva di Salvatores. Il regista racconta qui la storia di un ragazzo di dieci anni che giocando si ritrova improvvisamente in una situazione pericolosa: per caso si imbatte in un crimine di cui a poco a poco scopre le trame che lo conducono addirittura alla sua famiglia. Girato in base a un giallo di Niccolò Ammaniti, il film racconta una fase della crescita dei piccoli protagonisti, ma è anche un ritratto dell'Italia Meridionale e della sua specifica criminalità."
    ],
    "image": "../io-non-ho-paura2.jpg"
  },
  {
    "title": "IO SO CHE TU SAI CHE IO SO",
    "director": "Alberto Sordi",
    "country": "Italia",
    "releaseYear": 1982,
    "runtime": 112,
    "version": "OmU",
    "screeningDate": "29.06.2013",
    "readableDate": "2013-06-29",
    "screeningTime": "20:00",
    "actors": "Alberto Sordi, Monica Vitti, Micaela Pignatelli, Salvatore Jacono, Isabella De Bernardi, Giuseppe Mannajuolo, Ivana Monti",
    "subtitle": [""],
    "bodycopy": [
      "A causa di uno scambio di persona, Livia, la moglie di Fabio Bonetti, viene pedinata per tre settimane da un investigatore privato. Il film girato durante il pedinamento non interessa per nulla il bancario che ha la moglie più onesta del mondo. Il fatto che Livia però cerchi di far sparire il film, risveglia la curiosità di Fabio. Pezzo per pezzo se lo guarda e deve riconoscere che anche la donna più onesta del mondo ha i suoi segreti...",
      "Il film è stato scelto in omaggio al decimo anniversario della morte dell'attore e regista Alberto Sordi. Alla fine del film il gruppo universitario della facoltà di romanistica, indirizzo traduzione letteraria, dell'Università di Düsseldorf che ha sottotitolato il film, invita ad un rinfresco."
    ],
    "image": "../io-so-che-tu-sai.png"
  },
  {
    "title": "IO SONO L’AMORE",
    "director": "Luca Guadagnino",
    "country": "Italia",
    "releaseYear": 2009,
    "runtime": 119,
    "version": "OmU",
    "screeningDate": "20.09.2012",
    "readableDate": "2012-09-20",
    "screeningTime": "20:00",
    "actors": "Tilda Swinton, Flavio Parenti, Alba Rohrwacher, Diane Fieri, Maria Paiato, Edoardo Gabbriellini, Waris Ahluwalia, Gabriele Ferzetti, Marisa Berenson",
    "subtitle": [""],
    "bodycopy": [
      "Prima è la sua abilità in cucina, poi è Antonio stesso che scatena la passione di Emma e la induce a rompere con il suo matrimonio noioso con un industriale della moda. Nella famiglia alto-borghese dell’imprenditore ciò scatena un conflitto tra generazioni in cui si scontrano valori tra loro incompatibili."
    ],
    "image": "../io-sono-lamore.jpg"
  },
  {
    "title": "IO SONO LI",
    "director": "Andrea Segre",
    "country": "Italia/Francia",
    "releaseYear": 2011,
    "runtime": 98,
    "version": "OmU",
    "screeningDate": "20.11.2014",
    "readableDate": "2014-11-20",
    "screeningTime": "20:00",
    "actors": "Tao Zhao, Rade Šerbedžija, Marco Paolini, Roberto Citran, Giuseppe Battiston, Giordano Bacci, Spartaco Mainardi, Zhong Cheng, Wang Yuan, Amleto Voltolina, Andrea Pennacchi",
    "subtitle": [""],
    "bodycopy": [
      "Li con la sua grazia esotica, sebbene priva di qualsiasi esperienza in merito, dovrebbe far nuovamente funzionare un bar veneziano che appartiene alla mafia cinese. Però i veneziani la osteggiano. Fa eccezione soltanto il vecchio Bepi che, 30 anni prima, era pure arrivato come migrante a Venezia. Sotto gli occhi sospettosi sia della mafia cinese sia dei veneziani, tra i due inizia a svilupparsi un rapporto affettuoso."
    ],
    "image": "../io-sono-li.jpg"
  },
  {
    "title": "ITALY - LOVE IT OR LEAVE IT",
    "director": "Gustav Hofer und Luca Ragazz",
    "country": "Italia/Germania",
    "releaseYear": 2011,
    "runtime": 75,
    "version": "OmU",
    "screeningDate": "21.11.2013",
    "readableDate": "2013-11-21",
    "screeningTime": "20:00",
    "actors": "Gustav Hofer, Luca Ragazz",
    "subtitle": [""],
    "bodycopy": [
      "Nel loro ultimo film Gustav e Luca soffrivano per l’intolleranza nei confronti del matrimonio tra omosessuali in Italia. Nel frattempo la sofferenza la provano per la situazione del loro Paese e si pongono la domanda se rimanerci e godersi il sole del Mediterraneo o trasferirsi a Berlino.",
      "Per trovare una risposta intraprendono un viaggio attraverso una terra piena di contraddizioni, difficile da capire, ma anche molto umana e affascinante. Il risultato è un road movie, un quadro soggettivo e divertente del Bel Paese al giorno d’oggi."
    ],
    "image": "../italy-love-it-or-leave-it.jpg"
  },
  {
    "title": "L'albero degli zoccoli",
    "director": "",
    "country": "Italia",
    "releaseYear": 1977,
    "runtime": 179,
    "version": "OmitU",
    "screeningDate": "05.07.2006",
    "readableDate": "2006-07-05",
    "screeningTime": "17:30",
    "actors": "Luigi Ornaghi, Francesca Moriggi, Omar Brignoli, Antonio Ferrari, Teresa Brescianini, Giuseppe Brignoli, Carlo Rota, Pasqualina Brolis, Massimo Fratus, Francesca Villa",
    "subtitle": [""],
    "bodycopy": [
      "Un ritratto della vita contadina dei mezzadri bergamaschi alla fine del XIX secolo. Adottando un linguaggio estetico di grande bellezza, Olmi descrive con attori non professionisti la vita dura e le ingiustizie sociali di allora. Il suo sguardo si volge anche all'amore per la natura e alla profonda religiosità dei personaggi."
    ],
    "image": "../lalbero-degli-zoccoli.jpg"
  },
  {
    "title": "L'avventura",
    "director": "Michelangelo Antonioni",
    "country": "Italia/Francia",
    "releaseYear": 1960,
    "runtime": 143,
    "version": "OmitU",
    "screeningDate": "15.07.2010",
    "readableDate": "2010-07-15",
    "screeningTime": "19:00",
    "actors": "In memoria di Michelangelo Antonioni",
    "subtitle": [
      "Il film scelto dall'artista Ana Torfs da affiancare alla sua mostra ALBUM/TRACKS A nel K21 (dal 27.02.2010 al 18.07.2010)"
    ],
    "bodycopy": [
      "Il primo film della cosiddetta “trilogia dell'alienazione”, per il suo nuovo modo di raccontare e il suo linguaggio filmico, ha assunto una funzione didattica per molti artisti cinematografici portando allo stesso tempo al successo Antonioni. Durante una gita in barca Anna sparisce su un'isola che stava visitando. Il suo spensierato fidanzato e la sua amica si mettono a cercarla senza risultato. A poco a poco nasce una relazione fra i due che però non riescono a costruire insieme un futuro promettente."
    ],
    "image": "../avventura.jpg"
  },
  {
    "title": "L'avventura",
    "director": "Michelangelo Antonioni",
    "country": "Italia/Francia",
    "releaseYear": 1959,
    "runtime": 143,
    "version": "OmitU",
    "screeningDate": "07.11.2007",
    "readableDate": "2007-11-07",
    "screeningTime": "19:00",
    "actors": "In memoria di Michelangelo Antonioni",
    "subtitle": [
      "Il film scelto dall'artista Ana Torfs da affiancare alla sua mostra ALBUM/TRACKS A nel K21 (dal 27.02.2010 al 18.07.2010)"
    ],
    "bodycopy": [
      "Il primo film della cosiddetta “trilogia dell'alienazione”, per il suo nuovo modo di raccontare e il suo linguaggio filmico, ha assunto una funzione didattica per molti artisti cinematografici portando allo stesso tempo al successo Antonioni. Durante una gita in barca Anna sparisce su un'isola che stava visitando. Il suo spensierato fidanzato e la sua amica si mettono a cercarla senza risultato. A poco a poco nasce una relazione fra i due che però non riescono a costruire insieme un futuro promettente."
    ],
    "image": "../avventura.jpg"
  },
  {
    "title": "L'eclisse",
    "director": "Michelangelo Antonioni",
    "country": "Italia/Francia",
    "releaseYear": 1961,
    "runtime": 122,
    "version": "OmitU",
    "screeningDate": "05.12.2007",
    "readableDate": "2007-12-05",
    "screeningTime": "19:00",
    "actors": "Alain Delon, Monica Vitti, Francesco Rabal, Louis Seigner, Lilla Brignone, Rossana Rory, Mirella Ricciardi",
    "subtitle": ["In memoria di Michelangelo Antonioni"],
    "bodycopy": [
      "L'ultimo film della \"trilogia dell'alienazione\" è stato raramente proiettato nelle sale cinematografiche e perciò è una piccola \"rarità\". Piero (Alain Delon) e Vittoria (Monica Vitti) cercano di trovare l'amore. Però già la robusta colonna che li divide nell'inquadratura che riprende il loro primo incontro, indica l'estraniazione con cui hanno da combattere."
    ],
    "image": "../eclisse.jpg"
  },
  {
    "title": "L'estate di Martino",
    "director": "Massimo Natale",
    "country": "Italia",
    "releaseYear": 2010,
    "runtime": 80,
    "version": "OmitU",
    "screeningDate": "06.03.2012",
    "readableDate": "2012-03-06",
    "screeningTime": "20:00",
    "actors": "Treat Williams, Luigi Ciardo, Matilde Maggio",
    "subtitle": [""],
    "bodycopy": [
      "Nella calda estate politica del 1980 Martino si introduce con i suoi amici in una baia riservata alle truppe USA. Per caso questo timido adolescente fa la conoscenza di un ufficiale americano. Grazie a lui supera i suoi pregiudizi politici, impara il surf, scopre le sue capacità, acquista più fiducia in se stesso e trova il suo primo amore."
    ],
    "image": "../lestate-di-martino.jpg"
  },
  {
    "title": "L’ULTIMO CAPODANNO",
    "director": "Marco Risi",
    "country": "Italia",
    "releaseYear": 1998,
    "runtime": 99,
    "version": "OmU",
    "screeningDate": "12.04.2007",
    "readableDate": "2007-04-12",
    "screeningTime": "19:30",
    "actors": "Monica Bellucci, Alessandro Haber, Francesca D'Aloja, Claudio Santamaria, Marco Giallini, Ricky Memphis, Giorgio Tirabassi, Natale Tulli",
    "subtitle": [""],
    "bodycopy": [
      "Marco Risi è noto per la sensibilità e la critica sociale contenuta nei suoi film (Mery per sempre, Ragazzi fuori). Con questo film però cambia il suo modo di raccontare. Si tratta di una storia scatenata in un complesso residenziale nella Roma di oggi. Le più svariate persone e gruppi vivono in modo grottesco le ultime ore prima dell'Anno Nuovo. Riprendendo motivi della Commedia all'italiana e facendo abbondanti citazioni attinte dalla storia del cinema e da tutti i generi cinematografici possibili, Risi ha creato uno strano film che con le sue immagini stravaganti e ossessive ricorda Fellini. La trama si compone di episodi che si sviluppano parallelamente e in parte si intrecciano fra di loro: mentre una donna viene a sapere che suo marito la tradisce e progetta una vendetta mortale, poco lontano una contessa cerca di soddisfare le sue brame sessuali nelle braccia di un gigolò. In un altro appartamento un avvocato si fa \"coccolare\" da una domina, mentre altrove una donna tenta di suicidarsi ingerendo delle pillole. E poi ci sono anche due giovani drogati su una carica di dinamite. Più si avvicina la mezzanotte, più il tutto sembra sfociare in un'apocalisse caotica. I fuochi d'artificio vanno fuori controllo e i giochini sessuali dell'avvocato vengono brutalmente interrotti da dei gangster, suoi clienti. Questo film non è stato ancora proiettato in Germania. Approfittate dell'occasione pergustare questo bizzarro film."
    ],
    "image": "../lultimo-capodanno.jpg"
  },
  {
    "title": "L’UOMO IN PIÙ",
    "director": "Paolo Sorrentino",
    "country": "Italia",
    "releaseYear": 2001,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "18.04.2019",
    "readableDate": "2019-04-18",
    "screeningTime": "20:00",
    "actors": " Toni Servillo, Andrea Renzi, Nello Mascia, Ninni Bruschetta, Angela Goodwin, Roberto De Francesco, Enrica Rosso, Italo Celoro",
    "subtitle": [
      "Nome d’arte: Tony. Nome vero: Antonio Pisapia. Nato il 15 agosto 1934 a Napoli. Cantante di musica pop. ",
      "Nome : Antonio Pisapia. Nato il 15 agosto 1949 a Narni Scalo. Calciatore professionista.",
      "I due non potrebbero avere due caratteri più diversi: uno è lunatico, cinico, megalomane ed egocentrico, l’altro è timido, modesto, ossessionato e brontolone. Però non è soltanto il caso che li fa incontrare, anche il destino unisce le loro vite professionali e private. ",
      "Già in questo suo primo film finzionale di lunghezza normale, servendosi del suo attore preferito, Toni Servillo, Paolo Sorrentino (LA GRANDE BELLEZZA) racconta la tragedia di una vita marcata da episodi sconvolgenti avvolgendola in immagini di grande bellezza."
    ],
    "bodycopy": [
      "Nel 1980 incontriamo Tony dopo un concerto trionfale e Antonio dopo un gol che qualifica la sua squadra per la Coppa UEFA. Entrambi sono all’apice del loro successo. Ma il tutto è di breve durata: Tony devi rispondere dello stupro di una ragazza e Antonio subisce una rottura di tendini durante un allenamento, il che lo costringe a terminare la sua carriera calcistica.",
      "Nel 1984 la loro situazione è completamente cambiata: Tony è stato assolto dall’accusa di violenza carnale, ma la sua reputazione è irrimediabilmente compromessa tanto che trascina la sua vita in solitudine passando da una festa degenerata all’altra. Antonio è diventato allenatore, ma sembra che non ci sia un posto per lui né sul campo di calcio, né fuori. Un giorno Tony e Antonio si incontrano, si guardano e, senza scambiare una parola, si allontanano l’uno dall’altro. Ma le loro strade si incrociano nuovamente in un momento tragico."
    ],
    "image": "../un-uomo-in-piu.jpg"
  },
  {
    "title": "L’inverno",
    "director": "Nina Di Majo",
    "country": "Italia",
    "releaseYear": 2001,
    "runtime": 97,
    "version": "OmU",
    "screeningDate": "19.05.2004",
    "readableDate": "2004-05-19",
    "screeningTime": "19:30",
    "actors": "Valeria Bruni Tedeschi, Valeria Golino, Fabrizio Gifuni, Yorgo Voyagis, Paolo Paolini",
    "subtitle": [""],
    "bodycopy": [
      "In una metropoli post-industriale del Norditalia s'incontrano due coppie alle prese con i propri egoismi e con l'incapacità di relazionarsi e di comunicare. "
    ],
    "image": "../l-inverno.jpg"
  },

  {
    "title": "La battaglia di Algeri",
    "director": "Gillo Pontecorvo",
    "country": "Italia/Algerien",
    "releaseYear": 1965,
    "runtime": 121,
    "version": "OmenU",
    "screeningDate": "21.07.2005",
    "readableDate": "2005-07-21",
    "screeningTime": "19:30",
    "actors": "Brahim Haggiag, Saadi Yacef, Jean Martin, Tommaso Neri, Michéle Kerbash, Samia Kerbash, Ugo Paletti, Fusia El Kader, Franco Morici, Mohamed Ben Kassen",
    "subtitle": [""],
    "bodycopy": [
      "Algeria 1957: i francesi sono decisi a non abbandonare la loro ultima colonia nonostante la sanguinosa resistenza del “Fronte di liberazione nazionale” (FLN). Un film che anche dopo 40 anni non ha perso nulla della sua attualità e che racconta come nascono tanti conflitti violenti. Sebbene il film ricevette il Leone d’oro a Venezia nel 1966, la sua proiezione fu vietata in Francia, dove infatti è stato mostrato la prima volta appena lo scorso anno a Cannes."
    ],
    "image": "../battaglia-di-algeri.jpg"
  },
  {
    "title": "La battaglia di Algeri",
    "director": "Gillo Pontecorvo",
    "country": "Italia",
    "releaseYear": 1965,
    "runtime": 123,
    "version": "OmitU",
    "screeningDate": "06.09.2006",
    "readableDate": "2006-09-06",
    "screeningTime": "18:00",
    "actors": "Brahim Haggiag, Saadi Yacef, Jean Martin, Tommaso Neri, Michéle Kerbash, Samia Kerbash, Ugo Paletti, Fusia El Kader, Franco Morici, Mohamed Ben Kassen",
    "subtitle": [""],
    "bodycopy": [
      "Algeria 1957: i francesi sono decisi a non abbandonare la loro ultima colonia nonostante la sanguinosa resistenza del \"Fronte di liberazione nazionale\" (FLN). Un film, che anche dopo 40 anni, non manca di attualità. Descrive infatti come nascono conflitti violenti ed è stato analizzato dal governo USA per la propria strategia in Iraq. Leone d'oro 1966, divieto di proiezione in Francia. Dopo la nuova \"prima visione“ a Cannes nel 2004 grande successo negli USA, Francia e Italia."
    ],
    "image": "../la-battaglia-di-algeri.jpg"
  },
  {
    "title": "La bestia nel cuore",
    "director": "Cristina Comencini",
    "country": "Italia/Gran Bretagna/Francia/Spanien",
    "releaseYear": 2005,
    "runtime": 120,
    "version": "OmitU",
    "screeningDate": "01.08.2007",
    "readableDate": "2007-08-01",
    "screeningTime": "19:00",
    "actors": "Giovanna Mezzogiorno, Luigi Lo Cascio, Alessio Boni, Stefania Rocca, Angela Finocchiaro, Giuseppe Battiston",
    "subtitle": ["La famiglia Comencini"],
    "bodycopy": [
      "Sabina è ossessionata da incubi e quando viene a sapere di essere incinta, cerca di colmare le lacune che avverte nei suoi ricordi. La visita a suo fratello che vive negli Stati Uniti diventa un viaggio nel proprio passato che, sotto la superficiale serenità di una famiglia borghese, cela profondi abissi. Nella sua infanzia c'è un segreto che ha traumatizzato fratello e sorella e li influenza fino ad oggi."
    ],
    "image": "../la-bestia-nel-cuore.jpg"
  },
  {
    "title": "LA CICCIOLINA",
    "director": "Alessandro Melazzini",
    "country": "Germania/Francia",
    "releaseYear": 2016,
    "runtime": 54,
    "version": "OmU",
    "screeningDate": "05.12.2018",
    "readableDate": "2018-12-05",
    "screeningTime": "20:00",
    "actors": "Ilona Staller (Cicciolina), Michele Lo Foco, Filippo Ceccarelli, Marco Gregoretti, Gianfranco Spadaccia, Jeff Koons",
    "subtitle": [""],
    "bodycopy": [
      "In una carrellata biografica mette in luce il fenomeno Ilona Staller, in arte Cicciolina, ovvero l'icona della pornografia. Nata in Ungheria nel 1951, Cicciolina arriva con un matrimonio in Italia dove, degli anni 1970, diventa in breve un’icona pop del porno. Sfruttando la sua notorietà e la sua fama nel 1987 riesce ad entrare nel Parlamento italiano come deputata del Partito Radicale. Il fatto suscita enorme scalpore a livello internazionale e provoca grandi cambiamenti nei rapporti politici italiani anche se le iniziative di legge proposte da Cicciolina non sono provocatorie, ma piuttosto costruttive (protezione degli animali, tutela ambientale, situazione dei detenuti, ecc.). Attraverso un contatto di lavoro conosce Jeff Koons, lo sposa, fa un figlio con lui e lo ispira nelle sue opere, altamente quotate nel mercato dell'arte. Dopo breve tempo il matrimonio fallisce. Cicciolina si ritira dal mondo della pornografia, ma rimane attiva politicamente sulla scena internazionale.",
      "Alla fine il film di Melazzini si pone la domanda se Cicciolina, che aveva concentrato la campagna elettorale sulla sua persona e sul suo talento per lo spettacolo, non abbia cambiato il modo di intendere i politici nell'opinione pubblica tanto da aprire la strada a un personaggio dei media e dello show come Berlusconi."
    ],
    "image": "../la-cicciolina.jpg"
  },
  {
    "title": "La decima vittima",
    "director": "Elio Petri",
    "country": "Italia/Francia",
    "releaseYear": 1965,
    "runtime": 90,
    "version": "OmU",
    "screeningDate": "17.06.2010",
    "readableDate": "2010-06-17",
    "screeningTime": "20:00",
    "actors": "Marcello Mastroianni, Ursula Andress, Elsa Martinelli, Luce Bonifassy, Salvo Randone, Massimo Serato, Mio Quesada, Jacques Herlin",
    "subtitle": [
      "Il sottotitolaggio del film italiano è opera degli studenti di Düsseldorf che hanno così messo in luce un regista ingiustamente quasi sconosciuto in Germania: Elio Petri (vedi anche la serie dei film del mercoledì \"Cinema Italiano\")."
    ],
    "bodycopy": [
      "In questo film il registra anticipa degli sviluppi ancor oggi attuali. Amalgamando un’estetica ispirata all’arte pop, informale e concettuale, contrappone Ursula Andress e Marcello Mastroianni in un duello disciplinato da regole micidiali. Divulgandolo attraverso i media si intende convogliare l’aggressione collettiva al fine di evitare le guerre. Divertimento al massimo livello, come con James Bond e Hitchcock, con la profondità di quest’ultimo e un’accennata anticipazione di Fassbinder (“Il mondo sul filo”)."
    ],
    "image": "../la-decima-vittima.jpg"
  },
  {
    "title": "LA DEUTSCHE VITA",
    "director": "Alessandro Cassigoli, Tania Masi",
    "country": "Germania",
    "releaseYear": 2013,
    "runtime": 60,
    "version": "OmU",
    "screeningDate": "19.03.2015",
    "readableDate": "2015-03-19",
    "screeningTime": "20:00",
    "actors": " Alessandro Cassigoli, Giovanni Pane, Emanuele Lami",
    "subtitle": [""],
    "bodycopy": [
      "Come ci si sente, quando all'improvviso ci si accorge di essere un immigrato? A questa domanda Alessandro Cassigoli cerca una risposta nella comunità italiana di Berlino raccogliendo quelle esperienze che accomunano molti italiani che vivono in Germania."
    ],
    "image": "../la-deutsche-vita.jpg"
  },
  {
    "title": "La famiglia",
    "director": "Ettore Scola",
    "country": "Italia",
    "releaseYear": 1987,
    "runtime": 140,
    "version": "OmitU",
    "screeningDate": "02.04.2008",
    "readableDate": "2008-04-02",
    "screeningTime": "19:00",
    "actors": "Emanuele Lamaro, Andrea Occhipinti, Vittorio Gassman, Cecilia Dazzi, Stefania Sandrelli, Jo Champa, Fanny Ardant, Joska Versari, Massimo Dapporto, Carlo Dapporto, Ottavia Piccolo",
    "subtitle": ["Rassegna di Ettore Scola"],
    "bodycopy": [
      "80 anni della storia di una famiglia: il mondo in piccolo. Fuori si combattono due guerre e la rivoluzione tecnologica sta cambiando il mondo e tutto ciò si riflette soltanto in piccoli eventi. Carlo, inizialmente il più giovane membro della famiglia, alla fine il più anziano, narra i suoi ricordi, in parte corrispondenti a quelli di Scola. Verrà proiettata la versione integrale."
    ],
    "image": "../la-famiglia.jpg"
  },
  {
    "title": "La finestra di fronte",
    "director": "Ferzan Özpetek",
    "country": "Italia/Gran Bretagna/Turchia/Portogallo",
    "releaseYear": 2003,
    "runtime": 106,
    "version": "OmU",
    "screeningDate": "16.04.2009",
    "readableDate": "2009-04-16",
    "screeningTime": "20:00",
    "actors": "Giovanna Mezzogiorno, Massimo Girotti, Raoul Bova, Filippo Nigro, Serra Yilmaz, Maria Grazie Bon, Benedetta Gargari",
    "subtitle": [
      "Cinque film di successo del quinquennio del “Club del cinema italiano” nella sala Black Box"
    ],
    "bodycopy": [
      "Giovanna si è rassegnata alla sua infelice vita in famiglia e si sente attratta da un giovane uomo che vive nell'appartamento di fronte e che lei osserva ogni sera. Quando un uomo anziano confuso entra improvvisamente nella sua vita di ogni giorno, la ricerca del passato del vecchio diventa per Giovanna la ricerca dei suoi veri sentimenti."
    ],
    "image": "../la-finestra-di-fronte.jpg"
  },
  {
    "title": "La finestra di fronte",
    "director": "Ferzan Özpetek",
    "country": "Italia/Gran Bretagna/Turchia/Portogallo",
    "releaseYear": 2003,
    "runtime": 106,
    "version": "OmU",
    "screeningDate": "17.11.2005",
    "readableDate": "2005-11-17",
    "screeningTime": "19:30",
    "actors": "Giovanna Mezzogiorno, Massimo Girotti, Raoul Bova, Filippo Nigro, Serra Yilmaz, Maria Grazie Bon, Benedetta Gargari",
    "subtitle": [""],
    "bodycopy": [
      "Non basta gettare uno sguardo dalla finestra, bisogna uscire di casa affinché la vita possa cambiare. Giovanna si è rassegnata alla sua infelice vita in famiglia, però si sente attratta da un giovane uomo che vive nell’appartamento di fronte e che lei osserva ogni sera. Quando un uomo anziano confuso e sperduto entra improvvisamente nella sua vita di ogni giorno, Giovanna, cercando il passato del vecchio, inizia in effetti la ricerca dei suoi veri sentimenti e di una nuova vita nell’ambito di quella vecchia."
    ],
    "image": "../la-finestra-di-fronte.jpg"
  },
  {
    "title": "La forza del passato",
    "director": "Piergiorgio Gay",
    "country": "Italia",
    "releaseYear": 2002,
    "runtime": 98,
    "version": "OmitU",
    "screeningDate": "02.01.2008",
    "readableDate": "2008-01-02",
    "screeningTime": "19:00",
    "actors": "Sergio Rubini, Bruno Ganz, Valeria Moriconi, Mariangela D'Abbraccio, Sandra Ceccarelli, Giuseppe Battiston, Aleksander Krosl, Barbara Cerar",
    "subtitle": ["Location: Trieste"],
    "bodycopy": [
      "Conosciamo veramente la persona che ha influenzato più di ogni altra la nostra vita: nostro padre? Gianni Orzan (Sergio Rubini) è riuscito a gestire in modo più o meno infelice la sua vita quando, dopo la morte di suo padre, compare l'inquietante Bogliasco (Bruno Ganz), che sembra sapere tutto di lui e gli parla di un padre che Gianni non ha mai conosciuto."
    ],
    "image": "../la-forza-del-passato.jpg"
  },
  {
    "title": "La Gabbianella e il Gatto",
    "director": "Enzo D'Alò",
    "country": "Italia",
    "releaseYear": 1999,
    "runtime": 78,
    "version": "OF",
    "screeningDate": "29.05.2004",
    "readableDate": "2004-05-29",
    "screeningTime": "15:00",
    "actors": "Regisseur, Drehbuchschreiber und Zeichner: Enzo D'Alò",
    "subtitle": [""],
    "bodycopy": [
      "Kengah, una gabbiana avvelenata da una macchia di petrolio, in punto di morte riesce ad affidare il proprio uovo al gatto Zorba strappandogli tre promesse:Kengah, una gabbiana avvelenata da una macchia di petrolio, in punto di morte riesce ad affidare il proprio uovo al gatto Zorba strappandogli tre promesse:quella di non mangiare l’uovo; di averne cura finché non si schiuderà; di insegnare a volare al nascituro.La gabbianella orfana viene battezzata Fortunata dall’intera comunità dei gatti. La piccola Fortunata dovràimparare a conoscersi e capire di non essere un gatto, prima di imparare a volare."
    ],
    "image": "../gabianellagatto.jpg"
  },
  {
    "title": "LA GATTA CENERENTOLA",
    "director": "Ivan Cappiello, Marino Guarnieri, Alessandro Rak, Dario Sansone",
    "country": "Italia",
    "releaseYear": 2017,
    "runtime": 86,
    "version": "OmU",
    "screeningDate": "17.10.2019",
    "readableDate": "2019-10-17",
    "screeningTime": "20:00",
    "actors": "Massimiliano Gallo, Maria Pia Calzone, Alessandro Gassmann, Renato Carpentieri ",
    "subtitle": [
      "Chi afferma che i cartoni animati sono qualcosa per bambini? Anche se la \"cenerentola\", citata nel titolo fa pensare subito ad una fiaba, in verità si tratta chiaramente di una pellicola per adulti. Adattando uno dei racconti del cosiddetto \"cunto\" di Giambattista Basile, la raccolta nota come \"Pentamerone\" (1634/36), il film racconta non solo del fallimento di un'utopia e del suo declino che sfocia in corruzione, violenza e strutture mafiose, ma pure della speranza che sopravvive anche nei momenti più bui generando poi eventi inaspettati. "
    ],
    "bodycopy": [
      "Il film si svolge a bordo di Megarida, un'imbarcazione  costruita quale speranza di un futuro migliore dal padre della giovane Mia, un ricco scienziato visionario. . Da quando lui  15 anni prima si era portato la sua utopia nella tomba, la nave è ormeggiata in rada nel golfo di Napoli. Mia invece è rimasta sotto la tutela della matrigna che con le sue sei perfide figliole ha messo su un fiorente commercio di stupefacenti e tratta Mia come una serva. Però, improvvisamente Mia diventa importante per i criminali che lavorano con la matrigna, e il suo destino sembra segnato. Mia tuttavia non si rassegna e trova presto degli alleati dei tempi in cui viveva suo padre.",
      "Questa storia che si svolge su una nave da crociera nel porto di una Napoli futuristica, è raccontata in uno stile da fumetto. I ricordi olografici di Mia vengono inseriti come flashback tanto che i livelli narrativi del presente e del passato si intrecciano e si commentano a vicenda. Un film avvincente da tutti i punti di vista e un piacere per i sensi."
    ],
    "image": "../la-gatta-cenerentola.png"
  },
  {
    "title": "LA GRANDE BELLEZZA",
    "director": "Paolo Sorrentino",
    "country": "Italia/Francia",
    "releaseYear": 2013,
    "runtime": 142,
    "version": "OmU",
    "screeningDate": "18.09.2014",
    "readableDate": "2014-09-18",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Carlo Verdone, Sabrina Ferilli, Carlo Buccirosso ",
    "subtitle": [""],
    "bodycopy": [
      "È lui la star che brilla nelle feste romane di una presunta alta società colma di pseudointellettuali: Jep Gamberdella (Toni Servillo). Anche un edonista e uomo di mondo come Jep si ferma tuttavia di tanto in tanto a riflettere. Così al vuoto e alla superficialità di questa società reagisce con commenti cinici e ironici finché il giorno del suo 65° compleanno non lo induce a meditare sul suo passato e sul suo futuro (Oscar e Golden Globe 2014, 4 premi all’European Film Awards 2013)."
    ],
    "image": "../la-grande-bellezza.png"
  },
  {
    "title": "La grande guerra",
    "director": "Mario Monicelli",
    "country": "Italia/Francia",
    "releaseYear": 1959,
    "runtime": 100,
    "version": "OmitU",
    "screeningDate": "01.06.2011",
    "readableDate": "2011-06-01",
    "screeningTime": "20:00",
    "actors": "Alberto Sordi, VittorioGassman, Silvana Magano, Romolo Valli",
    "subtitle": ["150 anni dall'unità d'Italia"],
    "bodycopy": [
      "Una commedia che racconta di due soldati imboscati durante la prima guerra mondiale. Poiché Oreste e Giovanni non sono riusciti a sfuggire all’arruolamento, inviati al fronte cercano di sfuggire alle situazioni pericolose. Infine cadono prigionieri degli austriaci, muoiono da codardi però rendono possibile la vittoria del loro esercito."
    ],
    "image": "../la-grande-guerra.jpg"
  },
  {
    "title": "LA MAFIA UCCIDE SOLO D’ESTATE",
    "director": "Pif (Pierfrancesco Diliberto)",
    "country": "Italia",
    "releaseYear": 2013,
    "runtime": 90,
    "version": "OmU",
    "screeningDate": "19.05.2016",
    "readableDate": "2016-05-19",
    "screeningTime": "20:00",
    "actors": "Cristiana Capotondi, Pif, Ginevra Antona, Claudio Gioè, Ninni Bruschetta, Alex Bisconti, Maurizio Marchetti, Rosario Lisma, Barbara Tabita",
    "subtitle": [""],
    "bodycopy": [
      "Crescere e innamorarsi nella Palermo mafiosa. Vent'anni di storia visti con gli occhi di un bambino. Arturo cresce in quest'affascinante, ma allo stesso tempo terribile città in cui c'è posto sia per le passioni che per un sorriso."
    ],
    "image": "../la-mafia-uccide.jpg"
  },
  {
    "title": "La meglio gioventù",
    "director": "Marco Tullio Giordana",
    "country": "Italia",
    "releaseYear": 2003,
    "runtime": 366,
    "version": "OmU",
    "screeningDate": "21.05.2005",
    "readableDate": "2005-05-21",
    "screeningTime": "17:00",
    "actors": "Alessio Boni, Luigi Lo Cascio, Jasmine Trinca, Adriana Asti, Sonia Bergamasco, Fabrizio Gifuni, Maya Sansa, Camilla Filippi, Valentina Carnelutti",
    "subtitle": ["Rassegna di Luigi Lo Cascio"],
    "bodycopy": [
      "La storia della famiglia Casati dal 1966 ad oggi sullo sfondo di un periodo ricco di avvenimenti politici inquietanti in Italia. Gli eventi si succedono quasi per caso, lasciando tuttavia, impercettibilmente, profondi segni nelle persone coinvolte. In seguito al grande successo riscosso ai festival e presso il pubblico italiano, il film, prodotto inizialmente per la TV, ma mai trasmesso, passando prima per le sale cinematografiche ha poi conquistato anche i teleschermi."
    ],
    "image": "../la-meglio-gioventu-1.png"
  },
  {
    "title": "LA MEGLIO GIOVENTÙ",
    "director": "Marco Tullio Giordana",
    "country": "Italia",
    "releaseYear": 2003,
    "runtime": 366,
    "version": "OmU",
    "screeningDate": "22.03.2014",
    "readableDate": "2014-03-22",
    "screeningTime": "17:00",
    "actors": "Alessio Boni, Luigi Lo Cascio, Jasmine Trinca, Adriana Asti, Sonia Bergamasco, Fabrizio Gifuni, Maya Sansa, Camilla Filippi, Valentina Carnelutti",
    "subtitle": [
      "10° anniversario: i maggiori successi del Club del Cinema Italiano"
    ],
    "bodycopy": [
      "In Germania è stato Edgar Reitz con il suo progetto HEIMAT a raccontare la storia del Paese in base alla biografia di persone le cui vite si intrecciano. In Italia l’impresa se l’è assunta Marco Tullio Giordana che ha realizzato questo film seguendo lo stesso concetto: iniziando dagli anni ’60, quelli del boom e della solidarietà, racconta le vicende della famiglia Carati a Roma per oltre 40 anni. In questo lungo periodo ogni membro della famiglia prende le sue decisioni fortemente influenzate dallo sviluppo politico del Paese. Il risultato è un quadro storico della società italiana con le sue contraddizioni, un quadro divertente, interessante e drammaticamente condensato, il cui valore è stato riconosciuto da oltre 20 premi nazionali e internazionali.",
      "“Talvolta si afferma con leggerezza di non aver visto semplicemente un film, ma di aver fatto una vera e propria esperienza. Stavolta è vero”. (FAZ)"
    ],
    "image": "../la-meglio-gioventu-10.jpg"
  },
  {
    "title": "La mia generazione",
    "director": "Wilma Labate",
    "country": "Italia",
    "releaseYear": 1996,
    "runtime": 95,
    "version": "OmU",
    "screeningDate": "26.04.2004",
    "readableDate": "2004-04-26",
    "screeningTime": "19:30",
    "actors": "Stefano Accorsi, Claudio Amendola, Francesca Neri",
    "subtitle": [""],
    "bodycopy": [
      "In Sicilia, in un carcere speciale, Braccio, detenuto politico, viene prelevato con un furgone per essere tradotto a Milano, per ottenere alcuni colloqui con l'ex fidanzata, Giulia. Il Capitano dei Carabinieri, responsabile del trasferimento, con sagace psicologia, riesce a superare l'istintiva diffidenza del detenuto trattandolo da uomo. "
    ],
    "image": "../la mia generazione.jpg"
  },
  {
    "title": "La paranza dei bambini",
    "director": "Claudio Giovanesi",
    "country": "Italia",
    "releaseYear": 2019,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "15.10.2020",
    "readableDate": "2020-10-15",
    "screeningTime": "20:00",
    "actors": " Francesco Di Napoli, Viviana Aprea, Mattia Piano Del Balzo, Renato Carpentieri e altri",
    "subtitle": [
      "Non proiettato nel 1° semestre a causa di corona, ora riprogrammato.",
      "La proiezione rimandata del film permette di confrontare la \"classica mafia siciliana“, tema del prossimo film in programma IL TRADITORE, con la \"nuova camorra napoletana\". I classici boss provvedevano ancora personalmente di estorcere il pizzo, furti con scasso e vendita di stupefacenti ai drogati. Ora avendo praticamente delegato queste mansioni, dopo l'arresto di alcuni capi locali, prendono il loro posto gruppi di giovani criminali che penetrano nelle strutture già esistenti occupando i posti vacanti. Per i vecchi boss sono il campo di reclutamento delle nuove leve mentre loro si dedicano all'organizzazione della prostituzione e del traffico di stupefacenti in grande stile nonché al passaggio all'economia legale."
    ],

    "bodycopy": [
      "Il 15enne Nicola vive ancora con la madre, fa le prime esperienze d'amore e con i suoi compagni rende insicuro il quartiere della Sanità a Napoli. Dopo aver assistito all’umiliazione inflitta alla madre dai camorristi che pretendono da lei il pizzo, lui e i suoi amici si associano ad Agostino, il rampollo di un clan camorrista, una volta molto potente, che però non avendo capito i cambiamenti avvenuti nel frattempo è diventato insignificante. Rapinando un gioielliere la banda vuole procurarsi i soldi per comprare vestiti di marca e darsi un'apparenza di gran lusso. Però il capo locale requisisce il bottino, proibisce loro il contatto con Agostino e li costringe a vendere marijuana. Piano piano i ragazzi aiutano il capo camorrista anche ad incassare il pizzo e a vendere droghe più pesanti: e finalmente riescono ad accumulare la somma tanto aspirata.",
      "Quando per intervento della polizia anche il capo viene arrestato, i ragazzi fiutano le loro chance. Con poca esperienza, ma grande energia cercano di farsi strada nelle strutture criminali."
    ],
    "image": "../paranzadeibambini048586f7044erounded.jpg"
  },
  {
    "title": "LA PAROLA AMORE ESISTE",
    "director": "Mimmo Calopresti",
    "country": "Italia/Francia",
    "releaseYear": 1998,
    "runtime": 84,
    "version": "OmU",
    "screeningDate": "20.06.2012",
    "readableDate": "2012-06-20",
    "screeningTime": "20:00",
    "actors": " mit Valeria Bruni-Tedeschi, Fabrizio Bentivoglio, Gerard Depardieu, Valeria Milillo, Marina Confalone, Daria Nicolodi",
    "subtitle": [""],
    "bodycopy": [
      "Quando il cinema francese incontra quello italiano, ne esce una commedia profonda. Una donna psichicamente labile decide di innamorarsi di un insegnante di violoncello. Da ciò nascono divertenti intrecci intorno al tema dell’amore."
    ],
    "image": "../la-parola-amore-esiste.jpg"
  },
  {
    "title": "LA PAZZA GIOIA",
    "director": "Paolo Virzì",
    "country": "Italia/Francia",
    "releaseYear": 2016,
    "runtime": 118,
    "version": "OmU",
    "screeningDate": "20.04.2017",
    "readableDate": "2017-04-20",
    "screeningTime": "20:00",
    "actors": " Valeria Bruni Tedeschi, Micaela Ramazzotti, Valentina Carnelutti, Marco Messeri, Anna Galiena, Tommaso Ragno, Bob Messini, Sergio Albelli, Marisa Borini",
    "subtitle": [
      "Dopo TUTTA LA VITA DAVANTI e IL CAPITALE UMANO Paolo Virzì racconta in questo road movie la folle amicizia di due donne molto diverse tra di loro."
    ],
    "bodycopy": [
      "La contessa chiacchierona Maria Beatrice perde la sua reputazione sociale a causa della sua relazione con un delinquente abituale. Quando, durante una cura psicologica all’interno di una clinica incontra Donatella, una disadattata, le due decidono di cogliere l’occasione per scappare. Con una schiera di psicologi alle calcagna girano per la Toscana diventando amiche. Tra momenti di felicità bipolare, determinatezza maniacale e intrepidezza ossessiva, si capiscono meglio di qualsiasi altro.",
      "Il film di Virzì è pieno di gioia di vivere e nel contempo è uno quadro originale dell’Italia di oggi."
    ],
    "image": "../la-pazza-gioia.jpg"
  },
  {
    "title": "La pivellina",
    "director": "Tizza Covi und Rainer Frimmel",
    "country": "Austria/Italia",
    "releaseYear": 2009,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "15.12.2011",
    "readableDate": "2011-12-15",
    "screeningTime": "20:00",
    "actors": "Patrizia Gerardi, Walter Saabel, Tairo Caroli, Asia Crippa",
    "subtitle": [""],
    "bodycopy": [
      "Un film documentario veramente toccante. In alcuni dei loro progetti Covi e Frimmel hanno accompagnato la vita degli artisti di un piccolo circo e ora sfruttano questa loro esperienza per raccontare una storia fittizia di gente di circo in cui i protagonisti sono i personaggi reali che recitano se stessi. Il risultato non è soltanto la storia commuovente di una trovatella che in questo ambiente si sente per la prima volta amata e diventa il “cuore” della compagnia, ma anche il ritratto di una comunità di artisti che vivono ai limiti della povertà."
    ],
    "image": "../la-pivellina.jpg"
  },
  {
    "title": "La rabbia",
    "director": "Pier Paolo Pasolini",
    "country": "Italia",
    "releaseYear": 1963,
    "runtime": 53,
    "version": "OmU",
    "screeningDate": "09.03.2011",
    "readableDate": "2011-03-09",
    "screeningTime": "18:00",
    "actors": "Giorgio Bassani, Renato Guttuso",
    "subtitle": [""],
    "bodycopy": [
      "Un film frammentato sulla rabbia o collera di Pasolini. Una rabbia contro il mondo borghese, la barbarie e l'intolleranza, contro i pregiudizi e la banalità. Un documento eccezionale che implicitamente testimonia un'altra volta l'autonomia della creazione, della poesia, della cultura."
    ],
    "image": "../la_rabbia.jpg"
  },
  {
    "title": "La ragazza del Lago",
    "director": "Andrea Molaioli",
    "country": "Italia",
    "releaseYear": 2007,
    "runtime": 91,
    "version": "OmitU",
    "screeningDate": "04.03.2009",
    "readableDate": "2009-03-04",
    "screeningTime": "20:00",
    "actors": " Toni Servillo, Valeria Golino, Fabrizio Gifuni, Anna Bonaiuto, Omero Antoniutti, Marco Baliani, Denis Fasolo, Sara D'Amario",
    "subtitle": [""],
    "bodycopy": [
      "Inizialmente il commissario Sanzio dovrebbe occuparsi solamente della sparizione diun bambino di sei anni nell’Italia settentrionale. Però scopre che il caso hastrettamente a che fare con il cadavere di una bella ragazza, trovato sulla sponda di unlago. Improvvisamente l’apparente armonia e tranquillità dei rapporti umani intorno a questo lago romantico cambiano aspetto."
    ],
    "image": "../la-ragazza-del-lago.jpg"
  },
  {
    "title": "LA RAGAZZA NELLA NEBBIA",
    "director": "Donato Carrisi",
    "country": "Italia/Germania/Francia",
    "releaseYear": 2017,
    "runtime": 97,
    "version": "OmU",
    "screeningDate": "16.10.2019",
    "readableDate": "2019-10-16",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Alessio Boni, Jean Reno, Lorenzo Richelmy, Galatea Ranzi, Michela Cescon, Daniela Piazza, Thierry Toscan, Ekaterina Buscemi",
    "subtitle": [
      "In Italia, un paese prolifico di autori di gialli (Gianrico Carofiglio, Andrea Camilleri, Donna Leon, Veit Heinichen, ecc.), lo scrittore Donato Carrisi si è messo a girare un film ispirato al suo stesso bestseller LA RAGAZZA NELLA NEBBIA. Ne è risultata una storia, composta dal passato e dai ricordi, ma raccontata prevalentemente in ordine cronologico. La storia, che fino alla fine rimane misteriosa, gioca virtuosamente tra elementi di esteriorità e veri contenuti, e addirittura quando i fili della trama finalmente si incontrano e tutto sembra chiarito, prosegue con una svolta inaspettata. "
    ],
    "bodycopy": [
      "Toni Servillo, Alessio Boni, Jean Reno: il film non vanta soltanto famosi nomi del cinema attuale, ma riesca a trasformare un racconto letterario in emozioni visive.",
      "In un paesino di montagna, al termine della strada che si inerpica sulle Alpi italiane, scompare una ragazza. L'episodio risveglia vecchi ricordi di un evento simile, accaduto decenni prima. Tutte le speranze si infondono nell'agente Vogel che, invece, altezzoso, presenta ai media dei sospettati lavorando sulla sua immagine piuttosto malmessa dopo il suo ultimo caso.",
      "Chi è il reo, non interessa qui. Al centro del racconto sono invece i potenziali abissi che talvolta si aprono e in cui cadono i personaggi del film. Tipico di questo genere cinematografico è lo sguardo dietro alla facciata borghese. Carrisi però non si ferma lì, ma segue anche gli istinti più profondi delle singole persone."
    ],
    "image": "../la-ragazza-nella-nebbia.jpg"
  },
  {
    "title": "LA RESA DEI CONTI",
    "director": "Sergio Sollima",
    "country": "Italia/Spanien",
    "releaseYear": 1966,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "02.09.2016",
    "readableDate": "2016-09-02",
    "screeningTime": "21:15",
    "actors": "Lee Van Cleef, Tomas Milian, Walter Barnes, Nieves Navarro, Gérard Herter, Maria Granada, Roberto Camardiel, Ángel del Pozo, Luisa Rivelli",
    "subtitle": [""],
    "bodycopy": [
      "Il cacciatore di taglie Corbett insegue Cuchillo, il presunto assassino di una ragazza. Quando, superate alcune avversità, finalmente lo trova, capisce che è innocente e i due si mettono alla ricerca dei veri assassini. L'avvincente storia, gli ottimi attori e le eccezionali riprese del paesaggio fanno di questo film uno dei grandi classici di questo genere. La famosa colonna sonora - riutilizzata da Quentin Tarantino in BASTARDI SENZA GLORIA - è di Ennio Morricone."
    ],
    "image": "../la-resa-dei-conti.jpg"
  },
  {
    "title": "La ricotta",
    "director": "Pier Paolo Pasolini",
    "country": "Italia/Francia",
    "releaseYear": 1963,
    "runtime": 35,
    "version": "OmU",
    "screeningDate": "09.03.2011",
    "readableDate": "2011-03-09",
    "screeningTime": "18:00",
    "actors": "Orson Wells, Mario Cipriani, Laura Betti, Edmonda Aldini, Vittorio La Paglia, Maria Bernardini",
    "subtitle": [""],
    "bodycopy": [
      "La RICOTTA è un episodio del film RoGoPaG nel quale ai affianca ad altri episodi girati dai registi Roberto Rossellini, Jean-Luc Godard e Ugo Gregoretti.  Pasolini ha messo insieme un gruppo di personaggi che gli permettono di raffigurare in un microcosmo un universo di critica satirica, umorismo sarcastico e definizione estetico-politica."
    ],
    "image": "../la ricotta.jpg"
  },
  {
    "title": "LA SCONOSCIUTA",
    "director": "Giuseppe Tornatore",
    "country": "Italia",
    "releaseYear": 2006,
    "runtime": 121,
    "version": "OmU",
    "screeningDate": "18.08.2011",
    "readableDate": "2011-08-18",
    "screeningTime": "20:00",
    "actors": " Xenia Rappoport, Michela Placido, Claudia Gerini, Margherita Buy, Pierfrancesco Favino, Piera Degli Espositi, Clara Dossena, Angela Molina",
    "subtitle": [""],
    "bodycopy": [
      "Il maestro di “Cinema Paradiso” racconta in questo film la storia di un’ucraina con un passato oscuro che compare a Trieste e si annida sistematicamente nella casa di un gioielliere dal matrimonio fallito e con una figlia malata. Si aprono abissi. Le vicende traumatiche, accennate in sottofondo, riguardanti la tratta delle donne, la prostituzione e la migrazione, si scontrano con i conflitti familiari della media borghesia italiana. Il film è stato più volte premiato in diversi festival."
    ],
    "image": "../la-sconosciuta.jpg"
  },
  {
    "title": "LA SIGNORA SENZA CAMELIE",
    "director": "Michelangelo Antonioni",
    "country": "Italia/Francia",
    "releaseYear": 1953,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "17.03.2016",
    "readableDate": "2016-03-17",
    "screeningTime": "20:00",
    "actors": " Lucia Bosé, Gino Cervi, Andrea Checchi, Ivan Desny, Monica Clay, Alain Cuny, Anna Carena, Enrico Glori, Laura Tiberti",
    "subtitle": [""],
    "bodycopy": [
      "Ascesa e caduta: una commessa passata al cinema sposa un produttore, ma finisce per diventare un'attrice mediocre e l'amante di un diplomatico. Antonioni fa i conti con il mondo del cinema e con la luccicante società dei consumi."
    ],
    "image": "../la-signora-senza-camelie.jpg"
  },
  {
    "title": "LA SOLITUDINE DEI NUMERI PRIMI",
    "director": "Saverio Costanzo",
    "country": "Italia/Germania/Francia",
    "releaseYear": 2010,
    "runtime": 119,
    "version": "OmU",
    "screeningDate": "18.03.2012",
    "readableDate": "2012-03-18",
    "screeningTime": "20:00",
    "actors": " Alba Rohrwacher, Luca Marinelli, Isabella Rosselini, Arianna Nastro, MArtina Albano, Vittorio Lomartire, Tommaso Neri, Aurora Ruffino, Giorgia Pizzo",
    "subtitle": [""],
    "bodycopy": [
      "Due persone, accomunate dalle lacerazioni delle loro anime, si incontrano e provano una inspiegabile attrazione reciproca. Sebbene condividano la loro vita, i due non riescono a superare la loro solitudine personale. Poi sono le circostanze a separarli anche fisicamente. Rimarranno “numeri primi” o c’è ancora la speranza che riescano a “fondersi”?"
    ],
    "image": "../la-solitudine-dei-numeri-primi.jpg"
  },
  {
    "title": "La stanza del figlio",
    "director": "Nanni Moretti",
    "country": "Italia",
    "releaseYear": 2001,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "15.11.2012",
    "readableDate": "2012-11-15",
    "screeningTime": "20:00",
    "actors": "Nanni Moretti, Laura Morante, Silvio Orlando, Jasmine Trinca, Giuseppe Sanfelice, Sofia Vigliar",
    "subtitle": [""],
    "bodycopy": [
      "La morte del figlio durante un’immersione sconvolge la vita di uno psichiatra perché, invece di andare con lui a correre, aveva fatto visita a un paziente. Il trauma del dolore cambia la sua esistenza sia professionale che familiare. Cade sempre di più nell’autocommiserazione finché non compare una ragazza con delle foto con le quali suo figlio voleva mostrare a lei la sua stanza."
    ],
    "image": "../la-stanza-del-figlio.jpg"
  },
  {
    "title": "La terra",
    "director": "Sergio Rubini",
    "country": "Italia",
    "releaseYear": 2006,
    "runtime": 112,
    "version": "OmU",
    "screeningDate": "19.11.2009",
    "readableDate": "2009-11-19",
    "screeningTime": "20:00",
    "actors": "Sergio Rubini, Fabrizio Bentivoglio, Paolo Briguglia, Massimo Venturiello",
    "subtitle": [""],
    "bodycopy": [
      "Un conflitto culturale all'interno del proprio paese: Luigi, da giovane, se ne è andato dalla Puglia natia per fare carriera come professore universitario. Siccome la casa di famiglia a Mesagne deve essere venduta, torna per firmare il contratto e si ritrova in un intreccio di intrighi, conflitti mai risolti e sentimenti inaspettati. In sottofondo Tonino tesse la sua tela criminale ricattando l'intero villaggio. Nel ruolo di Luigi: Fabrizio Bentivoglio, uno dei più popolari attori italiani degli ultimi anni."
    ],
    "image": "../la-terra.jpg"
  },
  {
    "title": "LA TERRA DEI SANTI",
    "director": "Fernando Muraca",
    "country": "Italia",
    "releaseYear": 2015,
    "runtime": 89,
    "version": "OmU",
    "screeningDate": "18.01.2018",
    "readableDate": "2018-01-18",
    "screeningTime": "20:00",
    "actors": "Valeria Solarino, Daniela Marra, Lorenzo Indovina, Ninni Bruschetta",
    "subtitle": [
      "“Che cosa succederebbe se sottraessimo i figli ai mafiosi?”  Con quest’audace proposta Vittoria, di professione pubblico ministero, vuole intaccare il ruolo delle donne nella Mafia. Anche se le strutture patriarcali sono determinanti nell’organizzazione criminale, sono le donne che preparano i loro figli al loro futuro ruolo”."
    ],
    "bodycopy": [
      "Caterina, moglie di Alfredo, ricercato boss della ‘Ndragheta, ha educato il figlio Pasquale  in modo che diventi in futuro un capo clan. Assunta, la sorella più giovane, ha già perso il marito nella guerra tra le bande criminali e vede il figlio Giuseppe prendere la stessa strada del padre. Tuttavia, per ordine di Alfredo, deve sposare contro la sua volontà suo cognato Nando. In questa società chiusa irrompe Vittoria, un magistrato proveniente dal Norditalia. Vittoria ha un obiettivo: rompere il silenzio delle donne.",
      "“Spesso sono i film sulla Mafia e sulla ‘Ndragheta null’altro che film di genere. Ma io non volevo fare un film di questo tipo. Fin dall’inizio sentivo il bisogno di raccontare la storia dal punto di vista delle figure femminili perché mi sembrava più interessante e senza precedenti. Nelle famiglie calabresi non funziona molto diversamente”. [Fernando Muraca]"
    ],
    "image": "../la-terra-dei-santi.jpg"
  },
  {
    "title": "La tigre e la neve",
    "director": "Roberto Benigni",
    "country": "Italia",
    "releaseYear": 2005,
    "runtime": 114,
    "version": "OmU",
    "screeningDate": "11.10.2007",
    "readableDate": "2007-10-11",
    "screeningTime": "19:00",
    "actors": "Roberto Benigni, Nicoletta Braschi, Jean Reno, Tom Walts, Emilia Fox, Giuseppe Battiston, Andrea Renzi, Abdelhafid Metalsi, Francesco De Vito",
    "subtitle": [""],
    "bodycopy": [
      "Italia 2003: tutto il mondo parla della guerra in Iraq, ma Attilio (Roberto Benigni), poeta trasognato, ha solo occhi per la scrittrice Vittoria (Nicoletta Braschi). Andata in Iraq per ricerche, Vittoria viene gravemente ferita in un attentato. Spontaneamente Attilio decide di seguirla nel paese martoriato dalla guerra per salvarla. Come in tutti i film di Benigni la storia è solo un'occasione per sognare della forza dell'amore in un mondo spietato e vedere la vita come un campo da gioco per le proprie trovate burlesche."
    ],
    "image": "../la-tigre-e-la-neve.jpg"
  },
  {
    "title": "LA VITA CHE VORREI",
    "director": "Giuseppe Piccioni",
    "country": "Italia",
    "releaseYear": 2004,
    "runtime": 125,
    "version": "OmU",
    "screeningDate": "17.01.2007",
    "readableDate": "2007-01-17",
    "screeningTime": "19:00",
    "actors": "Luigi Lo Cascio, Sandra Ceccarelli, Ninni Bruschetta, Galatea Ranzi, Fabio Camilli, Gea Lionello, Roberto Citran, Camilla Filippi, Paolo Bassanelli",
    "subtitle": [""],
    "bodycopy": [
      "Giuseppe Piccioni in tutti i suoi film (ad es. \"Fuori dal mondo\" e \"Luce dei miei occhi\") ha dimostrato di essere un attento osservatore delle persone e della loro vita. In \"La vita che vorrei\" racconta la storia d'amore di Stefano e Laura, due attori che recitano nello stesso film il ruolo di una coppia di innamorati. Così si confondono i limiti tra interpretazione e vita. Mai si ha la certezza che stiano recitando o esprimendo sentimenti sinceri. I protagonisti, Luigi Lo Cascio e Sandra Ceccarelli, sono attori famosi in Italia tanto da essere ritenuti da alcuni critici la nuova \"coppia perfetta\" del cinema italiano."
    ],
    "image": "../la-vita-che-vorrei.jpg"
  },
  {
    "title": "LA VITA È BELLA",
    "director": "Roberto Benigni",
    "country": "Italia",
    "releaseYear": 1997,
    "runtime": 116,
    "version": "OmU",
    "screeningDate": "17.05.2018",
    "readableDate": "2018-05-17",
    "screeningTime": "20:00",
    "actors": " Roberto Benigni, Nicoletta Braschi, Giorgio Cantarini, Giustino Durano, Horst Buchholz, Lidia Alfonsi, Marisa Paredes, Sergio Bustric",
    "subtitle": [
      "Si può raccontare l’Olocausto in forma di commedia? Che ciò sia possibile con un personaggio come Hitler, lo hanno dimostrato Chaplin e Lubitsch nei loro capolavori. Ma fare dell’eccidio, organizzato industrialmente, della popolazione ebrea l’oggetto di una commedia? Può riuscire? Il film di Benigni rimane un evento ambivalente, un racconto ambientato in un periodo terribile che cerca di trovare con sensibilità delle immagini particolari per mantenere la dignità delle vittime. "
    ],
    "bodycopy": [
      "All’inizio degli anni ‘30 Guido, con espedienti originali, riesce a conquistare la sua amata Dora. La rapisce poco prima del fidanzamento e fonda con lei una famiglia. Lui apre una libreria, lei è maestra di scuola. La loro vita potrebbe continuare felicemente, se la coppia con il figlioletto Giosuè non incappasse nelle deportazioni naziste.",
      "Per proteggere il figlio dalla crudele realtà, Guido lo illude facendoli apparire la deportazione e il lager come un gioco di enormi dimensioni, nell’ambito del quale loro devono seguire attentamente le regole per vincerlo.",
      "“Il film, un inno alla forza della fantasia e alla volontà di sopravvivenza, inizia come un trascinante idillio con sfumature fiabesche e termina in un’orrenda tragedia in cui il riso rimane congelato in un riflesso doloroso”. (Lexikon des internationalen Films)"
    ],
    "image": "../la-vita-e-bella.jpg"
  },
  {
    "title": "Ladri di biciclette",
    "director": "Vittorio de Sica",
    "country": "Italia",
    "releaseYear": 1948,
    "runtime": 90,
    "version": "OmitU",
    "screeningDate": "05.10.2005",
    "readableDate": "2005-10-05",
    "screeningTime": "18:00",
    "actors": "Lamberto Maggiorani, Enzo Staiola, Lianella Carell, Elena Altieri, Gino Saltamerenda, Giulio Chiari, Vittorio Antonucci, Michele Sakara, Fausto Guerzoni, Massimo Randisi, Ida Bracci",
    "subtitle": [""],
    "bodycopy": [
      "Raccontando la storia di un disoccupato che insegue il ladro della sua bicicletta, indispensabile per il suo nuovo lavoro, questo capolavoro del Neorealismo (Oscar1949) mostra la Roma dell’immediato dopoguerra. Il derubato assieme al figlio incontra la solidarietà, l’indifferenza e in un caso l’evidente ostilità della gente. Infatti un intero quartiere si schiera dalla parte del ladro."
    ],
    "image": "../ladri-di-biciclette.jpg"
  },
  {
    "title": "LAMERICA",
    "director": "Gianni Amelio",
    "country": "Italia",
    "releaseYear": 1994,
    "runtime": 116,
    "version": "OmU",
    "screeningDate": "21.03.2013",
    "readableDate": "2013-03-21",
    "screeningTime": "20:00",
    "actors": "Enrico Lo Verso, Carmelo di Mazzarelli, Michele Placido, Pio Mikani, Carmelo Di Mazzarelli, Elida Janushi, Sefer Pema, Idajet Sejda, Marieta Ljarja, Elina Ndrei, Artan Marina",
    "subtitle": [""],
    "bodycopy": [
      "Per tentare di accaparrarsi una sovvenzione un italiano fonda una società fittizia in Albania. Quello che inizia come un semplice tentativi di truffa, diventa l’esplorazione di un paese ai margini d’Europa e una riflessione sulla migrazione."
    ],
    "image": "../lamerica.jpg"
  },
  {
    "title": "LAMERICA",
    "director": "Gianni Amelio",
    "country": "Italia",
    "releaseYear": 1994,
    "runtime": 116,
    "version": "OmU",
    "screeningDate": "19.06.2014",
    "readableDate": "2014-06-19",
    "screeningTime": "20:00",
    "actors": "Enrico Lo Verso, Carmelo di Mazzarelli, Michele Placido, Pio Mikani, Carmelo Di Mazzarelli, Elida Janushi, Sefer Pema, Idajet Sejda, Marieta Ljarja, Elina Ndrei, Artan Marina",
    "subtitle": [
      "10° anniversario: i maggiori successi del Club del Cinema Italiano"
    ],
    "bodycopy": [
      "Per tentare di accaparrarsi una sovvenzione un italiano fonda una società fittizia in Albania. Quello che inizia come un semplice tentativi di truffa, diventa l’esplorazione di un paese ai margini d’Europa e una riflessione sulla migrazione."
    ],
    "image": "../lamerica2.jpg"
  },
  {
    "title": "LAZZARO FELICE",
    "director": "Alice Rohrwacher",
    "country": "Italia/Svizzera/Francia/Germania",
    "releaseYear": 2018,
    "runtime": 128,
    "version": "OmU",
    "screeningDate": "19.12.2019",
    "readableDate": "2019-12-19",
    "screeningTime": "20:00",
    "actors": " Adriano Tardiolo, Agnese Graziani, Alba Rohrwacher,  Luca Chikovani, Tommaso Ragno, Sergi López, Natalino Balasso, Nicoletta Braschi",
    "subtitle": [
      "Che il film sia una parabola del Lazzaro biblico o meno, non importa. Alice Rohrwacher, servendosi in parte di un linguaggio fiabesco, racconta la storia della povertà nel sistema feudale e quella degli strati sociali che vivono ai margini della società moderna. Fedele alla tradizione del cinema italiano, si ispira però anche al Realismo magico."
    ],
    "bodycopy": [
      "Lazzaro è un osservatore silenzioso, si guarda intorno come se con i suoi occhi volesse penetrare negli anfratti del mondo. Nella vita quotidiana è lo sciocco del villaggio che aiuta tutti e non protesta neppure se gli bevono il suo marsala davanti alla bocca. Vive in una comunità, da collocare evidentemente nella seconda metà del XX secolo, che viene sfruttata come ai tempi del feudalismo. Su tutti domina la marchesa nella sua villa. L'indolente figlio di lei fa amicizia con Lazzaro che lo segue come uno schiavo. Poi un giorno arriva la polizia che fa sgombrare il possedimento e Lazzaro muore.",
      "Non appena resuscita, se ne va in città e incontra di nuovo i suoi vecchi compagni, ormai senzatetto che vivono in una specie di rottamaio. Sono passati dalla estrema povertà in campagna alla miseria urbana.",
      "In tal senso il film presenta succintamente le conseguenze dell'abbandono delle campagne e il perdurare della povertà che così cambia soltanto aspetto.",
      "Il racconto è arricchito da elementi mitici  come il lupo che attraversa più volte la scena, una padella che si trasforma nella luna e una fionda che con suo laccio elastico provoca un salto temporale."
    ],
    "image": "../lazzaro-felice.jpg"
  },
  {
    "title": "Le avventure di Pinocchio",
    "director": "Luigi Comencini",
    "country": "Italia",
    "releaseYear": 1972,
    "runtime": 120,
    "version": "OmitU",
    "screeningDate": "04.07.2007",
    "readableDate": "2007-07-04",
    "screeningTime": "19:00",
    "actors": " Andrea Balestri, Nino Manfredi, Gina Lollobrigida, Franco Franchi, Ciccio Ingrassia, Vittorio de Sica, Lionel Stander, Ugo D'Alessio, Mario Adorf, Enzo Cannavale",
    "subtitle": ["La famiglia Comencini"],
    "bodycopy": [
      "Il film di Luigi Comencini è ritenuto anche oggi la migliore realizzazione del famoso libro per bambini di Carlo Collodi, sebbene o forse proprio perché trasferisce quasi tutti gli elementi fantastici del libro nella realtà prendendosi molte libertà. Poiché Pinocchio la maggior parte del tempo è un ragazzino in carne ed ossa, la favola diventa un racconto reale rendendo il film interessante anche per gli adulti. Comencini convince poi anche per la composizione e l'ambientazione delle immagini."
    ],
    "image": "../pinocchio.jpg"
  },
  {
    "title": "LE CHIAVI DI CASA",
    "director": "Gianni Amelio",
    "country": "Italia/Francia/Deutschlad",
    "releaseYear": 2004,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "20.03.2008",
    "readableDate": "2008-03-20",
    "screeningTime": "19:00",
    "actors": "Kim Rossi Stuart, Charlotte Rampling, Andrea Rossi, Alla Faerovich, Pierfrancesco Favino, Manuel Katzy",
    "subtitle": [""],
    "bodycopy": [
      "La storia di un avvicinamento prudente e problematico. Dopo 15 anni il padre rivede suo figlio handicappato. Il teenager spastico deve sottoporsi a un'operazione a Berlino e il padre lo deve accompagnare proprio nel momento in cui i suoi pensieri sono rivolti alla sua nuova famiglia. Così l'incontro è caratterizzato da insicurezza e diffidenza da parte di entrambi. Mentre il padre si sente dibattuto tra l'istinto protettivo e il tentativo di distanziarsi dalla disabilità del figlio, il ragazzo cerca di sfruttare la nuova situazione per aumentare la sua indipendenza. Prendendo molto sul serio i suoi personaggi Gianni Amelio riesce a realizzare un film poetico e sensibile."
    ],
    "image": "../le-chiavi-di-casa.jpg"
  },
  {
    "title": "Le fate ignoranti",
    "director": "Ferzan Özpetek",
    "country": "Italia",
    "releaseYear": 2000,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "21.10.2004",
    "readableDate": "2004-10-21",
    "screeningTime": "19:30",
    "actors": " Margherita Buy, Stefano Accorsi, Serra Yilmaz, Andrea Renzi, Gabriele Garko",
    "subtitle": ["Italiano con sottotitoli in tedesco)"],
    "bodycopy": [
      "Un museo. Una donna osserva le sculture esposte. Un uomo si avvicina, la circuisce. La donna e l'uomo escono dal museo: da anni sono sposati e abitano in una villa alla periferia di Roma. Una strada trafficata, il cellulare squilla. Disattenzione. E poco dopo l'uomo non vive più. Rimane un dipinto. Sul retro un testo che non lascia ombra di dubbio: l'uomo aveva un rapporto amoroso con “Michele”.",
      "La donna è turbata dalla scoperta che la presunta amante in effetti è un uomo. A poco a poco scopre che suo marito aveva trovato una seconda famiglia in un gruppo di omosessuali e transessuali. Tra delusione, rabbia e fascino cerca i motivi per i quali suo marito amava questo modo così poco convenzionale. E con il tempo la donna sembra prendere inavvertitamente il ruolo del marito in questo strano cosmo. Però nulla è come sembra. Infatti quando le fate sono ignare e ignoranti, le conseguenze dei loro incantesimi sono imprevedibili."
    ],
    "image": "../le-fate-ignoranti.jpg"
  },
  {
    "title": "LE CONSEGUENZE DELL’AMORE",
    "director": "Paolo Sorrentino",
    "country": "Italia",
    "releaseYear": 2004,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "18.11.2021",
    "readableDate": "2021-11-18",
    "screeningTime": "20:00",
    "actors": "Gli attuali film di Paolo Sorrentino hanno incontrato l'interesse di un vasto pubblico (Cheyenne I/F 2011, La grande bellezza F/I 2013, Loro I/F 2018), i suoi primi film invece sono quasi sconosciuti in Germania. Diversamente dalle sue pellicole più recenti, le prime sono caratterizzate da una severità formale che pur non dominando il racconto, ne influenzano la struttura drammaturgica: forma e contenuto si fondono in un evento visivo-narrativo.",
    "subtitle": [""],
    "bodycopy": [
      "Toni Servillo, nel ruolo del commercialista Tita di Girolamo aspetta periodicamente da quasi un decennio in una camera d'albergo che gli portino una valigia che lui con altrettanta regolarità consegna in banca, dove contano le banconote in essa contenute. La sua attività ripetitiva, eseguita con distacco, si anima improvvisamente quando conosce Sofia, la cameriera di un bar. Dallo scambio di parole nasce una certa simpatia che si trasforma in amore, che a sua volta lo induce a prelevare una determinata parte del denaro trasportato. Un fatto che non può rimanere insospettato, l'innamorato viene sottoposto a pressioni da parte dei suoi clienti. E ci mancava pure un gruppo di mafiosi che inseguono la valigia. Rimane poco tempo per l'amore, che ha pure il suo prezzo, un prezzo che non si esprime soltanto in denaro."
    ],
    "image": "../conseguenze.jpg"
  },
  {
    "title": "LE MERAVIGLIE",
    "director": "Alice Rohrwacher",
    "country": "Italia/Germania/Svizzera",
    "releaseYear": 2013,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "17.03.2015",
    "readableDate": "2015-03-17",
    "screeningTime": "20:00",
    "actors": "Alba Rohrwacher, Maria Alexandra Lungu, Sam Louwyck, Monica Bellucci",
    "subtitle": [""],
    "bodycopy": [
      "Gelsomina vive in una masseria malmessa in Toscana con le sorelle e i genitori, che hanno rotti i ponti con la società borghese. I genitori che sognavano una vita alternativa, sono ormai disincantati, ma Gelsomina fa di tutto per salvare i rapporti familiari e la fattoria. Questo film fra la fiaba e la realtà ha ricevuto il \"Gran Premio della Giuria\" a Cannes."
    ],
    "image": "../le-meraviglie.jpg"
  },
  {
    "title": "Le mura di Sana’a",
    "director": "Pier Paolo Pasolini",
    "country": "Italia",
    "releaseYear": 1971,
    "runtime": 14,
    "version": "OmU",
    "screeningDate": "27.02.2011",
    "readableDate": "2011-02-27",
    "screeningTime": "15:00",
    "actors": "",
    "subtitle": [""],
    "bodycopy": [
      "Documentazione \"in forma di un appello all'UNESCO\" sull'architettura dei Sana'a, la capitale dello Yemen, che Pasolini aveva scelto per girare una sequenza poi tagliata fuori nella versione definitiva del DECAMERONE."
    ],
    "image": "../le mura di sana.jpg"
  },
  {
    "title": "Libera terra",
    "director": "Monica Colautti und Frank Wittlinger",
    "country": "Germania",
    "releaseYear": 2007,
    "runtime": 48,
    "version": "OmU",
    "screeningDate": "23.06.2007",
    "readableDate": "2007-06-23",
    "screeningTime": "19:30",
    "actors": "",
    "subtitle": [""],
    "bodycopy": [
      "Corleone – il nome, perlomeno da quando Hollywood iniziò a occuparsi del tema, è sinonimo di mafia e delitti di mafia. Corleone, la località da cui il boss dei boss, Bernardo Provenzano, poté tessere le sue trame per quarant'anni fino all'arresto avvenuto l'11 aprile 2006. Corleone, oggi un paese che con i comuni vicini circonda la cooperativa agricola antimafia \"Placido Rizzotto - Libera Terra“. 10 anni fa il sacerdote torinese, Don Luigi Ciotti, ebbe l'idea di fondare una cooperativa per utilizzare i possedimenti terrieri, confiscati a Cosa Nostra, come originariamente previsto e cioè per la produzione agricola. Grazie all'impegno di vari gruppi il progetto poté esserere alizzato 5 anni fa e, superate le difficoltà iniziali, oggi è bene accettato dagli abitanti della zona e sostenuto da tanti cittadini italiani. I membri della cooperativa non si sono lasciati né scoraggiare dai massicci ostacoli incontrati né dalle minacce ricevute (sementi distrutte, cane impiccato in mezzo ai campi, ecc.). Il film presenta l'iniziativa e la situazione subito dopo la cattura di Provenzano, lascia parlare i membri della cooperativa, gli abitanti e gli attivisti antimafia e mostra allo stesso tempo una mafia che, anche se non compare direttamente nel film, è sempre presente."
    ],
    "image": "../libera-terra-7.jpg"
  },
  {
    "title": "LO CHIAMAVANO JEEG ROBOT",
    "director": "Gabriele Mainetti",
    "country": "Italia",
    "releaseYear": 2015,
    "runtime": 118,
    "version": "OmU",
    "screeningDate": "21.04.2022",
    "readableDate": "2022-04-21",
    "screeningTime": "20:00",
    "actors": "Claudio Santamaria, Ilenia Pastorelli, Luca Marinelli, Stefano Ambrogi u.a",
    "subtitle": [
      "“L'Italia ha finalmente il suo supereroe” era il titolo di Vanity all'uscita di questo film. In effetti però questo eroe non è tanto super ma è più sperduto nel mondo e si barcamena con lavoretti di carattere criminale. Si ritrova improvvisamente ad affrontare il male nella persona di un capobanda esaltato che semina intorno a sé sventure sanguinose. Il film contiene una ricca collezione di citazioni del genere cinematografico dei supereroi mettendo in luce così le assurdità di questa forma di racconto. Il tutto in modo avvincente e divertente. Chi non conosce questo genere, lo vedrà come una commedia criminale in cui i protagonisti, pur dotati di forze speciali, agiscono in effetti come di solito per avidità, ingenuità, inettitudine e furberia. "
    ],
    "bodycopy": [
      "Enzo, un piccolo criminale misantropo, inseguito dalla polizia si getta nel Tevere e viene a contatto con prodotti chimici radioattivi che gli donano proprietà sovraumane. Un “collega” gli fa conoscere la figlia che, soffrendo di disturbi mentali, mescola le azioni dell'anime “Steel Jeeg” con le vicende reali. Enzo è per lei “Hiroshi Shiba”, l'eroe della serie televisiva. Per questo motivo sviluppa un grande attaccamento per lui.",
      "Nel frattempo Fabio, un capobanda criminale, diventa sempre più invidioso del misterioso supercriminale mascherato (Enzo), capace di strappare come niente un bancomat dalla parete e portarselo via. Quando poi davanti ai suoi occhi Enzo lo precede nella rapina di un furgone portavalori, il suo raggio d'azione si restringe. Fabio deve alla capomafia Nunzia i soldi per una fornitura di droga e ora deve temere per la sua vita.",
      "Da questa costellazione si sviluppa una serie di complicazioni fino ad arrivare a uno showdown tra Enzo, nel frattempo convertitosi al bene, e Fabio indiavolato più che mai e ora dotato anche lui di forze sovraumane.",
      "Il film era stato nominato in 17 categorie per il prestigioso premio italiano “David di Donatello” e ne ha vinte 8. La sua ispirazione proviene dalla serie anime “Steel Jeeg” ovvero in italiano “Jeeg robot d'acciaio”."
    ],
    "image": "../sie-nannten-ihn-jeeg-robot-1.jpg"
  },
  {
    "title": "LORO",
    "director": "Paolo Sorrentino",
    "country": "Italia/Francia",
    "releaseYear": 2018,
    "runtime": 157,
    "version": "OmU",
    "screeningDate": "17.06.2021",
    "readableDate": "2021-06-17",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Elena Sofia Ricci, Riccardo Scamarcio, Fabrizio Bentivoglio u.a",
    "subtitle": [
      "Su questo film le opinioni divergono molto. Mentre Dirk Schümer in una recensione afferma che Sorrentino è il primo regista che ha capito l'immenso potenziale visivo dell'epoca berlusconiana (sesso e potere - affari e politica), Lars-Olav Beier si esprime negativamente: \"Invece di osare di andare in profondità, il film si perde allargandosi e così lascia lo spettatore con un senso di vuoto. In ogni caso Sorrentino brilla con l'eccellente messa in scena di feste e incontri in cui Berlusconi, interpretato da Toni Servillo, si spinge con un sorriso stoico.Su questo film le opinioni divergono molto. Mentre Dirk Schümer in una recensione afferma che Sorrentino è il primo regista che ha capito l'immenso potenziale visivo dell'epoca berlusconiana (sesso e potere - affari e politica), Lars-Olav Beier si esprime negativamente: \"Invece di osare di andare in profondità, il film si perde allargandosi e così lascia lo spettatore con un senso di vuoto. In ogni caso Sorrentino brilla con l'eccellente messa in scena di feste e incontri in cui Berlusconi, interpretato da Toni Servillo, si spinge con un sorriso stoico."
    ],
    "bodycopy": [
      "Sergio gestisce un giro di callgirl e vuole conquistare il cliente più potente e più ricco d'Italia: Silvio Berlusconi. Affitta allo scopo uno yacht e la casa adiacente a quella di Berlusconi, organizza feste sontuose accompagnate da musica ad alto volume per attirare l'attenzione del vicino che può vedere che cosa sta succedendo nel giardino dei vicini. Lui e quelli che lo circondano sono affascinati dalla vicinanza del potere e per raggiungere il suo scopo intesse una rete di intrighi.",
      "Berlusconi invece, apparentemente l'uomo più potente del Paese, si annoia talmente nel suo podere da covare banalità. Il fascino di sesso e potere è logorato e il matrimonio è in crisi, infatti sua moglie Veronica lo disprezza. Nel momento in cui viene tradito dai suoi compagni più fidati, decide di riprendere il suo posto a capo del governo.",
      "Sorrentino cerca di illustrare il fenomeno Berlusconi dal suo lato privato, trovandovi però banalità e vuoto, cerca di superarli con delle trovate umoristiche. Rimane il dubbio se in tal modo sia riuscito a spiegare l'epoca berlusconiana."
    ],
    "image": "../loro-5.jpg"
  },
  {
    "title": "Luce dei miei occhi",
    "director": "Giuseppe Piccioni",
    "country": "Italia",
    "releaseYear": 2001,
    "runtime": 114,
    "version": "OmU",
    "screeningDate": "16.06.2005",
    "readableDate": "2005-06-16",
    "screeningTime": "19:30",
    "actors": "Luigi Lo Cascio, Sandra Ceccarelli, Silvio Orlando, Barbara Valente, Tony Bertorelli, Mario Paolo Pierobon",
    "subtitle": ["Rassegna di Luigi Lo Cascio"],
    "bodycopy": [
      "Una ragazza-madre, Maria, cerca con discreto successo di guadagnarsi la vita per sé e la figlia Lisa con un negozio di surgelati. L'autista Antonio riesce a sopportare la sua vita solo fuggendo nel mondo immaginario della fantascienza. Quando Antonio si innamora di Maria e lei inizialmente lo respinge, entrambi devono imparare ad uscire dal loro bozzolo per poter affrontare assieme i problemi della vita.Una ragazza-madre, Maria, cerca con discreto successo di guadagnarsi la vita per sé e la figlia Lisa con un negozio di surgelati. L'autista Antonio riesce a sopportare la sua vita solo fuggendo nel mondo immaginario della fantascienza. Quando Antonio si innamora di Maria e lei inizialmente lo respinge, entrambi devono imparare ad uscire dal loro bozzolo per poter affrontare assieme i problemi della vita.Girato con attori famosi, il film è stato più volte premiato."
    ],
    "image": "../luce-dei-miei-occhi-3.jpg"
  },
  {
    "title": "Ludwig",
    "director": "Luchino Visconti",
    "country": "Italia/Francia/Germania",
    "releaseYear": 1972,
    "runtime": 244,
    "version": "OmU",
    "screeningDate": "22.07.2004",
    "readableDate": "2004-07-22",
    "screeningTime": "19:30",
    "actors": "Helmut Berger, Trevor Howard, Romy Schneider, Silvana Mangano, Gert Fröbe",
    "subtitle": [""],
    "bodycopy": [
      "Durata: 244 minuti (in italiano con sottotitoli in tedesco)",
      "Un'occasione unica per gli amici del cinema italiano. Non mostriamo infatti la solita versione doppiata e accorciata di questo capolavoro di Visconti, ma quella in lingua originale e con la lunghezza originale!",
      "È l'ultimo film della trilogia tedesca (“la caduta degli dei (Die Verdammten)”, “Morte a Venezia (Der Tod in Venedig)” che Visconti ha dedicato alla storia del “re delle fiabe”, Ludwig II di Baviera.",
      "Il film ne racconta oltre 20 anni di vita, dall'incoronamento fino al 1886 e descrive la sua progressiva estraniazione dalla realtà e la sua fuga in mondi visionari e nelle belle arti, che incentiva generosamente. Ludwig convince Richard Wagner, fuggito dai suoi debitori, a tornare, cosa che quest'ultimo sfrutta ampiamente. Un'affinità spirituale la prova per la cugina Elisabetta d'Austria, Sissi, impersonata da Romy Schneider, all'apice della sua carriera e abilità artistica. Incapace di avere rapporti sessuali con il sesso femminile, si sente attirato da quello maschile, senza che pero instauri una vera e propria relazione omosessuale. La sua misteriosa morte nello Starnberger See sembra quindi la logica conseguenza di una vita ai margini della decadenza, la decadenza di un regnante ed anche di un'epoca.",
      "«Helmut Berger interpreta questo Ludwig “di getto”, sembra nato per il ruolo di un re nei confronti del quale si può provare sia disprezzo sia compassione». (Ulrich Behrens)"
    ],
    "image": "../ludwig.gif"
  },
  {
    "title": "Malena",
    "director": "Giuseppe Tornatore",
    "country": "Italia",
    "releaseYear": 2000,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "18.05.2005",
    "readableDate": "2005-05-18",
    "screeningTime": "19:30",
    "actors": "Monica Bellucci, Giuseppe Sulfaro, Luciano Federico, Matilde Piana, Gaetano Aronica, Gabriella di Luzio, Angelo Pellegrino",
    "subtitle": [""],
    "bodycopy": [
      "Poco prima dello scoppio della Seconda Guerra Mondiale a Catelcutò in Sicilia: \"Il fascino di Malena\" fa impazzire tutti gli uomini del paese, presi dalla passione per questa bellissima donna. Però anche un adolescente si innamora della bella, ma irraggiungibile vedova. La osserva e soffre vedendo come gli altri da una parte l'adorano, dall'altra abusano di lei fino a cacciarla dal villaggio a suon di botte. Tornatore (Cinema Paradiso, La leggenda del pianista sull'oceano) ha trasformato i suoi ricordi di gioventù in immagini cinematografiche."
    ],
    "image": "../malena.jpg"
  },
  {
    "title": "MAMMA ROMA",
    "director": "Pier Paolo Pasolini",
    "country": "Italia",
    "releaseYear": 1962,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "14.01.2023",
    "readableDate": "2023-01-14",
    "screeningTime": "21:00",
    "actors": "Anna Magnani, Ettore Garofolo, Franco Citti, Silvana Corsini e altri",
    "subtitle": [
      " Il restauro di MAMMA ROMA è stato eseguito nel 2022 dal Centro Sperimentale di Cinematografia Cineteca Nazionale in base a pellicole negative e con la colonna sonora messa a disposizione da RTI-Mediaset in cooperazione con Infinity+ e Cine 34. Per produrre una versione completa del film, alcune parti, che mancavano tra i negativi o erano compromesse, sono state combinate con un positivo conservato nella Cineteca Nazionale. "
    ],
    "bodycopy": [
      "Mama Roma cerca di lasciare dietro di sé il passato. Carmine, il suo magnaccia e padre di suo figlio, sposa un'altra donna. E lei vuole iniziare una nuova vita. Mamma Roma si trasferisce in un quartiere borghese con il figlio sedicenne, cresciuto in un collegio fuori città, e si mette a vendere frutta e verdura. La nuova vita assieme al ragazzo si rivela estremamente complicata e improvvisamente ricompare Carmine, che nel frattempo si è separato dalla moglie. Carmine pone un ultimatum a Mamma Roma. Mama Roma cerca di lasciare dietro di sé il passato. Carmine, il suo magnaccia e padre di suo figlio, sposa un'altra donna. E lei vuole iniziare una nuova vita. Mamma Roma si trasferisce in un quartiere borghese con il figlio sedicenne, cresciuto in un collegio fuori città, e si mette a vendere frutta e verdura. La nuova vita assieme al ragazzo si rivela estremamente complicata e improvvisamente ricompare Carmine, che nel frattempo si è separato dalla moglie. Carmine pone un ultimatum a Mamma Roma.",
      " \"In questo film ci sono dei momenti di sconvolgente bellezza che si affiancano a immagini di decadenza, anzi che nascono da tale declino e vi rifluiscono. Quando Ettore dopo un furto meschino e un tentativo di suicidio viene ricoverato in psichiatria, uno degli altri pazienti recita brani dall'Inferno di Dante. Subito dopo risuona Vivaldi. Bisogna viverlo al cinema per credere che questo momento non precipiti nel kitsch\". (Claus Löser) "
    ],
    "image": "../mamma-roma-1.jpg"
  },
  {
    "title": "Mamma Roma",
    "director": "Pier Paolo Pasolini",
    "country": "Italia",
    "releaseYear": 1962,
    "runtime": 110,
    "version": "OmitU",
    "screeningDate": "02.09.2009",
    "readableDate": "2009-09-02",
    "screeningTime": "20:00",
    "actors": "Anna Magnani, Ettore Garololo, Franco Citti, Silvana Corsini, Luisa Loiano, Paolo Volponi, Luciano Gonini, Vittorio La Paglia, Piero Morgia, Lanfranco Ceccarelli",
    "subtitle": ["Rassegna di Pier Paolo Pasolini"],
    "bodycopy": [
      "Già in questo film, uno dei suoi primi capolavori, Pasolini dimostra la sua incompatibilità con qualsiasi forma di ideologia. Il suo marxismo radicale lo induce ad orientarsi al Neorealismo per fornire un quadro del subproletariato in conflitto tra ideali piccolo borghesi e la lotta esistenziale contro lo sfruttamento e le ingiustizie: la prostituta “Mamma Roma” (Anna Magnani) pur facendo ogni sforzo per inserire il figlio in un ceto sociale più elevato, fallisce a causa degli insormontabili ostacoli posti da una società caratterizzata da rapporti rigidi, predefiniti."
    ],
    "image": "../mammaroma.jpg"
  },
  {
    "title": "MARRAKECH EXPRESS",
    "director": "Gabriele Salvatores",
    "country": "Italia",
    "releaseYear": 1989,
    "runtime": 110,
    "version": "OmitU",
    "screeningDate": "07.10.2009",
    "readableDate": "2009-10-07",
    "screeningTime": "20:00",
    "actors": "Diego Abantantuono, Fabrizio Bentivoglio, Cristina Marsillach, Giuseppe Cederna, Gigio Alberti",
    "subtitle": [
      "Rassegna: Un caso per due - Gabriele Salvatores (regista) e Diego Abantantuono (attore)"
    ],
    "bodycopy": [
      "Il film racconta la storia di un gruppo di amici che, ritrovandosi dopo quasi dieci anni, decidono di fare un viaggio allo scopo di liberare un altro membro del vecchio gruppo, finito in carcere per possesso di droga. L’avventuroso viaggio, caratterizzato dall’ebbrezza della fuga, li porta dall’Italia attraverso Francia e Spagna in Marocco e dà modo ai protagonisti di reinstaurare i rapporti che negli anni si erano appannati."
    ],
    "image": "../marrakech-express.jpg"
  },
  {
    "title": "MARTIN EDEN",
    "director": "Pietro Marcello",
    "country": "Italia/Francia/Germania",
    "releaseYear": 2019,
    "runtime": 129,
    "version": "OmU",
    "screeningDate": "16.06.2022",
    "readableDate": "2022-06-16",
    "screeningTime": "20:00",
    "actors": "Luca Marinelli, Jessica Cress, Denise Sardisc, Vincenzo Nemolato, Carmen Pommella, Elisabetta Volagoi e altri",
    "subtitle": [
      "Dopo aver conosciuto Elena Orsini, una donna di estrazione alto-borghese, il marinaio Martin Eden cova il desiderio di inserirsi nel mondo di lei. Inizia a studiare la letteratura e legge tutto quello che gli capita tra le mani. Il suo furore culturale e le sue ambizioni letterarie incontrano però soltanto una benevola condiscendenza, e non unicamente nella famiglia Orsini, ma anche da parte dell'amata Elena. Anche quando miete il primo successo, il loro atteggiamento non cambia. Un fatto che ha delle gravi conseguenze. "
    ],
    "bodycopy": [
      "L'amore può resistere nonostante la differenza di classe, o addirittura superare le contraddizioni che ciò comporta? Quanto deve piegarsi il proletario Martin Eden per immergersi nella vita altoborghese? Quanto deve cedere uno scrittore prima di perdere se stesso?",
      "Il regista Pietro Marcello ha trasferito il romanzo, semiautobiografico di Jack London, nella Napoli dell'inizio del XX secolo, e intreccia le vicende biografiche con i processi politici in corso in Europa. Un film storico che non mette in mostra i costumi e gli arredamenti, ma raffigura intensamente la vita delle persone nel loro secolo.",
      "Oltre a numerosi altri premi. Luca Marinelli ha ricevuto a Venezia nel 2019 la Coppa Volpi quale migliore attore."
    ],
    "image": "../martin-eden-liest-am-hafen.jpg"
  },
  {
    "title": "MATRIMONIO ALL’ITALIANA",
    "director": "Vittorio De Sica",
    "country": "Italia",
    "releaseYear": 1963,
    "runtime": 101,
    "version": "OmU",
    "screeningDate": "16.06.2011",
    "readableDate": "2011-06-16",
    "screeningTime": "20:00",
    "actors": "Sophia Loren, Marcello Mastroianni, Aldo Puglisi, Tecia Scarano, Marilù Tolo, Gianni Ridolfi, Vito Moricone, Generoso Cortini, Enzo Aita",
    "subtitle": ["Omaggio a Vittorio de Sica"],
    "bodycopy": [
      "Di nuovo una brillante interpretazione della coppia Mastroianni-Loren in una commedia di De Sica Per paura di perdere il suo amante Domenico, che si è invaghito di un'altra donna, la prostituta Filumena finge di avere una grave malattia. Il suo ultimo desiderio prima di morire è quello di sposare Domenico. Lui acconsente, subito si trova un prete che però non solo celebra il matrimonio, ma riesce pure “miracolosamente” a guarirla. Domenico ha ora un solo pensiero: come riuscire a liberarsi dalla trappola."
    ],
    "image": "../matrimonio-allitaliana.jpg"
  },
  {
    "title": "Medea",
    "director": "Pier Paolo Pasolini",
    "country": "Italia/Germania/Francia",
    "releaseYear": 1969,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "27.01.2021",
    "readableDate": "2021-01-27",
    "screeningTime": "20:00",
    "actors": "Maria Callas, Massimo GIrotti, Laurent Terzeiff, Giuseppe Gentile, ;argareth Clémenti, Gerard Weiss, Sergio Tramonti, Luigi Barbini, Anna Maria Chio",
    "subtitle": [""],
    "bodycopy": [
      "L'intenzione di Pasolini è evidente: non vuole mettere in scena un altro classico con lo spirito di una falsità umanistica, ma un dramma etnologico del confronto interculturale."
    ],
    "image": "../Medea.jpg"
  },
  {
    "title": "Mediterraneo",
    "director": "Gabriele Salvatores",
    "country": "Italia",
    "releaseYear": 1991,
    "runtime": 99,
    "version": "OmU",
    "screeningDate": "07.03.2007",
    "readableDate": "2007-03-07",
    "screeningTime": "19:00",
    "actors": "Diego Abantantuono, Claudio Bigagli, Giuseppe Cederna, Claudio Bisio, Luigi Alberti, Ugo Conti, Memo Dini, Vasco Mirandola, Vana Barba ",
    "subtitle": [""],
    "bodycopy": [
      "Nella primavera del 1941 una pattuglia di otto soldati italiani occupa Syrna,un'isoletta greca sperduta nell'Egeo. L'arida isola sembra al primo momento abbandonata. Poi però si scopre che è popolata da donne, vecchi e bambini, e da un pope arguto e spiritoso, mentre gli uomini sono stati deportati dai tedeschi. Ben presto i soldati dimenticano la guerra e la guerra i soldati. Oscar 1992 comemigliore film straniero."
    ],
    "image": "../mediterraneo.jpg"
  },
  {
    "title": "Mia madre (Mia Madre)",
    "director": "Nanni Moretti",
    "country": "Italia/Francia/Germania",
    "releaseYear": 2015,
    "runtime": 106,
    "version": "OmU",
    "screeningDate": "18.05.2017",
    "readableDate": "2017-05-18",
    "screeningTime": "20:00",
    "actors": "Margherita Buy, John Turturro, Giulia Lazzarini, Nanni Moretti, Beatrice Mancini, Stefano Abbati, Anna Bellato, Lorenzo Gioielli",
    "subtitle": [
      "Nel suo ultimo film Nanni Moretti elabora la morte di sua madre contrastando la pesante atmosfera di un ospedale con il caos del set cinematografico. Ricordi e sogni della protagonista (Margherita Buy) integrano il quadro."
    ],
    "bodycopy": [
      "La regista Margherita si è separata dal compagno, la figlia comincia a prendere la propria strada e sul set una stellina americana fa impazzire tutti. Allo stesso tempo sua madre è in ospedale senza speranza di recupero. Suo fratello si occupa con sensibilità di lei, mentre la sorella non è all’altezza della situazione.-",
      "In questo contesto Margherita si mette alla ricerca delle cose veramente importanti della vita.",
      "Moretti commemora con il film la morte di sua madre, parla però anche del significato del cinema, di realtà e finzione nonché del ruolo del lavoro e della sua importanza per le singole persone."
    ],
    "image": "../mia-madre.jpg"
  },
  {
    "title": "Milano Calibro 9",
    "director": "Fernando di Leo",
    "country": "Italia",
    "releaseYear": 1972,
    "runtime": 98,
    "version": "OmU",
    "screeningDate": "14.12.2005",
    "readableDate": "2005-12-14",
    "screeningTime": "21:30",
    "actors": "Gastone Moschin, Barbara Bouchet, Mario Adorf, Frank Wolff, Luigi Pistilli, Ivo Garrani, Philippe Leroy, Lionel Stander",
    "subtitle": ["Rassegna di Mario Adorf"],
    "bodycopy": [
      "Uno dei più significativi film polizieschi: Ugo Piazza esce di prigione dopo tre anni. L’“Americano” crede che Ugo gli abbia trafugato 300.000 dollari e gli mette alle calcagna Rocco Musco (Mario Adorf), un uomo violento e privo di scrupoli. Ma non solo lui è alla caccia dei soldi ....E così la storia continua tra sorprendenti capriole. Un film caratterizzato da inquadrature moderne e la musica avvincente di Luis Enríquez Bacalov, premiato con l'Oscar (“Il postino”, “Il Vangelo secondo Matteo”). Noi mostriamo la versione originale in tutta lunghezza. La versione doppiata in tedesco era stata notevolmente molto accorciata a suo tempo."
    ],
    "image": "../calibro-9.jpg"
  },
  {
    "title": "MIMÌ METALLURGICO FERITO NELL'ONORE",
    "director": "Lina Wertmüller",
    "country": "Italia",
    "releaseYear": 1972,
    "runtime": 115,
    "version": "OmU",
    "screeningDate": "15.08.2013",
    "readableDate": "2013-08-15",
    "screeningTime": "20:00",
    "actors": "Giancarlo Giannini, Mariangela Melato, Turi Ferro, Agostina Belli, Turi Ferro, Luigi Diberti",
    "subtitle": ["Lina Wertmüller compie 85 anni"],
    "bodycopy": [
      "Siccome Mimi alle elezioni ha dato il suo voto “segreto” a sinistra, deve andarsene al Nord dove trova lavoro alla Fiat. Lì si innamora di Fiore, una comunista che gli crea problemi con la sua possessività quando torna in Sicilia e sua moglie pretende che assolva i suoi “doveri coniugali”. Quando quest’ultima rimane incinta di un altro, tutti aspettano che lui difenda il suo onore. E Mimì ha un’idea inconsueta. Una brillante satira sociale."
    ],
    "image": "../film-damore.jpg"
  },
  {
    "title": "MINE VAGANTI",
    "director": "Ferzan Özpetek",
    "country": "Italia",
    "releaseYear": 2010,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "20-10-2011",
    "readableDate": "2011-10-20",
    "screeningTime": "20:00",
    "actors": "Riccardo Scamarcio, Nicole Grimaudo, Lunetta Savino, Elena Sofia Ricci, Ennio Fantastichini, Ilaria Occhini, Alessandro Preziosi, Bianca Nappi, Massimiliano Gallo, Daniele Pecci",
    "subtitle": [""],
    "bodycopy": [
      "Nella vita quello che conta è trovare il momento giusto. Tommaso vuole rivelare alla famiglia la sua omosessualità, però suo fratello maggiore lo precede, cosa che ha conseguenze fatali: il padre viene colpito da un infarto.Tutt’a un tratto si ritrova nel ruolo del successore nell’azienda del padre, un ruolo che non gli garba per nulla. E come se non bastasse gli viene affiancata una “partner” e anche la nonna non è quello che sembrava. Conviene confrontare questo nuovo film di Özpetek con quello con cui ha conquistato la sua fama internazionale."
    ],
    "image": "../mine-vaganti.jpg"
  },
  {
    "title": "MIO FRATELLO È FIGLIO UNICO",
    "director": "Daniele Luchetti",
    "country": "Italia/Francia",
    "releaseYear": 2007,
    "runtime": 104,
    "version": "OmU",
    "screeningDate": "18.02.2016",
    "readableDate": "2016-02-18",
    "screeningTime": "20:00",
    "actors": "Elio Germano, Riccardo Scamarcio, Angela Finocchiaro, Massimo Popolizio, Alba Rohrwacher, Luca Zingaretti, Anna Bonaiuto, Diane Fleri, Ascanio Celestini, Vittorio Emanuele Propizio",
    "subtitle": [""],
    "bodycopy": [
      "Anni '60/'70. È la storia di Accio, la pecora nera di una famiglia di operai. Oltre a cercare di portar via la ragazza a suo fratello Manrico, simpatizzante della sinistra, lo provoca avvicinandosi ai fascisti. Ciononostante il legame tra i due fratelli rimane intatto nel corso degli anni fino alla svolta incisiva dovuta al contatto con le Brigate rosse."
    ],
    "image": "../mio-fratello-e-figlio-unico.jpg"
  },
  {
    "title": "Miracolo a Milano",
    "director": "Vittorio de Sica",
    "country": "Italia",
    "releaseYear": 1951,
    "runtime": 100,
    "version": "OmitU",
    "screeningDate": "03.12.2008",
    "readableDate": "2008-12-03",
    "screeningTime": "19:00",
    "actors": "Emma Grammatica, Francesco Golisano, Paolo Stoppa, Guglielmo Barnabò, Brunella Bovo",
    "subtitle": [""],
    "bodycopy": [
      "Anche oggi commuove la favola surrealista del buon Totò, un ragazzo orfano che finisce in un misero quartiere ai margini di Milano. Quando lì viene scoperto un giacimento di petrolio, i poveri vengono sloggiati e mandati in campagna, dove \"buongiorno voglia davvero dire buongiorno\". Grazie all’angelo custode e alla colomba magica donatagli dalla madre adottiva riesce però a scacciare gli speculatori. I comunisti criticarono il film considerandolo una \"consolazione di stampo cattolico\". Altri ci videro il manifesto della rivoluzione sociale. Per i cinefili il film è uno dei capolavori della storia del cinema."
    ],
    "image": "../miracolo-a-milano.jpg"
  },
  {
    "title": "Mobbing - Mi piace lavorare",
    "director": "Francesca Comencini",
    "country": "Italia",
    "releaseYear": 2007,
    "runtime": 89,
    "version": "OmitU",
    "screeningDate": "05.09.2021",
    "readableDate": "2021-09-05",
    "screeningTime": "89",
    "actors": "Nicoletta Braschi, Camille Dugay Comencini, Marina Buoncristiani, Roberta Celea, Assunta Cestaro, Stefano Colace, Claudia Coli",
    "subtitle": ["La famiglia Comencini"],
    "bodycopy": [
      "Quello che inizia con piccole \"disattenzioni\" dopo la fusione dell'azienda in cui lavora, diventa per Anna una cascata di umiliazioni sempre più dolorose. Ne soffre anche il rapporto con sua figlia con la quale, dopo il divorzio, si capiva bene. Questo film di Francesca Comencini, una donna impegnata socialmente e politicamente, è stato presentato nella serie Panorama alla Berlinale, ma fino ad oggi non ha trovato un distributore tedesco. Approfittate dell’unica occasione per conoscere questa regista ancora praticamente sconosciuta in Germania."
    ],
    "image": "../mobbing.jpg"
  },
  {
    "title": "MÖRDERISCHE GESELLSCHAFTEN - Die Geschichte der Mafia” (Società micidiali - La storia della mafia)",
    "director": "Bernhard Pfletschinger",
    "country": "Germania",
    "releaseYear": 2010,
    "runtime": 90,
    "version": "OmU",
    "screeningDate": "07.10.2021",
    "readableDate": "2021-10-07",
    "screeningTime": "02:00",
    "actors": "",
    "subtitle": [""],
    "bodycopy": [
      "Non esiste una sola mafia. Troppo diverse sono le strutture mafiose della \"camorra\" campana, della \"‘ndragheta\" calabrese e della siciliana \"cosa nostra\" e la loro storia. Bernd Pfletschinger si è dedicato alla ricerca delle origini e degli sviluppi delle singole organizzazioni e mostra come sia profondo il radicamento di tali organizzazioni nella storia d’Italia e della sua popolazione. Ma le loro losche trame non si limitano al territorio italiano, bensì si stanno sempre più internazionalizzando e diventando una minaccia per le democrazie del mondo. In questo film parlano storici, giudici penali e parenti di vittime esprimendo i loro pareri e i loro ricordi e cercando di spiegare l’irrefrenabile scalata e il potere quasi illimitato delle mafie. Bernhard Pfletschinger presenterà personalmente il suo film e parlerà assieme ad altri ospiti con il pubblico. A fine serata verràofferto un piccolo rinfresco. "
    ],
    "image": "../moerderische-gesellschaften.jpg"
  },
  {
    "title": "NAPOLI VELATA",
    "director": "Ferzan Özpetek",
    "country": "Italia",
    "releaseYear": 2017,
    "runtime": 112,
    "version": "OmU",
    "screeningDate": "21.02.2019",
    "readableDate": "2019-02-21",
    "screeningTime": "20:00",
    "actors": "Giovanna Mezzogiorno, Alessandro Borghi, Anna Bonaiuto, Peppe Barra, Biagio Forestieri, Lina Sastri, Isabella Ferrari, Luisa Ranieri, Maria Pia Calzone, Carmine Recano, Loredana Cannata, Angela Pagano, Maria Luisa Santella",
    "subtitle": [
      "In questo film non ci si può assolutamente fidare di quello che si vede. Özpetek crea un mondo artificiale in quello reale e gioca abbondantemente con le limitazioni dei classici generi cinematografici. Il risultato è un’atmosfera enigmatica, riccamente illustrata, che nello spettatore provoca ripetute irritazioni e gli fa apparire in nuova luce quello che ha appena visto. Alla fine lo spettatore esce dalla sala chiedendosi che cosa sia veramente successo. "
    ],
    "bodycopy": [
      "Adriana, medico legale, ormai non più giovanissima, durante una festa elegante diventa oggetto dell’attenzione di Andrea, un uomo attraente, più giovane di lei, che la seduce. Le promette l’amore, ma tuttavia non compare all’appuntamento del giorno successivo. Ore più tardi lo ritrova invece ucciso brutalmente sul tavolo anatomico dell’obitorio in cui lavora.",
      "Vedendolo però più tardi nei vicoli di Napoli e infine pure nel suo giardino, dubita delle sue facoltà mentali. Nel frattempo viene sospettata della polizia di aver compiuto l’omicidio e lei, confusa dalle sue impressioni e dai suoi ricordi, cade in contraddizione. La situazione non migliora quando il presunto morto si fa vivo. La cosa si chiarisce abbastanza velocemente, ma si può essere certi che sia vero?"
    ],
    "image": "../napoli-velata.jpg"
  },
  {
    "title": "NIRVANA",
    "director": "Gabriele Salvatores",
    "country": "Italia/Francia",
    "releaseYear": 1997,
    "runtime": 112,
    "version": "OmU",
    "screeningDate": "15.03.2007",
    "readableDate": "2007-03-15",
    "screeningTime": "19:00",
    "actors": "Christopher Lambert, Diego Abantantuono, Stefania Rocca, Emmanuelle Seigner, Amanda Sandrelli",
    "subtitle": [""],
    "bodycopy": [
      "\"Che cosa faccio qui, e perché sono qui e non da un'altra parte?\" Questa è la domanda che si pone Solo, il protagonista di un gioco elettronico che, a causa di un virus, è diventato cosciente, però essendo un personaggio virtuale è condannato a ripetere sempre la stessa \"vita\". Perciò prende contatto con il suo \"creatore\" pregandolo di distruggere il suo programma. Con questo film Salvatores sonda le domande essenziali dell'esistenza umana reale nell'ambiente moderno della realtà virtuale. Un'opera che in Germania, ingiustamente, non è stata quasi notata e quindi raramente presente nei cinema."
    ],
    "image": "../nirvana.gif"
  },
  {
    "title": "NOME DI DONNA",
    "director": "Marco Tullio Giordana",
    "country": "Italia",
    "releaseYear": 2018,
    "runtime": 87,
    "version": "OmU",
    "screeningDate": "16.05.2019",
    "readableDate": "2019-05-16",
    "screeningTime": "20:00",
    "actors": "Cristiana Capotondi, Anita Kravos, Michela Cescon, Stefano Scandaletti, Bebo Storti, Laura Marinoni, Anita Kravos, Stefania Monaco",
    "subtitle": [
      "Se la produzione del film non fosse iniziata prima del movimento “Me-too”, si potrebbe prenderlo per il commento perfetto a questo tema. L’amicizia e la solidarietà tra colleghe ormai non conta più. Tutti “lo” sanno, molti lo fanno per paura di perdere il posto di lavoro, per la carriera o per una simpatia male interpretata e... tacciono. "
    ],
    "bodycopy": [
      "Nina è felice: ha preso un posto di lavoro in una lussuosa casa di riposo in Lombardia che gli permette di seguire anche la figlia nella sua vita privata. Si inserisce velocemente nelle sue nuove mansioni e fa amicizia con le colleghe. Quando un giorno, inaspettatamente, il direttore della clinica la fa chiamare per un colloquio dopo il suo turno di lavoro, non sa che cosa l’aspetta. Chiede alle colleghe che però le danno risposte sfuggenti e così va al colloquio nei suoi abiti normali. Prima di tutto il direttore le chiede perché non si sia presentata nella divisa di servizio, e le capisce in fretta che lui vuole far valere le sue pretese sessuali di tipo feticista.",
      "Quando Nina tenta di parlarne con le colleghe e far loro capire che lei si è difesa dai soprusi di lui, viene sempre più isolata fino ad essere oggetto di mobbing. Anche il prete, che le aveva procurato il posto di lavoro, afferma di non poterla aiutare. Il direttore ecclesiastico dell’istituzione cerca inizialmente di calmarla, però passa poi sempre di più a gravi minacce.",
      "Un aiuto lo riceve Nina da un’istituzione sociale i cui membri inizialmente non riescono a fare nulla. Però allora Nina può cominciare a lottare."
    ],
    "image": "../nome-di-donna.jpg"
  },
  {
    "title": "NON CI È STATO REGALATO NIENTE",
    "director": "Eric Esser",
    "country": "Germania",
    "releaseYear": 2014,
    "runtime": 58,
    "version": "OmU",
    "screeningDate": "19.11.2015",
    "readableDate": "2015-11-19",
    "screeningTime": "20:00",
    "actors": "Anita „Laila” Malavasi, Pierina „Iva Bonilauri”, Gina „Sonia” Moncigoli e altri",
    "subtitle": [""],
    "bodycopy": [
      "Un ritratto della partigiana Anita Malavasi che nel 1943, a 22 anni, combatté con il nome \"Leila\" contro l'occupazione tedesca e fu una delle poche comandanti donne della Resistenza italiana. Lei e due sue compagne raccontano di quel periodo che ha segnato la loro vita e del significato che ha avuto per la loro emancipazione."
    ],
    "image": "../non-ci-e-stato-regalato-niente.png"
  },
  {
    "title": "NON ESSERE CATTIVO",
    "director": "Claudio Caligari",
    "country": "Italia",
    "releaseYear": 2015,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "21.12.2017",
    "readableDate": "2017-12-21",
    "screeningTime": "20:00",
    "actors": "Luca Marinelli, Alessandro Borghi, Silvia D'Amico, Roberta Mattei, Valentino Campitelli, Alessandro Bernardini, Danilo Cappanelli, Manuel Rulli, Elisabetta De Vito",
    "subtitle": [
      "“Ragazzi di vita” di Pasolini, trasportato nella nostra epoca: Droghe, sesso e consumi sono al centro della loro vita di sfaccendati, caratterizzata da piccoli reati e da una violenza eruttiva che spesso si scatena improvvisamente. "
    ],
    "bodycopy": [
      "Vittorio e Cesare cercano di riempire la loro vita vuota con stupefacenti e notti nei night club. Gli eccessi li finanziano trafficando droga a basso livello e rapinando bar e tabaccherie. Vittorio, che si è innamorato, cerca di rimettersi in riga e condurre una vita normale. Cesare invece sprofonda sempre di più nella tossicodipendenza e nel traffico di droga e non ce la fa a sostenere Vittorio che cerca di aiutarlo.",
      "Da una piccola storia nasce il quadro dell’ambiente di persone socialmente emarginate, come il cinema italiano raramente è riuscito a dare dai tempi del Neorealismo. Il film non ha bisogno di grandi gesta per delineare questo mondo, gli bastano i luoghi originali, scelti e fotografati con grande maestria da Maurizio Calvesi (VIVA LA LIBERTÀ, MINE VAGANTI), luoghi che parlano da sé: strade dissestate, fiancheggiate da case diroccate, spiagge sporche, che tuttavia si trasformano in qualsiasi momento in pittoreschi panorami marini, mura sbiadite e molto di più."
    ],
    "image": "../non-essere-cattivo.jpg"
  },
  {
    "title": "Non pensarci",
    "director": "Gianni Zanasi",
    "country": "Italia",
    "releaseYear": 2007,
    "runtime": 104,
    "version": "OmU",
    "screeningDate": "15.09.2011",
    "readableDate": "2011-09-15",
    "screeningTime": "20:00",
    "actors": "Valerio Mastandrea, Anita Caprioli, Giuseppe Battiston, Teco Celio, Gisella Burinato, Caterina Murino, Paolo Briguglia, Dino Abbrescia",
    "subtitle": [""],
    "bodycopy": [
      "Conflitti intergenerazionali e familiari, crisi di identità e problemi di coppia. Hollywood ne avrebbe ricavato un melodramma. Zanasi racconta con una strizzata d’occhi tutta italiana la storia di uno spensierato musicista punk, nel quale in breve tutti i membri della famiglia sperano di trovare supporto. Il film è un quadro divertente e sensibile della media borghesia italiana dei nostri giorni."
    ],
    "image": "../non-pensarci.jpg"
  },
  {
    "title": "Novecento",
    "director": "Bernardo Bertolucci",
    "country": "Italia/Francia/Germania",
    "releaseYear": 1976,
    "runtime": 310,
    "version": "OmU",
    "screeningDate": "06.07.2011",
    "readableDate": "2011-07-06",
    "screeningTime": "18:00",
    "actors": "Robert De Niro, Gérard Depardieu, Dominique Sanda, Stefania Sandrelli, Laura Betti, Donald Sutherland, Burt Lancaster Berlinghieri, Sterling Hayden, Werner Bruhns, Romolo Valli, Anna Maria Gherardi, Roberto Maccanti, Paolo Pavesi, Alida Valli, Anna Henkel, Stefania Casini, Francesca Bertini, Ellen Schwiers",
    "subtitle": ["150 anni dall'unità d'Italia"],
    "bodycopy": [
      "Due ragazzi, nati lo stesso giorno a cavallo del nuovo secolo in un podere della pianura padana, sono amici d’infanzia, ma a causa degli avvenimenti storici e la loro estrazione sociale, crescendo diventano acerrimi nemici. Sullo sfondo di questa storia Bertolucci disegna un impressionante quadro dello sviluppo politico e sociale dell’Italia dalla fine dell’Ottocento alla caduta del fascismo. Mostriamo entrambe le parti del film, intervallate da una breve pausa."
    ],
    "image": "../novecento.jpg"
  },
  {
    "title": "NUOVOMONDO",
    "director": "Emanuele Crialese",
    "country": "Italia/Francia",
    "releaseYear": 2006,
    "runtime": 118,
    "version": "OmU",
    "screeningDate": "20.02.2014",
    "readableDate": "2014-02-20",
    "screeningTime": "20:00",
    "actors": "Charlotte Gainsbourg, Vincenzo Amato, Aurora Quattrocchi, Francesco Casisa, Filippo Pucillo, Federica de Cola, Isabella Ragonese, Vincent Schiavelli, Massimo Laguardia, Filippo Luna, Adrea Prodan, Ernesto Mahierux",
    "subtitle": [
      "10° anniversario: i maggiori successi del Club del Cinema Italiano"
    ],
    "bodycopy": [
      "Inizio del XX secolo: in Sicilia regna una terribile miseria che induce un incolto contadino vedovo a inseguire le leggende di quel paese delle meraviglie che è l'America ed emigrare con la famiglia. Durante il viaggio si unisce al gruppetto una misteriosa ed elegante inglesina (Charlotte Gainsbourg in un ruolo indimenticabile). Non soltanto la traversata dell'Atlantico mette a dura prova gli emigranti, ma anche quello che devono subire i nuovi arrivati a Ellis Island. Per l'intensità e la forza delle immagini, il film ha ricevuto il Leone d'Oro al Festival di Venezia."
    ],
    "image": "../nuovomondo.jpg"
  },
  {
    "title": "NUOVOMONDO",
    "director": "Emanuele Crialese",
    "country": "Italia/Francia",
    "releaseYear": 2006,
    "runtime": 118,
    "version": "OmU",
    "screeningDate": "15.11.2007",
    "readableDate": "2007-11-15",
    "screeningTime": "19:00",
    "actors": "Charlotte Gainsbourg, Vincenzo Amato, Aurora Quattrocchi, Francesco Casisa, Filippo Pucillo, Federica de Cola, Isabella Ragonese, Vincent Schiavelli, Massimo Laguardia, Filippo Luna, Adrea Prodan, Ernesto Mahierux",
    "subtitle": [""],
    "bodycopy": [
      "Inizio del XX secolo: in Sicilia regna una terribile miseria che induce un incolto contadino vedovo a inseguire le leggende di quel paese delle meraviglie che è l'America ed emigrare con la famiglia. Durante il viaggio si unisce al gruppetto una misteriosa ed elegante inglesina (Charlotte Gainsbourg in un ruolo indimenticabile). Non soltanto la traversata dell'Atlantico mette a dura prova gli emigranti, ma anche quello che devono subire i nuovi arrivati a Ellis Island. Per l'intensità e la forza delle immagini, il film ha ricevuto il Leone d'Oro al Festival di Venezia."
    ],
    "image": "../nuovomondo2.jpg"
  },
  {
    "title": "OLTRE IL GUADO",
    "director": "Lorenzo Bianchini",
    "country": "Italia",
    "releaseYear": 2013,
    "runtime": 88,
    "version": "OmU",
    "screeningDate": "18.03.2021",
    "readableDate": "2021-03-18",
    "screeningTime": "20:00",
    "actors": "Lidia Zabrieszach, Marco Marchese, Renzo Gariup",
    "subtitle": [""],
    "bodycopy": [
      "Seguendo le telecamere appostate per osservare gli animali un etologo si ritrova in un villaggio sperduto sul quale grava una maledizione. Una pioggia battente provoca un'inondazione che ne ostruisce l'unico accesso. Con immagini misteriose torna in scena il genere dell'orrore in veste italiana con un film moderno che ci tocca da vicino."
    ],
    "image": "../il-guado.jpg"
  },
  {
    "title": "Orecchie",
    "director": "Alessandro Aronadio",
    "country": "Italia",
    "releaseYear": 2016,
    "runtime": 90,
    "version": "OmU",
    "screeningDate": "31.10.2019",
    "readableDate": "2019-10-31",
    "screeningTime": "20:00",
    "actors": "Daniele Parisi, Silvia D'Amico, Rocco Papaleo, Pamela Villoresi, Ivan Franek, Piera Degli Esposti, Milena Vukotic, Paolo Giovannucci, Andrea Purgatori, Massimo Wertmüller, Francesca Antonelli, Niccolò Senni, Masaria Colucci, Silvana Bosi, Sonia Gessner",
    "subtitle": [
      "Girata in bianco e nero, questa commedia tratta quasi accidentalmente questioni esistenziali in una sequenza di situazioni spassose, curiose e assurde. Una fotografia severa e una composizione scenica quasi accademica creano un quadro di contrasto che ne sottolinea la serietà.",
      "In cooperazione con l'Istituto Italiano di Cultura di Colonia.",
      "Con il gentile supporto dell'Hotel Orangerie, Düsseldorf."
    ],
    "bodycopy": [
      "Un uomo si sveglia un mattino con un fischio nell'orecchio... che non lo lascia in pace per tutto il film. Sul frigorifero trova un foglietto \"Il tuo amico Luigi è morto\". Ma chi è questo Luigi? Questo è l'inizio di una giornata tragicomica con medici sadici, suore invadenti, una star dell'hip-hop in un ambiente speciale, la domanda di come riuscire a far sorridere la sua fidanzata, e l'incontro con la madre che sta vivendo la sua seconda primavera con un artista che chiama “Performance” le sue opere. E poi di nuovo questo Luigi di cui non riesce a ricordarsi in nessun modo."
    ],
    "image": "../orecchie-5.jpg"
  },
  {
    "title": "Otto e mezzo",
    "director": "Federico Fellini",
    "country": "Italia/Francia",
    "releaseYear": 1962,
    "runtime": 138,
    "version": "OmitU",
    "screeningDate": "03.05.2006",
    "readableDate": "2006-05-03",
    "screeningTime": "18:00",
    "actors": "Marcello Mastroianni, Claudia Cardinale, Anouk Aimée, Sandra Milo, Barbara Steele, Rossella Falk, Madeleine Lebeau, Guido Alberti, Caterina Boratto, Giuditta Rissone, Annibale Ninchi",
    "subtitle": [""],
    "bodycopy": [
      "Un autoritratto o un gioco con e contro le aspettative del suo pubblico? Il film racconta di un regista esaurito che assiste passivamente ai preparativi per il suo prossimo film, che non girerà mai. Fellini tematizza forse la sua crisi creativa? È improbabile perché il film rompe le convenzioni formali del suo tempo ed è considerato uno dei capolavori di Fellini."
    ],
    "image": "../otto-e-mezzo.jpg"
  },
  {
    "title": "Pane e tulipani",
    "director": "Silvio Soldini",
    "country": "Italia",
    "releaseYear": 2000,
    "runtime": 118,
    "version": "OmU",
    "screeningDate": "21.02.2009",
    "readableDate": "2009-02-21",
    "screeningTime": "20:00",
    "actors": "Licia Maglietta, Bruno Ganz, Giuseppe Battiston, Antonio Catania, Marna Massironi, Felice Andreasi",
    "subtitle": ["Rassegna di Silvio Soldini"],
    "bodycopy": [
      "Questo film, diventato il maggior successo di Soldini grazie all’acclamazione del pubblico, descrive con umorismo l’emancipazione di una casalinga qualsiasi dimenticata da marito e figlio in un autogrill. Con un tono da commedia e allo stesso tempo con grande umanità, la donna incontra tipi originali e bizzarri e riesce a farsi strada. Particolarità: Bruno Ganz nel ruolo del cameriere islandese di un malandato ristorante veneziano."
    ],
    "image": "../pane-e-tulipani.jpg"
  },
  {
    "title": "Pane e tulipani",
    "director": "Silvio Soldini",
    "country": "Italia/Svizzera",
    "releaseYear": 2000,
    "runtime": 115,
    "version": "OmU",
    "screeningDate": "19.02.2004",
    "readableDate": "2004-02-19",
    "screeningTime": "19:30",
    "actors": "Licia Maglietta, Bruno Ganz, Giuseppe Battiston, Antonio Catania",
    "subtitle": [""],
    "bodycopy": [
      "Bruno Ganz, nel suo ruolo di Fernando, un cameriere islandese, siede pensieroso di fronte ad un mazzo di tulipani che stanno appassendo. Più petali cadono, più ferma diventa la sua intenzione di parlare con Rosalba (Licia Maglietta) e porle la domanda della sua vita. In questo momento, però, il film sta volgendo già alla fine e non rimane altro che aspettare quali conseguenze i due protagonisti trarranno dalle loro esperienze.",
      "Dopo esser stata dimenticata dalla sua famiglia in un autogrill, Rosalba “approda” in un ristorante veneziano, dove lavora Fernando. Tra i due si sviluppa piano piano un rapporto umano discreto, intorno al quale ronzano un’”energica” massaggiatrice e un detective improvvisato, che li spia su incarico del marito di Rosalba.",
      "“Una commedia erotica senza carne nuda che può ben rinunciare ai gesti goffi di certe commedie tedesche“, così l’ha definita uno spettatore al Cineforum.",
      "Uno dei film di maggior successo degli ultimi anni nelle sale alternative di Düsseldorf. Mostrato prevalentemente nella versione doppiata, ora si presenta una delle rare occasioni di vederlo in lingua originale (con sottotitoli in tedesco) e sentire, ad esempio, Bruno Ganz parlare un italiano toccante."
    ],
    "image": "../pane-e-tulipani2.jpg"
  },
  {
    "title": "Pane, amore e...",
    "director": "Dino Risi",
    "country": "Italia",
    "releaseYear": 1955,
    "runtime": 98,
    "version": "OmU",
    "screeningDate": "07.07.2010",
    "readableDate": "2010-07-07",
    "screeningTime": "20:00",
    "actors": "Vittorio De Sica, Sophia Loren, Lea Padovani, Antonio Cifariello, Tica Pica, Mario Carotenuto, Yoka Berretty, Virgilio Riento",
    "subtitle": ["Rassegna di Dino Risi"],
    "bodycopy": [
      "Siccome Luigi Comencini non voleva più girare altre puntate della serie “Pane, amore eSiccome Luigi Comencini non voleva più girare altre puntate della serie “Pane, amore e...”, Sophia Loren subentrò nel ruolo di Gina Lollobrigida e il giovane Dino Risiassunse la regia. Nel film Vittorio de Sica è il maresciallo Antonio Carotenuto che alritorno nel paese natio trova il suo appartamento occupato da una bella donna dalcarattere ribelle. L'affascinante Sophia mette a dura prova l'irresistibile Casanova.Una tipica commedia all'italiana."
    ],
    "image": "../pane-amore.jpg"
  },
  {
    "title": "PASQUALINO SETTEBELLEZZE",
    "director": "Lina Wertmüller",
    "country": "Italia",
    "releaseYear": 1975,
    "runtime": 116,
    "version": "OmU",
    "screeningDate": "16.10.2008",
    "readableDate": "2008-10-16",
    "screeningTime": "19:00",
    "actors": "Giancarlo Giannini, Fernando Rey, Shirley Stoler, Elena Fiore",
    "subtitle": ["Lina Wertmüller fa 80 anni"],
    "bodycopy": [
      "Un gangster napoletano sa come difendere l’onore: ammazza l’amante di una delle sue sette sorelle. Quando più avanti nella vita si ritrova in un campo di concentramento, può sopravvivere soltanto prestando i suoi servizi amorosi a una kapò brutta e sadica. Ed ecco che si ripresenta il conflitto morale. “Un melodramma grottesco, unumorismo macabro, messo in scena magistralmente”. “Uno dei più importanti film degli anni 70, che funziona sia come commedia bislacca sia come film contro la guerra”."
    ],
    "image": "../pasqualino-settebellezze.jpg"
  },
  {
    "title": "Pianese Nunzio - 14 anni a maggio",
    "director": "Antonio Capuano",
    "country": "Italia",
    "releaseYear": 1996,
    "runtime": 115,
    "version": "OmU",
    "screeningDate": "16.03.2006",
    "readableDate": "2006-03-16",
    "screeningTime": "19:30",
    "actors": "Fabrizio Bentivoglio, Emanuele Gargiulo, Rosaria De Cicco, Teresa Saponangelo, Tonino Taiuti",
    "subtitle": [""],
    "bodycopy": [
      "Non appena il prete Lorenzo a Napoli comincia a incitare la gente contro la Camorra, l'organizzazione criminale lancia una campagna diffamatoria contro il sacerdote facendo perno sulla sua amicizia con il 13enne Nunzio. Però per Camorra, polizia e alta società non si rivela per nulla facile arrivare al ragazzo che proviene da una famiglia disgraziata. Quando Lorenzo si accorge che Nunzio non aprendo bocca si sta mettendo in pericolo, decide di intervenire.Non appena il prete Lorenzo a Napoli comincia a incitare la gente contro la Camorra, l'organizzazione criminale lancia una campagna diffamatoria contro il sacerdote facendo perno sulla sua amicizia con il 13enne Nunzio. Però per Camorra, polizia e alta società non si rivela per nulla facile arrivare al ragazzo che proviene da una famiglia disgraziata. Quando Lorenzo si accorge che Nunzio non aprendo bocca si sta mettendo in pericolo, decide di intervenire.Questo film girato dieci anni fa ha acquisito di nuovo attualità in seguito alle recenti direttive del Vaticano sui preti omosessuali."
    ],
    "image": "../pianese-nunzio.jpg"
  },
  {
    "title": "Piazza delle Cinque Lune",
    "director": "Renzo Martinelli",
    "country": "Italia/Gran Bretagna",
    "releaseYear": 2003,
    "runtime": 125,
    "version": "OmitU",
    "screeningDate": "02.11.2011",
    "readableDate": "2011-11-02",
    "screeningTime": "20:00",
    "actors": "Donald Sutherland, Giancarlo Giannini, Stefania Rocca, F. Murray Abraham, Aisha Cerami, Greg Wise, Nicola Di Pinto, Pino Calabrese, Federica Martinelli, Massimo Tellini, Philippe Leroy",
    "subtitle": ["150 anni dall'unità d'Italia"],
    "bodycopy": [
      "Appena andato in pensione, il giudice di provincia, Saracini, riceve un filmato super 8, che con suo grande stupore. mostra il sequestro di Aldo Moro avvenuto 25 anni prima sollevando nuove domande. Il suo informante ormai in fin di vita aveva partecipato all’agguato e non vuole portarsi nella tomba quello che sa. Allora il pensionato Saracini e la sua sostituta riaprono il caso con gran discrezione mettendo in luce intrighi e dissimulazioni. Un avvincente thriller a sfondo politico."
    ],
    "image": "../piazza-delle-cinque-lune.jpg"
  },
  {
    "title": "PRANZO DI FERRAGOSTO",
    "director": "Gianni Di Gregorio",
    "country": "Italia",
    "releaseYear": 2008,
    "runtime": 75,
    "version": "OmU",
    "screeningDate": "16.08.2012",
    "readableDate": "2012-08-16",
    "screeningTime": "20:00",
    "actors": " Gianni Di Gregorio, Valeria De Franciscis, Alfonso Santagata, Marina Cacciotti, Maria Cali, Grazia Cesarini Sforza",
    "subtitle": [""],
    "bodycopy": [
      "Poiché già si occupa premurosamente della propria madre, un amico gli propina anche la sua per il periodo delle vacanze. L’esempio fa scuola e alla fine si ritrova maggiordomo e intrattenitore di cinque vivaci donne anziane. Una commedia estiva sul “fattore demografico”."
    ],
    "image": "../pranzo-di-ferragosto.jpg"
  },
  {
    "title": "PREFERISCO IL RUMORE DEL MARE",
    "director": "Mimmo Calopresti",
    "country": "Italia",
    "releaseYear": 2000,
    "runtime": 84,
    "version": "OmU",
    "screeningDate": "21.06.2012",
    "readableDate": "2012-06-21",
    "screeningTime": "20:00",
    "actors": "Silvio Orlando, Polo Cirio, Fabrizio Sacchi, Michele Raso, Mimmo Calopresti, Andrea Occhipinti, Lorenzo Ventavoli",
    "subtitle": [""],
    "bodycopy": [
      "Torino Rosario, un ragazzo proveniente da una povera famiglia calabrese. I tentativi di farlo diventare amico di suo figlio fallisce a causa di problemi sociali e caratteriali."
    ],
    "image": "../preferisco-il-rumore-del-mare.jpg"
  },
  {
    "title": "Puccini e la fanciulla",
    "director": "Paolo Benvenuti, Paola Baroni",
    "country": "Italia",
    "releaseYear": 2009,
    "runtime": 78,
    "version": "S",
    "screeningDate": "16.09.2012",
    "readableDate": "2012-09-16",
    "screeningTime": "20:00",
    "actors": "Riccardo Moretti, Tania Squiliano, Giovanna Daddi, Debora Mattiello, Federica Chezzi",
    "subtitle": ["Senza dialoghi"],
    "bodycopy": [
      "Mentre Puccini sta componendo l’opera “La fanciulla del West“, l’ambiente che frequenta è pervaso da intrighi e rapporti a sfondo sessuale che influenzano lui stesso e il suo processo creativo."
    ],
    "image": "../puccini-e-la-fanciulla.jpg"
  },
  {
    "title": "Qualunquemente",
    "director": "Giulio Manfredonia",
    "country": "Italia",
    "releaseYear": 2011,
    "runtime": 93,
    "version": "OmitU",
    "screeningDate": "01.02.2012",
    "readableDate": "2012-02-01",
    "screeningTime": "20:00",
    "actors": "Antonio Albanese, Sergio Rubini, Lorenza Indovina, Davide Giordano, Salvatore Cantalupo",
    "subtitle": [""],
    "bodycopy": [
      "Manfredonia, rifacendosi alla commedia all’italiana e adeguandola al mondo di oggi, ha realizzato una satira dell’ex regime di Berlusconi. Nel momento in cui l’imprenditore Cetto La Qualunque si aspetta di essere punito dalla legge (“Pagare le tasse, applicare le leggi... è veramente legale?”), decide in quattro e quattr’otto di diventare sindaco ..."
    ],
    "image": "../qualunquemente.jpg"
  },
  {
    "title": "Quo Vadis, Baby?",
    "director": "Gabriele Salvatores",
    "country": "Italia",
    "releaseYear": 2005,
    "runtime": 105,
    "version": "OmitU",
    "screeningDate": "03.01.2007",
    "readableDate": "2007-01-03",
    "screeningTime": "19:00",
    "actors": "Angela Baraldi, Gigio Alberti, Claudia Zanella, Elio Germano, Luigi Maria Burruano, Andrea Renzi, Alessandra D'Elia, Gennaro Diana, Bebo Storti",
    "subtitle": [""],
    "bodycopy": [
      "Un giallo dalle tinte noir girato da questo famoso regista. Georgia, di professioneinvestigatrice privata, entra per caso in possesso di alcune videocassette registrate dalla sorella, che si era suicidata parecchi anni prima. Ciò la induce a indagare nel tragico passato che ha avuto e ha ancora un notevole influsso sulla sua vita. Questo film non è mai stato proiettato precedentemente nei cinematografi tedeschi."
    ],
    "image": "../quo-vadis-baby.jpg"
  },
  {
    "title": "QUO VADO?",
    "director": "Gennaro Nunziante",
    "country": "Italia",
    "releaseYear": 2016,
    "runtime": 86,
    "version": "OmU",
    "screeningDate": "16.02.2017",
    "readableDate": "2017-02-16",
    "screeningTime": "20:00",
    "actors": "Checco Zalone, Eleonora Giovanardi, Sonia Bergamasco, Ludovica Modugno, Maurizio Micheli, Ninni Bruschetta, Paolo Pierobon, Lino Banfi, Azzurra Martino",
    "subtitle": [
      "STAR WARS e HARRY POTTER non ci sono riusciti: il pubblico italiano ha dato la sua preferenza a Checco Zalone in QUO VADO? ."
    ],
    "bodycopy": [
      "I film che hanno come protagonista la figura immaginaria di Checco Zalone, creata dal musicista e comico Luca Pasquale Medici, battono un record dopo l’altro in Italia. Il personaggio egocentrico e ostinatamente naif che nonostante i trambusti e le contrarietà della vita non si lascia distogliere dalla sua strada, con il suo cuore d’oro e le sue manifestazioni passionali colpisce la sensibilità dell’anima italiana.",
      "In QUO VADO? Checco cerca di difendere il suo “posto fisso” messo in pericolo da una assurda riforma dell’amministrazione pubblica. La sua impresa sfocia in situazioni assurde, ridicole, satiriche nelle quali crisi e soddisfazioni amorose occupano un grande spazio.",
      "Con uno speciale intuito nell’inserire al momento giusto situazioni esilaranti e comicità il personaggio di Checco Zalone aggiunge un nuovo capitolo alla storia della commedia all’italiana giocando pure con cliché e pregiudizi."
    ],
    "image": "../quo-vado.jpg"
  },
  {
    "title": "Respiro",
    "director": "Emanuele Crialese",
    "country": "Italia/Francia",
    "releaseYear": 2002,
    "runtime": 90,
    "version": "OmU",
    "screeningDate": "17.06.2004",
    "readableDate": "2004-06-17",
    "screeningTime": "19:30",
    "actors": "Valeria Golino, Vincenzo Amato, Francesco Casisa, Veronica D’Agostino",
    "subtitle": [""],
    "bodycopy": [
      "In Italia e in Francia il titolo di questo film, “Respiro”, gioca con i suoi vari significati e cioè nel senso dell'azione di respirare, di calma e di ultimo attimo di tranquillità prima dell'esecuzione. Il distributore tedesco ha invece preferito intitolare il film con il nome dell'isola in cui si svolge. La versione inglese si concentra sulla protagonista e lo chiama “Gracia's Island”. La scelta di diversi titoli è indicatrice della varietà delle prospettive da cui vedere il film.",
      "Grazia, una giovane madre, tende a reazioni estreme dall'euforia alla depressione, e il suo egocentrismo è visto con sospetto dagli abitanti dell'isola. “La matta” deve essere messa sotto controllo medico, questa è la richiesta a cui alla fine si associa pure il marito. Per impedirlo, il figlio Pasquale mette in scena una misteriosa sparizione con la conseguente ricerca in gran stile della madre. Ecco la trama in breve.",
      "Però il film racconta anche la storia di una terra brulla avvolta da un caldo opprimente, racconta dei problemi che i figli adolescenti hanno fra di loro, ma anche della loro difficoltà di fronte ai litigi dei genitori. E non per ultimo si tratta anche di uno studio sociologico sull'equilibrio tra individualità e società.",
      "E se a qualcuno non basta, potrà comunque godere la magnifica fotografia di Fabio Zamarion."
    ],
    "image": "../respiro.jpg"
  },
  {
    "title": "Ribelli per caso",
    "director": "Vincenzo Terracciano",
    "country": "Italia",
    "releaseYear": 2001,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "02.05.2009",
    "readableDate": "2009-05-02",
    "screeningTime": "20:00",
    "actors": "Antonio Catania, Giovanni Esposito, Franco Javarone, Renato Scarpa",
    "subtitle": [
      "Cinque film di successo del quinquennio del “Club del cinema italiano” nella sala Black Box"
    ],
    "bodycopy": [
      "Dover rispettare il regolamento dell'ospedale e stare pure a dieta! Bisogna fare qualcosa per sopravvivere. E da un momento all'altro tutto l'ospedale è in subbuglio: una ribellione insorta per caso e la voglia di godersi la vita nonostante le piccole e grandi catastrofi che la costellano."
    ],
    "image": "../ribelli-per-caso.jpg"
  },
  {
    "title": "Ribelli per caso",
    "director": "Vincenzo Terracciano",
    "country": "Italia",
    "releaseYear": 2001,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "20.05.2004",
    "readableDate": "2004-05-20",
    "screeningTime": "19:30",
    "actors": "Antonio Catania, Giovanni Esposito, Franco Javarone, Renato Scarpa",
    "subtitle": [""],
    "bodycopy": [
      "Che cosa c'è di più importante che godere la vita e la buona cucina?",
      "Purtroppo esistono anche le malattie, gli ospedali e il loro personale. Con il supporto dei parenti, medici e infermiere cercano di tener lontani i loro pazienti da qualsiasi leccornia, per il bene dei malati stessi. Per loro però ciò significa tutt'altro: ma che prospettiva offre la vita se si deve rinunciare ai manicaretti della cucina italiana?",
      "Perciò un maestro di scuola, un fruttivendolo, un impiegato, un vinaio e un bancario, ricoverati per caso nella stessa camera di un ospedale, organizzano segretamente un banchetto. Inizialmente questa folle impresa sembra funzionare bene, poi però si sussegue un inghippo dopo l'altro e alla fine tutto l'ospedale è sottosopra: una ribellione nata per caso a favore del piacere di mangiare e di vivere e contro le piccole e grandi catastrofi della vita, e anche contro quello che spesso siamo disposti ad accettare troppo in fretta come \"ragionevole\"."
    ],
    "image": "../ribelli-per-caso.jpg"
  },
  {
    "title": "Ribelli per caso",
    "director": "Vincenzo Terracciano",
    "country": "Italia",
    "releaseYear": 2001,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "16.01.2014",
    "readableDate": "2014-01-16",
    "screeningTime": "20:00",
    "actors": "Antonio Catania, Giovanni Esposito, Franco Javarone, Renato Scarpa",
    "subtitle": [
      "10° anniversario: i maggiori successi del Club del Cinema Italiano"
    ],
    "bodycopy": [
      "Dover rispettare il regolamento dell'ospedale e stare pure a dieta! Bisogna fare qualcosa per sopravvivere. E da un momento all'altro tutto l'ospedale è in subbuglio: una ribellione insorta per caso e la voglia di godersi la vita nonostante le piccole e grandi catastrofi che la costellano."
    ],
    "image": "../ribelli-per-caso2.jpg"
  },
  {
    "title": "Rocco e i suoi fratelli",
    "director": "Luchino Visconti",
    "country": "Italia/Francia",
    "releaseYear": 1960,
    "runtime": 177,
    "version": "OmU",
    "screeningDate": "19.01.2017",
    "readableDate": "2017-01-19",
    "screeningTime": "20:00",
    "actors": "Alain Delon, Renato Salvatori, Annie Girardot, Alessandra Panaro, Katina Paxinou, Max Cartier, Spiros Focas, Rocco Vidolazzi, Claudia Cardinale, Roger Hanin, Paolo Stoppa",
    "subtitle": [
      "“Scene tumultuose in una sala cinematografica di Milano, minaccia di sequestro, interrogazione in parlamento per violazione dei diritti fondamentali, condanna da parte dell’Azione Cattolica, rivelazione di un ‘complotto clericale’ contro la libertà degli artisti da parte di comunisti, la fama dell’Italia all’estero in pericolo”, così il quotidiano londinese TIMES riportava dall’Italia quello che era avvenuto alla prima di ROCCO E I SUOI FRATELLI."
    ],
    "bodycopy": [
      "Che cosa era successo?",
      "Visconti aveva osato presentare uno stupro in tempi di castigatezza e mette a confronto l’ottimismo del Dopoguerra con un “quadro cupo” della realtà sociale dell’epoca. Il regista si è servito di elementi stilistici del Neorealismo per esporre in forma epica la sua storia. In modo avvincente racconta le vicende drammatiche di una famiglia meridionale: una madre con i figli adolescenti va a cercar fortuna nel Nord d’Italia contando sul figlio maggiore che già vive nel Settentrione.",
      "In base a un cosmo familiare il regista presenta un quadro sociale dell’Italia di allora. Nel conflitto tra la mentalità del Nord e quella degli immigrati del Sud, scoppiato in Italia all’inizio degli anni 60, si individuano certi parallelismi con l’attuale problematica dell’integrazione. Per Alain Delon il ruolo di Rocco è stato determinante per la sua fortunata carriera."
    ],
    "image": "../rocco-e-i-suoi-fratelli.jpg"
  },
  {
    "title": "Roma",
    "director": "Federico Fellini",
    "country": "Italia/Francia",
    "releaseYear": 1972,
    "runtime": 127,
    "version": "OmitU",
    "screeningDate": "18.02.2010",
    "readableDate": "2010-02-18",
    "screeningTime": "20:00",
    "actors": "Peter Gonzales, Fiona Florence, Pia De Doses, Renato Giovannoli",
    "subtitle": ["Federico Fellini: 90 anni (20.01.1920-31.10.1993)"],
    "bodycopy": [
      "L’omaggio di Fellini alla città di Roma è un ritratto fantastico della realtà italiana e del carattere singolare della sua gente. Allo stesso tempo presenta, con una strizzatina d’occhio, una divertente carrellata sulla narrativa cinematografica. Al primo incontro con la “grande città” si mostra apparentemente ingenuo per poi raffigurare l’Italia con raffinatezza ed enorme impegno in tutte le sue sfaccettature più assurde."
    ],
    "image": "../roma.jpg"
  },
  {
    "title": "Roma città aperta",
    "director": "Roberto Rossellini",
    "country": "Italia",
    "releaseYear": 1944,
    "runtime": 98,
    "version": "OmitU",
    "screeningDate": "01.03.2006",
    "readableDate": "2006-03-01",
    "screeningTime": "18:00",
    "actors": "Aldo Fabrizi, Anna Magnani, Marcello Pagliero, Vito Annichiarico, Harry Feist, Giovanna Galletti, Nando Bruno",
    "subtitle": [""],
    "bodycopy": [
      "In una serie di episodi collegati fra di loro Rossellini racconta il destino di unaIn una serie di episodi collegati fra di loro Rossellini racconta il destino di unadonna del popolo, di un prete e di un ingegnere comunista durante l’occupazionetedesca della città di Roma nel 1943-44. Il film si basa su avvenimenti veramenteaccaduti, filmati come se si trattasse di un documentario, e mostra i sacrifici e lepene della popolazione sotto l’occupazione."
    ],
    "image": "../roma-citta-aperta2.gif"
  },
  {
    "title": "ROMEO E GIULIETTA",
    "director": "Franco Zeffirelli",
    "country": "Italia/Gran Bretagna",
    "releaseYear": 1968,
    "runtime": 133,
    "version": "OmU",
    "screeningDate": "20.12.2007",
    "readableDate": "2007-12-20",
    "screeningTime": "19:30",
    "actors": "Leonard Whiting, Olivia Hussey, John McEnery, Milo O'Shea, Pat Heywood, Robert Stephens, Michael York, Bruce Robinson",
    "subtitle": [""],
    "bodycopy": [
      "La leggendaria versione cinematografica del dramma shakespeariano neppure oggi ha perso nulla del suo fascino. Zeffirelli aveva scelto come protagonisti il 17enne Leonard Whiting e la 15enne Olivia Hussey, entrambi allora del tutto sconosciuti, al fine di attenersi fedelmente al testo originale. Anche nei costumi e nei luoghi il regista ha cercato la massima autenticità. Il risultato è una splendida composizione visiva e un'interpretazione degli attori che sottolinea gli aspetti umani nelle loro tragiche implicazioni. Anche se si conosce già la fine, si augura ai due giovani che la loro storia termini in altro modo. (4 nomine all'Oscar, 7 nomine al BAFTA Award, 5 nomine al Golden Globe, di cui 3 con un premio, 5 premi Silver Ribbon, 1 National Board of Review, 2 Laurel Awards)"
    ],
    "image": "../romeo.jpg"
  },
  {
    "title": "Sacco e Vanzetti",
    "director": "Giuliano Montaldo",
    "country": "Italia",
    "releaseYear": 1971,
    "runtime": 120,
    "version": "OmitU",
    "screeningDate": "05.04.2006",
    "readableDate": "2006-04-05",
    "screeningTime": "18:00",
    "actors": "Gian Maria Volonté, Riccardo Cucciolla, Cyril Cusack, Rosana Fratello, Geoffrey Keen, Milo O'Shea, William Prince, Claude Mann",
    "subtitle": [""],
    "bodycopy": [
      "Boston 1920: due immigrati italiani, Nicola Sacco e Bartolomeo Vanzetti, vengono accusati ingiustamente di omicidio a scopo di rapina. Sebbene il difensore può provare la loro innocenza, i due vengono condannati a morte. Morirono per le loro convinzioni politiche? Entrambi erano anarchici dichiarati."
    ],
    "image": "../sacco.jpg"
  },
  {
    "title": "SALÒ O LE 120 GIORNATE DI SODOMA",
    "director": "Pier Paolo Pasolini",
    "country": "Italia/Francia",
    "releaseYear": 1975,
    "runtime": 116,
    "version": "OmU",
    "screeningDate": "15.04.2010",
    "readableDate": "2010-04-15",
    "screeningTime": "20:00",
    "actors": "Paolo Bonacelli, Giorgio Cataldi, Umberto Paolo Quintavalle, Aldo Valletti, Hélène Surgére, Caterina Boratto, Elsa De Giorgi",
    "subtitle": [""],
    "bodycopy": [
      "Il film più dibattuto di Pasolini. Nell’ultimo rifugio del regime mussoliniano,nella Repubblica fascista di Salò, Pasolini, riunendo un gruppo di altoborghesi che organizzano un’orgia sadica piena di terrore, sottolinea i fondamenti sessuali-autoritari delle strutture fasciste. Una schiera di ragazze e ragazzi vengono catturati e seviziati perversamente a morte,mentre i torturatori si divertono atteggiandosi a raffinati buongustai. Schliengensief ha ripreso la trama nel suo film I 120 GIORNI DIBOTTROP, che viene proiettato nell’ambito della retrospettiva del regista assegnatario del premio Käutner di quest’anno."
    ],
    "image": "../salo.jpg"
  },
  {
    "title": "Salvatore Giuliano",
    "director": "Francesco Rosi",
    "country": "Italia",
    "releaseYear": 1961,
    "runtime": 107,
    "version": "OmitU",
    "screeningDate": "04.01.2006",
    "readableDate": "2006-01-04",
    "screeningTime": "18:00",
    "actors": "Pietro Cammarata, Frank Wolff, Salvo Randone, Federico Zardi, Mario Lorito Fricano, Nando Cicero, Sannunccio Benelli, Bruno Ukmar",
    "subtitle": [""],
    "bodycopy": [
      "L’allora famosissimo bandito Salvatore Giuliano viene ucciso il 5 luglio 1950. GiàL’allora famosissimo bandito Salvatore Giuliano viene ucciso il 5 luglio 1950. Giàl’assunzione delle prove rivela varie contraddizioni. Adottando lo stile deldocumentario, Rosi cerca di far luce sulle stesse aprendo abissi sempre più profondi.E così crea un quadro degli intrecci tra mondo politico e criminalità organizzata.L’allora famosissimo bandito Salvatore Giuliano viene ucciso il 5 luglio 1950. GiàL’allora famosissimo bandito Salvatore Giuliano viene ucciso il 5 luglio 1950. Giàl’assunzione delle prove rivela varie contraddizioni. Adottando lo stile deldocumentario, Rosi cerca di far luce sulle stesse aprendo abissi sempre più profondi.E così crea un quadro degli intrecci tra mondo politico e criminalità organizzata."
    ],
    "image": "../salvatore-giuliano.jpg"
  },
  {
    "title": "Saturno contro",
    "director": "Ferzan Özpetek",
    "country": "Italia",
    "releaseYear": 2007,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "21.07.2011",
    "readableDate": "2011-07-21",
    "screeningTime": "20:00",
    "actors": "Pierfrancesco Favino, Stefano Accorsi, Margherita Buy, Ennio Fantastichini, Ambra Angiolini, Luca Argentero, Michelangelo Tommaso, Serrra Yilmaz",
    "subtitle": [""],
    "bodycopy": [
      "I piaceri della tavola sono spesso per Özpetek un’occasione per eventi che mettono in subbuglio la vita dei protagonisti. Stavolta tra gli illustri commensali eterosessuali della coppia omosessuale ideale Davide/Lorenzo c’è l’astrologa tossicodipendente che sentenzia che il pianeta Saturno è \"contro\". Inaspettatamente Lorenzo subisce un crollo e gli amici si ritrovano all’improvviso ad affrontare questioni di vita o di morte. "
    ],
    "image": "../saturno-contro.jpg"
  },
  {
    "title": "Scialla!",
    "director": "Francesco Bruni",
    "country": "Italia",
    "releaseYear": 2011,
    "runtime": 95,
    "version": "OmU",
    "screeningDate": "15.01.2015",
    "readableDate": "2015-01-15",
    "screeningTime": "20:00",
    "actors": "Fabrizio Bentivoglio, Filippo Scicchitano, Barbara Bobulova, Vinicio Marchioni, Giuseppe Guarino, Prince Chidozie Manujibeya, Arianna Scommegna, Giacomo Ceccarelli, Raffaella Lebboroni, Alessandro Tuzzi",
    "subtitle": [""],
    "bodycopy": [
      "Bruno, che non ne poteva più del suo lavoro di insegnante, fa ora una vita tranquilla dando lezioni private e scrivendo come ghostwriter. Fino al momento in cui nella sua vita compare Luca, un quindicenne con poca voglia di studiare, ma pieno di vitalità e .... figlio di Bruno. La commedia dal ritmo vivace, si alimenta dallo scontro tra questi due caratteri così contrastanti tanto da augurare ai protagonisti solo una cosa: \"Scialla!\",” stai sereno” in dialetto romanesco."
    ],
    "image": "../scialla.jpg"
  },
  {
    "title": "SE DIO VUOLE",
    "director": "Eduardo Maria Falcone",
    "country": "Italia",
    "releaseYear": 2015,
    "runtime": 87,
    "version": "OmU",
    "screeningDate": "15.11.2018",
    "readableDate": "2018-11-15",
    "screeningTime": "20:00",
    "actors": "Marco Giallini, Alessandro Gassman, Laura Morante, Ilaria Spada, Edoardo Pesce, Enrico Oetiker, Giuseppina Cervizzi",
    "subtitle": [
      "\"Sarà forse frocio?\" Nonostante la sua arroganza e vanità Tommaso si accorge che suo figlio si comporta in modo strano. Non sarebbe un problema, perché, anche se malvolentieri, il padre si mostra tollerante. Ma quando il figlio proclama che vuole farsi prete, tutta la sua comprensione svanisce. "
    ],
    "bodycopy": [
      "Il cardiochirurgo Tommaso si crogiola nella fama di cui gode grazie ai suoi successi. Si ritiene liberale, anche se trascura moglie e figlia e ha occhi soltanto per il suo primogenito che studia medicina e dovrebbe poi prendere il suo posto. Però quando il figlio si sente chiamato da Dio, e si avvia al sacerdozio, tutta la sua tolleranza e liberalità spariscono. Si mette in contatto con un prete eccentrico, Don Pietro, e accusandolo di essere il responsabile della trasformazione del figlio, cerca di \"smascherarlo\" come ciarlatano. Quest'ultimo però riesce a rovesciare le parti e Tommaso si ritrova nel ruolo dell'aiutante. E più cerca di ribellare, più gli sfugge dalle mani la vita che ha condotto fino a quel momento. Una commedia ironica su presunzione, incertezza e affermazione di sé stessi. Per questo film Edoardo Falcone ha ricevuto in Italia il David di Donatello come migliore regista debuttante."
    ],
    "image": "../se-dio-vuole.jpg"
  },
  {
    "title": "Segreti di stato",
    "director": "Paolo Benvenuti",
    "country": "Italia",
    "releaseYear": 2003,
    "runtime": 85,
    "version": "OmU",
    "screeningDate": "05.10.2011",
    "readableDate": "2011-10-05",
    "screeningTime": "20:00",
    "actors": "David Coco, Antonio Catania, Sergio Graziani, Aldo Puglisi, Francesco Guzzo",
    "subtitle": ["150 anni dall'unità d'Italia"],
    "bodycopy": [
      "In base a documenti di Stato, ora accessibili negli USA, Benvenuti ha ricostruito glieventi riguardanti l’attentato di Portella della Ginestra del maggio 1947 e i tentativi di offuscarli. Il risultato è un film visivamente convincente che non svela soltanto trame criminali, ma fornisce anche un quadro dell’Italia del Dopoguerra."
    ],
    "image": "../segreti-di-stato.jpg"
  },
  {
    "title": "SEI VENEZIA",
    "director": "Carlo Mazzacurati",
    "country": "Italia",
    "releaseYear": 2010,
    "runtime": 92,
    "version": "OmU",
    "screeningDate": "21.02.2013",
    "readableDate": "2013-02-21",
    "screeningTime": "20:00",
    "actors": "",
    "subtitle": [""],
    "bodycopy": [
      "L’anziano regista Carlo Mazzacurati gira per la città e la sua laguna riproducendone l’atmosfera in base alle storie di sei veneziani."
    ],
    "image": "../sei-venezia.jpg"
  },
  {
    "title": "SENSO",
    "director": "Luchino Visconti",
    "country": "Italia",
    "releaseYear": 1953,
    "runtime": 0,
    "version": "OmU",
    "screeningDate": "18.12.2008",
    "readableDate": "2008-12-18",
    "screeningTime": "19:00",
    "actors": "Alida Valli, Farley Granger, Massimo Girotti, Heinz Moog, Rina Morelli, Chstian Marquand, Sergio Fantoni",
    "subtitle": [""],
    "bodycopy": [
      "In atmosfera prenatalizia mostriamo questo capolavoro visivamente spettacolare di Luchino Visconti. Una storia d’amore sullo sfondo delle guerre d’indipendenza italiane è un quadro storico nel vero senso della parola. La musica avvincente, la maestria delle riprese e l’arte della recitazione si coniugano in un’opera d’arte complessiva, in un epos sull’amore e sul tradimento, in cui il destino individuale si incrocia drammaticamente con le vicende storiche. Un film neorealista girato in un’epoca passata."
    ],
    "image": "../senso.jpg"
  },
  {
    "title": "Sessomatto",
    "director": "Dino Risi",
    "country": "Italia",
    "releaseYear": 1974,
    "runtime": 82,
    "version": "OmitU",
    "screeningDate": "01.09.2010",
    "readableDate": "2010-09-01",
    "screeningTime": "20:00",
    "actors": "Giancarlo Giannini, Laura Antonelli, Paola Borboni, Alberto LIonello, Duilio Del Prete, Carla Mancini, Franca Scagnetti, Lino Puglisi",
    "subtitle": ["Rassegna di Dino Risi"],
    "bodycopy": [
      "Una comicità semplice caratterizza i sei episodi che compongono il film su un tema allora ancora tabuizzato: il sesso. Agli occhi dello spettatore di oggi l’approccio appare piuttosto puritano, ma a suo tempo segnò il lancio della “maggiorata” Laura Antonelli, futura compagna di Paul Belmondo, come seconda Sophia Loren."
    ],
    "image": "../sesso-matto.jpg"
  },
  {
    "title": "Si può fare",
    "director": "Giulio Manfredonia",
    "country": "Italia",
    "releaseYear": 2008,
    "runtime": 111,
    "version": "OmU",
    "screeningDate": "16.02.2012",
    "readableDate": "2012-02-16",
    "screeningTime": "20:00",
    "actors": "Claudio Bisio, Giuseppe Battiston, Anita Caprioli, Andrea Bosca, Giovanni Calcagno, Michele De Virgilio, Carlo Giuseppe GabardiniClaudio Bisio, Giuseppe Battiston, Anita Caprioli, Andrea Bosca, Giovanni Calcagno, Michele De Virgilio, Carlo Giuseppe Gabardini",
    "subtitle": [""],
    "bodycopy": [
      "Anni 80: i “manicomi” diventano cooperative. Nello cerca di mettere in piedi un’impresa artigianale con dei disabili. Una commedia ottimista e sensibile sui limiti e sulle potenzialità umane.Anni 80: i “manicomi” diventano cooperative. Nello cerca di mettere in piedi un’impresa artigianale con dei disabili. Una commedia ottimista e sensibile sui limiti e sulle potenzialità umane."
    ],
    "image": "../si-puo-fare.jpg"
  },
  {
    "title": "SOGNI DI NUMERI",
    "director": "Anna Bacchetti",
    "country": "Italia/Paesi Bassi",
    "releaseYear": 2005,
    "runtime": 75,
    "version": "OmU",
    "screeningDate": "17.09.2009",
    "readableDate": "2009-09-17",
    "screeningTime": "20:00",
    "actors": "",
    "subtitle": ["\"Ritratti italiani\" - Documentari su temi italiani"],
    "bodycopy": [
      "Concentrandosi sulla ricevitoria del lotto gestita dalle sorelle Anna e Maria, Anna Bucchetti fornisce un quadro del centro storico di Napoli e dei suoi abitanti. ai quali non rimane molto di più che sognare un futuro migliore. E così Anna e Maria trasformano “scientificamente” i sogni della loro clientela in serie di numeri su cui puntare al gioco. Un film su persone alla ricerca della fortuna; che credono al potere dei numeri in una città italiana ricca di tradizioni e fotografata con maestria in bianco e nero.Concentrandosi sulla ricevitoria del lotto gestita dalle sorelle Anna e Maria, Anna Bucchetti fornisce un quadro del centro storico di Napoli e dei suoi abitanti. ai quali non rimane molto di più che sognare un futuro migliore. E così Anna e Maria trasformano “scientificamente” i sogni della loro clientela in serie di numeri su cui puntare al gioco. Un film su persone alla ricerca della fortuna; che credono al potere dei numeri in una città italiana ricca di tradizioni e fotografata con maestria in bianco e nero."
    ],
    "image": "../sogni-di-numeri.jpg"
  },
  {
    "title": "Solino",
    "director": "Fatih Akin",
    "country": "Germania",
    "releaseYear": 2002,
    "runtime": 123,
    "version": "OmU",
    "screeningDate": "11.03.2021",
    "readableDate": "2021-03-11",
    "screeningTime": "19:00",
    "actors": "Barnaby Metschurat, Moritz Bleibtreu, Antonella Atilli, Gigi Savoia",
    "subtitle": [""],
    "bodycopy": [
      "Sembrano proprio sperduti, i componenti della famiglia Amato. Emigrati nel 1964 dall'Italia, si ritrovano in una Germania che non conosce né risotto, né spaghetti, né tantomeno la pizza. La scelta di verdure lascia alquanto a desiderare e per mamma Rosa, che non ne voleva proprio sapere di venire in Germania, i tedeschi sono soltanto dei \"barbari\".",
      "Quando di fronte al loro appartamento scopre un locale vuoto, che prima ospitava una gelateria, sa subito che cosa si debba fare. In breve convince tutta la famiglia ad offrire ai suoi compatrioti le leccornie del loro paese. Con altrettanta rapidità anche i tedeschi cominciano a trovare gusto nella cucina italiana e Romano, il padre, nelle donne tedesche. Quando anche i due figli cercano di farsi una vita al di fuori della pizzeria, la famiglia si trova a dover affrontare nel paese straniero problemi inaspettati.",
      "Prima di girare il suo film \"Contro il muro\", che ha vinto il primo premio alla Berlinale di quest'anno, Faith Akin, tedesco di origine turca, si era subito identificato con la sceneggiatura di \"Solino\", sulla quale inizialmente avrebbe dovuto solamente esprimere il suo giudizio. Nato nel 1973, il registra stesso vive la spaccatura tra due mondi come gli Amato. Sin dalla sua infanzia aveva sognato il cinema come Gigi, uno dei due fratelli protagonisti del film, che invece sogna la fotografia. Ecco perché Akin è riuscito a creare un film che mette in luce un importante aspetto della storia italo-tedesca."
    ],
    "image": "../solino.jpg"
  },
  {
    "title": "Sopralluoghi in Palestina",
    "director": "Pier Paolo Pasolini",
    "country": "Italia",
    "releaseYear": 1965,
    "runtime": 55,
    "version": "OmU",
    "screeningDate": "14.03.2011",
    "readableDate": "2011-03-14",
    "screeningTime": "20:00",
    "actors": "Pier Paolo Pasolini, Adrea Carraro",
    "subtitle": [""],
    "bodycopy": [
      "Per poter ricostruire delle località storiche per il film Il Vangelo secondo Matteo, Pasolini andò in Israele dove fece le necessarie ricerche. Questo film ne è il resoconto raccontato con la macchina da presa."
    ],
    "image": "../sopralluoghi.jpg"
  },
  {
    "title": "Sostiene Pereira",
    "director": "Roberto Faenza",
    "country": "Italia/Francia",
    "releaseYear": 1995,
    "runtime": 104,
    "version": "OmU",
    "screeningDate": "02.05.2009",
    "readableDate": "2009.05.02",
    "screeningTime": "20:00",
    "actors": "Marcello Mastroianni, Daniel Auteuil, Stafano Dionisi, Nicoletta Braschi, Joaquim de Almeida, Marthe Keller",
    "subtitle": [
      "Cinque film di successo del quinquennio del“Club del cinema italiano” nella sala Black Box"
    ],
    "bodycopy": [
      "Marcello Mastroianni recita il ruolo di un redattore letterario invecchiato, ingrassato estanco nel Portogallo fascista della fine degli anni Trenta. Uno studente comunista, il suo medico e gli avvenimenti arbitrari della sua epoca trasformano l'uomo, che ogni giorno parla con la fotografia della sua defunta moglie, in un piccolo eroe silenzioso."
    ],
    "image": "../sostiene-pereira.png"
  },
  {
    "title": "Sostiene Pereira",
    "director": "Roberto Faenza",
    "country": "Italia/Francia",
    "releaseYear": 1995,
    "runtime": 104,
    "version": "OmU",
    "screeningDate": "17.02.2005",
    "readableDate": "2005-02-17",
    "screeningTime": "19:30",
    "actors": "Marcello Mastroianni, Daniel Auteuil, Stafano Dionisi, Nicoletta Braschi, Joaquim de Almeida, Marthe Keller",
    "subtitle": [""],
    "bodycopy": [
      "Marcello Mastroianni nel suo penultimo ruolo cinematografica rappresenta un redattore letterario invecchiato, ingrassato e stanco nel Portogallo fascista della fine degli anni Trenta. La conoscenza con uno studente comunista, le discussioni con il suo medico e gli avvenimenti arbitrari della sua epoca, trasformano l'uomo solitario, che ogni giorno racconta quello che gli succede alla fotografia della sua defunta moglie, in un piccolo eroe silenzioso.",
      "Il film è basato sul famoso libro omonimo di Antonio Tabucchi."
    ],
    "image": "../sostiene-pereira.png"
  },
  {
    "title": "Stromboli - Terra di Dio",
    "director": "Roberto Rossellini",
    "country": "Italia/USA",
    "releaseYear": 1950,
    "runtime": 107,
    "version": "OmitU",
    "screeningDate": "04.04.2007",
    "readableDate": "2007-04-04",
    "screeningTime": "19:00",
    "actors": "Ingrid Bergmann, Mario Vitale, Renzo Cesana, Mario Sponza",
    "subtitle": ["Rassegna di Roberto Rossellini"],
    "bodycopy": [
      "Il film racconta la storia di una ragazza profuga che cerca sicurezza nel matrimonio con un pescatore dell'isola di Stromboli, ma che non viene accettata dalla popolazione locale perché non è una di loro. Il dramma raggiunge il suo apice quando, a causa dell'incombente eruzione del vulcano, tutti gli abitanti devono fuggire a mare aperto ammassandosi sulle loro barche. È il primo lavoro di Rossellini assieme a Ingrid Bergmann. A suo tempo la relazione istauratasi fra i due fece scandalo."
    ],
    "image": "../stromboli.jpg"
  },
  {
    "title": "SUBURRA",
    "director": "Stefano Sollima",
    "country": "Italia/Francia",
    "releaseYear": 2017,
    "runtime": 130,
    "version": "OmU",
    "screeningDate": "19.10.2007",
    "readableDate": "2007-10-19",
    "screeningTime": "20:00",
    "actors": "Pierfrancesco Favino, Greta Scarano, Claudio Amendola, Alessandro Borghi, Greta Scarano, Giulia Elettra Gorietti",
    "subtitle": [
      "Una notte d'amore che termina con una morte, un padrino che si presenta come \"samurai”, un progetto edilizio intriso di corruzione, intrighi al Vaticano e rivalità tra clan. Quando tutti questi eventi si mescolano tra di loro, si attiva una famiglia di mafiosi dando inizio ad un'apocalisse. "
    ],
    "bodycopy": [
      "Con immagini buie si raccontano frammentariamente storie di corruzione, criminalità organizzata e delinquenza dozzinale, sporchi intrallazzi politici e smania morbosa di carriera. Una visione generale si riesce ad averla soltanto alla fine del film, un effetto che a volte disorienta sia i protagonisti, sia lo spettatore preso dalle drammatiche vicende. Fotografia e montaggio di questa moderna versione a colori del genere noir sono un particolare godimento estetico.",
      "Stefano Sollima (ROMANZO CRIMINALE) è figlio di Sergio Sollima, il regista di western e thriller a sfondo politico-critico molto apprezzato dai fan di questi filoni. E SUBURRA riprende i temi del film di genere degli anni Settanta esprimendoli in maniera estremamente attuale e moderne."
    ],
    "image": "../suburra.jpg"
  },
  {
    "title": "Sud",
    "director": "Gabriele Salvatores",
    "country": "Italia",
    "releaseYear": 1993,
    "runtime": 85,
    "version": "OmitU",
    "screeningDate": "07.02.2007",
    "readableDate": "2007-02-07",
    "screeningTime": "19:00",
    "actors": "Silvio Orlando, Francesca Neri, Gigio Alberti, Marco Marchisi, Claudio Bisio, Antonio Catania, Renato Carpentieri, Antonio PetroncelliSilvio Orlando, Francesca Neri, Gigio Alberti, Marco Marchisi, Claudio Bisio, Antonio Catania, Renato Carpentieri, Antonio Petroncelli",
    "subtitle": [""],
    "bodycopy": [
      "Quattro vogliono occupare per protesta il seggio elettorale di Marzamemi in segno di ribellione contro i brogli organizzati da un politico locale. Casualmente prendono in ostaggio la figlia del candidato favorito con il suo fidanzato. Nonostante un massiccio intervento dei carabinieri, a causa dell'incapacità di decidere e gli interessi contrastanti, la situazione si prolunga fino alla notte delle elezioni. Questo film non è mai stato proiettato precedentemente nei cinematografi tedeschi."
    ],
    "image": "../sud.jpg"
  },
  {
    "title": "Tano da morire",
    "director": "Roberta Torre",
    "country": "Italia",
    "releaseYear": 1997,
    "runtime": 80,
    "version": "OmU",
    "screeningDate": "16.04.2004",
    "readableDate": "2004-04-16",
    "screeningTime": "19:30",
    "actors": "Andrea Di Stefano, Donatella Finocchiaro, Mario Pupella",
    "subtitle": [""],
    "bodycopy": [
      "Angela, nata e cresciuta a Ballarò, il quartiere del mercato di Palermo, a vent'anni sposa Saro e con lui condivide una vita fatta di traffico di droga e guadagni facili. Quando conosce Masino, diventato il braccio destro di suo marito, nasce tra i due un'attrazione irresistibile"
    ],
    "image": "../Tano-da-morire.jpg"
  },
  {
    "title": "Tartarughe sul dorso",
    "director": "Stefano Pasetto",
    "country": "Italia",
    "releaseYear": 2005,
    "runtime": 92,
    "version": "OmitU",
    "screeningDate": "05.03.2008",
    "readableDate": "2008-03-05",
    "screeningTime": "19:00",
    "actors": "Barbora Bobulova, Fabrizio Rongione, Gordana Miletic, Luigi Diberti, Vittorio Amandola, Antonio Manzini, Caterina Casini, Lucia Mascino, Chiara Sani, Giulietta Ravel",
    "subtitle": ["Location: Trieste"],
    "bodycopy": [
      "All'inizio c'è una partita di scarabeo. Come succede in questo gioco in cui con le lettere si formano parole che non diventano mai frasi compiute, così si sviluppa il rapporto tra due disadattati nell'intimità di una Trieste lontana dalle immagini turistiche. Il \"Lui\", dimesso dal carcere, e la \"Lei\", che dopo aver interrotto gli studi fala donna delle pulizie, si incontrano ripetutamente. Però il rapporto si riduce a incontri più o meno intensi, anche se sembra possibile una relazione più profonda."
    ],
    "image": "../tartarughe-sul-dorso.jpg"
  },
  {
    "title": "Teorema",
    "director": "Pier Paolo Pasolini",
    "country": "Italia",
    "releaseYear": 1968,
    "runtime": 105,
    "version": "OmitU",
    "screeningDate": "01.07.2009",
    "readableDate": "2009-07-01",
    "screeningTime": "20:00",
    "actors": "Silvana Mangano, Massimo Girotti, Andrés José Cruz Soublette, Anne Wiazemsky, Laura Betti, Terence Stamp, Ninetto Davoli",
    "subtitle": ["Rassegna di Pier Paolo Pasolini"],
    "bodycopy": [
      "Una critica sociale per la quale Pasolini si è ispirato al Tartufo di Molière. Mentre però in questa commedia è un impostore che, sfruttando le ipocrisie dell’alta società, mette in subbuglio un’intera famiglia, nel film di Pasolini tutti i membri di una famiglia benestante vengono conquistati da un bellissimo giovane, loro ospite. Quando quest’ultimo, specchio della loro liberazione interiore, improvvisamente sparisce, crollano tutte le convenzioni borghesi che la tenevano formalmente insieme."
    ],
    "image": "../teorema.jpg"
  },
  {
    "title": "Teorema Venezia",
    "director": "Andreas Pichler",
    "country": "Germania",
    "releaseYear": 2012,
    "runtime": 80,
    "version": "OmitU",
    "screeningDate": "21.08.2014",
    "readableDate": "2014-08-21",
    "screeningTime": "20:00",
    "actors": "",
    "subtitle": [""],
    "bodycopy": [
      "Venezia senza veneziani: se l'attuale trasformazione di Venezia in un misto tra museo all’aperto e parco dei divertimenti proseguisse allo stesso ritmo, si arriverebbe a compimento probabilmente nel 2030. Andreas Pichler esamina questo processo nel suo documentario disegnando un quadro insolito della città lagunare, sottolineato da un’ottima fotografia."
    ],
    "image": "../teorema-venezia.jpg"
  },
  {
    "title": "THE SPECIAL NEED",
    "director": "Carlo Zoratti",
    "country": "Italia/Germania/Austria/Francia",
    "releaseYear": 2013,
    "runtime": 84,
    "version": "OmU",
    "screeningDate": "15.02.2018",
    "readableDate": "2018-02-15",
    "screeningTime": "20:00",
    "actors": "Carlo Zoratti, Alex Nazzi, Enea Gabino und alle, die sie auf ihrer Reise treffen",
    "subtitle": [
      "Una fiction documentaria su un giovane mentalmente disabile a confronto con il tema della sessualità può diventare imbarazzante, o diventa un film simpatico come è successo in questo caso."
    ],
    "bodycopy": [
      "A trent’anni Enea ha un posto di lavoro, ma anche un problema, o meglio una necessità: vorrebbe avere un rapporto sessuale. Una questione per nulla facile, essendo mentalmente ritardato. Ma a che cosa servono gli amici? Carlo e Alex infatti vogliono aiutarlo. E così si mettono in moto per realizzare con grande sensibilità il sogno di Enea.",
      "Sulla loro strada incontrano sia ostacoli inaspettati, sia inconsuete offerte di aiuto: episodi che, incidentalmente, mettono in evidenza quella che la nostra società ritiene “normale”. Ma soprattutto Enea conquista le simpatie degli spettatori nel suo tentativo di soddisfare questo suo intimo desiderio."
    ],
    "image": "../the-special-need.jpg"
  },
  {
    "title": "TRE PIANI",
    "director": "Nanni Moretti",
    "country": "Italia",
    "releaseYear": 2019,
    "runtime": 121,
    "version": "OmU",
    "screeningDate": "20.10.2022",
    "readableDate": "2022-10-20",
    "screeningTime": "20:00",
    "actors": "Margherita Buy, Nanni Moretti, Riccardo Scamarcio, Alba Rohrwacher u.aMargherita Buy, Nanni Moretti, Riccardo Scamarcio, Alba Rohrwacher u.a",
    "subtitle": [
      "Con il suo nuovo film Nanni Moretti dimostra nuovamente di essere un ottimo conoscitore dell’essere umano e un narratore avvincente. Per la prima volta si ispira al libro di un altro autore (Eshkol Nevo: Tre piani / Neri Pozza Editore), però lo ristruttura completamente. Gli eventi si incrociano con maggiore frequenza e le persone hanno un profilo più accentuato. Spesso bastano piccoli gesti e brevi osservazioni per delineare meglio una situazione o uno stato d’animo. Al contrario del film IL PARADISO DEL PAVONE del mese successivo (novembre 2022), che tratta un tema simile, ma lo racconta in modo piuttosto enigmatico, il film di Moretti puntualizza sempre e si premura di fare chiarezza. "
    ],
    "bodycopy": [
      "Comincia con una donna incinta per la strada. Accanto a lei passa un’autovettura che procede a serpentina e va a sbattere contro una casa sfondandone il pianterreno.",
      "E così ci troviamo già nella palazzina e iniziamo a conoscerne gli abitanti che esterrefatti e sgomenti accorrono nel luogo dell’incidente per prestare aiuto: La coppia anziana che si occupa premurosamente della figlia dei vicini di pianerottolo quando la combinazione tra vita in famiglia e lavoro non lascia loro il tempo per curarsi della bambina. Poi il giudice e sua moglie, genitori del giovane che ha causato l’incidente. Manca soltanto la famiglia dell’ultimo piano: il marito è in cantiere e la moglie, che è la donna incinta della prima scena, è afflitta sempre di più da pensieri ossessivi.",
      "Alti e bassi caratterizzano la vita di questo cosmo di personaggi. Spesso l’attaccarsi alle abitudini o lo smarrirsi tra idee fisse è ciò che mette in difficoltà chi sta loro intorno. E alla fine ne soffrono proprio loro stessi.",
      "Con interesse e una certa porzione di immedesimazione seguiamo gli sviluppi fino ad un accennato lieto fine di cui avremmo fatto volentieri a meno."
    ],
    "image": "../tre-piani-03.jpg"
  },
  {
    "title": "Turné",
    "director": "Gabriele Salvatores",
    "country": "Italia",
    "releaseYear": 1990,
    "runtime": 91,
    "version": "OmitU",
    "screeningDate": "02.12.2009",
    "readableDate": "2009-12-02",
    "screeningTime": "20:00",
    "actors": "Fabrizio Bentivoglio, Diego Abantantuono, Laura Morante, Ugo Conti",
    "subtitle": [
      "Rassegna: Un caso per due - Gabriele Salvatores (regista) e Diego Abantantuono (attore)"
    ],
    "bodycopy": [
      "Gli inseparabili amici Dario e Federico sono in tournée per l’Italia per portare in scena “Il giardino dei ciliegi” di Čechov. Le loro differenze di carattere e le loro diverse biografie sembrano allontanarli quando l’amore per la stessa donna mette a dura prova la loro amicizia."
    ],
    "image": "../turne.png"
  },
  {
    "title": "TUTTA LA VITA DAVANTI",
    "director": "Paolo Virzì",
    "country": "Italia",
    "releaseYear": 2008,
    "runtime": 117,
    "version": "OmU",
    "screeningDate": "20.10.2016",
    "readableDate": "2016-10-20",
    "screeningTime": "20:00",
    "actors": "Isabella Ragonese, Sabrina Ferilli, Elio Germano, Massimo Ghini, Valerio Mastandrea, Micaela Ramazzotti, Valentina Carnelutti, Edoardo Gabbriellini",
    "subtitle": [""],
    "bodycopy": [
      "Dopo essersi laureata in filosofia, Marta ha tutta la vita davanti. Però quando inizia con ottimismo il suo lavoro in un call center, scopre l'Italia come un paese in cui si deve essere sempre gentili e disponibili, ma che solo attraverso gli intrighi si riesce ad avere successo e quello che conta è far soldi. Un ritratto commediante dell'Italia dell'epoca berlusconiana."
    ],
    "image": "../tutta-la-vita-davanti.jpg"
  },
  {
    "title": "TUTTI I SANTI GIORNI",
    "director": "Paolo Virzì",
    "country": "Italia",
    "releaseYear": 2012,
    "runtime": 102,
    "version": "OmU",
    "screeningDate": "19.09.2019",
    "readableDate": "2019-09-19",
    "screeningTime": "20:00",
    "actors": "Luca Marinelli, Thony, Micol Azzurro, Claudio Pallitto, Frank Crudele, Christian Ginepro, Regina Orioli, Giovanni La Parola",
    "subtitle": [
      "Se amare fosse soltanto \"amarsi\". Ma c'è il desiderio inappagato di aver figli, amici e conoscenti che distribuiscono benevoli consigli, genitori che continuano a chiedere quando arriva il bebè e la realtà del lavoro con il suo influsso sul rapporto di coppia. Possono aiutare in tale situazione le moderne tecniche di riproduzione? I luminari del settore sanno veramente dare il consiglio giusto? Oppure l'amore viene soffocato dall'intensa partecipazione altrui?"
    ],
    "bodycopy": [
      "Guido, nato in Toscana, è un'entusiasta di lingue antiche e dei santi dei primi tempi del cristianesimo. Lavora come portiere di notte. È innamorato di Antonia, siciliana, impiegata presso un'agenzia rent-a-car, e a sua volta innamorata di Guido. La loro passione comune è la musica.- Lei suona in un bar dove i due si sono conosciuti e dove nonostante la diversità di carattere, si sono innamorati.",
      "Entrambi desiderano un figlio che però non arriva. Più passa il tempo, più insistenti diventano le domande dei genitori, desiderosi di nipotini, e degli amici che vorrebbero condividere con loro lo stesso destino: una vita con figli. Poiché anche i benefici della medicina moderna non li aiutano, si sentono sotto pressione e rischiano di guastare il loro rapporto. Riusciranno i due innamorati a superare la crisi?"
    ],
    "image": "../tutti-i-santi-giorni.jpg"
  },
  {
    "title": "TUTTO A POSTO E NIENTE IN ORDINE",
    "director": "Lina Wertmüller",
    "country": "Italia",
    "releaseYear": 1974,
    "runtime": 194,
    "version": "OmU",
    "screeningDate": "19.09.2013",
    "readableDate": "2013-09-19",
    "screeningTime": "20:00",
    "actors": "Luigi Diberti, Lina Polito, Giuliana Calandra, Isa Danieli, Sara Rapisarda, Nino Bignamini",
    "subtitle": ["Lina Wertmüller compie 85 anni"],
    "bodycopy": [
      "Chi sono i veri buoi? Gli animali, che già spezzati in due attraversano coreograficamente il macello o gli ingenui contadini meridionali che lavorano qui? Milano, paese delle meraviglie e contemporaneamente destino, tra prostituzione, piccola criminalità e adattamento. Un cosmo satirico disegnato drasticamente dalla Wertmüller. Una critica alla società italiana, ma anche allo sfruttamento capitalista. Un film che si vede raramente in Germania."
    ],
    "image": "../tutto-a-posto.jpg"
  },
  {
    "title": "TUTTO QUELLO CHE VUOI",
    "director": "Francesco Bruni",
    "country": "Italia",
    "releaseYear": 2017,
    "runtime": 106,
    "version": "OmU",
    "screeningDate": "16.01.2020",
    "readableDate": "2020-01-16",
    "screeningTime": "20:00",
    "actors": "Andrea  Carpenzano, Giuliano Montaldo, Donatella Finocchiaro, Arturo Bruni, Antonio Gerardi",
    "subtitle": [
      "I film con o sui disabili diventano spesso un po’ kitsch o comunque stereotipati. Anche questo film di Francesco Bruni (SCIALLA) non fa un’eccezione. Però associa il tema della demenza al racconto del mutamento che avviene in un gruppo di ragazzi socialmente emarginati ai quali, grazie all’incontro con un vecchio demente e la sua esperienza di vita, si apre una nuova prospettiva per il futuro. "
    ],
    "bodycopy": [
      "Originariamente il 22enne Alessandro fiuta la grande opportunità di derubare del suo tesoro Giorgio, un vecchio poeta ormai dimenticato e demente. Giorgio stesso gliene aveva parlato, anche se in modo frammentario a causa della sua malattia, quando il giovane, esortato dal padre, lo aveva preso in cura seppure controvoglia. Alessandro e i suoi amici cominciano ad annidarsi nell’appartamento del vecchio che gode chiaramente della loro compagnia e non si lascia irritare dal comportamento volgare e ignorante dei ragazzi. Così nasce una strana amicizia fra persone molto diverse fra di loro. Mentre la dignità e l’eleganza del vecchio hanno un influsso evidente sui giovani, il poeta si rianima e in lui si risvegliano i ricordi del passato. Ed è proprio questo che interessa ai ragazzi. Infatti Giorgio parla ripetutamente di un tesoro che aveva nascosto assieme a dei soldati americani con cui aveva fatto amicizia. Una stanza del poeta piena di note scritte sulle pareti dovrebbe essere loro d’aiuto, ma li fa pure avvicinare alla letteratura affascinandoli. E così alla fine gli amici partono assieme al vecchio per la Toscana alla ricerca del tesoro.",
      "Il film ha ricevuto due prestigiosi premi in Italia, il “David di Donatello” e quello del pubblico della rassegna Cinema! Italia! 2018"
    ],
    "image": "../tutto-quello-che-vuoi-01.jpg"
  },
  {
    "title": "Uccellacci e uccellini",
    "director": "Pier Paolo Pasolini",
    "country": "Italia",
    "releaseYear": 1966,
    "runtime": 88,
    "version": "OmU",
    "screeningDate": "19.02.2011",
    "readableDate": "2011-02-19",
    "screeningTime": "20:00",
    "actors": "Totò, Ninetto Davoli, Femi Benussi, Umberto Bevilacqua, Renato Capogna, Alfredo Leggi, Renato Montalbano, Flaminia Siciliano, Giovanni Tarallo, Vittorio Vittori, Domenico Modugno, Gabriele Baldini",
    "subtitle": [""],
    "bodycopy": [
      "Padre e figlio se ne vanno in giro. La loro meta rimane sconosciuta. Li accompagna un corvo parlante che spiega loro il mondo in modo cattedratico, fino a che, su due piedi, decidono di mangiarselo e continuare la strada da soli. Lo stile della messa in scena e del montaggio è un compendio delle possibilità che offre il linguaggio cinematografico."
    ],
    "image": "../uccellacci e uccellini.jpg"
  },
  {
    "title": "UMBERTO D.",
    "director": "Vittorio De Sica",
    "country": "Italia",
    "releaseYear": 1951,
    "runtime": 90,
    "version": "OmU",
    "screeningDate": "21.04.2011",
    "readableDate": "2011-04-21",
    "screeningTime": "20:00",
    "actors": " Carlo Battisti, Maria Pia Casilio, Lina Gennari, Ileana Simova, Elena Rea, Memmo Carotenuto, Alberto Albani Barbieri",
    "subtitle": ["Omaggio a Vittorio de Sica"],
    "bodycopy": [
      "Il film fa anche parte della serie \"Minimal Cinema\" del Museo del Cinema. DeSica è riuscito a girare un dramma tragicomico che nonostante la scarsità dei mezzi affascina gli spettatori: un uomo disperato non può porre fine alla sua vita perche non riesce né ad abbandonare il suo cane, né vuole farlo morire con lui. Partendo da questo legame affettivo tra uomo e animale De Sica sviluppa una critica velata a una società che ha perso la capacità di una partecipazione emotiva. L'istrione De Sica riesce a trattare un tema così tragico con leggerezza e molta empatia. Un capolavoro della storia del cinema."
    ],
    "image": "../umberto-d.jpg"
  },
  {
    "title": "Un amore",
    "director": "Gianluca Tavarelli",
    "country": "Italia",
    "releaseYear": 1999,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "16.02.2006",
    "readableDate": "2006-02-16",
    "screeningTime": "19:30",
    "actors": "Lorenza Indovina, Fabrizio Gifuni, Luciano Federico, Roberta Lena, Riccardo Montanaro",
    "subtitle": [""],
    "bodycopy": [
      "Dodici episodi – dodici inquadrature: una storia d'amore, come Sara e Marco la potrebbero raccontare ai loro nipoti. Una lunga storia d'amore con tante rotture e interruzioni. Il sognatore introverso e la dinamica, cocciuta e ribelle, non riescono a vivere assieme, ma neppure a separarsi. Entrambi sposano un altro partner, però continuano a incontrarsi, talvolta per caso, talvolta perché si cercano. Dodici episodi di due vite: \"Un paio di minuti decisivi dicono qualcosa su questa vita nel suo complesso\" afferma convinto il regista Tavarelli."
    ],
    "image": "../un-amore.jpg"
  },
  {
    "title": "UN BACIO",
    "director": "Ivan Cotroneo",
    "country": "Italia",
    "releaseYear": 2016,
    "runtime": 102,
    "version": "OmU",
    "screeningDate": "21.06.2018",
    "readableDate": "2018-06-21",
    "screeningTime": "20:00",
    "actors": "Rimau Ritzberger Grillo, Valentina Romani, Leonardo Pazzagli, Susy Laude: Stefania, Thomas Trabacchi, Laura Mazzi",
    "subtitle": [
      "Un emarginato o una personalità speciale? In gioventù nessuno lo può affermare con certezza di se stesso. Alla ricerca di una risposta Lorenzo, Blu e Antonio si ritrovano isolati dai loro coetanei. Lorenzo è omosessuale e si rifugia in fantasie di autoaffermazione, Blu è considerata la sciattona della scuola perché si dice che abbia avuto un rapporto sessuale di gruppo con quattro uomini, e l’introverso Antonio, che pur essendo un ottimo giocatore di pallacanestro, è ritenuto quasi un ritardato."
    ],
    "bodycopy": [
      "Tra i tre sorge una profonda amicizia e in piena solidarietà riescono a difendersi dal mobbing e a trovare insieme un’irrefrenabile gioia di vivere.",
      "Il loro rapporto si inclina quando Lorenzo, valutando erroneamente la situazione, cerca di avvicinarsi eroticamente ad Antonio e Blu scopre la verità sulla sua “avventura” sessuale.",
      "Un dramma giovanile, che con leggerezza e immagini gioiose racconta l’insorgere e lo spezzarsi di una grande amicizia, fornendo un quadro sensibile dei sentimenti dei ragazzi di oggi."
    ],
    "image": "../un-bacio.jpg"
  },
  {
    "title": "Un'agenzia matrimoniale",
    "director": "Federico Fellini",
    "country": "Italia/Francia",
    "releaseYear": 1973,
    "runtime": 90,
    "version": "OmU",
    "screeningDate": "21.01.2010",
    "readableDate": "2010-01-21",
    "screeningTime": "20:00",
    "actors": "Pina Renzi, Erminio Macario, Delia Scala, Aroldo Tieri, Fulvia Franco, Eva Vanicek, Vittorio Mangano, Vera Carini, Laura Gore, Ernesto Almirante, Oscar Blando, Gisella Monaldi, Galeazzo Benti",
    "subtitle": ["Federico Fellini: 90 anni (20.01.1920-31.10.1993)"],
    "bodycopy": [
      "Nel 1953 sette registi italiani affrontarono insieme il tema dei rapporti fra i due sessi. Di questo documento di portata storica è rimasta con i sottotitoli tedeschi soltanto una versione incompleta. Noi mostriamo soltanto gli episodi disponibili, tra i quali l’AGENZIA MATRIMONIALE di Federico Fellini."
    ],
    "image": "../unagenzia-matrimoniale.jpg"
  },
  {
    "title": "Una giornata particolare",
    "director": "Ettore Scola",
    "country": "Italia/Canada",
    "releaseYear": 1977,
    "runtime": 105,
    "version": "OmitU",
    "screeningDate": "06.07.2011",
    "readableDate": "2011-07-06",
    "screeningTime": "20:00",
    "actors": "Sophia Loren, Marcello Mastroianni, John  Vernon, Alessandra Mussolini, Vittorio Guerrieri, Nicole Magny, Patrizia Basso, Tiziano De Persio, Maurizio Di Paolantonio, Antonio Garibaldi",
    "subtitle": ["150 anni dall'unità d'Italia"],
    "bodycopy": [
      "Un’interpretazione eccellente di Sophia Loren e Marcello Mastroianni, l’immagine di un’intera epoca in un cortile. 3.5.1938. Mentre tutta Roma festeggia la storica visita di Adolf Hitler, in una palazzina di un grande caseggiato una madre di sei figli “lasciata a casa” dalla famiglia incontra un presentatore radiofonico, emarginato a causa della sua omosessualità. E così per entrambi questa diventa una \"giornata particolare\"."
    ],
    "image": "../una-giornata-particolare.gif"
  },
  {
    "title": "Una pura formalità",
    "director": "Giuseppe Tornatore",
    "country": "Italia",
    "releaseYear": 1994,
    "runtime": 108,
    "version": "OmitU",
    "screeningDate": "05.05.2010",
    "readableDate": "2010-05-05",
    "screeningTime": "20:00",
    "actors": "Gérard Depardieu, Roman Polanski, Sergio Rubini, Nicola Di Pinto, Paolo Lombardi, Maria Rosa Spagnolo, Tano Cimarosa",
    "subtitle": [""],
    "bodycopy": [
      "Un diverbio kafkiano negli Abruzzi tra un poliziotto (Roman Polanski) e un uomon diverbio kafkiano negli Abruzzi tra un poliziotto (Roman Polanski) e un uomotrovato senza documenti (Gérard Depardieu) che afferma di essere un autore famoso.Il commissario di polizia che conosce bene le opere dello scrittore fa incappare l’uomoin contraddizioni. Realtà e finzione iniziano pericolosamente a mescolarsi ..."
    ],
    "image": "../una-pura-formalita.jpg"
  },
  {
    "title": "UNA QUESTIONE PRIVATA",
    "director": "Paolo e Vittorio Taviani",
    "country": "Italia/Francia",
    "releaseYear": 2017,
    "runtime": 85,
    "version": "OmU",
    "screeningDate": "19.05.2022",
    "readableDate": "2022-05-19",
    "screeningTime": "20:00",
    "actors": "Luca Marinelli, Lorenzo Richelm, Valentina Bellé, Giulio Beranek, Francesca Agostini, Alessandro Sperduti, Andrea Di Maria e altri",
    "subtitle": [
      "Con il film “La notte di San Lorenzo” i fratelli Taviani pensavano di aver lasciato dietro di se il tema della Resistenza e dei partigiani. Con questo loro ultimo lavoro invece lo riprendono. “L'antifascismo è tornato ad essere un tema di grande attualità”, affermano come loro motivazione. Lo sguardo al passato vuole anche essere uno spunto di riflessione sul presente. Nelle ultime settimane della Seconda Guerra Mondiale l'ex nemico poteva essere amico e il pluriennale amico nemico, spesso si trattava di una spaccatura all'interno della stessa famiglia. “Una questione privata” scandaglia il campo minato tra privato e politico in un'epoca violenta."
    ],
    "bodycopy": [
      "Sia Milton che Giorgio amano Fulvia. Sono amici e rivali allo stesso tempo. Lo si scopre però soltanto durante il film attraverso dei flashback e dai dialoghi. Lo spettatore segue prevalentemente Milton che attraverso il paesaggio nebbioso del Piemonte va alla ricerca di Giorgio. Incontra vari gruppi di partigiani che, in concorrenza fra di loro, in parte gelosi, in parte solidali, lottano contro le truppe tedesche e le camicie nere nazionali. Nessuno ci vede chiaro, la nebbia avvolge il paesaggio, e regna la diffidenza verso chiunque si incontri che potrebbe essere un amico o un nemico.",
      "I fratelli Taviani avevano concepito il film insieme, ma prima delle riprese, il più anziano, Vittorio, morì nell'aprile 2018 a Roma, investito da un'automobile. Così quest'opera è diventata il loro lascito comune."
    ],
    "image": "../privateangelegenheit05.jpg"
  },
  {
    "title": "UNA VITA TRANQUILLA",
    "director": "Claudio Cupellini",
    "country": "Italia/Deutschlanf/Francia",
    "releaseYear": 2010,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "16.05.2013",
    "readableDate": "2013-05-16",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Marco D'Amore, Francesco Di Leva, Juliane Köhler, Maurizio Donadoni, Alice Dwyer, Leonardo Sprengler",
    "subtitle": [""],
    "bodycopy": [
      "Toni Servillo è stato a ragione premiato al Festival del cinema di Roma come migliore attore maschile per il suo ruolo di ex camorrista inseguito dal suo passato, dopo essere riuscito a rifarsi la vita in Germania dove gestisce assieme alla moglie tedesca un ristorante."
    ],
    "image": "../una-vita-tranquilla.jpg"
  },
  {
    "title": "UNA VITA TRANQUILLA",
    "director": "Claudio Cupellini",
    "country": "Italia/Germania/Francia",
    "releaseYear": 2010,
    "runtime": 105,
    "version": "OmitU",
    "screeningDate": "27.04.2015",
    "readableDate": "2015-04-27",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Marco D'Amore, Francesco Di Leva, Juliane Köhler, Maurizio Donadoni, Alice Dwyer, Leonardo Sprengler",
    "subtitle": [""],
    "bodycopy": [
      "Un aspetto dei rapporti italo-tedeschi nella vita quotidiana di una famiglia: un ex mafioso ha fondato una famiglia in Germania, dove ha aperto un ristorante. Improvvisamente arriva il suo primo figlio dall’Italia che sconvolge il suo mondo."
    ],
    "image": "../una-vita-tranquilla.jpg"
  },
  {
    "title": "Va' dove ti porta il cuore",
    "director": "Cristina Comencini",
    "country": "Italia/Francia",
    "releaseYear": 1996,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "17.03.2005",
    "readableDate": "2005-03-17",
    "screeningTime": "19:30",
    "actors": "Virna Lisi, Margherita Buy, Galatea Ranzi, Massimo Ghini, Tchéky Kayro",
    "subtitle": [""],
    "bodycopy": [
      "Nella storia di tre donne di tre diverse generazioni si rispecchia il XX secolo. La racconta la voce di Olga, la nonna 80enne che poco prima di morire ha scritto un diario. Il libretto aiuta la nipote Marta a capire le intricate vicende della sua famiglia e a scoprire la verità sulla vita della propria madre.",
      "Secondo il parere dei critici, il film è più interessane del libro a cui si ispira."
    ],
    "image": "../cuore.png"
  },
  {
    "title": "VELOCE COME IL VENTO",
    "director": "Matteo Rovere",
    "country": "Italia",
    "releaseYear": 2016,
    "runtime": 119,
    "version": "OmU",
    "screeningDate": "16.11.2017",
    "readableDate": "2017-11-16",
    "screeningTime": "20:00",
    "actors": "Stefano Accorsi, Matilda De Angelis, Roberta Mattei, Paolo Graziosi, Lorenzo Gioielli, Giulio Pugnaghi, Cristina Spina",
    "subtitle": [
      "Per Giulia, dopo la morte del padre, la lotta per la vittoria nelle gare di motorsport si accompagnano alla lotta e alla solidarietà all'interno della famiglia."
    ],
    "bodycopy": [
      "Inaspettatamente infatti, al funerale del padre riappare il fratello Loris con la sua compagna, entrambi tossicodipendenti. Loris si appropria di parte della casa e dell'officina. Però questi beni sono pignorati sperando nella vittoria automobilistica della diciassettenne Giulia. Allora Loris, un tempo pilota geniale ma ormai solo l'ombra di se stesso, si impegna a risvegliare il suo istinto strategico per allenare Giulia. Ma che cosa si può veramente aspettarsi da un drogato?",
      "Le riprese di Michele D’Attanasio (IN GRAZIA DI DIO) appassionano anche lo spettatore più disinteressato alle gare automobilistiche e Stefano Accorsi (SATURNO CONTRO, L’ULTIMO BACIO) offre una prestazione eccezionale, forse la più convincente, nel ruolo di Loris."
    ],
    "image": "../veloce-come-il-vento.jpg"
  },
  {
    "title": "Vesna va veloce",
    "director": "Carlo Mazzacurati",
    "country": "Italia",
    "releaseYear": 1996,
    "runtime": 92,
    "version": "OmitU",
    "screeningDate": "06.02.2008",
    "readableDate": "2008-02-06",
    "screeningTime": "19:00",
    "actors": "Tereza Zajickova, Antonio Albanese, Silvio Orlando, Ivano Marescutti, Antonio Catania, Stefano Accorsi, Paolo Montevecchi, Tony Sperandeo, Marco Messeri",
    "subtitle": ["Location: Triest"],
    "bodycopy": [
      "Vesna, una giovane cecoslovacca, arriva con il pullman a Trieste e decide di rimanere in Italia. Lottando per una vita dignitosa nella \"terra promessa\" finisce nella prostituzione. Finalmente può permettersi nel mondo del consumismo quello che non aveva mai potuto avere nel suo paese. Ma a quale prezzo? Il film mette in evidenza il ruolo di questa città come \"porta di accesso\" dei migranti nel periodo tra la caduta del Muro e l'allargamento ad est dell'Unione Europea."
    ],
    "image": "../vesna-va-veloce.jpg"
  },
  {
    "title": "Viaggio segreto",
    "director": "Roberto Andò",
    "country": "Italia",
    "releaseYear": 2007,
    "runtime": 1,
    "version": "OmitU",
    "screeningDate": "04.02.2009",
    "readableDate": "2009-02-04",
    "screeningTime": "20:00",
    "actors": "Alessio Boni, Donatella Finocchiaro, Valeria Solarino, Claudia Gerini, Marco Baliani, Emir Kusturica, Roebrto Herlitzka",
    "subtitle": [""],
    "bodycopy": [
      "Leo ritrova se stesso tornando in Sicilia, l’isola che aveva lasciato con la sorella minore 25 anni prima. Il ritorno riporta alla luce un tragico segreto del passato che ha avuto grande influsso sulla loro vita. Piano piano, come sciogliendo una treccia, riaffiorano in superficie episodi nascosti che risvegliano ricordi, ma che possono pure provocare paure e passioni."
    ],
    "image": "../viaggio-segreto.jpg"
  },
  {
    "title": "VIVA LA LIBERTÀ",
    "director": "Roberto Andò",
    "country": "Italia",
    "releaseYear": 2013,
    "runtime": 94,
    "version": "OmU",
    "screeningDate": "16.10.2014",
    "readableDate": "2014-10-16",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Valerio Mastandrea, Valeria Bruni Tedeschi, Michela Cescon, Anna Bonaiuto, Eric Nguyen, Judith Davis, Andrea Renzi, Massimo De Francovich, Renato Scarpa",
    "subtitle": [""],
    "bodycopy": [
      "“C’è del metodo nella sua follia” è il secondo titolo italiano di questo film. In effetti con la storia del politico ormai logoro, sostituito dal suo gemello pazzo che attira le masse con parole vuote, Andò ha creato una satira,divertente e allo stesso tempo profonda, della politica italiana."
    ],
    "image": "../viva-la-liberta.jpg"
  },
  {
    "title": "WHAT IS LEFT",
    "director": "Gustav Hofer und Luca Ragazzi",
    "country": "Italia",
    "releaseYear": 2013,
    "runtime": 74,
    "version": "OmU",
    "screeningDate": "17.03.2014",
    "readableDate": "2014-03-17",
    "screeningTime": "20:00",
    "actors": "Lucia Mascino, Fabrizio Barca, Celeste Costantino",
    "subtitle": ["Narratrice: Lucia Mascino"],
    "bodycopy": [
      "Nel loro nuovo film gli autori di ITALY - LOVE IT OR LEAVE IT si inoltrano nei meandri della politica italiana. Deluse ormai le speranze che gli elettori di centro-sinistra nutrivano al momento del voto del 2013, molti italiani si sentono disorientati. Luca e Gustav descrivono gli alti e bassi dello loro stato d'animo in quest'anno politicamente così importante per l’Italia e ritraggono con leggerezza questo paese dominato dall'incertezza."
    ],
    "image": "../what-is-left.jpg"
  },
  {
    "title": "ZORAN, IL MIO NIPOTE SCEMO",
    "director": "Matteo Oleotto",
    "country": "Italia",
    "releaseYear": 2013,
    "runtime": 112,
    "version": "OmU",
    "screeningDate": "16.04.2015",
    "readableDate": "2015-04-16",
    "screeningTime": "20:00",
    "actors": "Giuseppe Battiston, Teco Celio, Rok Prasnikar, Roberto Citran, Marjuta Slamic, Riccardo Maranzana, Doina Komissarov",
    "subtitle": [""],
    "bodycopy": [
      "Davanti a Paolo, un simpaticone fallito più o meno in tutto nella vita, si presenta improvvisamente Zoran, un quindicenne mentalmente ritardato che afferma di essere imparentato con lui esortandolo ad assumere il ruolo del padre. Paolo, che all'inizio non è per nulla entusiasta, scopre le eccezionali capacità di Zoran e le vuole sfruttare a suo vantaggio. Piano piano però i ruoli si invertono ed è Zoran a vigilare su quell'adulto irrequieto."
    ],
    "image": "../zoran-mio-nipote-scemo.jpg"
  }
]
